import * as React$6 from "react";
import React__default, { useContext, useRef, forwardRef, useMemo, useState, Children, useEffect, createRef, useImperativeHandle } from "react";
import { a1 as isFragment$1, Q as _inherits, R as _createSuper, x as _classCallCheck, v as _createClass, O as supportRef, u as useComposeRef, f as _objectSpread2, y as findDOMNode, _ as _typeof, w as warning, k as _extends, t as wrapperRaf, N as CSSMotion, h as composeRef, d as classNames, M as unit, A as canUseDom, e as _slicedToArray, o as _toConsumableArray, q as useLayoutEffect$2, a2 as updateCSS, a3 as removeCSS, m as warningOnce, c as reactDomExports, L as Keyframe, a4 as fillRef, a5 as isDOM, l as _objectWithoutProperties, a6 as getCountryId, j as jsxRuntimeExports, D as classnamesExports, g as getCookie, a7 as setCookiesWithLoginData, a8 as dayjs, U as commonjsGlobal, $ as getDefaultExportFromCjs, E as getCountryKey } from "./country-d4e42059.js";
import { s as genComponentStyleHook, v as defaultPrefixCls, w as render, x as unmount, a as ConfigContext, k as useToken, S as SizeContext, g as genStyleHooks, m as merge, d as devUseWarning, L as LoadingOutlined, y as getLineHeight, b as genFocusStyle, B as genSubStyleComponent, D as DisabledContext, E as getShadowRoot, r as resetComponent, u as useZIndex, z as zIndexContext, K as KeyCode } from "./lib-1be19634.js";
import { a as useEvent, u as useMergedState, i as interopRequireDefaultExports, e as interopRequireWildcardExports, p as canUseDom$1, m as reactNode, h as require$$0, g as internal, s as style$1, w as warning$1, f as configProvider, L as LoadingOutlined$1 } from "./reactNode-61f1c13f.js";
import { y as fetchService, b as useGetStarted, a as useNotificationContext, z as getQrCode, A as qrCodePolling, B as linkToHunt, h as useLanguageContext } from "./index-23ca9bfe.js";
import { B as BroadcastChannel } from "./helper-4f6e6639.js";
import { W as WebPng } from "./index-510f96a1.js";
function toArray$1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return React__default.Children.forEach(e, function(i) {
    i == null && !t.keepEmpty || (Array.isArray(i) ? r = r.concat(toArray$1(i)) : isFragment$1(i) && i.props ? r = r.concat(toArray$1(i.props.children, t)) : r.push(i));
  }), r;
}
var CollectionContext = /* @__PURE__ */ React$6.createContext(null);
function Collection(e) {
  var t = e.children, r = e.onBatchResize, i = React$6.useRef(0), n = React$6.useRef([]), a = React$6.useContext(CollectionContext), s = React$6.useCallback(function(l, o, c) {
    i.current += 1;
    var f = i.current;
    n.current.push({
      size: l,
      element: o,
      data: c
    }), Promise.resolve().then(function() {
      f === i.current && (r == null || r(n.current), n.current = []);
    }), a == null || a(l, o, c);
  }, [r, a]);
  return /* @__PURE__ */ React$6.createElement(CollectionContext.Provider, {
    value: s
  }, t);
}
var MapShim = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var i = -1;
    return t.some(function(n, a) {
      return n[0] === r ? (i = a, !0) : !1;
    }), i;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(r) {
        var i = e(this.__entries__, r), n = this.__entries__[i];
        return n && n[1];
      }, t.prototype.set = function(r, i) {
        var n = e(this.__entries__, r);
        ~n ? this.__entries__[n][1] = i : this.__entries__.push([r, i]);
      }, t.prototype.delete = function(r) {
        var i = this.__entries__, n = e(i, r);
        ~n && i.splice(n, 1);
      }, t.prototype.has = function(r) {
        return !!~e(this.__entries__, r);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(r, i) {
        i === void 0 && (i = null);
        for (var n = 0, a = this.__entries__; n < a.length; n++) {
          var s = a[n];
          r.call(i, s[1], s[0]);
        }
      }, t;
    }()
  );
}(), isBrowser = typeof window < "u" && typeof document < "u" && window.document === document, global$1 = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), requestAnimationFrame$1 = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(global$1) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), trailingTimeout = 2;
function throttle$1(e, t) {
  var r = !1, i = !1, n = 0;
  function a() {
    r && (r = !1, e()), i && l();
  }
  function s() {
    requestAnimationFrame$1(a);
  }
  function l() {
    var o = Date.now();
    if (r) {
      if (o - n < trailingTimeout)
        return;
      i = !0;
    } else
      r = !0, i = !1, setTimeout(s, t);
    n = o;
  }
  return l;
}
var REFRESH_DELAY = 20, transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], mutationObserverSupported = typeof MutationObserver < "u", ResizeObserverController = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var r = this.observers_, i = r.indexOf(t);
      ~i && r.splice(i, 1), !r.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(r) {
        return r.gatherActive(), r.hasActive();
      });
      return t.forEach(function(r) {
        return r.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !isBrowser || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), mutationObserverSupported ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !isBrowser || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var r = t.propertyName, i = r === void 0 ? "" : r, n = transitionKeys.some(function(a) {
        return !!~i.indexOf(a);
      });
      n && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), defineConfigurable = function(e, t) {
  for (var r = 0, i = Object.keys(t); r < i.length; r++) {
    var n = i[r];
    Object.defineProperty(e, n, {
      value: t[n],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, getWindowOf = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || global$1;
}, emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(e) {
  return parseFloat(e) || 0;
}
function getBordersSize(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(i, n) {
    var a = e["border-" + n + "-width"];
    return i + toFloat(a);
  }, 0);
}
function getPaddings(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, i = 0, n = t; i < n.length; i++) {
    var a = n[i], s = e["padding-" + a];
    r[a] = toFloat(s);
  }
  return r;
}
function getSVGContentRect(e) {
  var t = e.getBBox();
  return createRectInit(0, 0, t.width, t.height);
}
function getHTMLElementContentRect(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return emptyRect;
  var i = getWindowOf(e).getComputedStyle(e), n = getPaddings(i), a = n.left + n.right, s = n.top + n.bottom, l = toFloat(i.width), o = toFloat(i.height);
  if (i.boxSizing === "border-box" && (Math.round(l + a) !== t && (l -= getBordersSize(i, "left", "right") + a), Math.round(o + s) !== r && (o -= getBordersSize(i, "top", "bottom") + s)), !isDocumentElement(e)) {
    var c = Math.round(l + a) - t, f = Math.round(o + s) - r;
    Math.abs(c) !== 1 && (l -= c), Math.abs(f) !== 1 && (o -= f);
  }
  return createRectInit(n.left, n.top, l, o);
}
var isSVGGraphicsElement = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof getWindowOf(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof getWindowOf(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function isDocumentElement(e) {
  return e === getWindowOf(e).document.documentElement;
}
function getContentRect(e) {
  return isBrowser ? isSVGGraphicsElement(e) ? getSVGContentRect(e) : getHTMLElementContentRect(e) : emptyRect;
}
function createReadOnlyRect(e) {
  var t = e.x, r = e.y, i = e.width, n = e.height, a = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, s = Object.create(a.prototype);
  return defineConfigurable(s, {
    x: t,
    y: r,
    width: i,
    height: n,
    top: r,
    right: t + i,
    bottom: n + r,
    left: t
  }), s;
}
function createRectInit(e, t, r, i) {
  return { x: e, y: t, width: r, height: i };
}
var ResizeObservation = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = createRectInit(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = getContentRect(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), ResizeObserverEntry = (
  /** @class */
  function() {
    function e(t, r) {
      var i = createReadOnlyRect(r);
      defineConfigurable(this, { target: t, contentRect: i });
    }
    return e;
  }()
), ResizeObserverSPI = (
  /** @class */
  function() {
    function e(t, r, i) {
      if (this.activeObservations_ = [], this.observations_ = new MapShim(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = r, this.callbackCtx_ = i;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof getWindowOf(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) || (r.set(t, new ResizeObservation(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof getWindowOf(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var r = this.observations_;
        r.has(t) && (r.delete(t), r.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(r) {
        r.isActive() && t.activeObservations_.push(r);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, r = this.activeObservations_.map(function(i) {
          return new ResizeObserverEntry(i.target, i.broadcastRect());
        });
        this.callback_.call(t, r, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), observers = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new MapShim(), ResizeObserver$2 = (
  /** @class */
  function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var r = ResizeObserverController.getInstance(), i = new ResizeObserverSPI(t, r, this);
      observers.set(this, i);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  ResizeObserver$2.prototype[e] = function() {
    var t;
    return (t = observers.get(this))[e].apply(t, arguments);
  };
});
var index = function() {
  return typeof global$1.ResizeObserver < "u" ? global$1.ResizeObserver : ResizeObserver$2;
}(), elementListeners = /* @__PURE__ */ new Map();
function onResize(e) {
  e.forEach(function(t) {
    var r, i = t.target;
    (r = elementListeners.get(i)) === null || r === void 0 || r.forEach(function(n) {
      return n(i);
    });
  });
}
var resizeObserver = new index(onResize);
process.env.NODE_ENV;
process.env.NODE_ENV;
function observe(e, t) {
  elementListeners.has(e) || (elementListeners.set(e, /* @__PURE__ */ new Set()), resizeObserver.observe(e)), elementListeners.get(e).add(t);
}
function unobserve(e, t) {
  elementListeners.has(e) && (elementListeners.get(e).delete(t), elementListeners.get(e).size || (resizeObserver.unobserve(e), elementListeners.delete(e)));
}
var DomWrapper = /* @__PURE__ */ function(e) {
  _inherits(r, e);
  var t = _createSuper(r);
  function r() {
    return _classCallCheck(this, r), t.apply(this, arguments);
  }
  return _createClass(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(React$6.Component);
function SingleObserver(e, t) {
  var r = e.children, i = e.disabled, n = React$6.useRef(null), a = React$6.useRef(null), s = React$6.useContext(CollectionContext), l = typeof r == "function", o = l ? r(n) : r, c = React$6.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), f = !l && /* @__PURE__ */ React$6.isValidElement(o) && supportRef(o), x = f ? o.ref : null, m = useComposeRef(x, n), A = function() {
    var u;
    return findDOMNode(n.current) || // Support `nativeElement` format
    (n.current && _typeof(n.current) === "object" ? findDOMNode((u = n.current) === null || u === void 0 ? void 0 : u.nativeElement) : null) || findDOMNode(a.current);
  };
  React$6.useImperativeHandle(t, function() {
    return A();
  });
  var M = React$6.useRef(e);
  M.current = e;
  var d = React$6.useCallback(function(C) {
    var u = M.current, g = u.onResize, p = u.data, y = C.getBoundingClientRect(), E = y.width, T = y.height, Z = C.offsetWidth, G = C.offsetHeight, I = Math.floor(E), V = Math.floor(T);
    if (c.current.width !== I || c.current.height !== V || c.current.offsetWidth !== Z || c.current.offsetHeight !== G) {
      var Y = {
        width: I,
        height: V,
        offsetWidth: Z,
        offsetHeight: G
      };
      c.current = Y;
      var D = Z === Math.round(E) ? E : Z, R = G === Math.round(T) ? T : G, B = _objectSpread2(_objectSpread2({}, Y), {}, {
        offsetWidth: D,
        offsetHeight: R
      });
      s == null || s(B, C, p), g && Promise.resolve().then(function() {
        g(B, C);
      });
    }
  }, []);
  return React$6.useEffect(function() {
    var C = A();
    return C && !i && observe(C, d), function() {
      return unobserve(C, d);
    };
  }, [n.current, i]), /* @__PURE__ */ React$6.createElement(DomWrapper, {
    ref: a
  }, f ? /* @__PURE__ */ React$6.cloneElement(o, {
    ref: m
  }) : o);
}
var RefSingleObserver = /* @__PURE__ */ React$6.forwardRef(SingleObserver);
process.env.NODE_ENV !== "production" && (RefSingleObserver.displayName = "SingleObserver");
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver$1(e, t) {
  var r = e.children, i = typeof r == "function" ? [r] : toArray$1(r);
  return process.env.NODE_ENV !== "production" && (i.length > 1 ? warning(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : i.length === 0 && warning(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), i.map(function(n, a) {
    var s = (n == null ? void 0 : n.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(a);
    return /* @__PURE__ */ React$6.createElement(RefSingleObserver, _extends({}, e, {
      key: s,
      ref: a === 0 ? t : void 0
    }), n);
  });
}
var RefResizeObserver = /* @__PURE__ */ React$6.forwardRef(ResizeObserver$1);
process.env.NODE_ENV !== "production" && (RefResizeObserver.displayName = "ResizeObserver");
RefResizeObserver.Collection = Collection;
function omit(e, t) {
  var r = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(i) {
    delete r[i];
  }), r;
}
const PresetColors = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"];
function genPresetColor(e, t) {
  return PresetColors.reduce((r, i) => {
    const n = e[`${i}1`], a = e[`${i}3`], s = e[`${i}6`], l = e[`${i}7`];
    return Object.assign(Object.assign({}, r), t(i, {
      lightColor: n,
      lightBorderColor: a,
      darkColor: s,
      textColor: l
    }));
  }, {});
}
function isFragment(e) {
  return e && /* @__PURE__ */ React__default.isValidElement(e) && e.type === React__default.Fragment;
}
const replaceElement = (e, t, r) => /* @__PURE__ */ React__default.isValidElement(e) ? /* @__PURE__ */ React__default.cloneElement(e, typeof r == "function" ? r(e.props || {}) : r) : t;
function cloneElement(e, t) {
  return replaceElement(e, e, t);
}
const getCollapsedHeight = () => ({
  height: 0,
  opacity: 0
}), getRealHeight = (e) => {
  const {
    scrollHeight: t
  } = e;
  return {
    height: t,
    opacity: 1
  };
}, getCurrentHeight = (e) => ({
  height: e ? e.offsetHeight : 0
}), skipOpacityTransition = (e, t) => (t == null ? void 0 : t.deadline) === !0 || t.propertyName === "height", initCollapseMotion = function() {
  return {
    motionName: `${arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant"}-motion-collapse`,
    onAppearStart: getCollapsedHeight,
    onEnterStart: getCollapsedHeight,
    onAppearActive: getRealHeight,
    onEnterActive: getRealHeight,
    onLeaveStart: getCurrentHeight,
    onLeaveActive: getCollapsedHeight,
    onAppearEnd: skipOpacityTransition,
    onEnterEnd: skipOpacityTransition,
    onLeaveEnd: skipOpacityTransition,
    motionDeadline: 500
  };
}, getTransitionName = (e, t, r) => r !== void 0 ? r : `${e}-${t}`, isVisible = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), r = t.width, i = t.height;
      if (r || i)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var n = e.getBoundingClientRect(), a = n.width, s = n.height;
      if (a || s)
        return !0;
    }
  }
  return !1;
}, genWaveStyle = (e) => {
  const {
    componentCls: t,
    colorPrimary: r
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${r})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${e.motionDurationSlow} ${e.motionEaseInOut}`, `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, useStyle$4 = genComponentStyleHook("Wave", (e) => [genWaveStyle(e)]), TARGET_CLS = `${defaultPrefixCls}-wave-target`;
function isNotGrey(e) {
  const t = (e || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  return t && t[1] && t[2] && t[3] ? !(t[1] === t[2] && t[2] === t[3]) : !0;
}
function isValidWaveColor(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && isNotGrey(e) && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function getTargetWaveColor(e) {
  const {
    borderTopColor: t,
    borderColor: r,
    backgroundColor: i
  } = getComputedStyle(e);
  return isValidWaveColor(t) ? t : isValidWaveColor(r) ? r : isValidWaveColor(i) ? i : null;
}
function validateNum(e) {
  return Number.isNaN(e) ? 0 : e;
}
const WaveEffect = (e) => {
  const {
    className: t,
    target: r,
    component: i
  } = e, n = React$6.useRef(null), [a, s] = React$6.useState(null), [l, o] = React$6.useState([]), [c, f] = React$6.useState(0), [x, m] = React$6.useState(0), [A, M] = React$6.useState(0), [d, C] = React$6.useState(0), [u, g] = React$6.useState(!1), p = {
    left: c,
    top: x,
    width: A,
    height: d,
    borderRadius: l.map((T) => `${T}px`).join(" ")
  };
  a && (p["--wave-color"] = a);
  function y() {
    const T = getComputedStyle(r);
    s(getTargetWaveColor(r));
    const Z = T.position === "static", {
      borderLeftWidth: G,
      borderTopWidth: I
    } = T;
    f(Z ? r.offsetLeft : validateNum(-parseFloat(G))), m(Z ? r.offsetTop : validateNum(-parseFloat(I))), M(r.offsetWidth), C(r.offsetHeight);
    const {
      borderTopLeftRadius: V,
      borderTopRightRadius: Y,
      borderBottomLeftRadius: D,
      borderBottomRightRadius: R
    } = T;
    o([V, Y, R, D].map((B) => validateNum(parseFloat(B))));
  }
  if (React$6.useEffect(() => {
    if (r) {
      const T = wrapperRaf(() => {
        y(), g(!0);
      });
      let Z;
      return typeof ResizeObserver < "u" && (Z = new ResizeObserver(y), Z.observe(r)), () => {
        wrapperRaf.cancel(T), Z == null || Z.disconnect();
      };
    }
  }, []), !u)
    return null;
  const E = (i === "Checkbox" || i === "Radio") && (r == null ? void 0 : r.classList.contains(TARGET_CLS));
  return /* @__PURE__ */ React$6.createElement(CSSMotion, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (T, Z) => {
      var G;
      if (Z.deadline || Z.propertyName === "opacity") {
        const I = (G = n.current) === null || G === void 0 ? void 0 : G.parentElement;
        unmount(I).then(() => {
          I == null || I.remove();
        });
      }
      return !1;
    }
  }, (T, Z) => {
    let {
      className: G
    } = T;
    return /* @__PURE__ */ React$6.createElement("div", {
      ref: composeRef(n, Z),
      className: classNames(t, G, {
        "wave-quick": E
      }),
      style: p
    });
  });
}, showWaveEffect = (e, t) => {
  var r;
  const {
    component: i
  } = t;
  if (i === "Checkbox" && !(!((r = e.querySelector("input")) === null || r === void 0) && r.checked))
    return;
  const n = document.createElement("div");
  n.style.position = "absolute", n.style.left = "0px", n.style.top = "0px", e == null || e.insertBefore(n, e == null ? void 0 : e.firstChild), render(/* @__PURE__ */ React$6.createElement(WaveEffect, Object.assign({}, t, {
    target: e
  })), n);
}, showWaveEffect$1 = showWaveEffect, useWave = (e, t, r) => {
  const {
    wave: i
  } = React$6.useContext(ConfigContext), [, n, a] = useToken(), s = useEvent((c) => {
    const f = e.current;
    if (i != null && i.disabled || !f)
      return;
    const x = f.querySelector(`.${TARGET_CLS}`) || f, {
      showEffect: m
    } = i || {};
    (m || showWaveEffect$1)(x, {
      className: t,
      token: n,
      component: r,
      event: c,
      hashId: a
    });
  }), l = React$6.useRef();
  return (c) => {
    wrapperRaf.cancel(l.current), l.current = wrapperRaf(() => {
      s(c);
    });
  };
}, useWave$1 = useWave, Wave = (e) => {
  const {
    children: t,
    disabled: r,
    component: i
  } = e, {
    getPrefixCls: n
  } = useContext(ConfigContext), a = useRef(null), s = n("wave"), [, l] = useStyle$4(s), o = useWave$1(a, classNames(s, l), i);
  if (React__default.useEffect(() => {
    const f = a.current;
    if (!f || f.nodeType !== 1 || r)
      return;
    const x = (m) => {
      !isVisible(m.target) || // No need wave
      !f.getAttribute || f.getAttribute("disabled") || f.disabled || f.className.includes("disabled") || f.className.includes("-leave") || o(m);
    };
    return f.addEventListener("click", x, !0), () => {
      f.removeEventListener("click", x, !0);
    };
  }, [r]), !/* @__PURE__ */ React__default.isValidElement(t))
    return t ?? null;
  const c = supportRef(t) ? composeRef(t.ref, a) : a;
  return cloneElement(t, {
    ref: c
  });
};
process.env.NODE_ENV !== "production" && (Wave.displayName = "Wave");
const Wave$1 = Wave, useSize = (e) => {
  const t = React__default.useContext(SizeContext);
  return React__default.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
}, useSize$1 = useSize, genSpaceCompactStyle = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
}, genSpaceCompactStyle$1 = genSpaceCompactStyle, genSpaceStyle = (e) => {
  const {
    componentCls: t,
    antCls: r
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-item:empty`]: {
        display: "none"
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${t}-item > ${r}-badge-not-a-wrapper:only-child`]: {
        display: "block"
      }
    }
  };
}, genSpaceGapStyle = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-row-small": {
        rowGap: e.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: e.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: e.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: e.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: e.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: e.spaceGapLargeSize
      }
    }
  };
}, useStyle$3 = genStyleHooks("Space", (e) => {
  const t = merge(e, {
    spaceGapSmallSize: e.paddingXS,
    spaceGapMiddleSize: e.padding,
    spaceGapLargeSize: e.paddingLG
  });
  return [genSpaceStyle(t), genSpaceGapStyle(t), genSpaceCompactStyle$1(t)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var __rest$6 = globalThis && globalThis.__rest || function(e, t) {
  var r = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
};
const SpaceCompactItemContext = /* @__PURE__ */ React$6.createContext(null), useCompactItemContext = (e, t) => {
  const r = React$6.useContext(SpaceCompactItemContext), i = React$6.useMemo(() => {
    if (!r)
      return "";
    const {
      compactDirection: n,
      isFirstItem: a,
      isLastItem: s
    } = r, l = n === "vertical" ? "-vertical-" : "-";
    return classNames(`${e}-compact${l}item`, {
      [`${e}-compact${l}first-item`]: a,
      [`${e}-compact${l}last-item`]: s,
      [`${e}-compact${l}item-rtl`]: t === "rtl"
    });
  }, [e, t, r]);
  return {
    compactSize: r == null ? void 0 : r.compactSize,
    compactDirection: r == null ? void 0 : r.compactDirection,
    compactItemClassnames: i
  };
}, NoCompactStyle = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ React$6.createElement(SpaceCompactItemContext.Provider, {
    value: null
  }, t);
}, CompactItem = (e) => {
  var {
    children: t
  } = e, r = __rest$6(e, ["children"]);
  return /* @__PURE__ */ React$6.createElement(SpaceCompactItemContext.Provider, {
    value: r
  }, t);
}, Compact = (e) => {
  const {
    getPrefixCls: t,
    direction: r
  } = React$6.useContext(ConfigContext), {
    size: i,
    direction: n,
    block: a,
    prefixCls: s,
    className: l,
    rootClassName: o,
    children: c
  } = e, f = __rest$6(e, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), x = useSize$1((p) => i ?? p), m = t("space-compact", s), [A, M] = useStyle$3(m), d = classNames(m, M, {
    [`${m}-rtl`]: r === "rtl",
    [`${m}-block`]: a,
    [`${m}-vertical`]: n === "vertical"
  }, l, o), C = React$6.useContext(SpaceCompactItemContext), u = toArray$1(c), g = React$6.useMemo(() => u.map((p, y) => {
    const E = p && p.key || `${m}-item-${y}`;
    return /* @__PURE__ */ React$6.createElement(CompactItem, {
      key: E,
      compactSize: x,
      compactDirection: n,
      isFirstItem: y === 0 && (!C || (C == null ? void 0 : C.isFirstItem)),
      isLastItem: y === u.length - 1 && (!C || (C == null ? void 0 : C.isLastItem))
    }, p);
  }), [i, u, C]);
  return u.length === 0 ? null : A(/* @__PURE__ */ React$6.createElement("div", Object.assign({
    className: d
  }, f), g));
};
var __rest$5 = globalThis && globalThis.__rest || function(e, t) {
  var r = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
};
const GroupSizeContext = /* @__PURE__ */ React$6.createContext(void 0), ButtonGroup = (e) => {
  const {
    getPrefixCls: t,
    direction: r
  } = React$6.useContext(ConfigContext), {
    prefixCls: i,
    size: n,
    className: a
  } = e, s = __rest$5(e, ["prefixCls", "size", "className"]), l = t("btn-group", i), [, , o] = useToken();
  let c = "";
  switch (n) {
    case "large":
      c = "lg";
      break;
    case "small":
      c = "sm";
      break;
  }
  if (process.env.NODE_ENV !== "production") {
    const x = devUseWarning("Button.Group");
    process.env.NODE_ENV !== "production" && x(!n || ["large", "small", "middle"].includes(n), "usage", "Invalid prop `size`.");
  }
  const f = classNames(l, {
    [`${l}-${c}`]: c,
    [`${l}-rtl`]: r === "rtl"
  }, a, o);
  return /* @__PURE__ */ React$6.createElement(GroupSizeContext.Provider, {
    value: n
  }, /* @__PURE__ */ React$6.createElement("div", Object.assign({}, s, {
    className: f
  })));
}, Group = ButtonGroup, rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/, isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(e) {
  return typeof e == "string";
}
function isUnBorderedButtonType(e) {
  return e === "text" || e === "link";
}
function splitCNCharsBySpace(e, t) {
  if (e == null)
    return;
  const r = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && isString(e.type) && isTwoCNChar(e.props.children) ? cloneElement(e, {
    children: e.props.children.split("").join(r)
  }) : isString(e) ? isTwoCNChar(e) ? /* @__PURE__ */ React__default.createElement("span", null, e.split("").join(r)) : /* @__PURE__ */ React__default.createElement("span", null, e) : isFragment(e) ? /* @__PURE__ */ React__default.createElement("span", null, e) : e;
}
function spaceChildren(e, t) {
  let r = !1;
  const i = [];
  return React__default.Children.forEach(e, (n) => {
    const a = typeof n, s = a === "string" || a === "number";
    if (r && s) {
      const l = i.length - 1, o = i[l];
      i[l] = `${o}${n}`;
    } else
      i.push(n);
    r = s;
  }), React__default.Children.map(i, (n) => splitCNCharsBySpace(n, t));
}
const IconWrapper = /* @__PURE__ */ forwardRef((e, t) => {
  const {
    className: r,
    style: i,
    children: n,
    prefixCls: a
  } = e, s = classNames(`${a}-icon`, r);
  return /* @__PURE__ */ React__default.createElement("span", {
    ref: t,
    className: s,
    style: i
  }, n);
}), IconWrapper$1 = IconWrapper, InnerLoadingIcon = /* @__PURE__ */ forwardRef((e, t) => {
  const {
    prefixCls: r,
    className: i,
    style: n,
    iconClassName: a
  } = e, s = classNames(`${r}-loading-icon`, i);
  return /* @__PURE__ */ React__default.createElement(IconWrapper$1, {
    prefixCls: r,
    className: s,
    style: n,
    ref: t
  }, /* @__PURE__ */ React__default.createElement(LoadingOutlined, {
    className: a
  }));
}), getCollapsedWidth = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), getRealWidth = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), LoadingIcon = (e) => {
  const {
    prefixCls: t,
    loading: r,
    existIcon: i,
    className: n,
    style: a
  } = e, s = !!r;
  return i ? /* @__PURE__ */ React__default.createElement(InnerLoadingIcon, {
    prefixCls: t,
    className: n,
    style: a
  }) : /* @__PURE__ */ React__default.createElement(CSSMotion, {
    visible: s,
    // We do not really use this motionName
    motionName: `${t}-loading-icon-motion`,
    motionLeave: s,
    removeOnLeave: !0,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, (l, o) => {
    let {
      className: c,
      style: f
    } = l;
    return /* @__PURE__ */ React__default.createElement(InnerLoadingIcon, {
      prefixCls: t,
      className: n,
      style: Object.assign(Object.assign({}, a), f),
      ref: o,
      iconClassName: c
    });
  });
}, LoadingIcon$1 = LoadingIcon, genButtonBorderStyle = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), genGroupStyle = (e) => {
  const {
    componentCls: t,
    fontSize: r,
    lineWidth: i,
    groupBorderColor: n,
    colorErrorHover: a
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(i).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover,\n          &:focus,\n          &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: r
        }
      },
      // Border Color
      genButtonBorderStyle(`${t}-primary`, n),
      genButtonBorderStyle(`${t}-danger`, a)
    ]
  };
}, genGroupStyle$1 = genGroupStyle, prepareToken = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: r,
    paddingBlock: i
  } = e;
  return merge(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: i,
    buttonIconOnlyFontSize: r
  });
}, prepareComponentToken$3 = (e) => {
  var t, r, i, n, a, s;
  const l = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, o = (r = e.contentFontSizeSM) !== null && r !== void 0 ? r : e.fontSize, c = (i = e.contentFontSizeLG) !== null && i !== void 0 ? i : e.fontSizeLG, f = (n = e.contentLineHeight) !== null && n !== void 0 ? n : getLineHeight(l), x = (a = e.contentLineHeightSM) !== null && a !== void 0 ? a : getLineHeight(o), m = (s = e.contentLineHeightLG) !== null && s !== void 0 ? s : getLineHeight(c);
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: e.fontSizeLG,
    onlyIconSizeSM: e.fontSizeLG - 2,
    onlyIconSizeLG: e.fontSizeLG + 2,
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textHoverBg: e.colorBgTextHover,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    contentFontSize: l,
    contentFontSizeSM: o,
    contentFontSizeLG: c,
    contentLineHeight: f,
    contentLineHeightSM: x,
    contentLineHeightLG: m,
    paddingBlock: Math.max((e.controlHeight - l * f) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - o * x) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - c * m) / 2 - e.lineWidth, 0)
  };
}, genSharedButtonStyle = (e) => {
  const {
    componentCls: t,
    iconCls: r,
    fontWeight: i
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: e.marginXS,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: i,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${unit(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${t}-icon`]: {
        lineHeight: 1
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, genFocusStyle(e)),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${r})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // iconPosition="end"
      "&-icon-end": {
        flexDirection: "row-reverse"
      }
    }
  };
}, genHoverActiveButtonStyle = (e, t, r) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": r
  }
}), genCircleButtonStyle = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), genRoundButtonStyle = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), genDisabledStyle = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), genGhostButtonStyle = (e, t, r, i, n, a, s, l) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: r || void 0,
    background: t,
    borderColor: i || void 0,
    boxShadow: "none"
  }, genHoverActiveButtonStyle(e, Object.assign({
    background: t
  }, s), Object.assign({
    background: t
  }, l))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: n || void 0,
      borderColor: a || void 0
    }
  })
}), genSolidDisabledButtonStyle = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, genDisabledStyle(e))
}), genSolidButtonStyle = (e) => Object.assign({}, genSolidDisabledButtonStyle(e)), genPureDisabledButtonStyle = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), genDefaultButtonStyle = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genSolidButtonStyle(e)), {
  background: e.defaultBg,
  borderColor: e.defaultBorderColor,
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}), genHoverActiveButtonStyle(e.componentCls, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), genGhostButtonStyle(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    color: e.colorError,
    borderColor: e.colorError
  }, genHoverActiveButtonStyle(e.componentCls, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorBorderHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), genGhostButtonStyle(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder)), genSolidDisabledButtonStyle(e))
}), genPrimaryButtonStyle = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genSolidButtonStyle(e)), {
  color: e.primaryColor,
  background: e.colorPrimary,
  boxShadow: e.primaryShadow
}), genHoverActiveButtonStyle(e.componentCls, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryHover
}, {
  color: e.colorTextLightSolid,
  background: e.colorPrimaryActive
})), genGhostButtonStyle(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    background: e.colorError,
    boxShadow: e.dangerShadow,
    color: e.dangerColor
  }, genHoverActiveButtonStyle(e.componentCls, {
    background: e.colorErrorHover
  }, {
    background: e.colorErrorActive
  })), genGhostButtonStyle(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
    color: e.colorErrorHover,
    borderColor: e.colorErrorHover
  }, {
    color: e.colorErrorActive,
    borderColor: e.colorErrorActive
  })), genSolidDisabledButtonStyle(e))
}), genDashedButtonStyle = (e) => Object.assign(Object.assign({}, genDefaultButtonStyle(e)), {
  borderStyle: "dashed"
}), genLinkButtonStyle = (e) => Object.assign(Object.assign(Object.assign({
  color: e.colorLink
}, genHoverActiveButtonStyle(e.componentCls, {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), genPureDisabledButtonStyle(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, genHoverActiveButtonStyle(e.componentCls, {
    color: e.colorErrorHover
  }, {
    color: e.colorErrorActive
  })), genPureDisabledButtonStyle(e))
}), genTextButtonStyle = (e) => Object.assign(Object.assign(Object.assign({}, genHoverActiveButtonStyle(e.componentCls, {
  color: e.colorText,
  background: e.textHoverBg
}, {
  color: e.colorText,
  background: e.colorBgTextActive
})), genPureDisabledButtonStyle(e)), {
  [`&${e.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: e.colorError
  }, genPureDisabledButtonStyle(e)), genHoverActiveButtonStyle(e.componentCls, {
    color: e.colorErrorHover,
    background: e.colorErrorBg
  }, {
    color: e.colorErrorHover,
    background: e.colorErrorBgActive
  }))
}), genTypeButtonStyle = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-default`]: genDefaultButtonStyle(e),
    [`${t}-primary`]: genPrimaryButtonStyle(e),
    [`${t}-dashed`]: genDashedButtonStyle(e),
    [`${t}-link`]: genLinkButtonStyle(e),
    [`${t}-text`]: genTextButtonStyle(e),
    [`${t}-ghost`]: genGhostButtonStyle(e.componentCls, e.ghostBg, e.colorBgContainer, e.colorBgContainer, e.colorTextDisabled, e.colorBorder)
  };
}, genButtonStyle = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: r,
    controlHeight: i,
    fontSize: n,
    lineHeight: a,
    borderRadius: s,
    buttonPaddingHorizontal: l,
    iconCls: o,
    buttonPaddingVertical: c
  } = e, f = `${r}-icon-only`;
  return [
    {
      [`${t}`]: {
        fontSize: n,
        lineHeight: a,
        height: i,
        padding: `${unit(c)} ${unit(l)}`,
        borderRadius: s,
        [`&${f}`]: {
          width: i,
          paddingInline: 0,
          // make `btn-icon-only` not too narrow
          [`&${r}-compact-item`]: {
            flex: "none"
          },
          [`&${r}-round`]: {
            width: "auto"
          },
          [o]: {
            fontSize: e.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${r}-loading`]: {
          opacity: e.opacityLoading,
          cursor: "default"
        },
        [`${r}-loading-icon`]: {
          transition: `width ${e.motionDurationSlow} ${e.motionEaseInOut}, opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${r}${r}-circle${t}`]: genCircleButtonStyle(e)
    },
    {
      [`${r}${r}-round${t}`]: genRoundButtonStyle(e)
    }
  ];
}, genSizeBaseButtonStyle = (e) => {
  const t = merge(e, {
    fontSize: e.contentFontSize,
    lineHeight: e.contentLineHeight
  });
  return genButtonStyle(t, e.componentCls);
}, genSizeSmallButtonStyle = (e) => {
  const t = merge(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    lineHeight: e.contentLineHeightSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: e.paddingBlockSM,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return genButtonStyle(t, `${e.componentCls}-sm`);
}, genSizeLargeButtonStyle = (e) => {
  const t = merge(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    lineHeight: e.contentLineHeightLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: e.paddingBlockLG,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return genButtonStyle(t, `${e.componentCls}-lg`);
}, genBlockButtonStyle = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, useStyle$2 = genStyleHooks("Button", (e) => {
  const t = prepareToken(e);
  return [
    // Shared
    genSharedButtonStyle(t),
    // Size
    genSizeBaseButtonStyle(t),
    genSizeSmallButtonStyle(t),
    genSizeLargeButtonStyle(t),
    // Block
    genBlockButtonStyle(t),
    // Group (type, ghost, danger, loading)
    genTypeButtonStyle(t),
    // Button Group
    genGroupStyle$1(t)
  ];
}, prepareComponentToken$3, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function compactItemBorder(e, t, r) {
  const {
    focusElCls: i,
    focus: n,
    borderElCls: a
  } = r, s = a ? "> *" : "", l = ["hover", n ? "focus" : null, "active"].filter(Boolean).map((o) => `&:${o} ${s}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [l]: {
        zIndex: 2
      }
    }, i ? {
      [`&${i}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${s}`]: {
        zIndex: 0
      }
    })
  };
}
function compactItemBorderRadius(e, t, r) {
  const {
    borderElCls: i
  } = r, n = i ? `> ${i}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${n}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${n}, &${e}-sm ${n}, &${e}-lg ${n}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${n}, &${e}-sm ${n}, &${e}-lg ${n}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: r
  } = e, i = `${r}-compact`;
  return {
    [i]: Object.assign(Object.assign({}, compactItemBorder(e, i, t)), compactItemBorderRadius(r, i, t))
  };
}
function compactItemVerticalBorder(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function compactItemBorderVerticalRadius(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function genCompactItemVerticalStyle(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, compactItemVerticalBorder(e, t)), compactItemBorderVerticalRadius(e.componentCls, t))
  };
}
const genButtonCompactStyle = (e) => {
  const {
    componentCls: t,
    calc: r
  } = e;
  return {
    [t]: {
      // Special styles for Primary Button
      [`&-compact-item${t}-primary`]: {
        [`&:not([disabled]) + ${t}-compact-item${t}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: r(e.lineWidth).mul(-1).equal(),
            insetInlineStart: r(e.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: e.lineWidth,
            height: `calc(100% + ${unit(e.lineWidth)} * 2)`,
            backgroundColor: e.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${t}-primary`]: {
          [`&:not([disabled]) + ${t}-compact-vertical-item${t}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: r(e.lineWidth).mul(-1).equal(),
              insetInlineStart: r(e.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${unit(e.lineWidth)} * 2)`,
              height: e.lineWidth,
              backgroundColor: e.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, CompactCmp = genSubStyleComponent(["Button", "compact"], (e) => {
  const t = prepareToken(e);
  return [
    // Space Compact
    genCompactItemStyle(t),
    genCompactItemVerticalStyle(t),
    genButtonCompactStyle(t)
  ];
}, prepareComponentToken$3);
var __rest$4 = globalThis && globalThis.__rest || function(e, t) {
  var r = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
};
function getLoadingConfig(e) {
  if (typeof e == "object" && e) {
    let t = e == null ? void 0 : e.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const InternalCompoundedButton = /* @__PURE__ */ React__default.forwardRef((e, t) => {
  var r, i, n;
  const {
    loading: a = !1,
    prefixCls: s,
    type: l,
    danger: o = !1,
    shape: c = "default",
    size: f,
    styles: x,
    disabled: m,
    className: A,
    rootClassName: M,
    children: d,
    icon: C,
    iconPosition: u = "start",
    ghost: g = !1,
    block: p = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: y = "button",
    classNames: E,
    style: T = {},
    autoInsertSpace: Z
  } = e, G = __rest$4(e, ["loading", "prefixCls", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace"]), I = l || "default", {
    getPrefixCls: V,
    direction: Y,
    button: D
  } = useContext(ConfigContext), R = (r = Z ?? (D == null ? void 0 : D.autoInsertSpace)) !== null && r !== void 0 ? r : !0, B = V("btn", s), [j, N, P] = useStyle$2(B), z = useContext(DisabledContext), b = m ?? z, k = useContext(GroupSizeContext), S = useMemo(() => getLoadingConfig(a), [a]), [F, Q] = useState(S.loading), [L, W] = useState(!1), _ = composeRef(t, /* @__PURE__ */ createRef()), ee = Children.count(d) === 1 && !C && !isUnBorderedButtonType(I);
  useEffect(() => {
    let U = null;
    S.delay > 0 ? U = setTimeout(() => {
      U = null, Q(!0);
    }, S.delay) : Q(S.loading);
    function ne() {
      U && (clearTimeout(U), U = null);
    }
    return ne;
  }, [S]), useEffect(() => {
    if (!_ || !_.current || !R)
      return;
    const U = _.current.textContent;
    ee && isTwoCNChar(U) ? L || W(!0) : L && W(!1);
  }, [_]);
  const se = (U) => {
    const {
      onClick: ne
    } = e;
    if (F || b) {
      U.preventDefault();
      return;
    }
    ne == null || ne(U);
  };
  if (process.env.NODE_ENV !== "production") {
    const U = devUseWarning("Button");
    process.env.NODE_ENV !== "production" && U(!(typeof C == "string" && C.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${C}\` at https://ant.design/components/icon`), process.env.NODE_ENV !== "production" && U(!(g && isUnBorderedButtonType(I)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const {
    compactSize: ae,
    compactItemClassnames: re
  } = useCompactItemContext(B, Y), me = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, $ = useSize$1((U) => {
    var ne, oe;
    return (oe = (ne = f ?? ae) !== null && ne !== void 0 ? ne : k) !== null && oe !== void 0 ? oe : U;
  }), O = $ && me[$] || "", ge = F ? "loading" : C, he = omit(G, ["navigate"]), le = classNames(B, N, P, {
    [`${B}-${c}`]: c !== "default" && c,
    [`${B}-${I}`]: I,
    [`${B}-${O}`]: O,
    [`${B}-icon-only`]: !d && d !== 0 && !!ge,
    [`${B}-background-ghost`]: g && !isUnBorderedButtonType(I),
    [`${B}-loading`]: F,
    [`${B}-two-chinese-chars`]: L && R && !F,
    [`${B}-block`]: p,
    [`${B}-dangerous`]: o,
    [`${B}-rtl`]: Y === "rtl",
    [`${B}-icon-end`]: u === "end"
  }, re, A, M, D == null ? void 0 : D.className), ce = Object.assign(Object.assign({}, D == null ? void 0 : D.style), T), K = classNames(E == null ? void 0 : E.icon, (i = D == null ? void 0 : D.classNames) === null || i === void 0 ? void 0 : i.icon), ue = Object.assign(Object.assign({}, (x == null ? void 0 : x.icon) || {}), ((n = D == null ? void 0 : D.styles) === null || n === void 0 ? void 0 : n.icon) || {}), ie = C && !F ? /* @__PURE__ */ React__default.createElement(IconWrapper$1, {
    prefixCls: B,
    className: K,
    style: ue
  }, C) : /* @__PURE__ */ React__default.createElement(LoadingIcon$1, {
    existIcon: !!C,
    prefixCls: B,
    loading: F
  }), Ae = d || d === 0 ? spaceChildren(d, ee && R) : null;
  if (he.href !== void 0)
    return j(/* @__PURE__ */ React__default.createElement("a", Object.assign({}, he, {
      className: classNames(le, {
        [`${B}-disabled`]: b
      }),
      href: b ? void 0 : he.href,
      style: ce,
      onClick: se,
      ref: _,
      tabIndex: b ? -1 : 0
    }), ie, Ae));
  let te = /* @__PURE__ */ React__default.createElement("button", Object.assign({}, G, {
    type: y,
    className: le,
    style: ce,
    onClick: se,
    disabled: b,
    ref: _
  }), ie, Ae, !!re && /* @__PURE__ */ React__default.createElement(CompactCmp, {
    key: "compact",
    prefixCls: B
  }));
  return isUnBorderedButtonType(I) || (te = /* @__PURE__ */ React__default.createElement(Wave$1, {
    component: "Button",
    disabled: F
  }, te)), j(te);
}), Button = InternalCompoundedButton;
Button.Group = Group;
Button.__ANT_BUTTON = !0;
process.env.NODE_ENV !== "production" && (Button.displayName = "Button");
const Button$1 = Button;
var OrderContext = /* @__PURE__ */ React$6.createContext(null), EMPTY_LIST = [];
function useDom(e, t) {
  var r = React$6.useState(function() {
    if (!canUseDom())
      return null;
    var M = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && M.setAttribute("data-debug", t), M;
  }), i = _slicedToArray(r, 1), n = i[0], a = React$6.useRef(!1), s = React$6.useContext(OrderContext), l = React$6.useState(EMPTY_LIST), o = _slicedToArray(l, 2), c = o[0], f = o[1], x = s || (a.current ? void 0 : function(M) {
    f(function(d) {
      var C = [M].concat(_toConsumableArray(d));
      return C;
    });
  });
  function m() {
    n.parentElement || document.body.appendChild(n), a.current = !0;
  }
  function A() {
    var M;
    (M = n.parentElement) === null || M === void 0 || M.removeChild(n), a.current = !1;
  }
  return useLayoutEffect$2(function() {
    return e ? s ? s(m) : m() : A(), A;
  }, [e]), useLayoutEffect$2(function() {
    c.length && (c.forEach(function(M) {
      return M();
    }), f(EMPTY_LIST));
  }, [c]), [n, x];
}
function measureScrollbarSize(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), r = document.createElement("div");
  r.id = t;
  var i = r.style;
  i.position = "absolute", i.left = "0", i.top = "0", i.width = "100px", i.height = "100px", i.overflow = "scroll";
  var n, a;
  if (e) {
    var s = getComputedStyle(e);
    i.scrollbarColor = s.scrollbarColor, i.scrollbarWidth = s.scrollbarWidth;
    var l = getComputedStyle(e, "::-webkit-scrollbar"), o = parseInt(l.width, 10), c = parseInt(l.height, 10);
    try {
      var f = o ? "width: ".concat(l.width, ";") : "", x = c ? "height: ".concat(l.height, ";") : "";
      updateCSS(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(f, `
`).concat(x, `
}`), t);
    } catch {
      n = o, a = c;
    }
  }
  document.body.appendChild(r);
  var m = e && n && !isNaN(n) ? n : r.offsetWidth - r.clientWidth, A = e && a && !isNaN(a) ? a : r.offsetHeight - r.clientHeight;
  return document.body.removeChild(r), removeCSS(t), {
    width: m,
    height: A
  };
}
function getTargetScrollBarSize(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : measureScrollbarSize(e);
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var UNIQUE_ID = "rc-util-locker-".concat(Date.now()), uuid$1 = 0;
function useScrollLocker(e) {
  var t = !!e, r = React$6.useState(function() {
    return uuid$1 += 1, "".concat(UNIQUE_ID, "_").concat(uuid$1);
  }), i = _slicedToArray(r, 1), n = i[0];
  useLayoutEffect$2(function() {
    if (t) {
      var a = getTargetScrollBarSize(document.body).width, s = isBodyOverflowing();
      updateCSS(`
html body {
  overflow-y: hidden;
  `.concat(s ? "width: calc(100% - ".concat(a, "px);") : "", `
}`), n);
    } else
      removeCSS(n);
    return function() {
      removeCSS(n);
    };
  }, [t, n]);
}
var inline = !1;
function inlineMock(e) {
  return typeof e == "boolean" && (inline = e), inline;
}
var getPortalContainer = function(t) {
  return t === !1 ? !1 : !canUseDom() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, Portal = /* @__PURE__ */ React$6.forwardRef(function(e, t) {
  var r = e.open, i = e.autoLock, n = e.getContainer, a = e.debug, s = e.autoDestroy, l = s === void 0 ? !0 : s, o = e.children, c = React$6.useState(r), f = _slicedToArray(c, 2), x = f[0], m = f[1], A = x || r;
  process.env.NODE_ENV !== "production" && warningOnce(canUseDom() || !r, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), React$6.useEffect(function() {
    (l || r) && m(r);
  }, [r, l]);
  var M = React$6.useState(function() {
    return getPortalContainer(n);
  }), d = _slicedToArray(M, 2), C = d[0], u = d[1];
  React$6.useEffect(function() {
    var D = getPortalContainer(n);
    u(D ?? null);
  });
  var g = useDom(A && !C, a), p = _slicedToArray(g, 2), y = p[0], E = p[1], T = C ?? y;
  useScrollLocker(i && r && canUseDom() && (T === y || T === document.body));
  var Z = null;
  if (o && supportRef(o) && t) {
    var G = o;
    Z = G.ref;
  }
  var I = useComposeRef(Z, t);
  if (!A || !canUseDom() || C === void 0)
    return null;
  var V = T === !1 || inlineMock(), Y = o;
  return t && (Y = /* @__PURE__ */ React$6.cloneElement(o, {
    ref: I
  })), /* @__PURE__ */ React$6.createElement(OrderContext.Provider, {
    value: E
  }, V ? Y : /* @__PURE__ */ reactDomExports.createPortal(Y, T));
});
process.env.NODE_ENV !== "production" && (Portal.displayName = "Portal");
function getUseId() {
  var e = _objectSpread2({}, React$6);
  return e.useId;
}
var uuid = 0, useOriginId = getUseId();
const useId = useOriginId ? (
  // Use React `useId`
  function(t) {
    var r = useOriginId();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : r);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var r = React$6.useState("ssr-id"), i = _slicedToArray(r, 2), n = i[0], a = i[1];
    return React$6.useEffect(function() {
      var s = uuid;
      uuid += 1, a("rc_unique_".concat(s));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : n);
  }
), initMotionCommon = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), initMotionCommonLeave = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), initMotion = function(e, t, r, i) {
  const a = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${a}${e}-enter,
      ${a}${e}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon(i)), {
      animationPlayState: "paused"
    }),
    [`${a}${e}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(i)), {
      animationPlayState: "paused"
    }),
    [`
      ${a}${e}-enter${e}-enter-active,
      ${a}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${a}${e}-leave${e}-leave-active`]: {
      animationName: r,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, zoomIn = new Keyframe("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), zoomOut = new Keyframe("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), zoomBigIn = new Keyframe("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), zoomBigOut = new Keyframe("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), zoomUpIn = new Keyframe("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), zoomUpOut = new Keyframe("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), zoomLeftIn = new Keyframe("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), zoomLeftOut = new Keyframe("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), zoomRightIn = new Keyframe("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), zoomRightOut = new Keyframe("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), zoomDownIn = new Keyframe("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), zoomDownOut = new Keyframe("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), zoomMotion = {
  zoom: {
    inKeyframes: zoomIn,
    outKeyframes: zoomOut
  },
  "zoom-big": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-big-fast": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-left": {
    inKeyframes: zoomLeftIn,
    outKeyframes: zoomLeftOut
  },
  "zoom-right": {
    inKeyframes: zoomRightIn,
    outKeyframes: zoomRightOut
  },
  "zoom-up": {
    inKeyframes: zoomUpIn,
    outKeyframes: zoomUpOut
  },
  "zoom-down": {
    inKeyframes: zoomDownIn,
    outKeyframes: zoomDownOut
  }
}, initZoomMotion = (e, t) => {
  const {
    antCls: r
  } = e, i = `${r}-${t}`, {
    inKeyframes: n,
    outKeyframes: a
  } = zoomMotion[t];
  return [initMotion(i, n, a, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${i}-enter,
        ${i}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${i}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, isMobile = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
function Arrow(e) {
  var t = e.prefixCls, r = e.align, i = e.arrow, n = e.arrowPos, a = i || {}, s = a.className, l = a.content, o = n.x, c = o === void 0 ? 0 : o, f = n.y, x = f === void 0 ? 0 : f, m = React$6.useRef();
  if (!r || !r.points)
    return null;
  var A = {
    position: "absolute"
  };
  if (r.autoArrow !== !1) {
    var M = r.points[0], d = r.points[1], C = M[0], u = M[1], g = d[0], p = d[1];
    C === g || !["t", "b"].includes(C) ? A.top = x : C === "t" ? A.top = 0 : A.bottom = 0, u === p || !["l", "r"].includes(u) ? A.left = c : u === "l" ? A.left = 0 : A.right = 0;
  }
  return /* @__PURE__ */ React$6.createElement("div", {
    ref: m,
    className: classNames("".concat(t, "-arrow"), s),
    style: A
  }, l);
}
function Mask(e) {
  var t = e.prefixCls, r = e.open, i = e.zIndex, n = e.mask, a = e.motion;
  return n ? /* @__PURE__ */ React$6.createElement(CSSMotion, _extends({}, a, {
    motionAppear: !0,
    visible: r,
    removeOnLeave: !0
  }), function(s) {
    var l = s.className;
    return /* @__PURE__ */ React$6.createElement("div", {
      style: {
        zIndex: i
      },
      className: classNames("".concat(t, "-mask"), l)
    });
  }) : null;
}
var PopupContent = /* @__PURE__ */ React$6.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (PopupContent.displayName = "PopupContent");
var Popup$1 = /* @__PURE__ */ React$6.forwardRef(function(e, t) {
  var r = e.popup, i = e.className, n = e.prefixCls, a = e.style, s = e.target, l = e.onVisibleChanged, o = e.open, c = e.keepDom, f = e.fresh, x = e.onClick, m = e.mask, A = e.arrow, M = e.arrowPos, d = e.align, C = e.motion, u = e.maskMotion, g = e.forceRender, p = e.getPopupContainer, y = e.autoDestroy, E = e.portal, T = e.zIndex, Z = e.onMouseEnter, G = e.onMouseLeave, I = e.onPointerEnter, V = e.ready, Y = e.offsetX, D = e.offsetY, R = e.offsetR, B = e.offsetB, j = e.onAlign, N = e.onPrepare, P = e.stretch, z = e.targetWidth, b = e.targetHeight, k = typeof r == "function" ? r() : r, S = o || c, F = (p == null ? void 0 : p.length) > 0, Q = React$6.useState(!p || !F), L = _slicedToArray(Q, 2), W = L[0], q = L[1];
  if (useLayoutEffect$2(function() {
    !W && F && s && q(!0);
  }, [W, F, s]), !W)
    return null;
  var _ = "auto", ee = {
    left: "-1000vw",
    top: "-1000vh",
    right: _,
    bottom: _
  };
  if (V || !o) {
    var se, ae = d.points, re = d.dynamicInset || ((se = d._experimental) === null || se === void 0 ? void 0 : se.dynamicInset), me = re && ae[0][1] === "r", $ = re && ae[0][0] === "b";
    me ? (ee.right = R, ee.left = _) : (ee.left = Y, ee.right = _), $ ? (ee.bottom = B, ee.top = _) : (ee.top = D, ee.bottom = _);
  }
  var O = {};
  return P && (P.includes("height") && b ? O.height = b : P.includes("minHeight") && b && (O.minHeight = b), P.includes("width") && z ? O.width = z : P.includes("minWidth") && z && (O.minWidth = z)), o || (O.pointerEvents = "none"), /* @__PURE__ */ React$6.createElement(E, {
    open: g || S,
    getContainer: p && function() {
      return p(s);
    },
    autoDestroy: y
  }, /* @__PURE__ */ React$6.createElement(Mask, {
    prefixCls: n,
    open: o,
    zIndex: T,
    mask: m,
    motion: u
  }), /* @__PURE__ */ React$6.createElement(RefResizeObserver, {
    onResize: j,
    disabled: !o
  }, function(ge) {
    return /* @__PURE__ */ React$6.createElement(CSSMotion, _extends({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: g,
      leavedClassName: "".concat(n, "-hidden")
    }, C, {
      onAppearPrepare: N,
      onEnterPrepare: N,
      visible: o,
      onVisibleChanged: function(le) {
        var ce;
        C == null || (ce = C.onVisibleChanged) === null || ce === void 0 || ce.call(C, le), l(le);
      }
    }), function(he, le) {
      var ce = he.className, K = he.style, ue = classNames(n, ce, i);
      return /* @__PURE__ */ React$6.createElement("div", {
        ref: composeRef(ge, t, le),
        className: ue,
        style: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
          "--arrow-x": "".concat(M.x || 0, "px"),
          "--arrow-y": "".concat(M.y || 0, "px")
        }, ee), O), K), {}, {
          boxSizing: "border-box",
          zIndex: T
        }, a),
        onMouseEnter: Z,
        onMouseLeave: G,
        onPointerEnter: I,
        onClick: x
      }, A && /* @__PURE__ */ React$6.createElement(Arrow, {
        prefixCls: n,
        arrow: A,
        arrowPos: M,
        align: d
      }), /* @__PURE__ */ React$6.createElement(PopupContent, {
        cache: !o && !f
      }, k));
    });
  }));
});
process.env.NODE_ENV !== "production" && (Popup$1.displayName = "Popup");
var TriggerWrapper = /* @__PURE__ */ React$6.forwardRef(function(e, t) {
  var r = e.children, i = e.getTriggerDOMNode, n = supportRef(r), a = React$6.useCallback(function(l) {
    fillRef(t, i ? i(l) : l);
  }, [i]), s = useComposeRef(a, r.ref);
  return n ? /* @__PURE__ */ React$6.cloneElement(r, {
    ref: s
  }) : r;
});
process.env.NODE_ENV !== "production" && (TriggerWrapper.displayName = "TriggerWrapper");
var TriggerContext = /* @__PURE__ */ React$6.createContext(null);
function toArray(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function useAction(e, t, r, i) {
  return React$6.useMemo(function() {
    var n = toArray(r ?? t), a = toArray(i ?? t), s = new Set(n), l = new Set(a);
    return e && (s.has("hover") && (s.delete("hover"), s.add("click")), l.has("hover") && (l.delete("hover"), l.add("click"))), [s, l];
  }, [e, t, r, i]);
}
function isPointsEq() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 ? arguments[2] : void 0;
  return r ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function getAlignPopupClassName(e, t, r, i) {
  for (var n = r.points, a = Object.keys(e), s = 0; s < a.length; s += 1) {
    var l, o = a[s];
    if (isPointsEq((l = e[o]) === null || l === void 0 ? void 0 : l.points, n, i))
      return "".concat(t, "-placement-").concat(o);
  }
  return "";
}
function getMotion(e, t, r, i) {
  return t || (r ? {
    motionName: "".concat(e, "-").concat(r)
  } : i ? {
    motionName: i
  } : null);
}
function getWin(e) {
  return e.ownerDocument.defaultView;
}
function collectScroller(e) {
  for (var t = [], r = e == null ? void 0 : e.parentElement, i = ["hidden", "scroll", "clip", "auto"]; r; ) {
    var n = getWin(r).getComputedStyle(r), a = n.overflowX, s = n.overflowY, l = n.overflow;
    [a, s, l].some(function(o) {
      return i.includes(o);
    }) && t.push(r), r = r.parentElement;
  }
  return t;
}
function toNum(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function getPxValue(e) {
  return toNum(parseFloat(e), 0);
}
function getVisibleArea(e, t) {
  var r = _objectSpread2({}, e);
  return (t || []).forEach(function(i) {
    if (!(i instanceof HTMLBodyElement || i instanceof HTMLHtmlElement)) {
      var n = getWin(i).getComputedStyle(i), a = n.overflow, s = n.overflowClipMargin, l = n.borderTopWidth, o = n.borderBottomWidth, c = n.borderLeftWidth, f = n.borderRightWidth, x = i.getBoundingClientRect(), m = i.offsetHeight, A = i.clientHeight, M = i.offsetWidth, d = i.clientWidth, C = getPxValue(l), u = getPxValue(o), g = getPxValue(c), p = getPxValue(f), y = toNum(Math.round(x.width / M * 1e3) / 1e3), E = toNum(Math.round(x.height / m * 1e3) / 1e3), T = (M - d - g - p) * y, Z = (m - A - C - u) * E, G = C * E, I = u * E, V = g * y, Y = p * y, D = 0, R = 0;
      if (a === "clip") {
        var B = getPxValue(s);
        D = B * y, R = B * E;
      }
      var j = x.x + V - D, N = x.y + G - R, P = j + x.width + 2 * D - V - Y - T, z = N + x.height + 2 * R - G - I - Z;
      r.left = Math.max(r.left, j), r.top = Math.max(r.top, N), r.right = Math.min(r.right, P), r.bottom = Math.min(r.bottom, z);
    }
  }), r;
}
function getUnitOffset(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = "".concat(t), i = r.match(/^(.*)\%$/);
  return i ? e * (parseFloat(i[1]) / 100) : parseFloat(r);
}
function getNumberOffset(e, t) {
  var r = t || [], i = _slicedToArray(r, 2), n = i[0], a = i[1];
  return [getUnitOffset(e.width, n), getUnitOffset(e.height, a)];
}
function splitPoints() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function getAlignPoint(e, t) {
  var r = t[0], i = t[1], n, a;
  return r === "t" ? a = e.y : r === "b" ? a = e.y + e.height : a = e.y + e.height / 2, i === "l" ? n = e.x : i === "r" ? n = e.x + e.width : n = e.x + e.width / 2, {
    x: n,
    y: a
  };
}
function reversePoints(e, t) {
  var r = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(i, n) {
    return n === t ? r[i] || "c" : i;
  }).join("");
}
function useAlign(e, t, r, i, n, a, s) {
  var l = React$6.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: n[i] || {}
  }), o = _slicedToArray(l, 2), c = o[0], f = o[1], x = React$6.useRef(0), m = React$6.useMemo(function() {
    return t ? collectScroller(t) : [];
  }, [t]), A = React$6.useRef({}), M = function() {
    A.current = {};
  };
  e || M();
  var d = useEvent(function() {
    if (t && r && e) {
      let Te = function(Nt, Ne) {
        var rt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ue, Zt = k.x + Nt, it = k.y + Ne, Gt = Zt + se, mt = it + ee, Pt = Math.max(Zt, rt.left), qt = Math.max(it, rt.top), Ut = Math.min(Gt, rt.right), Ht = Math.min(mt, rt.bottom);
        return Math.max(0, (Ut - Pt) * (Ht - qt));
      }, Tt = function() {
        Je = k.y + de, We = Je + ee, De = k.x + ve, qe = De + se;
      };
      var g, p, y = t, E = y.ownerDocument, T = getWin(y), Z = T.getComputedStyle(y), G = Z.width, I = Z.height, V = Z.position, Y = y.style.left, D = y.style.top, R = y.style.right, B = y.style.bottom, j = y.style.overflow, N = _objectSpread2(_objectSpread2({}, n[i]), a), P = E.createElement("div");
      (g = y.parentElement) === null || g === void 0 || g.appendChild(P), P.style.left = "".concat(y.offsetLeft, "px"), P.style.top = "".concat(y.offsetTop, "px"), P.style.position = V, P.style.height = "".concat(y.offsetHeight, "px"), P.style.width = "".concat(y.offsetWidth, "px"), y.style.left = "0", y.style.top = "0", y.style.right = "auto", y.style.bottom = "auto", y.style.overflow = "hidden";
      var z;
      if (Array.isArray(r))
        z = {
          x: r[0],
          y: r[1],
          width: 0,
          height: 0
        };
      else {
        var b = r.getBoundingClientRect();
        z = {
          x: b.x,
          y: b.y,
          width: b.width,
          height: b.height
        };
      }
      var k = y.getBoundingClientRect(), S = E.documentElement, F = S.clientWidth, Q = S.clientHeight, L = S.scrollWidth, W = S.scrollHeight, q = S.scrollTop, _ = S.scrollLeft, ee = k.height, se = k.width, ae = z.height, re = z.width, me = {
        left: 0,
        top: 0,
        right: F,
        bottom: Q
      }, $ = {
        left: -_,
        top: -q,
        right: L - _,
        bottom: W - q
      }, O = N.htmlRegion, ge = "visible", he = "visibleFirst";
      O !== "scroll" && O !== he && (O = ge);
      var le = O === he, ce = getVisibleArea($, m), K = getVisibleArea(me, m), ue = O === ge ? K : ce, ie = le ? K : ue;
      y.style.left = "auto", y.style.top = "auto", y.style.right = "0", y.style.bottom = "0";
      var Ae = y.getBoundingClientRect();
      y.style.left = Y, y.style.top = D, y.style.right = R, y.style.bottom = B, y.style.overflow = j, (p = y.parentElement) === null || p === void 0 || p.removeChild(P);
      var te = toNum(Math.round(se / parseFloat(G) * 1e3) / 1e3), U = toNum(Math.round(ee / parseFloat(I) * 1e3) / 1e3);
      if (te === 0 || U === 0 || isDOM(r) && !isVisible(r))
        return;
      var ne = N.offset, oe = N.targetOffset, Ze = getNumberOffset(k, ne), Se = _slicedToArray(Ze, 2), xe = Se[0], ze = Se[1], ft = getNumberOffset(z, oe), Ge = _slicedToArray(ft, 2), kt = Ge[0], pt = Ge[1];
      z.x -= kt, z.y -= pt;
      var It = N.points || [], Oe = _slicedToArray(It, 2), be = Oe[0], Ye = Oe[1], ke = splitPoints(Ye), Ee = splitPoints(be), ut = getAlignPoint(z, ke), dt = getAlignPoint(k, Ee), Ie = _objectSpread2({}, N), ve = ut.x - dt.x + xe, de = ut.y - dt.y + ze, ye = Te(ve, de), _e = Te(ve, de, K), Re = getAlignPoint(z, ["t", "l"]), Qe = getAlignPoint(k, ["t", "l"]), nt = getAlignPoint(z, ["b", "r"]), at = getAlignPoint(k, ["b", "r"]), Le = N.overflow || {}, Pe = Le.adjustX, Dt = Le.adjustY, st = Le.shiftX, $e = Le.shiftY, ot = function(Ne) {
        return typeof Ne == "boolean" ? Ne : Ne >= 0;
      }, Je, We, De, qe;
      Tt();
      var yt = ot(Dt), lt = Ee[0] === ke[0];
      if (yt && Ee[0] === "t" && (We > ie.bottom || A.current.bt)) {
        var Ve = de;
        lt ? Ve -= ee - ae : Ve = Re.y - at.y - ze;
        var gt = Te(ve, Ve), et = Te(ve, Ve, K);
        // Of course use larger one
        gt > ye || gt === ye && (!le || // Choose recommend one
        et >= _e) ? (A.current.bt = !0, de = Ve, ze = -ze, Ie.points = [reversePoints(Ee, 0), reversePoints(ke, 0)]) : A.current.bt = !1;
      }
      if (yt && Ee[0] === "b" && (Je < ie.top || A.current.tb)) {
        var Ue = de;
        lt ? Ue += ee - ae : Ue = nt.y - Qe.y - ze;
        var Ce = Te(ve, Ue), jt = Te(ve, Ue, K);
        // Of course use larger one
        Ce > ye || Ce === ye && (!le || // Choose recommend one
        jt >= _e) ? (A.current.tb = !0, de = Ue, ze = -ze, Ie.points = [reversePoints(Ee, 0), reversePoints(ke, 0)]) : A.current.tb = !1;
      }
      var vt = ot(Pe), Mt = Ee[1] === ke[1];
      if (vt && Ee[1] === "l" && (qe > ie.right || A.current.rl)) {
        var He = ve;
        Mt ? He -= se - re : He = Re.x - at.x - xe;
        var At = Te(He, de), Bt = Te(He, de, K);
        // Of course use larger one
        At > ye || At === ye && (!le || // Choose recommend one
        Bt >= _e) ? (A.current.rl = !0, ve = He, xe = -xe, Ie.points = [reversePoints(Ee, 1), reversePoints(ke, 1)]) : A.current.rl = !1;
      }
      if (vt && Ee[1] === "r" && (De < ie.left || A.current.lr)) {
        var Ke = ve;
        Mt ? Ke += se - re : Ke = nt.x - Qe.x - xe;
        var xt = Te(Ke, de), Yt = Te(Ke, de, K);
        // Of course use larger one
        xt > ye || xt === ye && (!le || // Choose recommend one
        Yt >= _e) ? (A.current.lr = !0, ve = Ke, xe = -xe, Ie.points = [reversePoints(Ee, 1), reversePoints(ke, 1)]) : A.current.lr = !1;
      }
      Tt();
      var we = st === !0 ? 0 : st;
      typeof we == "number" && (De < K.left && (ve -= De - K.left - xe, z.x + re < K.left + we && (ve += z.x - K.left + re - we)), qe > K.right && (ve -= qe - K.right - xe, z.x > K.right - we && (ve += z.x - K.right + we)));
      var je = $e === !0 ? 0 : $e;
      typeof je == "number" && (Je < K.top && (de -= Je - K.top - ze, z.y + ae < K.top + je && (de += z.y - K.top + ae - je)), We > K.bottom && (de -= We - K.bottom - ze, z.y > K.bottom - je && (de += z.y - K.bottom + je)));
      var ht = k.x + ve, zt = ht + se, Fe = k.y + de, Xe = Fe + ee, ct = z.x, tt = ct + re, Be = z.y, Rt = Be + ae, Vt = Math.max(ht, ct), Ft = Math.min(zt, tt), Ct = (Vt + Ft) / 2, Ot = Ct - ht, Qt = Math.max(Fe, Be), Lt = Math.min(Xe, Rt), Et = (Qt + Lt) / 2, Jt = Et - Fe;
      s == null || s(t, Ie);
      var Wt = Ae.right - k.x - (ve + k.width), bt = Ae.bottom - k.y - (de + k.height);
      f({
        ready: !0,
        offsetX: ve / te,
        offsetY: de / U,
        offsetR: Wt / te,
        offsetB: bt / U,
        arrowX: Ot / te,
        arrowY: Jt / U,
        scaleX: te,
        scaleY: U,
        align: Ie
      });
    }
  }), C = function() {
    x.current += 1;
    var p = x.current;
    Promise.resolve().then(function() {
      x.current === p && d();
    });
  }, u = function() {
    f(function(p) {
      return _objectSpread2(_objectSpread2({}, p), {}, {
        ready: !1
      });
    });
  };
  return useLayoutEffect$2(u, [i]), useLayoutEffect$2(function() {
    e || u();
  }, [e]), [c.ready, c.offsetX, c.offsetY, c.offsetR, c.offsetB, c.arrowX, c.arrowY, c.scaleX, c.scaleY, c.align, C];
}
function useWatch(e, t, r, i, n) {
  useLayoutEffect$2(function() {
    if (e && t && r) {
      let x = function() {
        i(), n();
      };
      var a = t, s = r, l = collectScroller(a), o = collectScroller(s), c = getWin(s), f = new Set([c].concat(_toConsumableArray(l), _toConsumableArray(o)));
      return f.forEach(function(m) {
        m.addEventListener("scroll", x, {
          passive: !0
        });
      }), c.addEventListener("resize", x, {
        passive: !0
      }), i(), function() {
        f.forEach(function(m) {
          m.removeEventListener("scroll", x), c.removeEventListener("resize", x);
        });
      };
    }
  }, [e, t, r]);
}
function useWinClick(e, t, r, i, n, a, s, l) {
  var o = React$6.useRef(e);
  o.current = e, React$6.useEffect(function() {
    if (t && i && (!n || a)) {
      var c = function(u) {
        var g = u.target;
        o.current && !s(g) && l(!1);
      }, f = getWin(i);
      f.addEventListener("mousedown", c, !0), f.addEventListener("contextmenu", c, !0);
      var x = getShadowRoot(r);
      if (x && (x.addEventListener("mousedown", c, !0), x.addEventListener("contextmenu", c, !0)), process.env.NODE_ENV !== "production") {
        var m, A, M = r == null || (m = r.getRootNode) === null || m === void 0 ? void 0 : m.call(r), d = (A = i.getRootNode) === null || A === void 0 ? void 0 : A.call(i);
        warning(M === d, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        f.removeEventListener("mousedown", c, !0), f.removeEventListener("contextmenu", c, !0), x && (x.removeEventListener("mousedown", c, !0), x.removeEventListener("contextmenu", c, !0));
      };
    }
  }, [t, r, i, n, a]);
}
var _excluded$1 = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function generateTrigger() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Portal, t = /* @__PURE__ */ React$6.forwardRef(function(r, i) {
    var n = r.prefixCls, a = n === void 0 ? "rc-trigger-popup" : n, s = r.children, l = r.action, o = l === void 0 ? "hover" : l, c = r.showAction, f = r.hideAction, x = r.popupVisible, m = r.defaultPopupVisible, A = r.onPopupVisibleChange, M = r.afterPopupVisibleChange, d = r.mouseEnterDelay, C = r.mouseLeaveDelay, u = C === void 0 ? 0.1 : C, g = r.focusDelay, p = r.blurDelay, y = r.mask, E = r.maskClosable, T = E === void 0 ? !0 : E, Z = r.getPopupContainer, G = r.forceRender, I = r.autoDestroy, V = r.destroyPopupOnHide, Y = r.popup, D = r.popupClassName, R = r.popupStyle, B = r.popupPlacement, j = r.builtinPlacements, N = j === void 0 ? {} : j, P = r.popupAlign, z = r.zIndex, b = r.stretch, k = r.getPopupClassNameFromAlign, S = r.fresh, F = r.alignPoint, Q = r.onPopupClick, L = r.onPopupAlign, W = r.arrow, q = r.popupMotion, _ = r.maskMotion, ee = r.popupTransitionName, se = r.popupAnimation, ae = r.maskTransitionName, re = r.maskAnimation, me = r.className, $ = r.getTriggerDOMNode, O = _objectWithoutProperties(r, _excluded$1), ge = I || V || !1, he = React$6.useState(!1), le = _slicedToArray(he, 2), ce = le[0], K = le[1];
    useLayoutEffect$2(function() {
      K(isMobile());
    }, []);
    var ue = React$6.useRef({}), ie = React$6.useContext(TriggerContext), Ae = React$6.useMemo(function() {
      return {
        registerSubPopup: function(H, fe) {
          ue.current[H] = fe, ie == null || ie.registerSubPopup(H, fe);
        }
      };
    }, [ie]), te = useId(), U = React$6.useState(null), ne = _slicedToArray(U, 2), oe = ne[0], Ze = ne[1], Se = React$6.useRef(null), xe = useEvent(function(J) {
      Se.current = J, isDOM(J) && oe !== J && Ze(J), ie == null || ie.registerSubPopup(te, J);
    }), ze = React$6.useState(null), ft = _slicedToArray(ze, 2), Ge = ft[0], kt = ft[1], pt = React$6.useRef(null), It = useEvent(function(J) {
      isDOM(J) && Ge !== J && (kt(J), pt.current = J);
    }), Oe = React$6.Children.only(s), be = (Oe == null ? void 0 : Oe.props) || {}, Ye = {}, ke = useEvent(function(J) {
      var H, fe, Me = Ge;
      return (Me == null ? void 0 : Me.contains(J)) || ((H = getShadowRoot(Me)) === null || H === void 0 ? void 0 : H.host) === J || J === Me || (oe == null ? void 0 : oe.contains(J)) || ((fe = getShadowRoot(oe)) === null || fe === void 0 ? void 0 : fe.host) === J || J === oe || Object.values(ue.current).some(function(pe) {
        return (pe == null ? void 0 : pe.contains(J)) || J === pe;
      });
    }), Ee = getMotion(a, q, se, ee), ut = getMotion(a, _, re, ae), dt = React$6.useState(m || !1), Ie = _slicedToArray(dt, 2), ve = Ie[0], de = Ie[1], ye = x ?? ve, _e = useEvent(function(J) {
      x === void 0 && de(J);
    });
    useLayoutEffect$2(function() {
      de(x || !1);
    }, [x]);
    var Re = React$6.useRef(ye);
    Re.current = ye;
    var Qe = React$6.useRef([]);
    Qe.current = [];
    var nt = useEvent(function(J) {
      var H;
      _e(J), ((H = Qe.current[Qe.current.length - 1]) !== null && H !== void 0 ? H : ye) !== J && (Qe.current.push(J), A == null || A(J));
    }), at = React$6.useRef(), Le = function() {
      clearTimeout(at.current);
    }, Pe = function(H) {
      var fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Le(), fe === 0 ? nt(H) : at.current = setTimeout(function() {
        nt(H);
      }, fe * 1e3);
    };
    React$6.useEffect(function() {
      return Le;
    }, []);
    var Dt = React$6.useState(!1), st = _slicedToArray(Dt, 2), $e = st[0], ot = st[1];
    useLayoutEffect$2(function(J) {
      (!J || ye) && ot(!0);
    }, [ye]);
    var Je = React$6.useState(null), We = _slicedToArray(Je, 2), De = We[0], qe = We[1], yt = React$6.useState([0, 0]), lt = _slicedToArray(yt, 2), Ve = lt[0], gt = lt[1], et = function(H) {
      gt([H.clientX, H.clientY]);
    }, Ue = useAlign(ye, oe, F ? Ve : Ge, B, N, P, L), Ce = _slicedToArray(Ue, 11), jt = Ce[0], vt = Ce[1], Mt = Ce[2], He = Ce[3], At = Ce[4], Bt = Ce[5], Ke = Ce[6], xt = Ce[7], Yt = Ce[8], we = Ce[9], je = Ce[10], ht = useAction(ce, o, c, f), zt = _slicedToArray(ht, 2), Fe = zt[0], Xe = zt[1], ct = Fe.has("click"), tt = Xe.has("click") || Xe.has("contextMenu"), Be = useEvent(function() {
      $e || je();
    }), Rt = function() {
      Re.current && F && tt && Pe(!1);
    };
    useWatch(ye, Ge, oe, Be, Rt), useLayoutEffect$2(function() {
      Be();
    }, [Ve, B]), useLayoutEffect$2(function() {
      ye && !(N != null && N[B]) && Be();
    }, [JSON.stringify(P)]);
    var Vt = React$6.useMemo(function() {
      var J = getAlignPopupClassName(N, a, we, F);
      return classNames(J, k == null ? void 0 : k(we));
    }, [we, k, N, a, F]);
    React$6.useImperativeHandle(i, function() {
      return {
        nativeElement: pt.current,
        popupElement: Se.current,
        forceAlign: Be
      };
    });
    var Ft = React$6.useState(0), Ct = _slicedToArray(Ft, 2), Ot = Ct[0], Qt = Ct[1], Lt = React$6.useState(0), Et = _slicedToArray(Lt, 2), Jt = Et[0], Wt = Et[1], bt = function() {
      if (b && Ge) {
        var H = Ge.getBoundingClientRect();
        Qt(H.width), Wt(H.height);
      }
    }, Te = function() {
      bt(), Be();
    }, Tt = function(H) {
      ot(!1), je(), M == null || M(H);
    }, Nt = function() {
      return new Promise(function(H) {
        bt(), qe(function() {
          return H;
        });
      });
    };
    useLayoutEffect$2(function() {
      De && (je(), De(), qe(null));
    }, [De]);
    function Ne(J, H, fe, Me) {
      Ye[J] = function(pe) {
        var St;
        Me == null || Me(pe), Pe(H, fe);
        for (var Kt = arguments.length, Xt = new Array(Kt > 1 ? Kt - 1 : 0), wt = 1; wt < Kt; wt++)
          Xt[wt - 1] = arguments[wt];
        (St = be[J]) === null || St === void 0 || St.call.apply(St, [be, pe].concat(Xt));
      };
    }
    (ct || tt) && (Ye.onClick = function(J) {
      var H;
      Re.current && tt ? Pe(!1) : !Re.current && ct && (et(J), Pe(!0));
      for (var fe = arguments.length, Me = new Array(fe > 1 ? fe - 1 : 0), pe = 1; pe < fe; pe++)
        Me[pe - 1] = arguments[pe];
      (H = be.onClick) === null || H === void 0 || H.call.apply(H, [be, J].concat(Me));
    }), useWinClick(ye, tt, Ge, oe, y, T, ke, Pe);
    var rt = Fe.has("hover"), Zt = Xe.has("hover"), it, Gt;
    rt && (Ne("onMouseEnter", !0, d, function(J) {
      et(J);
    }), Ne("onPointerEnter", !0, d, function(J) {
      et(J);
    }), it = function(H) {
      (ye || $e) && oe !== null && oe !== void 0 && oe.contains(H.target) && Pe(!0, d);
    }, F && (Ye.onMouseMove = function(J) {
      var H;
      (H = be.onMouseMove) === null || H === void 0 || H.call(be, J);
    })), Zt && (Ne("onMouseLeave", !1, u), Ne("onPointerLeave", !1, u), Gt = function() {
      Pe(!1, u);
    }), Fe.has("focus") && Ne("onFocus", !0, g), Xe.has("focus") && Ne("onBlur", !1, p), Fe.has("contextMenu") && (Ye.onContextMenu = function(J) {
      var H;
      Re.current && Xe.has("contextMenu") ? Pe(!1) : (et(J), Pe(!0)), J.preventDefault();
      for (var fe = arguments.length, Me = new Array(fe > 1 ? fe - 1 : 0), pe = 1; pe < fe; pe++)
        Me[pe - 1] = arguments[pe];
      (H = be.onContextMenu) === null || H === void 0 || H.call.apply(H, [be, J].concat(Me));
    }), me && (Ye.className = classNames(be.className, me));
    var mt = _objectSpread2(_objectSpread2({}, be), Ye), Pt = {}, qt = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    qt.forEach(function(J) {
      O[J] && (Pt[J] = function() {
        for (var H, fe = arguments.length, Me = new Array(fe), pe = 0; pe < fe; pe++)
          Me[pe] = arguments[pe];
        (H = mt[J]) === null || H === void 0 || H.call.apply(H, [mt].concat(Me)), O[J].apply(O, Me);
      });
    });
    var Ut = /* @__PURE__ */ React$6.cloneElement(Oe, _objectSpread2(_objectSpread2({}, mt), Pt)), Ht = {
      x: Bt,
      y: Ke
    }, _t = W ? _objectSpread2({}, W !== !0 ? W : {}) : null;
    return /* @__PURE__ */ React$6.createElement(React$6.Fragment, null, /* @__PURE__ */ React$6.createElement(RefResizeObserver, {
      disabled: !ye,
      ref: It,
      onResize: Te
    }, /* @__PURE__ */ React$6.createElement(TriggerWrapper, {
      getTriggerDOMNode: $
    }, Ut)), /* @__PURE__ */ React$6.createElement(TriggerContext.Provider, {
      value: Ae
    }, /* @__PURE__ */ React$6.createElement(Popup$1, {
      portal: e,
      ref: xe,
      prefixCls: a,
      popup: Y,
      className: classNames(D, Vt),
      style: R,
      target: Ge,
      onMouseEnter: it,
      onMouseLeave: Gt,
      onPointerEnter: it,
      zIndex: z,
      open: ye,
      keepDom: $e,
      fresh: S,
      onClick: Q,
      mask: y,
      motion: Ee,
      maskMotion: ut,
      onVisibleChanged: Tt,
      onPrepare: Nt,
      forceRender: G,
      autoDestroy: ge,
      getPopupContainer: Z,
      align: we,
      arrow: _t,
      arrowPos: Ht,
      ready: jt,
      offsetX: vt,
      offsetY: Mt,
      offsetR: He,
      offsetB: At,
      onAlign: Be,
      stretch: b,
      targetWidth: Ot / xt,
      targetHeight: Jt / Yt
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const Trigger = generateTrigger(Portal), getRenderPropValue = (e) => e ? typeof e == "function" ? e() : e : null;
function Popup(e) {
  var t = e.children, r = e.prefixCls, i = e.id, n = e.overlayInnerStyle, a = e.className, s = e.style;
  return /* @__PURE__ */ React$6.createElement("div", {
    className: classNames("".concat(r, "-content"), a),
    style: s
  }, /* @__PURE__ */ React$6.createElement("div", {
    className: "".concat(r, "-inner"),
    id: i,
    role: "tooltip",
    style: n
  }, typeof t == "function" ? t() : t));
}
var autoAdjustOverflowTopBottom = {
  shiftX: 64,
  adjustY: 1
}, autoAdjustOverflowLeftRight = {
  adjustX: 1,
  shiftY: !0
}, targetOffset = [0, 0], placements = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  }
}, _excluded = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], Tooltip$2 = function(t, r) {
  var i = t.overlayClassName, n = t.trigger, a = n === void 0 ? ["hover"] : n, s = t.mouseEnterDelay, l = s === void 0 ? 0 : s, o = t.mouseLeaveDelay, c = o === void 0 ? 0.1 : o, f = t.overlayStyle, x = t.prefixCls, m = x === void 0 ? "rc-tooltip" : x, A = t.children, M = t.onVisibleChange, d = t.afterVisibleChange, C = t.transitionName, u = t.animation, g = t.motion, p = t.placement, y = p === void 0 ? "right" : p, E = t.align, T = E === void 0 ? {} : E, Z = t.destroyTooltipOnHide, G = Z === void 0 ? !1 : Z, I = t.defaultVisible, V = t.getTooltipContainer, Y = t.overlayInnerStyle;
  t.arrowContent;
  var D = t.overlay, R = t.id, B = t.showArrow, j = B === void 0 ? !0 : B, N = _objectWithoutProperties(t, _excluded), P = useRef(null);
  useImperativeHandle(r, function() {
    return P.current;
  });
  var z = _objectSpread2({}, N);
  "visible" in t && (z.popupVisible = t.visible);
  var b = function() {
    return /* @__PURE__ */ React$6.createElement(Popup, {
      key: "content",
      prefixCls: m,
      id: R,
      overlayInnerStyle: Y
    }, D);
  };
  return /* @__PURE__ */ React$6.createElement(Trigger, _extends({
    popupClassName: i,
    prefixCls: m,
    popup: b,
    action: a,
    builtinPlacements: placements,
    popupPlacement: y,
    ref: P,
    popupAlign: T,
    getPopupContainer: V,
    onPopupVisibleChange: M,
    afterPopupVisibleChange: d,
    popupTransitionName: C,
    popupAnimation: u,
    popupMotion: g,
    defaultPopupVisible: I,
    autoDestroy: G,
    mouseLeaveDelay: c,
    popupStyle: f,
    mouseEnterDelay: l,
    arrow: j
  }, z), A);
};
const Tooltip$3 = /* @__PURE__ */ forwardRef(Tooltip$2);
function getArrowToken(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: r,
    borderRadiusOuter: i
  } = e, n = t / 2, a = 0, s = n, l = i * 1 / Math.sqrt(2), o = n - i * (1 - 1 / Math.sqrt(2)), c = n - r * (1 / Math.sqrt(2)), f = i * (Math.sqrt(2) - 1) + r * (1 / Math.sqrt(2)), x = 2 * n - c, m = f, A = 2 * n - l, M = o, d = 2 * n - a, C = s, u = n * Math.sqrt(2) + i * (Math.sqrt(2) - 2), g = i * (Math.sqrt(2) - 1), p = `polygon(${g}px 100%, 50% ${g}px, ${2 * n - g}px 100%, ${g}px 100%)`, y = `path('M ${a} ${s} A ${i} ${i} 0 0 0 ${l} ${o} L ${c} ${f} A ${r} ${r} 0 0 1 ${x} ${m} L ${A} ${M} A ${i} ${i} 0 0 0 ${d} ${C} Z')`;
  return {
    arrowShadowWidth: u,
    arrowPath: y,
    arrowPolygon: p
  };
}
const genRoundedArrow = (e, t, r) => {
  const {
    sizePopupArrow: i,
    arrowPolygon: n,
    arrowPath: a,
    arrowShadowWidth: s,
    borderRadiusXS: l,
    calc: o
  } = e;
  return {
    pointerEvents: "none",
    width: i,
    height: i,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: i,
      height: o(i).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [n, a]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: s,
      height: s,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${unit(l)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: r,
      zIndex: 0,
      background: "transparent"
    }
  };
}, MAX_VERTICAL_CONTENT_RADIUS = 8;
function getArrowOffsetToken(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: r
  } = e, i = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: i,
    arrowOffsetVertical: r ? MAX_VERTICAL_CONTENT_RADIUS : i
  };
}
function isInject(e, t) {
  return e ? t : {};
}
function getArrowStyle(e, t, r) {
  const {
    componentCls: i,
    boxShadowPopoverArrow: n,
    arrowOffsetVertical: a,
    arrowOffsetHorizontal: s
  } = e, {
    arrowDistance: l = 0,
    arrowPlacement: o = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = r || {};
  return {
    [i]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${i}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, genRoundedArrow(e, t, n)), {
        "&:before": {
          background: t
        }
      })]
    }, isInject(!!o.top, {
      [[`&-placement-top > ${i}-arrow`, `&-placement-topLeft > ${i}-arrow`, `&-placement-topRight > ${i}-arrow`].join(",")]: {
        bottom: l,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${i}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft > ${i}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: s
        }
      },
      [`&-placement-topRight > ${i}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: s
        }
      }
    })), isInject(!!o.bottom, {
      [[`&-placement-bottom > ${i}-arrow`, `&-placement-bottomLeft > ${i}-arrow`, `&-placement-bottomRight > ${i}-arrow`].join(",")]: {
        top: l,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${i}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      [`&-placement-bottomLeft > ${i}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: s
        }
      },
      [`&-placement-bottomRight > ${i}-arrow`]: {
        right: {
          _skip_check_: !0,
          value: s
        }
      }
    })), isInject(!!o.left, {
      [[`&-placement-left > ${i}-arrow`, `&-placement-leftTop > ${i}-arrow`, `&-placement-leftBottom > ${i}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: l
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${i}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${i}-arrow`]: {
        top: a
      },
      [`&-placement-leftBottom > ${i}-arrow`]: {
        bottom: a
      }
    })), isInject(!!o.right, {
      [[`&-placement-right > ${i}-arrow`, `&-placement-rightTop > ${i}-arrow`, `&-placement-rightBottom > ${i}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: l
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${i}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${i}-arrow`]: {
        top: a
      },
      [`&-placement-rightBottom > ${i}-arrow`]: {
        bottom: a
      }
    }))
  };
}
function getOverflowOptions(e, t, r, i) {
  if (i === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const n = i && typeof i == "object" ? i : {}, a = {};
  switch (e) {
    case "top":
    case "bottom":
      a.shiftX = t.arrowOffsetHorizontal * 2 + r, a.shiftY = !0, a.adjustY = !0;
      break;
    case "left":
    case "right":
      a.shiftY = t.arrowOffsetVertical * 2 + r, a.shiftX = !0, a.adjustX = !0;
      break;
  }
  const s = Object.assign(Object.assign({}, a), n);
  return s.shiftX || (s.adjustX = !0), s.shiftY || (s.adjustY = !0), s;
}
const PlacementAlignMap = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, ArrowCenterPlacementAlignMap = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, DisableAutoArrowList = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function getPlacements(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: r,
    arrowPointAtCenter: i,
    offset: n,
    borderRadius: a,
    visibleFirst: s
  } = e, l = t / 2, o = {};
  return Object.keys(PlacementAlignMap).forEach((c) => {
    const f = i && ArrowCenterPlacementAlignMap[c] || PlacementAlignMap[c], x = Object.assign(Object.assign({}, f), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (o[c] = x, DisableAutoArrowList.has(c) && (x.autoArrow = !1), c) {
      case "top":
      case "topLeft":
      case "topRight":
        x.offset[1] = -l - n;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        x.offset[1] = l + n;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        x.offset[0] = -l - n;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        x.offset[0] = l + n;
        break;
    }
    const m = getArrowOffsetToken({
      contentRadius: a,
      limitVerticalRadius: !0
    });
    if (i)
      switch (c) {
        case "topLeft":
        case "bottomLeft":
          x.offset[0] = -m.arrowOffsetHorizontal - l;
          break;
        case "topRight":
        case "bottomRight":
          x.offset[0] = m.arrowOffsetHorizontal + l;
          break;
        case "leftTop":
        case "rightTop":
          x.offset[1] = -m.arrowOffsetHorizontal - l;
          break;
        case "leftBottom":
        case "rightBottom":
          x.offset[1] = m.arrowOffsetHorizontal + l;
          break;
      }
    x.overflow = getOverflowOptions(c, m, t, r), s && (x.htmlRegion = "visibleFirst");
  }), o;
}
const genTooltipStyle = (e) => {
  const {
    componentCls: t,
    // ant-tooltip
    tooltipMaxWidth: r,
    tooltipColor: i,
    tooltipBg: n,
    tooltipBorderRadius: a,
    zIndexPopup: s,
    controlHeight: l,
    boxShadowSecondary: o,
    paddingSM: c,
    paddingXS: f
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(e)), {
        position: "absolute",
        zIndex: s,
        display: "block",
        width: "max-content",
        maxWidth: r,
        visibility: "visible",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": n,
        // Wrapper for the tooltip content
        [`${t}-inner`]: {
          minWidth: "1em",
          minHeight: l,
          padding: `${unit(e.calc(c).div(2).equal())} ${unit(f)}`,
          color: i,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: n,
          borderRadius: a,
          boxShadow: o,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${t}-inner`]: {
            borderRadius: e.min(a, MAX_VERTICAL_CONTENT_RADIUS)
          }
        },
        [`${t}-content`]: {
          position: "relative"
        }
      }), genPresetColor(e, (x, m) => {
        let {
          darkColor: A
        } = m;
        return {
          [`&${t}-${x}`]: {
            [`${t}-inner`]: {
              backgroundColor: A
            },
            [`${t}-arrow`]: {
              "--antd-arrow-background-color": A
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    getArrowStyle(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, prepareComponentToken$2 = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, getArrowOffsetToken({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), getArrowToken(merge(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), useStyle$1 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return genStyleHooks("Tooltip", (i) => {
    const {
      borderRadius: n,
      colorTextLightSolid: a,
      colorBgSpotlight: s
    } = i, l = merge(i, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: a,
      tooltipBorderRadius: n,
      tooltipBg: s
    });
    return [genTooltipStyle(l), initZoomMotion(i, "zoom-big-fast")];
  }, prepareComponentToken$2, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, inverseColors = PresetColors.map((e) => `${e}-inverse`);
function isPresetColor(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(_toConsumableArray(inverseColors), _toConsumableArray(PresetColors)).includes(e) : PresetColors.includes(e);
}
function parseColor(e, t) {
  const r = isPresetColor(t), i = classNames({
    [`${e}-${t}`]: t && r
  }), n = {}, a = {};
  return t && !r && (n.background = t, a["--antd-arrow-background-color"] = t), {
    className: i,
    overlayStyle: n,
    arrowStyle: a
  };
}
const PurePanel$1 = (e) => {
  const {
    prefixCls: t,
    className: r,
    placement: i = "top",
    title: n,
    color: a,
    overlayInnerStyle: s
  } = e, {
    getPrefixCls: l
  } = React$6.useContext(ConfigContext), o = l("tooltip", t), [c, f, x] = useStyle$1(o), m = parseColor(o, a), A = m.arrowStyle, M = Object.assign(Object.assign({}, s), m.overlayStyle), d = classNames(f, x, o, `${o}-pure`, `${o}-placement-${i}`, r, m.className);
  return c(/* @__PURE__ */ React$6.createElement("div", {
    className: d,
    style: A
  }, /* @__PURE__ */ React$6.createElement("div", {
    className: `${o}-arrow`
  }), /* @__PURE__ */ React$6.createElement(Popup, Object.assign({}, e, {
    className: f,
    prefixCls: o,
    overlayInnerStyle: M
  }), n)));
}, PurePanel$2 = PurePanel$1;
var __rest$3 = globalThis && globalThis.__rest || function(e, t) {
  var r = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
};
const InternalTooltip = /* @__PURE__ */ React$6.forwardRef((e, t) => {
  var r, i;
  const {
    prefixCls: n,
    openClassName: a,
    getTooltipContainer: s,
    overlayClassName: l,
    color: o,
    overlayInnerStyle: c,
    children: f,
    afterOpenChange: x,
    afterVisibleChange: m,
    destroyTooltipOnHide: A,
    arrow: M = !0,
    title: d,
    overlay: C,
    builtinPlacements: u,
    arrowPointAtCenter: g = !1,
    autoAdjustOverflow: p = !0
  } = e, y = !!M, [, E] = useToken(), {
    getPopupContainer: T,
    getPrefixCls: Z,
    direction: G
  } = React$6.useContext(ConfigContext), I = devUseWarning("Tooltip"), V = React$6.useRef(null), Y = () => {
    var te;
    (te = V.current) === null || te === void 0 || te.forceAlign();
  };
  React$6.useImperativeHandle(t, () => {
    var te;
    return {
      forceAlign: Y,
      forcePopupAlign: () => {
        I.deprecated(!1, "forcePopupAlign", "forceAlign"), Y();
      },
      nativeElement: (te = V.current) === null || te === void 0 ? void 0 : te.nativeElement
    };
  }), process.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"]].forEach((te) => {
    let [U, ne] = te;
    I.deprecated(!(U in e), U, ne);
  }), process.env.NODE_ENV !== "production" && I(!A || typeof A == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), process.env.NODE_ENV !== "production" && I(!M || typeof M == "boolean" || !("arrowPointAtCenter" in M), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [D, R] = useMergedState(!1, {
    value: (r = e.open) !== null && r !== void 0 ? r : e.visible,
    defaultValue: (i = e.defaultOpen) !== null && i !== void 0 ? i : e.defaultVisible
  }), B = !d && !C && d !== 0, j = (te) => {
    var U, ne;
    R(B ? !1 : te), B || ((U = e.onOpenChange) === null || U === void 0 || U.call(e, te), (ne = e.onVisibleChange) === null || ne === void 0 || ne.call(e, te));
  }, N = React$6.useMemo(() => {
    var te, U;
    let ne = g;
    return typeof M == "object" && (ne = (U = (te = M.pointAtCenter) !== null && te !== void 0 ? te : M.arrowPointAtCenter) !== null && U !== void 0 ? U : g), u || getPlacements({
      arrowPointAtCenter: ne,
      autoAdjustOverflow: p,
      arrowWidth: y ? E.sizePopupArrow : 0,
      borderRadius: E.borderRadius,
      offset: E.marginXXS,
      visibleFirst: !0
    });
  }, [g, M, u, E]), P = React$6.useMemo(() => d === 0 ? d : C || d || "", [C, d]), z = /* @__PURE__ */ React$6.createElement(NoCompactStyle, null, typeof P == "function" ? P() : P), {
    getPopupContainer: b,
    placement: k = "top",
    mouseEnterDelay: S = 0.1,
    mouseLeaveDelay: F = 0.1,
    overlayStyle: Q,
    rootClassName: L
  } = e, W = __rest$3(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), q = Z("tooltip", n), _ = Z(), ee = e["data-popover-inject"];
  let se = D;
  !("open" in e) && !("visible" in e) && B && (se = !1);
  const ae = /* @__PURE__ */ React$6.isValidElement(f) && !isFragment(f) ? f : /* @__PURE__ */ React$6.createElement("span", null, f), re = ae.props, me = !re.className || typeof re.className == "string" ? classNames(re.className, a || `${q}-open`) : re.className, [$, O, ge] = useStyle$1(q, !ee), he = parseColor(q, o), le = he.arrowStyle, ce = Object.assign(Object.assign({}, c), he.overlayStyle), K = classNames(l, {
    [`${q}-rtl`]: G === "rtl"
  }, he.className, L, O, ge), [ue, ie] = useZIndex("Tooltip", W.zIndex), Ae = /* @__PURE__ */ React$6.createElement(Tooltip$3, Object.assign({}, W, {
    zIndex: ue,
    showArrow: y,
    placement: k,
    mouseEnterDelay: S,
    mouseLeaveDelay: F,
    prefixCls: q,
    overlayClassName: K,
    overlayStyle: Object.assign(Object.assign({}, le), Q),
    getTooltipContainer: b || s || T,
    ref: V,
    builtinPlacements: N,
    overlay: z,
    visible: se,
    onVisibleChange: j,
    afterVisibleChange: x ?? m,
    overlayInnerStyle: ce,
    arrowContent: /* @__PURE__ */ React$6.createElement("span", {
      className: `${q}-arrow-content`
    }),
    motion: {
      motionName: getTransitionName(_, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!A
  }), se ? cloneElement(ae, {
    className: me
  }) : ae);
  return $(/* @__PURE__ */ React$6.createElement(zIndexContext.Provider, {
    value: ie
  }, Ae));
}), Tooltip = InternalTooltip;
process.env.NODE_ENV !== "production" && (Tooltip.displayName = "Tooltip");
Tooltip._InternalPanelDoNotUseOrYouWillBeFired = PurePanel$2;
const Tooltip$1 = Tooltip, genBaseStyle = (e) => {
  const {
    componentCls: t,
    popoverColor: r,
    titleMinWidth: i,
    fontWeightStrong: n,
    innerPadding: a,
    boxShadowSecondary: s,
    colorTextHeading: l,
    borderRadiusLG: o,
    zIndexPopup: c,
    titleMarginBottom: f,
    colorBgElevated: x,
    popoverBg: m,
    titleBorderBottom: A,
    innerContentPadding: M,
    titlePadding: d
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign({}, resetComponent(e)), {
        position: "absolute",
        top: 0,
        // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
        left: {
          _skip_check_: !0,
          value: 0
        },
        zIndex: c,
        fontWeight: "normal",
        whiteSpace: "normal",
        textAlign: "start",
        cursor: "auto",
        userSelect: "text",
        transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
        "--antd-arrow-background-color": x,
        width: "max-content",
        maxWidth: "100vw",
        "&-rtl": {
          direction: "rtl"
        },
        "&-hidden": {
          display: "none"
        },
        [`${t}-content`]: {
          position: "relative"
        },
        [`${t}-inner`]: {
          backgroundColor: m,
          backgroundClip: "padding-box",
          borderRadius: o,
          boxShadow: s,
          padding: a
        },
        [`${t}-title`]: {
          minWidth: i,
          marginBottom: f,
          color: l,
          fontWeight: n,
          borderBottom: A,
          padding: d
        },
        [`${t}-inner-content`]: {
          color: r,
          padding: M
        }
      })
    },
    // Arrow Style
    getArrowStyle(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow,
        display: "inline-block",
        [`${t}-content`]: {
          display: "inline-block"
        }
      }
    }
  ];
}, genColorStyle = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: PresetColors.map((r) => {
      const i = e[`${r}6`];
      return {
        [`&${t}-${r}`]: {
          "--antd-arrow-background-color": i,
          [`${t}-inner`]: {
            backgroundColor: i
          },
          [`${t}-arrow`]: {
            background: "transparent"
          }
        }
      };
    })
  };
}, prepareComponentToken$1 = (e) => {
  const {
    lineWidth: t,
    controlHeight: r,
    fontHeight: i,
    padding: n,
    wireframe: a,
    zIndexPopupBase: s,
    borderRadiusLG: l,
    marginXS: o,
    lineType: c,
    colorSplit: f,
    paddingSM: x
  } = e, m = r - i, A = m / 2, M = m / 2 - t, d = n;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: s + 30
  }, getArrowToken(e)), getArrowOffsetToken({
    contentRadius: l,
    limitVerticalRadius: !0
  })), {
    // internal
    innerPadding: a ? 0 : 12,
    titleMarginBottom: a ? 0 : o,
    titlePadding: a ? `${A}px ${d}px ${M}px` : 0,
    titleBorderBottom: a ? `${t}px ${c} ${f}` : "none",
    innerContentPadding: a ? `${x}px ${d}px` : 0
  });
}, useStyle = genStyleHooks("Popover", (e) => {
  const {
    colorBgElevated: t,
    colorText: r
  } = e, i = merge(e, {
    popoverBg: t,
    popoverColor: r
  });
  return [genBaseStyle(i), genColorStyle(i), initZoomMotion(i, "zoom-big")];
}, prepareComponentToken$1, {
  resetStyle: !1,
  deprecatedTokens: [["width", "titleMinWidth"], ["minWidth", "titleMinWidth"]]
});
var __rest$2 = globalThis && globalThis.__rest || function(e, t) {
  var r = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
};
const getOverlay = (e, t, r) => !t && !r ? null : /* @__PURE__ */ React$6.createElement(React$6.Fragment, null, t && /* @__PURE__ */ React$6.createElement("div", {
  className: `${e}-title`
}, getRenderPropValue(t)), /* @__PURE__ */ React$6.createElement("div", {
  className: `${e}-inner-content`
}, getRenderPropValue(r))), RawPurePanel = (e) => {
  const {
    hashId: t,
    prefixCls: r,
    className: i,
    style: n,
    placement: a = "top",
    title: s,
    content: l,
    children: o
  } = e;
  return /* @__PURE__ */ React$6.createElement("div", {
    className: classNames(t, r, `${r}-pure`, `${r}-placement-${a}`, i),
    style: n
  }, /* @__PURE__ */ React$6.createElement("div", {
    className: `${r}-arrow`
  }), /* @__PURE__ */ React$6.createElement(Popup, Object.assign({}, e, {
    className: t,
    prefixCls: r
  }), o || getOverlay(r, s, l)));
}, PurePanel = (e) => {
  const {
    prefixCls: t,
    className: r
  } = e, i = __rest$2(e, ["prefixCls", "className"]), {
    getPrefixCls: n
  } = React$6.useContext(ConfigContext), a = n("popover", t), [s, l, o] = useStyle(a);
  return s(/* @__PURE__ */ React$6.createElement(RawPurePanel, Object.assign({}, i, {
    prefixCls: a,
    hashId: l,
    className: classNames(r, o)
  })));
}, PopoverPurePanel = PurePanel;
var __rest$1 = globalThis && globalThis.__rest || function(e, t) {
  var r = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
};
const Overlay = (e) => {
  let {
    title: t,
    content: r,
    prefixCls: i
  } = e;
  return /* @__PURE__ */ React$6.createElement(React$6.Fragment, null, t && /* @__PURE__ */ React$6.createElement("div", {
    className: `${i}-title`
  }, getRenderPropValue(t)), /* @__PURE__ */ React$6.createElement("div", {
    className: `${i}-inner-content`
  }, getRenderPropValue(r)));
}, InternalPopover = /* @__PURE__ */ React$6.forwardRef((e, t) => {
  var r, i;
  const {
    prefixCls: n,
    title: a,
    content: s,
    overlayClassName: l,
    placement: o = "top",
    trigger: c = "hover",
    children: f,
    mouseEnterDelay: x = 0.1,
    mouseLeaveDelay: m = 0.1,
    onOpenChange: A,
    overlayStyle: M = {}
  } = e, d = __rest$1(e, ["prefixCls", "title", "content", "overlayClassName", "placement", "trigger", "children", "mouseEnterDelay", "mouseLeaveDelay", "onOpenChange", "overlayStyle"]), {
    getPrefixCls: C
  } = React$6.useContext(ConfigContext), u = C("popover", n), [g, p, y] = useStyle(u), E = C(), T = classNames(l, p, y), [Z, G] = useMergedState(!1, {
    value: (r = e.open) !== null && r !== void 0 ? r : e.visible,
    defaultValue: (i = e.defaultOpen) !== null && i !== void 0 ? i : e.defaultVisible
  }), I = (D, R) => {
    G(D, !0), A == null || A(D, R);
  }, V = (D) => {
    D.keyCode === KeyCode.ESC && I(!1, D);
  }, Y = (D) => {
    I(D);
  };
  return g(/* @__PURE__ */ React$6.createElement(Tooltip$1, Object.assign({
    placement: o,
    trigger: c,
    mouseEnterDelay: x,
    mouseLeaveDelay: m,
    overlayStyle: M
  }, d, {
    prefixCls: u,
    overlayClassName: T,
    ref: t,
    open: Z,
    onOpenChange: Y,
    overlay: a || s ? /* @__PURE__ */ React$6.createElement(Overlay, {
      prefixCls: u,
      title: a,
      content: s
    }) : null,
    transitionName: getTransitionName(E, "zoom-big", d.transitionName),
    "data-popover-inject": !0
  }), cloneElement(f, {
    onKeyDown: (D) => {
      var R, B;
      /* @__PURE__ */ React$6.isValidElement(f) && ((B = f == null ? void 0 : (R = f.props).onKeyDown) === null || B === void 0 || B.call(R, D)), V(D);
    }
  })));
}), Popover = InternalPopover;
Popover._InternalPanelDoNotUseOrYouWillBeFired = PopoverPurePanel;
process.env.NODE_ENV !== "production" && (Popover.displayName = "Popover");
const Popover$1 = Popover;
var cjs = {};
Object.defineProperty(cjs, "__esModule", { value: !0 });
function throttle(e, t, r) {
  var i = r || {}, n = i.noTrailing, a = n === void 0 ? !1 : n, s = i.noLeading, l = s === void 0 ? !1 : s, o = i.debounceMode, c = o === void 0 ? void 0 : o, f, x = !1, m = 0;
  function A() {
    f && clearTimeout(f);
  }
  function M(C) {
    var u = C || {}, g = u.upcomingOnly, p = g === void 0 ? !1 : g;
    A(), x = !p;
  }
  function d() {
    for (var C = arguments.length, u = new Array(C), g = 0; g < C; g++)
      u[g] = arguments[g];
    var p = this, y = Date.now() - m;
    if (x)
      return;
    function E() {
      m = Date.now(), t.apply(p, u);
    }
    function T() {
      f = void 0;
    }
    !l && c && !f && E(), A(), c === void 0 && y > e ? l ? (m = Date.now(), a || (f = setTimeout(c ? T : E, e))) : E() : a !== !0 && (f = setTimeout(c ? T : E, c === void 0 ? e - y : e));
  }
  return d.cancel = M, d;
}
function debounce(e, t, r) {
  var i = r || {}, n = i.atBegin, a = n === void 0 ? !1 : n;
  return throttle(e, t, {
    debounceMode: a !== !1
  });
}
cjs.debounce = debounce;
cjs.throttle = throttle;
const LeftBannerEnums = {
  aicv: "1",
  // 简历
  bossjob: "2",
  // bossJob
  neptune: "3"
  // 海王星黄页
}, main = "_main_1661a_7", bg = "_bg_1661a_24", qrPollingCode = "_qrPollingCode_1661a_34", code = "_code_1661a_40", codeImg = "_codeImg_1661a_47", codeTitle = "_codeTitle_1661a_58", codeTitleSed = "_codeTitleSed_1661a_72", qrCode = "_qrCode_1661a_84", qrCodeBox = "_qrCodeBox_1661a_96", circle = "_circle_1661a_109", overTime = "_overTime_1661a_116", codePopver$1 = "_codePopver_1661a_162", popver = "_popver_1661a_187", menu = "_menu_1661a_233", active = "_active_1661a_252", popver2 = "_popver2_1661a_256", popverContent = "_popverContent_1661a_274", qrAvator = "_qrAvator_1661a_281", scanned = "_scanned_1661a_293", loginOn = "_loginOn_1661a_303", codePage = "_codePage_1661a_310", container = "_container_1661a_324", leftContainer = "_leftContainer_1661a_333", leftBanner = "_leftBanner_1661a_338", bannner$3 = "_bannner_1661a_342", rightContainer = "_rightContainer_1661a_346", loginItems = "_loginItems_1661a_357", mainModal = "_mainModal_1661a_363", list = "_list_1661a_366", phoneBox = "_phoneBox_1661a_390", list2 = "_list2_1661a_398", login_itemActive = "_login_itemActive_1661a_413", account = "_account_1661a_418", name = "_name_1661a_447", email = "_email_1661a_468", listEmail = "_listEmail_1661a_476", divider = "_divider_1661a_487", divider_text = "_divider_text_1661a_495", divider_none = "_divider_none_1661a_501", captcha = "_captcha_1661a_505", codeBox = "_codeBox_1661a_510", optErr = "_optErr_1661a_549", InputBoxWrap = "_InputBoxWrap_1661a_553", resendCode = "_resendCode_1661a_557", captchaThemeBox = "_captchaThemeBox_1661a_560", itemContent = "_itemContent_1661a_564", itemContentActive = "_itemContentActive_1661a_568", itemContentHit = "_itemContentHit_1661a_572", enabled = "_enabled_1661a_583", imgContainer = "_imgContainer_1661a_583", phoneNumber = "_phoneNumber_1661a_597", phoneInputDec = "_phoneInputDec_1661a_617", phone = "_phone_1661a_390", select = "_select_1661a_673", item = "_item_1661a_564", btn = "_btn_1661a_687", checkbox = "_checkbox_1661a_711", upLater = "_upLater_1661a_714", upLaterText = "_upLaterText_1661a_718", msg = "_msg_1661a_726", newUser = "_newUser_1661a_740", newUser_title = "_newUser_title_1661a_743", newUser_tip = "_newUser_tip_1661a_752", optBox = "_optBox_1661a_761", enterTips = "_enterTips_1661a_767", extra = "_extra_1661a_780", countdown = "_countdown_1661a_788", trouble = "_trouble_1661a_803", checkYourSpam = "_checkYourSpam_1661a_813", linkTips = "_linkTips_1661a_821", dotBox = "_dotBox_1661a_827", agreement = "_agreement_1661a_839", link = "_link_1661a_821", avatar = "_avatar_1661a_858", avatar_content = "_avatar_content_1661a_863", avatar_img = "_avatar_img_1661a_869", avatar_vip = "_avatar_vip_1661a_877", avatar_icon = "_avatar_icon_1661a_880", phone_text = "_phone_text_1661a_887", emailTitle = "_emailTitle_1661a_890", emailTip = "_emailTip_1661a_899", emailFactor = "_emailFactor_1661a_908", emailFactorTitle = "_emailFactorTitle_1661a_908", secure = "_secure_1661a_918", emailTips = "_emailTips_1661a_925", backBox = "_backBox_1661a_936", verifyEmailTitle = "_verifyEmailTitle_1661a_954", verifyEmailTips = "_verifyEmailTips_1661a_965", tips = "_tips_1661a_981", login_item = "_login_item_1661a_413", login_disabled = "_login_disabled_1661a_1030", dialogContainer = "_dialogContainer_1661a_1034", leftBannerDesc$1 = "_leftBannerDesc_1661a_1037", leftBannerItem = "_leftBannerItem_1661a_1042", leftBannerTitle = "_leftBannerTitle_1661a_1045", leftBannerText = "_leftBannerText_1661a_1055", vipUserPromptWrap = "_vipUserPromptWrap_1661a_1063", vipUserPrompt = "_vipUserPrompt_1661a_1063", buttonContent = "_buttonContent_1661a_1090", returnButton = "_returnButton_1661a_1095", exitButton = "_exitButton_1661a_1106", back = "_back_1661a_936", errorTip = "_errorTip_1661a_1127", flagField = "_flagField_1661a_1132", overrideAutoFill = "_overrideAutoFill_1661a_1147", emailComponent = "_emailComponent_1661a_1154", headerTitle = "_headerTitle_1661a_1161", headerTitle2 = "_headerTitle2_1661a_1172", loginForPhoneSelect = "_loginForPhoneSelect_1661a_1188", havingTroubleText = "_havingTroubleText_1661a_1192", needHelpText = "_needHelpText_1661a_1209", havingTroubleContent = "_havingTroubleContent_1661a_1226", havingTroubleTip = "_havingTroubleTip_1661a_1237", PhoneChooseEmailTitle = "_PhoneChooseEmailTitle_1661a_1277", PhoneChooseEmailTips = "_PhoneChooseEmailTips_1661a_1287", overlayAntStyle = "_overlayAntStyle_1661a_1296", QRHelpWrapper = "_QRHelpWrapper_1661a_1305", QRHelp = "_QRHelp_1661a_1305", qrDownAppText = "_qrDownAppText_1661a_1336", howToScanWrapper = "_howToScanWrapper_1661a_1349", howToScanImg = "_howToScanImg_1661a_1364", qrDownAppImg = "_qrDownAppImg_1661a_1375", rightButtons = "_rightButtons_1661a_1381", buttonWrapper = "_buttonWrapper_1661a_1387", textWrapper = "_textWrapper_1661a_1401", label = "_label_1661a_1405", title = "_title_1661a_1412", howToScanTitle = "_howToScanTitle_1661a_1420", qrCodeWrapper = "_qrCodeWrapper_1661a_1430", userScanned = "_userScanned_1661a_1438", userScannedAvatar = "_userScannedAvatar_1661a_1446", scannedHeader = "_scannedHeader_1661a_1451", scannedTitle = "_scannedTitle_1661a_1459", scannedName = "_scannedName_1661a_1467", scannedSuccessful = "_scannedSuccessful_1661a_1479", scannedInfo = "_scannedInfo_1661a_1494", switchWrapper = "_switchWrapper_1661a_1503", switchOption = "_switchOption_1661a_1514", switchSlider = "_switchSlider_1661a_1528", verifyEmailLater = "_verifyEmailLater_1661a_1651", emailHeader = "_emailHeader_1661a_1652", needHelpTextMobile = "_needHelpTextMobile_1661a_1656", havingTroubleMobile = "_havingTroubleMobile_1661a_1668", havingTroubleMobileHeader = "_havingTroubleMobileHeader_1661a_1671", havingTroubleMobileContent = "_havingTroubleMobileContent_1661a_1676", havingTroubleMobileTitle = "_havingTroubleMobileTitle_1661a_1679", havingTroubleMobileDesc = "_havingTroubleMobileDesc_1661a_1688", havingTroubleEmailMobile = "_havingTroubleEmailMobile_1661a_1717", styles$3 = {
  main,
  bg,
  qrPollingCode,
  code,
  codeImg,
  codeTitle,
  codeTitleSed,
  qrCode,
  qrCodeBox,
  circle,
  overTime,
  codePopver: codePopver$1,
  popver,
  menu,
  active,
  popver2,
  popverContent,
  qrAvator,
  scanned,
  loginOn,
  codePage,
  container,
  leftContainer,
  leftBanner,
  bannner: bannner$3,
  rightContainer,
  loginItems,
  mainModal,
  list,
  phoneBox,
  list2,
  login_itemActive,
  account,
  name,
  email,
  listEmail,
  divider,
  divider_text,
  divider_none,
  captcha,
  codeBox,
  optErr,
  InputBoxWrap,
  resendCode,
  captchaThemeBox,
  itemContent,
  itemContentActive,
  itemContentHit,
  enabled,
  imgContainer,
  phoneNumber,
  phoneInputDec,
  phone,
  select,
  item,
  btn,
  checkbox,
  upLater,
  upLaterText,
  msg,
  newUser,
  newUser_title,
  newUser_tip,
  optBox,
  enterTips,
  extra,
  countdown,
  trouble,
  checkYourSpam,
  linkTips,
  dotBox,
  agreement,
  link,
  avatar,
  avatar_content,
  avatar_img,
  avatar_vip,
  avatar_icon,
  phone_text,
  emailTitle,
  emailTip,
  emailFactor,
  emailFactorTitle,
  secure,
  emailTips,
  backBox,
  verifyEmailTitle,
  verifyEmailTips,
  tips,
  login_item,
  login_disabled,
  dialogContainer,
  leftBannerDesc: leftBannerDesc$1,
  leftBannerItem,
  leftBannerTitle,
  leftBannerText,
  vipUserPromptWrap,
  vipUserPrompt,
  buttonContent,
  returnButton,
  exitButton,
  back,
  errorTip,
  flagField,
  overrideAutoFill,
  emailComponent,
  headerTitle,
  headerTitle2,
  loginForPhoneSelect,
  havingTroubleText,
  needHelpText,
  havingTroubleContent,
  havingTroubleTip,
  PhoneChooseEmailTitle,
  PhoneChooseEmailTips,
  overlayAntStyle,
  QRHelpWrapper,
  QRHelp,
  qrDownAppText,
  howToScanWrapper,
  howToScanImg,
  qrDownAppImg,
  rightButtons,
  buttonWrapper,
  textWrapper,
  label,
  title,
  howToScanTitle,
  qrCodeWrapper,
  userScanned,
  userScannedAvatar,
  scannedHeader,
  scannedTitle,
  scannedName,
  scannedSuccessful,
  scannedInfo,
  switchWrapper,
  switchOption,
  switchSlider,
  verifyEmailLater,
  emailHeader,
  needHelpTextMobile,
  havingTroubleMobile,
  havingTroubleMobileHeader,
  havingTroubleMobileContent,
  havingTroubleMobileTitle,
  havingTroubleMobileDesc,
  havingTroubleEmailMobile,
  "rc-captcha-input-flash": "_rc-captcha-input-flash_1661a_1"
}, scannedImg = "data:image/png;base64,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", serveIsMobile = (e) => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(e), isServer = () => typeof window > "u", jobSeekerUrlPrefix = "/jobseekers", isMobileDevice = () => {
  if (isServer())
    return !1;
  {
    const e = navigator.userAgent;
    return serveIsMobile(e);
  }
}, fetchUserService = () => {
  const e = {
    "Country-Id": getCountryId()
  }, t = isMobileDevice();
  return fetchService("GET", `${jobSeekerUrlPrefix}/me`, {
    source: t ? "mobile_web" : "web"
  }, e);
};
var browser = {}, canPromise$1 = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, qrcode = {}, utils$1 = {};
let toSJISFunction;
const CODEWORDS_COUNT = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
utils$1.getSymbolSize = function(t) {
  if (!t)
    throw new Error('"version" cannot be null or undefined');
  if (t < 1 || t > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return t * 4 + 17;
};
utils$1.getSymbolTotalCodewords = function(t) {
  return CODEWORDS_COUNT[t];
};
utils$1.getBCHDigit = function(e) {
  let t = 0;
  for (; e !== 0; )
    t++, e >>>= 1;
  return t;
};
utils$1.setToSJISFunction = function(t) {
  if (typeof t != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  toSJISFunction = t;
};
utils$1.isKanjiModeEnabled = function() {
  return typeof toSJISFunction < "u";
};
utils$1.toSJIS = function(t) {
  return toSJISFunction(t);
};
var errorCorrectionLevel = {};
(function(e) {
  e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
  function t(r) {
    if (typeof r != "string")
      throw new Error("Param is not a string");
    switch (r.toLowerCase()) {
      case "l":
      case "low":
        return e.L;
      case "m":
      case "medium":
        return e.M;
      case "q":
      case "quartile":
        return e.Q;
      case "h":
      case "high":
        return e.H;
      default:
        throw new Error("Unknown EC Level: " + r);
    }
  }
  e.isValid = function(i) {
    return i && typeof i.bit < "u" && i.bit >= 0 && i.bit < 4;
  }, e.from = function(i, n) {
    if (e.isValid(i))
      return i;
    try {
      return t(i);
    } catch {
      return n;
    }
  };
})(errorCorrectionLevel);
function BitBuffer$1() {
  this.buffer = [], this.length = 0;
}
BitBuffer$1.prototype = {
  get: function(e) {
    const t = Math.floor(e / 8);
    return (this.buffer[t] >>> 7 - e % 8 & 1) === 1;
  },
  put: function(e, t) {
    for (let r = 0; r < t; r++)
      this.putBit((e >>> t - r - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(e) {
    const t = Math.floor(this.length / 8);
    this.buffer.length <= t && this.buffer.push(0), e && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
  }
};
var bitBuffer = BitBuffer$1;
function BitMatrix$1(e) {
  if (!e || e < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = e, this.data = new Uint8Array(e * e), this.reservedBit = new Uint8Array(e * e);
}
BitMatrix$1.prototype.set = function(e, t, r, i) {
  const n = e * this.size + t;
  this.data[n] = r, i && (this.reservedBit[n] = !0);
};
BitMatrix$1.prototype.get = function(e, t) {
  return this.data[e * this.size + t];
};
BitMatrix$1.prototype.xor = function(e, t, r) {
  this.data[e * this.size + t] ^= r;
};
BitMatrix$1.prototype.isReserved = function(e, t) {
  return this.reservedBit[e * this.size + t];
};
var bitMatrix = BitMatrix$1, alignmentPattern = {};
(function(e) {
  const t = utils$1.getSymbolSize;
  e.getRowColCoords = function(i) {
    if (i === 1)
      return [];
    const n = Math.floor(i / 7) + 2, a = t(i), s = a === 145 ? 26 : Math.ceil((a - 13) / (2 * n - 2)) * 2, l = [a - 7];
    for (let o = 1; o < n - 1; o++)
      l[o] = l[o - 1] - s;
    return l.push(6), l.reverse();
  }, e.getPositions = function(i) {
    const n = [], a = e.getRowColCoords(i), s = a.length;
    for (let l = 0; l < s; l++)
      for (let o = 0; o < s; o++)
        l === 0 && o === 0 || // top-left
        l === 0 && o === s - 1 || // bottom-left
        l === s - 1 && o === 0 || n.push([a[l], a[o]]);
    return n;
  };
})(alignmentPattern);
var finderPattern = {};
const getSymbolSize = utils$1.getSymbolSize, FINDER_PATTERN_SIZE = 7;
finderPattern.getPositions = function(t) {
  const r = getSymbolSize(t);
  return [
    // top-left
    [0, 0],
    // top-right
    [r - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, r - FINDER_PATTERN_SIZE]
  ];
};
var maskPattern = {};
(function(e) {
  e.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const t = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  e.isValid = function(n) {
    return n != null && n !== "" && !isNaN(n) && n >= 0 && n <= 7;
  }, e.from = function(n) {
    return e.isValid(n) ? parseInt(n, 10) : void 0;
  }, e.getPenaltyN1 = function(n) {
    const a = n.size;
    let s = 0, l = 0, o = 0, c = null, f = null;
    for (let x = 0; x < a; x++) {
      l = o = 0, c = f = null;
      for (let m = 0; m < a; m++) {
        let A = n.get(x, m);
        A === c ? l++ : (l >= 5 && (s += t.N1 + (l - 5)), c = A, l = 1), A = n.get(m, x), A === f ? o++ : (o >= 5 && (s += t.N1 + (o - 5)), f = A, o = 1);
      }
      l >= 5 && (s += t.N1 + (l - 5)), o >= 5 && (s += t.N1 + (o - 5));
    }
    return s;
  }, e.getPenaltyN2 = function(n) {
    const a = n.size;
    let s = 0;
    for (let l = 0; l < a - 1; l++)
      for (let o = 0; o < a - 1; o++) {
        const c = n.get(l, o) + n.get(l, o + 1) + n.get(l + 1, o) + n.get(l + 1, o + 1);
        (c === 4 || c === 0) && s++;
      }
    return s * t.N2;
  }, e.getPenaltyN3 = function(n) {
    const a = n.size;
    let s = 0, l = 0, o = 0;
    for (let c = 0; c < a; c++) {
      l = o = 0;
      for (let f = 0; f < a; f++)
        l = l << 1 & 2047 | n.get(c, f), f >= 10 && (l === 1488 || l === 93) && s++, o = o << 1 & 2047 | n.get(f, c), f >= 10 && (o === 1488 || o === 93) && s++;
    }
    return s * t.N3;
  }, e.getPenaltyN4 = function(n) {
    let a = 0;
    const s = n.data.length;
    for (let o = 0; o < s; o++)
      a += n.data[o];
    return Math.abs(Math.ceil(a * 100 / s / 5) - 10) * t.N4;
  };
  function r(i, n, a) {
    switch (i) {
      case e.Patterns.PATTERN000:
        return (n + a) % 2 === 0;
      case e.Patterns.PATTERN001:
        return n % 2 === 0;
      case e.Patterns.PATTERN010:
        return a % 3 === 0;
      case e.Patterns.PATTERN011:
        return (n + a) % 3 === 0;
      case e.Patterns.PATTERN100:
        return (Math.floor(n / 2) + Math.floor(a / 3)) % 2 === 0;
      case e.Patterns.PATTERN101:
        return n * a % 2 + n * a % 3 === 0;
      case e.Patterns.PATTERN110:
        return (n * a % 2 + n * a % 3) % 2 === 0;
      case e.Patterns.PATTERN111:
        return (n * a % 3 + (n + a) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + i);
    }
  }
  e.applyMask = function(n, a) {
    const s = a.size;
    for (let l = 0; l < s; l++)
      for (let o = 0; o < s; o++)
        a.isReserved(o, l) || a.xor(o, l, r(n, o, l));
  }, e.getBestMask = function(n, a) {
    const s = Object.keys(e.Patterns).length;
    let l = 0, o = 1 / 0;
    for (let c = 0; c < s; c++) {
      a(c), e.applyMask(c, n);
      const f = e.getPenaltyN1(n) + e.getPenaltyN2(n) + e.getPenaltyN3(n) + e.getPenaltyN4(n);
      e.applyMask(c, n), f < o && (o = f, l = c);
    }
    return l;
  };
})(maskPattern);
var errorCorrectionCode = {};
const ECLevel$1 = errorCorrectionLevel, EC_BLOCKS_TABLE = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], EC_CODEWORDS_TABLE = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
errorCorrectionCode.getBlocksCount = function(t, r) {
  switch (r) {
    case ECLevel$1.L:
      return EC_BLOCKS_TABLE[(t - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_BLOCKS_TABLE[(t - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_BLOCKS_TABLE[(t - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_BLOCKS_TABLE[(t - 1) * 4 + 3];
    default:
      return;
  }
};
errorCorrectionCode.getTotalCodewordsCount = function(t, r) {
  switch (r) {
    case ECLevel$1.L:
      return EC_CODEWORDS_TABLE[(t - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_CODEWORDS_TABLE[(t - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_CODEWORDS_TABLE[(t - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_CODEWORDS_TABLE[(t - 1) * 4 + 3];
    default:
      return;
  }
};
var polynomial = {}, galoisField = {};
const EXP_TABLE = new Uint8Array(512), LOG_TABLE = new Uint8Array(256);
(function() {
  let t = 1;
  for (let r = 0; r < 255; r++)
    EXP_TABLE[r] = t, LOG_TABLE[t] = r, t <<= 1, t & 256 && (t ^= 285);
  for (let r = 255; r < 512; r++)
    EXP_TABLE[r] = EXP_TABLE[r - 255];
})();
galoisField.log = function(t) {
  if (t < 1)
    throw new Error("log(" + t + ")");
  return LOG_TABLE[t];
};
galoisField.exp = function(t) {
  return EXP_TABLE[t];
};
galoisField.mul = function(t, r) {
  return t === 0 || r === 0 ? 0 : EXP_TABLE[LOG_TABLE[t] + LOG_TABLE[r]];
};
(function(e) {
  const t = galoisField;
  e.mul = function(i, n) {
    const a = new Uint8Array(i.length + n.length - 1);
    for (let s = 0; s < i.length; s++)
      for (let l = 0; l < n.length; l++)
        a[s + l] ^= t.mul(i[s], n[l]);
    return a;
  }, e.mod = function(i, n) {
    let a = new Uint8Array(i);
    for (; a.length - n.length >= 0; ) {
      const s = a[0];
      for (let o = 0; o < n.length; o++)
        a[o] ^= t.mul(n[o], s);
      let l = 0;
      for (; l < a.length && a[l] === 0; )
        l++;
      a = a.slice(l);
    }
    return a;
  }, e.generateECPolynomial = function(i) {
    let n = new Uint8Array([1]);
    for (let a = 0; a < i; a++)
      n = e.mul(n, new Uint8Array([1, t.exp(a)]));
    return n;
  };
})(polynomial);
const Polynomial = polynomial;
function ReedSolomonEncoder$1(e) {
  this.genPoly = void 0, this.degree = e, this.degree && this.initialize(this.degree);
}
ReedSolomonEncoder$1.prototype.initialize = function(t) {
  this.degree = t, this.genPoly = Polynomial.generateECPolynomial(this.degree);
};
ReedSolomonEncoder$1.prototype.encode = function(t) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const r = new Uint8Array(t.length + this.degree);
  r.set(t);
  const i = Polynomial.mod(r, this.genPoly), n = this.degree - i.length;
  if (n > 0) {
    const a = new Uint8Array(this.degree);
    return a.set(i, n), a;
  }
  return i;
};
var reedSolomonEncoder = ReedSolomonEncoder$1, version = {}, mode = {}, versionCheck = {};
versionCheck.isValid = function(t) {
  return !isNaN(t) && t >= 1 && t <= 40;
};
var regex = {};
const numeric = "[0-9]+", alphanumeric = "[A-Z $%*+\\-./:]+";
let kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
kanji = kanji.replace(/u/g, "\\u");
const byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + kanji + `)(?:.|[\r
]))+`;
regex.KANJI = new RegExp(kanji, "g");
regex.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
regex.BYTE = new RegExp(byte, "g");
regex.NUMERIC = new RegExp(numeric, "g");
regex.ALPHANUMERIC = new RegExp(alphanumeric, "g");
const TEST_KANJI = new RegExp("^" + kanji + "$"), TEST_NUMERIC = new RegExp("^" + numeric + "$"), TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
regex.testKanji = function(t) {
  return TEST_KANJI.test(t);
};
regex.testNumeric = function(t) {
  return TEST_NUMERIC.test(t);
};
regex.testAlphanumeric = function(t) {
  return TEST_ALPHANUMERIC.test(t);
};
(function(e) {
  const t = versionCheck, r = regex;
  e.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, e.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, e.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, e.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, e.MIXED = {
    bit: -1
  }, e.getCharCountIndicator = function(a, s) {
    if (!a.ccBits)
      throw new Error("Invalid mode: " + a);
    if (!t.isValid(s))
      throw new Error("Invalid version: " + s);
    return s >= 1 && s < 10 ? a.ccBits[0] : s < 27 ? a.ccBits[1] : a.ccBits[2];
  }, e.getBestModeForData = function(a) {
    return r.testNumeric(a) ? e.NUMERIC : r.testAlphanumeric(a) ? e.ALPHANUMERIC : r.testKanji(a) ? e.KANJI : e.BYTE;
  }, e.toString = function(a) {
    if (a && a.id)
      return a.id;
    throw new Error("Invalid mode");
  }, e.isValid = function(a) {
    return a && a.bit && a.ccBits;
  };
  function i(n) {
    if (typeof n != "string")
      throw new Error("Param is not a string");
    switch (n.toLowerCase()) {
      case "numeric":
        return e.NUMERIC;
      case "alphanumeric":
        return e.ALPHANUMERIC;
      case "kanji":
        return e.KANJI;
      case "byte":
        return e.BYTE;
      default:
        throw new Error("Unknown mode: " + n);
    }
  }
  e.from = function(a, s) {
    if (e.isValid(a))
      return a;
    try {
      return i(a);
    } catch {
      return s;
    }
  };
})(mode);
(function(e) {
  const t = utils$1, r = errorCorrectionCode, i = errorCorrectionLevel, n = mode, a = versionCheck, s = 7973, l = t.getBCHDigit(s);
  function o(m, A, M) {
    for (let d = 1; d <= 40; d++)
      if (A <= e.getCapacity(d, M, m))
        return d;
  }
  function c(m, A) {
    return n.getCharCountIndicator(m, A) + 4;
  }
  function f(m, A) {
    let M = 0;
    return m.forEach(function(d) {
      const C = c(d.mode, A);
      M += C + d.getBitsLength();
    }), M;
  }
  function x(m, A) {
    for (let M = 1; M <= 40; M++)
      if (f(m, M) <= e.getCapacity(M, A, n.MIXED))
        return M;
  }
  e.from = function(A, M) {
    return a.isValid(A) ? parseInt(A, 10) : M;
  }, e.getCapacity = function(A, M, d) {
    if (!a.isValid(A))
      throw new Error("Invalid QR Code version");
    typeof d > "u" && (d = n.BYTE);
    const C = t.getSymbolTotalCodewords(A), u = r.getTotalCodewordsCount(A, M), g = (C - u) * 8;
    if (d === n.MIXED)
      return g;
    const p = g - c(d, A);
    switch (d) {
      case n.NUMERIC:
        return Math.floor(p / 10 * 3);
      case n.ALPHANUMERIC:
        return Math.floor(p / 11 * 2);
      case n.KANJI:
        return Math.floor(p / 13);
      case n.BYTE:
      default:
        return Math.floor(p / 8);
    }
  }, e.getBestVersionForData = function(A, M) {
    let d;
    const C = i.from(M, i.M);
    if (Array.isArray(A)) {
      if (A.length > 1)
        return x(A, C);
      if (A.length === 0)
        return 1;
      d = A[0];
    } else
      d = A;
    return o(d.mode, d.getLength(), C);
  }, e.getEncodedBits = function(A) {
    if (!a.isValid(A) || A < 7)
      throw new Error("Invalid QR Code version");
    let M = A << 12;
    for (; t.getBCHDigit(M) - l >= 0; )
      M ^= s << t.getBCHDigit(M) - l;
    return A << 12 | M;
  };
})(version);
var formatInfo = {};
const Utils$3 = utils$1, G15 = 1335, G15_MASK = 21522, G15_BCH = Utils$3.getBCHDigit(G15);
formatInfo.getEncodedBits = function(t, r) {
  const i = t.bit << 3 | r;
  let n = i << 10;
  for (; Utils$3.getBCHDigit(n) - G15_BCH >= 0; )
    n ^= G15 << Utils$3.getBCHDigit(n) - G15_BCH;
  return (i << 10 | n) ^ G15_MASK;
};
var segments = {};
const Mode$4 = mode;
function NumericData(e) {
  this.mode = Mode$4.NUMERIC, this.data = e.toString();
}
NumericData.getBitsLength = function(t) {
  return 10 * Math.floor(t / 3) + (t % 3 ? t % 3 * 3 + 1 : 0);
};
NumericData.prototype.getLength = function() {
  return this.data.length;
};
NumericData.prototype.getBitsLength = function() {
  return NumericData.getBitsLength(this.data.length);
};
NumericData.prototype.write = function(t) {
  let r, i, n;
  for (r = 0; r + 3 <= this.data.length; r += 3)
    i = this.data.substr(r, 3), n = parseInt(i, 10), t.put(n, 10);
  const a = this.data.length - r;
  a > 0 && (i = this.data.substr(r), n = parseInt(i, 10), t.put(n, a * 3 + 1));
};
var numericData = NumericData;
const Mode$3 = mode, ALPHA_NUM_CHARS = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function AlphanumericData(e) {
  this.mode = Mode$3.ALPHANUMERIC, this.data = e;
}
AlphanumericData.getBitsLength = function(t) {
  return 11 * Math.floor(t / 2) + 6 * (t % 2);
};
AlphanumericData.prototype.getLength = function() {
  return this.data.length;
};
AlphanumericData.prototype.getBitsLength = function() {
  return AlphanumericData.getBitsLength(this.data.length);
};
AlphanumericData.prototype.write = function(t) {
  let r;
  for (r = 0; r + 2 <= this.data.length; r += 2) {
    let i = ALPHA_NUM_CHARS.indexOf(this.data[r]) * 45;
    i += ALPHA_NUM_CHARS.indexOf(this.data[r + 1]), t.put(i, 11);
  }
  this.data.length % 2 && t.put(ALPHA_NUM_CHARS.indexOf(this.data[r]), 6);
};
var alphanumericData = AlphanumericData, encodeUtf8$1 = function(t) {
  for (var r = [], i = t.length, n = 0; n < i; n++) {
    var a = t.charCodeAt(n);
    if (a >= 55296 && a <= 56319 && i > n + 1) {
      var s = t.charCodeAt(n + 1);
      s >= 56320 && s <= 57343 && (a = (a - 55296) * 1024 + s - 56320 + 65536, n += 1);
    }
    if (a < 128) {
      r.push(a);
      continue;
    }
    if (a < 2048) {
      r.push(a >> 6 | 192), r.push(a & 63 | 128);
      continue;
    }
    if (a < 55296 || a >= 57344 && a < 65536) {
      r.push(a >> 12 | 224), r.push(a >> 6 & 63 | 128), r.push(a & 63 | 128);
      continue;
    }
    if (a >= 65536 && a <= 1114111) {
      r.push(a >> 18 | 240), r.push(a >> 12 & 63 | 128), r.push(a >> 6 & 63 | 128), r.push(a & 63 | 128);
      continue;
    }
    r.push(239, 191, 189);
  }
  return new Uint8Array(r).buffer;
};
const encodeUtf8 = encodeUtf8$1, Mode$2 = mode;
function ByteData(e) {
  this.mode = Mode$2.BYTE, typeof e == "string" && (e = encodeUtf8(e)), this.data = new Uint8Array(e);
}
ByteData.getBitsLength = function(t) {
  return t * 8;
};
ByteData.prototype.getLength = function() {
  return this.data.length;
};
ByteData.prototype.getBitsLength = function() {
  return ByteData.getBitsLength(this.data.length);
};
ByteData.prototype.write = function(e) {
  for (let t = 0, r = this.data.length; t < r; t++)
    e.put(this.data[t], 8);
};
var byteData = ByteData;
const Mode$1 = mode, Utils$2 = utils$1;
function KanjiData(e) {
  this.mode = Mode$1.KANJI, this.data = e;
}
KanjiData.getBitsLength = function(t) {
  return t * 13;
};
KanjiData.prototype.getLength = function() {
  return this.data.length;
};
KanjiData.prototype.getBitsLength = function() {
  return KanjiData.getBitsLength(this.data.length);
};
KanjiData.prototype.write = function(e) {
  let t;
  for (t = 0; t < this.data.length; t++) {
    let r = Utils$2.toSJIS(this.data[t]);
    if (r >= 33088 && r <= 40956)
      r -= 33088;
    else if (r >= 57408 && r <= 60351)
      r -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[t] + `
Make sure your charset is UTF-8`
      );
    r = (r >>> 8 & 255) * 192 + (r & 255), e.put(r, 13);
  }
};
var kanjiData = KanjiData, dijkstra = { exports: {} };
(function(e) {
  var t = {
    single_source_shortest_paths: function(r, i, n) {
      var a = {}, s = {};
      s[i] = 0;
      var l = t.PriorityQueue.make();
      l.push(i, 0);
      for (var o, c, f, x, m, A, M, d, C; !l.empty(); ) {
        o = l.pop(), c = o.value, x = o.cost, m = r[c] || {};
        for (f in m)
          m.hasOwnProperty(f) && (A = m[f], M = x + A, d = s[f], C = typeof s[f] > "u", (C || d > M) && (s[f] = M, l.push(f, M), a[f] = c));
      }
      if (typeof n < "u" && typeof s[n] > "u") {
        var u = ["Could not find a path from ", i, " to ", n, "."].join("");
        throw new Error(u);
      }
      return a;
    },
    extract_shortest_path_from_predecessor_list: function(r, i) {
      for (var n = [], a = i; a; )
        n.push(a), r[a], a = r[a];
      return n.reverse(), n;
    },
    find_path: function(r, i, n) {
      var a = t.single_source_shortest_paths(r, i, n);
      return t.extract_shortest_path_from_predecessor_list(
        a,
        n
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(r) {
        var i = t.PriorityQueue, n = {}, a;
        r = r || {};
        for (a in i)
          i.hasOwnProperty(a) && (n[a] = i[a]);
        return n.queue = [], n.sorter = r.sorter || i.default_sorter, n;
      },
      default_sorter: function(r, i) {
        return r.cost - i.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(r, i) {
        var n = { value: r, cost: i };
        this.queue.push(n), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  e.exports = t;
})(dijkstra);
var dijkstraExports = dijkstra.exports;
(function(e) {
  const t = mode, r = numericData, i = alphanumericData, n = byteData, a = kanjiData, s = regex, l = utils$1, o = dijkstraExports;
  function c(u) {
    return unescape(encodeURIComponent(u)).length;
  }
  function f(u, g, p) {
    const y = [];
    let E;
    for (; (E = u.exec(p)) !== null; )
      y.push({
        data: E[0],
        index: E.index,
        mode: g,
        length: E[0].length
      });
    return y;
  }
  function x(u) {
    const g = f(s.NUMERIC, t.NUMERIC, u), p = f(s.ALPHANUMERIC, t.ALPHANUMERIC, u);
    let y, E;
    return l.isKanjiModeEnabled() ? (y = f(s.BYTE, t.BYTE, u), E = f(s.KANJI, t.KANJI, u)) : (y = f(s.BYTE_KANJI, t.BYTE, u), E = []), g.concat(p, y, E).sort(function(Z, G) {
      return Z.index - G.index;
    }).map(function(Z) {
      return {
        data: Z.data,
        mode: Z.mode,
        length: Z.length
      };
    });
  }
  function m(u, g) {
    switch (g) {
      case t.NUMERIC:
        return r.getBitsLength(u);
      case t.ALPHANUMERIC:
        return i.getBitsLength(u);
      case t.KANJI:
        return a.getBitsLength(u);
      case t.BYTE:
        return n.getBitsLength(u);
    }
  }
  function A(u) {
    return u.reduce(function(g, p) {
      const y = g.length - 1 >= 0 ? g[g.length - 1] : null;
      return y && y.mode === p.mode ? (g[g.length - 1].data += p.data, g) : (g.push(p), g);
    }, []);
  }
  function M(u) {
    const g = [];
    for (let p = 0; p < u.length; p++) {
      const y = u[p];
      switch (y.mode) {
        case t.NUMERIC:
          g.push([
            y,
            { data: y.data, mode: t.ALPHANUMERIC, length: y.length },
            { data: y.data, mode: t.BYTE, length: y.length }
          ]);
          break;
        case t.ALPHANUMERIC:
          g.push([
            y,
            { data: y.data, mode: t.BYTE, length: y.length }
          ]);
          break;
        case t.KANJI:
          g.push([
            y,
            { data: y.data, mode: t.BYTE, length: c(y.data) }
          ]);
          break;
        case t.BYTE:
          g.push([
            { data: y.data, mode: t.BYTE, length: c(y.data) }
          ]);
      }
    }
    return g;
  }
  function d(u, g) {
    const p = {}, y = { start: {} };
    let E = ["start"];
    for (let T = 0; T < u.length; T++) {
      const Z = u[T], G = [];
      for (let I = 0; I < Z.length; I++) {
        const V = Z[I], Y = "" + T + I;
        G.push(Y), p[Y] = { node: V, lastCount: 0 }, y[Y] = {};
        for (let D = 0; D < E.length; D++) {
          const R = E[D];
          p[R] && p[R].node.mode === V.mode ? (y[R][Y] = m(p[R].lastCount + V.length, V.mode) - m(p[R].lastCount, V.mode), p[R].lastCount += V.length) : (p[R] && (p[R].lastCount = V.length), y[R][Y] = m(V.length, V.mode) + 4 + t.getCharCountIndicator(V.mode, g));
        }
      }
      E = G;
    }
    for (let T = 0; T < E.length; T++)
      y[E[T]].end = 0;
    return { map: y, table: p };
  }
  function C(u, g) {
    let p;
    const y = t.getBestModeForData(u);
    if (p = t.from(g, y), p !== t.BYTE && p.bit < y.bit)
      throw new Error('"' + u + '" cannot be encoded with mode ' + t.toString(p) + `.
 Suggested mode is: ` + t.toString(y));
    switch (p === t.KANJI && !l.isKanjiModeEnabled() && (p = t.BYTE), p) {
      case t.NUMERIC:
        return new r(u);
      case t.ALPHANUMERIC:
        return new i(u);
      case t.KANJI:
        return new a(u);
      case t.BYTE:
        return new n(u);
    }
  }
  e.fromArray = function(g) {
    return g.reduce(function(p, y) {
      return typeof y == "string" ? p.push(C(y, null)) : y.data && p.push(C(y.data, y.mode)), p;
    }, []);
  }, e.fromString = function(g, p) {
    const y = x(g, l.isKanjiModeEnabled()), E = M(y), T = d(E, p), Z = o.find_path(T.map, "start", "end"), G = [];
    for (let I = 1; I < Z.length - 1; I++)
      G.push(T.table[Z[I]].node);
    return e.fromArray(A(G));
  }, e.rawSplit = function(g) {
    return e.fromArray(
      x(g, l.isKanjiModeEnabled())
    );
  };
})(segments);
const Utils$1 = utils$1, ECLevel = errorCorrectionLevel, BitBuffer = bitBuffer, BitMatrix = bitMatrix, AlignmentPattern = alignmentPattern, FinderPattern = finderPattern, MaskPattern = maskPattern, ECCode = errorCorrectionCode, ReedSolomonEncoder = reedSolomonEncoder, Version = version, FormatInfo = formatInfo, Mode = mode, Segments = segments;
function setupFinderPattern(e, t) {
  const r = e.size, i = FinderPattern.getPositions(t);
  for (let n = 0; n < i.length; n++) {
    const a = i[n][0], s = i[n][1];
    for (let l = -1; l <= 7; l++)
      if (!(a + l <= -1 || r <= a + l))
        for (let o = -1; o <= 7; o++)
          s + o <= -1 || r <= s + o || (l >= 0 && l <= 6 && (o === 0 || o === 6) || o >= 0 && o <= 6 && (l === 0 || l === 6) || l >= 2 && l <= 4 && o >= 2 && o <= 4 ? e.set(a + l, s + o, !0, !0) : e.set(a + l, s + o, !1, !0));
  }
}
function setupTimingPattern(e) {
  const t = e.size;
  for (let r = 8; r < t - 8; r++) {
    const i = r % 2 === 0;
    e.set(r, 6, i, !0), e.set(6, r, i, !0);
  }
}
function setupAlignmentPattern(e, t) {
  const r = AlignmentPattern.getPositions(t);
  for (let i = 0; i < r.length; i++) {
    const n = r[i][0], a = r[i][1];
    for (let s = -2; s <= 2; s++)
      for (let l = -2; l <= 2; l++)
        s === -2 || s === 2 || l === -2 || l === 2 || s === 0 && l === 0 ? e.set(n + s, a + l, !0, !0) : e.set(n + s, a + l, !1, !0);
  }
}
function setupVersionInfo(e, t) {
  const r = e.size, i = Version.getEncodedBits(t);
  let n, a, s;
  for (let l = 0; l < 18; l++)
    n = Math.floor(l / 3), a = l % 3 + r - 8 - 3, s = (i >> l & 1) === 1, e.set(n, a, s, !0), e.set(a, n, s, !0);
}
function setupFormatInfo(e, t, r) {
  const i = e.size, n = FormatInfo.getEncodedBits(t, r);
  let a, s;
  for (a = 0; a < 15; a++)
    s = (n >> a & 1) === 1, a < 6 ? e.set(a, 8, s, !0) : a < 8 ? e.set(a + 1, 8, s, !0) : e.set(i - 15 + a, 8, s, !0), a < 8 ? e.set(8, i - a - 1, s, !0) : a < 9 ? e.set(8, 15 - a - 1 + 1, s, !0) : e.set(8, 15 - a - 1, s, !0);
  e.set(i - 8, 8, 1, !0);
}
function setupData(e, t) {
  const r = e.size;
  let i = -1, n = r - 1, a = 7, s = 0;
  for (let l = r - 1; l > 0; l -= 2)
    for (l === 6 && l--; ; ) {
      for (let o = 0; o < 2; o++)
        if (!e.isReserved(n, l - o)) {
          let c = !1;
          s < t.length && (c = (t[s] >>> a & 1) === 1), e.set(n, l - o, c), a--, a === -1 && (s++, a = 7);
        }
      if (n += i, n < 0 || r <= n) {
        n -= i, i = -i;
        break;
      }
    }
}
function createData(e, t, r) {
  const i = new BitBuffer();
  r.forEach(function(o) {
    i.put(o.mode.bit, 4), i.put(o.getLength(), Mode.getCharCountIndicator(o.mode, e)), o.write(i);
  });
  const n = Utils$1.getSymbolTotalCodewords(e), a = ECCode.getTotalCodewordsCount(e, t), s = (n - a) * 8;
  for (i.getLengthInBits() + 4 <= s && i.put(0, 4); i.getLengthInBits() % 8 !== 0; )
    i.putBit(0);
  const l = (s - i.getLengthInBits()) / 8;
  for (let o = 0; o < l; o++)
    i.put(o % 2 ? 17 : 236, 8);
  return createCodewords(i, e, t);
}
function createCodewords(e, t, r) {
  const i = Utils$1.getSymbolTotalCodewords(t), n = ECCode.getTotalCodewordsCount(t, r), a = i - n, s = ECCode.getBlocksCount(t, r), l = i % s, o = s - l, c = Math.floor(i / s), f = Math.floor(a / s), x = f + 1, m = c - f, A = new ReedSolomonEncoder(m);
  let M = 0;
  const d = new Array(s), C = new Array(s);
  let u = 0;
  const g = new Uint8Array(e.buffer);
  for (let Z = 0; Z < s; Z++) {
    const G = Z < o ? f : x;
    d[Z] = g.slice(M, M + G), C[Z] = A.encode(d[Z]), M += G, u = Math.max(u, G);
  }
  const p = new Uint8Array(i);
  let y = 0, E, T;
  for (E = 0; E < u; E++)
    for (T = 0; T < s; T++)
      E < d[T].length && (p[y++] = d[T][E]);
  for (E = 0; E < m; E++)
    for (T = 0; T < s; T++)
      p[y++] = C[T][E];
  return p;
}
function createSymbol(e, t, r, i) {
  let n;
  if (Array.isArray(e))
    n = Segments.fromArray(e);
  else if (typeof e == "string") {
    let c = t;
    if (!c) {
      const f = Segments.rawSplit(e);
      c = Version.getBestVersionForData(f, r);
    }
    n = Segments.fromString(e, c || 40);
  } else
    throw new Error("Invalid data");
  const a = Version.getBestVersionForData(n, r);
  if (!a)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!t)
    t = a;
  else if (t < a)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + a + `.
`
    );
  const s = createData(t, r, n), l = Utils$1.getSymbolSize(t), o = new BitMatrix(l);
  return setupFinderPattern(o, t), setupTimingPattern(o), setupAlignmentPattern(o, t), setupFormatInfo(o, r, 0), t >= 7 && setupVersionInfo(o, t), setupData(o, s), isNaN(i) && (i = MaskPattern.getBestMask(
    o,
    setupFormatInfo.bind(null, o, r)
  )), MaskPattern.applyMask(i, o), setupFormatInfo(o, r, i), {
    modules: o,
    version: t,
    errorCorrectionLevel: r,
    maskPattern: i,
    segments: n
  };
}
qrcode.create = function(t, r) {
  if (typeof t > "u" || t === "")
    throw new Error("No input text");
  let i = ECLevel.M, n, a;
  return typeof r < "u" && (i = ECLevel.from(r.errorCorrectionLevel, ECLevel.M), n = Version.from(r.version), a = MaskPattern.from(r.maskPattern), r.toSJISFunc && Utils$1.setToSJISFunction(r.toSJISFunc)), createSymbol(t, n, i, a);
};
var canvas = {}, utils = {};
(function(e) {
  function t(r) {
    if (typeof r == "number" && (r = r.toString()), typeof r != "string")
      throw new Error("Color should be defined as hex string");
    let i = r.slice().replace("#", "").split("");
    if (i.length < 3 || i.length === 5 || i.length > 8)
      throw new Error("Invalid hex color: " + r);
    (i.length === 3 || i.length === 4) && (i = Array.prototype.concat.apply([], i.map(function(a) {
      return [a, a];
    }))), i.length === 6 && i.push("F", "F");
    const n = parseInt(i.join(""), 16);
    return {
      r: n >> 24 & 255,
      g: n >> 16 & 255,
      b: n >> 8 & 255,
      a: n & 255,
      hex: "#" + i.slice(0, 6).join("")
    };
  }
  e.getOptions = function(i) {
    i || (i = {}), i.color || (i.color = {});
    const n = typeof i.margin > "u" || i.margin === null || i.margin < 0 ? 4 : i.margin, a = i.width && i.width >= 21 ? i.width : void 0, s = i.scale || 4;
    return {
      width: a,
      scale: a ? 4 : s,
      margin: n,
      color: {
        dark: t(i.color.dark || "#000000ff"),
        light: t(i.color.light || "#ffffffff")
      },
      type: i.type,
      rendererOpts: i.rendererOpts || {}
    };
  }, e.getScale = function(i, n) {
    return n.width && n.width >= i + n.margin * 2 ? n.width / (i + n.margin * 2) : n.scale;
  }, e.getImageWidth = function(i, n) {
    const a = e.getScale(i, n);
    return Math.floor((i + n.margin * 2) * a);
  }, e.qrToImageData = function(i, n, a) {
    const s = n.modules.size, l = n.modules.data, o = e.getScale(s, a), c = Math.floor((s + a.margin * 2) * o), f = a.margin * o, x = [a.color.light, a.color.dark];
    for (let m = 0; m < c; m++)
      for (let A = 0; A < c; A++) {
        let M = (m * c + A) * 4, d = a.color.light;
        if (m >= f && A >= f && m < c - f && A < c - f) {
          const C = Math.floor((m - f) / o), u = Math.floor((A - f) / o);
          d = x[l[C * s + u] ? 1 : 0];
        }
        i[M++] = d.r, i[M++] = d.g, i[M++] = d.b, i[M] = d.a;
      }
  };
})(utils);
(function(e) {
  const t = utils;
  function r(n, a, s) {
    n.clearRect(0, 0, a.width, a.height), a.style || (a.style = {}), a.height = s, a.width = s, a.style.height = s + "px", a.style.width = s + "px";
  }
  function i() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  e.render = function(a, s, l) {
    let o = l, c = s;
    typeof o > "u" && (!s || !s.getContext) && (o = s, s = void 0), s || (c = i()), o = t.getOptions(o);
    const f = t.getImageWidth(a.modules.size, o), x = c.getContext("2d"), m = x.createImageData(f, f);
    return t.qrToImageData(m.data, a, o), r(x, c, f), x.putImageData(m, 0, 0), c;
  }, e.renderToDataURL = function(a, s, l) {
    let o = l;
    typeof o > "u" && (!s || !s.getContext) && (o = s, s = void 0), o || (o = {});
    const c = e.render(a, s, o), f = o.type || "image/png", x = o.rendererOpts || {};
    return c.toDataURL(f, x.quality);
  };
})(canvas);
var svgTag = {};
const Utils = utils;
function getColorAttrib(e, t) {
  const r = e.a / 255, i = t + '="' + e.hex + '"';
  return r < 1 ? i + " " + t + '-opacity="' + r.toFixed(2).slice(1) + '"' : i;
}
function svgCmd(e, t, r) {
  let i = e + t;
  return typeof r < "u" && (i += " " + r), i;
}
function qrToPath(e, t, r) {
  let i = "", n = 0, a = !1, s = 0;
  for (let l = 0; l < e.length; l++) {
    const o = Math.floor(l % t), c = Math.floor(l / t);
    !o && !a && (a = !0), e[l] ? (s++, l > 0 && o > 0 && e[l - 1] || (i += a ? svgCmd("M", o + r, 0.5 + c + r) : svgCmd("m", n, 0), n = 0, a = !1), o + 1 < t && e[l + 1] || (i += svgCmd("h", s), s = 0)) : n++;
  }
  return i;
}
svgTag.render = function(t, r, i) {
  const n = Utils.getOptions(r), a = t.modules.size, s = t.modules.data, l = a + n.margin * 2, o = n.color.light.a ? "<path " + getColorAttrib(n.color.light, "fill") + ' d="M0 0h' + l + "v" + l + 'H0z"/>' : "", c = "<path " + getColorAttrib(n.color.dark, "stroke") + ' d="' + qrToPath(s, a, n.margin) + '"/>', f = 'viewBox="0 0 ' + l + " " + l + '"', m = '<svg xmlns="http://www.w3.org/2000/svg" ' + (n.width ? 'width="' + n.width + '" height="' + n.width + '" ' : "") + f + ' shape-rendering="crispEdges">' + o + c + `</svg>
`;
  return typeof i == "function" && i(null, m), m;
};
const canPromise = canPromise$1, QRCode$1 = qrcode, CanvasRenderer = canvas, SvgRenderer = svgTag;
function renderCanvas(e, t, r, i, n) {
  const a = [].slice.call(arguments, 1), s = a.length, l = typeof a[s - 1] == "function";
  if (!l && !canPromise())
    throw new Error("Callback required as last argument");
  if (l) {
    if (s < 2)
      throw new Error("Too few arguments provided");
    s === 2 ? (n = r, r = t, t = i = void 0) : s === 3 && (t.getContext && typeof n > "u" ? (n = i, i = void 0) : (n = i, i = r, r = t, t = void 0));
  } else {
    if (s < 1)
      throw new Error("Too few arguments provided");
    return s === 1 ? (r = t, t = i = void 0) : s === 2 && !t.getContext && (i = r, r = t, t = void 0), new Promise(function(o, c) {
      try {
        const f = QRCode$1.create(r, i);
        o(e(f, t, i));
      } catch (f) {
        c(f);
      }
    });
  }
  try {
    const o = QRCode$1.create(r, i);
    n(null, e(o, t, i));
  } catch (o) {
    n(o);
  }
}
browser.create = QRCode$1.create;
browser.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
browser.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
browser.toString = renderCanvas.bind(null, function(e, t, r) {
  return SvgRenderer.render(e, r);
});
const qrlogo = "data:image/png;base64,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", SmallAppLogo = "data:image/png;base64,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", appLinkUrl$1 = "http://bossjob.com/app", generateMatrix = (e, t) => {
  const r = Array.prototype.slice.call(browser.create(e, { errorCorrectionLevel: t }).modules.data, 0), i = Math.sqrt(r.length);
  return r.reduce(
    (n, a, s) => (s % i === 0 ? n.push([a]) : n[n.length - 1].push(a)) && n,
    []
  );
};
function makeQrcodeSvgStr({ text: e, size: t = 160, logo: r = SmallAppLogo, logoSize: i = 40, ecl: n = "M" }) {
  const a = [], s = generateMatrix(e, n), l = t / s.length;
  [
    { x: 0, y: 0 },
    { x: 1, y: 0 },
    { x: 0, y: 1 }
  ].forEach(({ x: M, y: d }) => {
    const C = (s.length - 7) * l * M, u = (s.length - 7) * l * d;
    for (let g = 0; g < 3; g++)
      a.push(`<rect
        fill="${g % 2 !== 0 ? "white" : "black"}"
        height="${l * (7 - g * 2)}"
        rx="${(g - 0.5) * -6 + (g === 0 ? 2 : 0)}"
        ry="${(g - 0.5) * -6 + (g === 0 ? 2 : 0)}"
        width="${l * (7 - g * 2)}"
        x="${C + l * g}"
        y="${u + l * g}"
      />`);
  });
  const c = Math.floor((i + 3) / l), f = s.length / 2 - c / 2, x = s.length / 2 + c / 2 - 2;
  s.forEach((M, d) => {
    M.forEach((C, u) => {
      s[d][u] && (d < 7 && u < 7 || d > s.length - 8 && u < 7 || d < 7 && u > s.length - 8 || d > f && d < x && u > f && u < x && d < u + c / 2 && u < d + c / 2 + 1 || a.push(`<circle
              cx="${d * l + l / 3}"
              cy="${u * l + l / 3}"
              fill="black"
              r="${l / 3}"
            />`));
    });
  });
  const m = t / 2 - i / 2 - 0;
  return `<svg xmlns="http://www.w3.org/2000/svg" height="${t}" width="${t}" viewBox="0 0 ${t} ${t}">
    <defs><clipPath id="clip-logo"><rect x="${m}" y="${m}" height="${i}" width="${i}" /></clipPath></defs>
    ${a.join("")}
    ${r && `<image
        clipPath="url(#clip-logo)"
        x="${m}" y="${m}"
        height="${i}"
        href="${qrlogo}"
        width="${i}"
      />`}
  </svg>`;
}
function delay(e) {
  return new Promise((t) => {
    setTimeout(() => {
      t(!0);
    }, e);
  });
}
async function makeQrcodeUrl(e) {
  const { size: t = 500 } = e;
  e.logo = SmallAppLogo;
  const r = makeQrcodeSvgStr(e), i = new Image(), n = document.createElement("canvas");
  return n.width = t * 2, n.height = t * 2, i.src = `data:image/svg+xml;base64, ${window.btoa(r)}`, new Promise((a) => {
    i.onload = async () => {
      await delay(100);
      const s = n.getContext("2d");
      s && (s.fillStyle = "white", s.fillRect(0, 0, n.width, n.height), s.drawImage(i, 0, 0, n.width, n.height));
      const l = n.toDataURL("image/jpeg");
      a(l);
    };
  });
}
async function makeBaseQrcodeUrl({ text: e, size: t = 500 }) {
  return browser.toDataURL(e, {
    type: "image/jpeg",
    width: t,
    margin: 2
  });
}
const QrCodeDraw = React__default.memo(function({
  text: t = appLinkUrl$1,
  size: r,
  logo: i,
  logoSize: n,
  ecl: a,
  type: s,
  ...l
}) {
  const o = useQrcodeUrl({ text: t, size: r, logo: i, logoSize: n, ecl: a, type: s });
  return o ? /* @__PURE__ */ jsxRuntimeExports.jsx("img", { ...l, src: o, alt: "qr" }) : null;
});
function useQrcodeUrl({ text: e, size: t, logo: r, logoSize: i, ecl: n, type: a = "circle" }) {
  const [s, l] = useState("");
  return useEffect(() => {
    const o = { text: e, size: t, logo: r, logoSize: i, ecl: n };
    e && (a === "circle" ? makeQrcodeUrl(o).then((c) => {
      l(c);
    }) : makeBaseQrcodeUrl(o).then((c) => {
      l(c);
    }));
  }, [e, a, t, i, r, n]), s || null;
}
var spin = {}, Indicator$1 = {}, Looper$1 = {}, Progress$1 = {}, useLayoutEffect$1 = {}, _interopRequireDefault$4 = interopRequireDefaultExports.default, _interopRequireWildcard$5 = interopRequireWildcardExports.default;
Object.defineProperty(useLayoutEffect$1, "__esModule", {
  value: !0
});
useLayoutEffect$1.useLayoutUpdateEffect = useLayoutEffect$1.default = void 0;
var React$5 = _interopRequireWildcard$5(React__default), _canUseDom = _interopRequireDefault$4(canUseDom$1), useInternalLayoutEffect = process.env.NODE_ENV !== "test" && (0, _canUseDom.default)() ? React$5.useLayoutEffect : React$5.useEffect, useLayoutEffect = function(t, r) {
  var i = React$5.useRef(!0);
  useInternalLayoutEffect(function() {
    return t(i.current);
  }, r), useInternalLayoutEffect(function() {
    return i.current = !1, function() {
      i.current = !0;
    };
  }, []);
};
useLayoutEffect$1.useLayoutUpdateEffect = function(t, r) {
  useLayoutEffect(function(i) {
    if (!i)
      return t();
  }, r);
};
useLayoutEffect$1.default = useLayoutEffect;
var _interopRequireDefault$3 = interopRequireDefaultExports.default, _interopRequireWildcard$4 = interopRequireWildcardExports.default;
Object.defineProperty(Progress$1, "__esModule", {
  value: !0
});
Progress$1.default = Progress;
var React$4 = _interopRequireWildcard$4(React__default), _classnames$3 = _interopRequireDefault$3(classnamesExports), _useLayoutEffect = _interopRequireDefault$3(useLayoutEffect$1);
function Progress(e) {
  let {
    percent: t,
    prefixCls: r
  } = e;
  const i = `${r}-dot`, n = `${i}-holder`, a = `${n}-hidden`, [s, l] = React$4.useState(!1);
  (0, _useLayoutEffect.default)(() => {
    t !== 0 && l(!0);
  }, [t !== 0]);
  const o = Math.max(Math.min(t, 100), 0), c = 100, f = c / 5, x = c / 2 - f / 2, m = x * 2 * Math.PI, A = (M, d) => /* @__PURE__ */ React$4.createElement("circle", {
    className: (0, _classnames$3.default)(M, `${i}-circle`),
    r: x,
    cx: "50",
    cy: "50",
    strokeWidth: f,
    style: d
  });
  return s ? /* @__PURE__ */ React$4.createElement("span", {
    className: (0, _classnames$3.default)(n, `${i}-progress`, o <= 0 && a)
  }, /* @__PURE__ */ React$4.createElement("svg", {
    viewBox: `0 0 ${c} ${c}`,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": o
  }, A(`${i}-circle-bg`), A("", {
    strokeDasharray: `${m * o / 100} ${m * (100 - o) / 100}`,
    strokeDashoffset: `${m / 4}`
  }))) : null;
}
var _interopRequireDefault$2 = interopRequireDefaultExports.default, _interopRequireWildcard$3 = interopRequireWildcardExports.default;
Object.defineProperty(Looper$1, "__esModule", {
  value: !0
});
Looper$1.default = Looper;
var React$3 = _interopRequireWildcard$3(React__default), _classnames$2 = _interopRequireDefault$2(classnamesExports), _Progress = _interopRequireDefault$2(Progress$1);
function Looper(e) {
  const {
    prefixCls: t,
    percent: r = 0
  } = e, i = `${t}-dot`, n = `${i}-holder`, a = `${n}-hidden`;
  return /* @__PURE__ */ React$3.createElement(React$3.Fragment, null, /* @__PURE__ */ React$3.createElement("span", {
    className: (0, _classnames$2.default)(n, r > 0 && a)
  }, /* @__PURE__ */ React$3.createElement("span", {
    className: (0, _classnames$2.default)(i, `${t}-dot-spin`)
  }, [1, 2, 3, 4].map((s) => /* @__PURE__ */ React$3.createElement("i", {
    className: `${t}-dot-item`,
    key: s
  })))), /* @__PURE__ */ React$3.createElement(_Progress.default, {
    prefixCls: t,
    percent: r
  }));
}
var _interopRequireDefault$1 = interopRequireDefaultExports.default, _interopRequireWildcard$2 = interopRequireWildcardExports.default;
Object.defineProperty(Indicator$1, "__esModule", {
  value: !0
});
Indicator$1.default = Indicator;
var React$2 = _interopRequireWildcard$2(React__default), _classnames$1 = _interopRequireDefault$1(classnamesExports), _reactNode = reactNode, _Looper = _interopRequireDefault$1(Looper$1);
function Indicator(e) {
  const {
    prefixCls: t,
    indicator: r,
    percent: i
  } = e, n = `${t}-dot`;
  return r && /* @__PURE__ */ React$2.isValidElement(r) ? (0, _reactNode.cloneElement)(r, {
    className: (0, _classnames$1.default)(r.props.className, n),
    percent: i
  }) : /* @__PURE__ */ React$2.createElement(_Looper.default, {
    prefixCls: t,
    percent: i
  });
}
var style = {};
Object.defineProperty(style, "__esModule", {
  value: !0
});
style.prepareComponentToken = style.default = void 0;
var _cssinjs = require$$0, _style = style$1, _internal = internal;
const antSpinMove = new _cssinjs.Keyframes("antSpinMove", {
  to: {
    opacity: 1
  }
}), antRotate = new _cssinjs.Keyframes("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), genSpinStyle = (e) => {
  const {
    componentCls: t,
    calc: r
  } = e;
  return {
    [`${t}`]: Object.assign(Object.assign({}, (0, _style.resetComponent)(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: r(r(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [t]: {
          [`${t}-dot-holder`]: {
            color: e.colorWhite
          },
          [`${t}-text`]: {
            color: e.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: r(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: r(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: r(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: r(r(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: r(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: r(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: r(r(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: r(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        top: 0,
        insetInlineStart: 0
      },
      [`${t}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: e.dotSize,
        display: "inline-block",
        transition: `transform ${e.motionDurationSlow} ease, opacity ${e.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: e.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        top: 0,
        insetInlineStart: 0
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: r(e.dotSize).sub(r(e.marginXXS).div(2)).div(2).equal(),
          height: r(e.dotSize).sub(r(e.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: antSpinMove,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: antRotate,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((i) => `${i} ${e.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: e.colorFillSecondary
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        fontSize: e.dotSizeSM
      },
      [`&-sm ${t}-dot-holder`]: {
        i: {
          width: r(r(e.dotSizeSM).sub(r(e.marginXXS).div(2))).div(2).equal(),
          height: r(r(e.dotSizeSM).sub(r(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        fontSize: e.dotSizeLG
      },
      [`&-lg ${t}-dot-holder`]: {
        i: {
          width: r(r(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: r(r(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, prepareComponentToken = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: r
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: r
  };
};
style.prepareComponentToken = prepareComponentToken;
style.default = (0, _internal.genStyleHooks)("Spin", (e) => {
  const t = (0, _internal.mergeToken)(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [genSpinStyle(t)];
}, prepareComponentToken);
var usePercent$1 = {}, _interopRequireWildcard$1 = interopRequireWildcardExports.default;
Object.defineProperty(usePercent$1, "__esModule", {
  value: !0
});
usePercent$1.default = usePercent;
var React$1 = _interopRequireWildcard$1(React__default);
const AUTO_INTERVAL = 200, STEP_BUCKETS = [[30, 0.05], [70, 0.03], [96, 0.01]];
function usePercent(e, t) {
  const [r, i] = React$1.useState(0), n = React$1.useRef(), a = t === "auto";
  return React$1.useEffect(() => (a && e && (i(0), n.current = setInterval(() => {
    i((s) => {
      const l = 100 - s;
      for (let o = 0; o < STEP_BUCKETS.length; o += 1) {
        const [c, f] = STEP_BUCKETS[o];
        if (s <= c)
          return s + l * f;
      }
      return s;
    });
  }, AUTO_INTERVAL)), () => {
    clearInterval(n.current);
  }), [a, e]), a ? r : t;
}
var _interopRequireDefault = interopRequireDefaultExports.default, _interopRequireWildcard = interopRequireWildcardExports.default;
Object.defineProperty(spin, "__esModule", {
  value: !0
});
var default_1 = spin.default = void 0, React = _interopRequireWildcard(React__default), _classnames = _interopRequireDefault(classnamesExports), _throttleDebounce = cjs, _warning = warning$1, _configProvider = configProvider, _Indicator = _interopRequireDefault(Indicator$1), _index = _interopRequireDefault(style), _usePercent = _interopRequireDefault(usePercent$1), __rest = function(e, t) {
  var r = {};
  for (var i in e)
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
  return r;
};
let defaultIndicator;
function shouldDelay(e, t) {
  return !!e && !!t && !isNaN(Number(t));
}
const Spin = (e) => {
  const {
    prefixCls: t,
    spinning: r = !0,
    delay: i = 0,
    className: n,
    rootClassName: a,
    size: s = "default",
    tip: l,
    wrapperClassName: o,
    style: c,
    children: f,
    fullscreen: x = !1,
    indicator: m,
    percent: A
  } = e, M = __rest(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]), {
    getPrefixCls: d
  } = React.useContext(_configProvider.ConfigContext), C = d("spin", t), [u, g, p] = (0, _index.default)(C), [y, E] = React.useState(() => r && !shouldDelay(r, i)), T = (0, _usePercent.default)(y, A);
  React.useEffect(() => {
    if (r) {
      const B = (0, _throttleDebounce.debounce)(i, () => {
        E(!0);
      });
      return B(), () => {
        var j;
        (j = B == null ? void 0 : B.cancel) === null || j === void 0 || j.call(B);
      };
    }
    E(!1);
  }, [i, r]);
  const Z = React.useMemo(() => typeof f < "u" && !x, [f, x]);
  if (process.env.NODE_ENV !== "production") {
    const B = (0, _warning.devUseWarning)("Spin");
    process.env.NODE_ENV !== "production" && B(!l || Z || x, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const {
    direction: G,
    spin: I
  } = React.useContext(_configProvider.ConfigContext), V = (0, _classnames.default)(C, I == null ? void 0 : I.className, {
    [`${C}-sm`]: s === "small",
    [`${C}-lg`]: s === "large",
    [`${C}-spinning`]: y,
    [`${C}-show-text`]: !!l,
    [`${C}-rtl`]: G === "rtl"
  }, n, !x && a, g, p), Y = (0, _classnames.default)(`${C}-container`, {
    [`${C}-blur`]: y
  }), D = Object.assign(Object.assign({}, I == null ? void 0 : I.style), c), R = /* @__PURE__ */ React.createElement("div", Object.assign({}, M, {
    style: D,
    className: V,
    "aria-live": "polite",
    "aria-busy": y
  }), /* @__PURE__ */ React.createElement(_Indicator.default, {
    prefixCls: C,
    indicator: m ?? defaultIndicator,
    percent: T
  }), l && (Z || x) ? /* @__PURE__ */ React.createElement("div", {
    className: `${C}-text`
  }, l) : null);
  return u(Z ? /* @__PURE__ */ React.createElement("div", Object.assign({}, M, {
    className: (0, _classnames.default)(`${C}-nested-loading`, o, g, p)
  }), y && /* @__PURE__ */ React.createElement("div", {
    key: "loading"
  }, R), /* @__PURE__ */ React.createElement("div", {
    className: Y,
    key: "container"
  }, f)) : x ? /* @__PURE__ */ React.createElement("div", {
    className: (0, _classnames.default)(`${C}-fullscreen`, {
      [`${C}-fullscreen-show`]: y
    }, a, g, p)
  }, R) : R);
};
Spin.setDefaultIndicator = (e) => {
  defaultIndicator = e;
};
process.env.NODE_ENV !== "production" && (Spin.displayName = "Spin");
default_1 = spin.default = Spin;
const FB = ({ color: e = "black" }) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M22.0591 12.0069C22.0591 6.44957 17.5548 1.94531 11.9983 1.94531C6.44175 1.94531 1.9375 6.44957 1.9375 12.0069C1.9375 17.0277 5.6167 21.1899 10.4262 21.9445V14.9148H7.87218V12.0061H10.4262V9.79003C10.4262 7.26791 11.9287 5.87522 14.2261 5.87522C15.327 5.87522 16.4782 6.07142 16.4782 6.07142V8.54742H15.2105C13.9611 8.54742 13.5713 9.323 13.5713 10.1187V12.0069H16.3617L15.9156 14.9156H13.5713V21.9453C18.3807 21.1907 22.0599 17.0285 22.0599 12.0069H22.0591Z", fill: e }) }), X = ({ color: e = "white" }) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M3.27396 3.4248H9.19353L13.3972 9.14878L18.4982 3.4248H20.3627L14.2392 10.2947L21.7901 20.5758H15.872L10.9939 13.9348L5.0743 20.5758H3.20987L10.152 12.7889L3.27396 3.4248ZM6.12887 4.85405L16.6498 19.1465H18.9352L8.41426 4.85405H6.12887Z", fill: e }) }), Google = ({ color: e }) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "24", height: "24", viewBox: "0 0 25 25", fill: e, xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21.8882 11.0358L21.7904 10.6292H12.7794V14.3708H18.1627C17.6039 16.9748 15.01 18.3453 12.8912 18.3453C11.3498 18.3453 9.72451 17.7103 8.64877 16.6869C7.5451 15.6362 6.84191 14.0875 6.84191 12.4931C6.84191 10.917 7.56373 9.34095 8.61618 8.30392C9.66397 7.27146 11.252 6.6867 12.8306 6.6867C14.6375 6.6867 15.9321 7.6278 16.4164 8.05723L19.1267 5.41212C18.3304 4.72686 16.1463 3 12.7422 3C10.1157 3 7.59632 3.98678 5.75686 5.78673C3.94069 7.55927 3 10.1221 3 12.4977C3 14.8733 3.88946 17.3128 5.64976 19.0991C7.53113 21.0041 10.1949 22 12.9377 22C15.4338 22 17.7995 21.0406 19.4853 19.3001C21.1431 17.5869 22 15.2159 22 12.7307C22 11.6845 21.8929 11.0632 21.8882 11.0358Z", fill: e }) }), More = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M7.10156 12.5C7.10156 13.3284 6.42999 14 5.60156 14C4.77314 14 4.10156 13.3284 4.10156 12.5C4.10156 11.6716 4.77314 11 5.60156 11C6.42999 11 7.10156 11.6716 7.10156 12.5Z", fill: "#121212" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M13.5015 12.5C13.5015 13.3284 12.8299 14 12.0015 14C11.173 14 10.5015 13.3284 10.5015 12.5C10.5015 11.6716 11.173 11 12.0015 11C12.8299 11 13.5015 11.6716 13.5015 12.5Z", fill: "#121212" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M18.4014 14C19.2298 14 19.9014 13.3284 19.9014 12.5C19.9014 11.6716 19.2298 11 18.4014 11C17.5729 11 16.9014 11.6716 16.9014 12.5C16.9014 13.3284 17.5729 14 18.4014 14Z", fill: "#121212" })
] }), BossjobLogo = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "46", height: "47", viewBox: "0 0 46 47", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { y: "0.5", width: "45.723", height: "45.723", rx: "10.451", fill: "#1C70EE" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M9.20312 21.745C9.20312 22.8181 9.98939 23.6121 11.073 23.6121C11.3201 23.6181 11.566 23.5739 11.7956 23.4822C12.0251 23.3905 12.2337 23.2532 12.4085 23.0786C12.5834 22.904 12.7209 22.6958 12.8127 22.4666C12.9046 22.2373 12.9488 21.9918 12.9428 21.745C12.9428 20.6246 12.1368 19.8779 11.073 19.8779C9.98939 19.8779 9.20312 20.6246 9.20312 21.745Z", fill: "#FFC53D" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M21.1015 18.4552C23.3403 18.4552 24.6907 16.8116 24.6907 14.8998C24.6907 12.988 23.3385 11.3686 21.1015 11.3686C18.8645 11.3686 17.5373 12.9871 17.5373 14.8998C17.5373 16.8125 18.8896 18.4552 21.1015 18.4552ZM21.1015 16.8608C19.9955 16.8608 19.3812 15.9541 19.3812 14.8998C19.3812 13.8456 19.9955 12.938 21.1015 12.938C22.2325 12.938 22.8468 13.8456 22.8468 14.8998C22.8468 15.9541 22.2325 16.8599 21.1015 16.8599V16.8608ZM28.8333 18.4552C30.7014 18.4552 31.7832 17.5476 31.7832 16.2975C31.7832 13.5755 27.7534 14.4089 27.7534 13.4289C27.7534 13.0605 28.1707 12.7663 28.8101 12.7663C29.6456 12.7663 30.4086 13.1347 30.8259 13.5514L31.5423 12.2995C30.7628 11.689 29.7989 11.3608 28.8083 11.3686C27.0172 11.3686 26.0322 12.3523 26.0322 13.5022C26.0322 16.1499 30.0396 15.2432 30.0396 16.3458C30.0396 16.7633 29.6707 17.0611 28.9086 17.0611C28.0731 17.0611 27.0647 16.5952 26.5731 16.1294L25.8092 17.3964C26.5471 18.0626 27.6781 18.4552 28.8333 18.4552ZM35.9329 18.4552C37.8009 18.4552 38.8827 17.5476 38.8827 16.2975C38.8827 13.5755 34.8529 14.4089 34.8529 13.4289C34.8529 13.0605 35.2711 12.7663 35.9105 12.7663C36.746 12.7663 37.5081 13.1347 37.9254 13.5514L38.6418 12.2995C37.8638 11.6899 36.902 11.3615 35.9132 11.3677C34.1176 11.3677 33.1371 12.3514 33.1371 13.5013C33.1371 16.149 37.1436 15.2423 37.1436 16.3449C37.1436 16.7624 36.7746 17.0602 36.0126 17.0602C35.177 17.0602 34.1687 16.5943 33.6771 16.1285L32.9096 17.3964C33.6224 18.0626 34.7526 18.4552 35.9329 18.4552Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.55469 8.31445H11.3545V11.412H12.6468C13.1109 11.412 13.5706 11.5033 13.9994 11.6807C14.4283 11.858 14.818 12.118 15.1462 12.4458C15.4744 12.7735 15.7348 13.1626 15.9124 13.5908C16.0901 14.0191 16.1815 14.478 16.1815 14.9415C16.1815 15.8776 15.8091 16.7754 15.1462 17.4373C14.4833 18.0992 13.5842 18.4711 12.6468 18.4711H9.55469V8.31445ZM11.354 16.3626V16.9097H12.3814L12.3808 16.9086C12.6435 16.9087 12.9037 16.8571 13.1464 16.7567C13.3891 16.6564 13.6096 16.5093 13.7954 16.3238C13.9811 16.1383 14.1285 15.9181 14.229 15.6757C14.3295 15.4334 14.3812 15.1736 14.3811 14.9113C14.3811 14.3816 14.1703 13.8735 13.7952 13.499C13.4201 13.1244 12.9113 12.914 12.3808 12.914H11.3545V16.3626H11.354Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8.73468 38.4099C7.7983 38.4099 7.16671 38.2566 6.6875 38.0812L7.25392 35.6936C7.57579 35.807 7.91423 35.8663 8.25547 35.869C9.30018 35.869 9.60588 35.1683 9.60588 33.789V24.9559H12.807V33.7046C12.807 36.3318 11.8045 38.4099 8.73468 38.4099Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20.2742 36.8252C24.0913 36.8252 26.3983 34.0171 26.3983 30.7489C26.3983 27.4806 24.0895 24.7138 20.2742 24.7138C16.4589 24.7138 14.1905 27.4825 14.1905 30.7489C14.1905 34.0152 16.4975 36.8252 20.2742 36.8252ZM20.2742 34.1006C18.3858 34.1006 17.3365 32.5506 17.3365 30.7479C17.3365 28.9453 18.3849 27.3952 20.2742 27.3952C22.202 27.3952 23.2523 28.9462 23.2523 30.7479C23.2523 32.5496 22.202 34.1006 20.2742 34.1006Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M27.7872 19.835H30.7882V25.0086H32.9428C33.7168 25.0086 34.4832 25.1611 35.1982 25.4574C35.9133 25.7537 36.563 26.1879 37.1103 26.7354C37.6575 27.2828 38.0917 27.9327 38.3878 28.648C38.684 29.3633 38.8365 30.1299 38.8365 30.9041C38.8365 32.4677 38.2155 33.9672 37.1103 35.0728C36.005 36.1785 34.5059 36.7996 32.9428 36.7996H27.7872V19.835ZM30.7873 33.2779V34.1916H32.5003L32.4994 34.1898C32.9374 34.1899 33.3711 34.1037 33.7758 33.9361C34.1805 33.7685 34.5483 33.5227 34.858 33.2129C35.1677 32.9031 35.4134 32.5353 35.5809 32.1305C35.7485 31.7256 35.8347 31.2918 35.8346 30.8536C35.8346 29.9688 35.4832 29.1202 34.8577 28.4946C34.2322 27.8689 33.3839 27.5174 32.4994 27.5174H30.7882V33.2779H30.7873Z", fill: "white" })
] }), AppleColor = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "21", height: "25", viewBox: "0 0 21 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M20.7806 17.8424C20.3988 19.0662 19.7967 20.2899 18.9743 21.5137C17.7114 23.4326 16.4534 24.392 15.2003 24.392C14.7205 24.392 14.0352 24.2354 13.1443 23.9221C12.3024 23.6088 11.5632 23.4521 10.9269 23.4521C10.3297 23.4521 9.63459 23.6137 8.84159 23.9368C8.0486 24.2696 7.40245 24.4361 6.90316 24.4361C5.41506 24.4361 3.94166 23.1682 2.48293 20.6326C1.04379 18.0774 0.324219 15.6152 0.324219 13.246C0.324219 11.0138 0.877359 9.1831 1.98364 7.75375C3.08992 6.34397 4.48011 5.63909 6.15422 5.63909C6.8591 5.63909 7.72552 5.78594 8.75348 6.07964C9.77165 6.37334 10.4472 6.5202 10.78 6.5202C11.2206 6.5202 11.9206 6.35376 12.88 6.0209C13.8786 5.68804 14.7254 5.52161 15.4205 5.52161C16.5856 5.52161 17.6282 5.83979 18.5485 6.47614C19.0576 6.82858 19.5666 7.31809 20.0757 7.94465C19.3023 8.60059 18.7443 9.1782 18.4016 9.6775C17.7653 10.5978 17.4471 11.611 17.4471 12.7173C17.4471 13.9313 17.7848 15.0229 18.4604 15.9921C19.1359 16.9613 19.9093 17.5781 20.7806 17.8424ZM15.259 0.616775C15.259 1.21397 15.117 1.8797 14.8331 2.61395C14.5394 3.34821 14.0842 4.02372 13.4674 4.6405C12.9387 5.16916 12.4101 5.52161 11.8814 5.69783C11.5192 5.80552 11.0101 5.88874 10.3542 5.94748C10.3835 4.48875 10.7653 3.23073 11.4996 2.1734C12.2241 1.12586 13.4478 0.401393 15.1709 0C15.1807 0.0293703 15.1929 0.0832157 15.2076 0.161536C15.2223 0.239857 15.2345 0.293703 15.2443 0.323073C15.2443 0.362233 15.2468 0.411184 15.2517 0.469924C15.2565 0.528665 15.259 0.577615 15.259 0.616775Z", fill: "black" }) }), GoogleColor = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "20", height: "22", viewBox: "0 0 20 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M0.401651 0.335532C0.147235 0.595198 0 0.999475 0 1.52303V20.1979C0 20.7214 0.147235 21.1257 0.401651 21.3854L0.464443 21.4424L11.1975 10.9818V10.7348L0.464443 0.274311L0.401651 0.335532Z", fill: "url(#paint0_linear_3056_64139)" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M14.7729 14.4697L11.1992 10.9811V10.7341L14.7773 7.24552L14.8574 7.29091L19.0948 9.64162C20.304 10.3087 20.304 11.4065 19.0948 12.0778L14.8574 14.4243L14.7729 14.4697Z", fill: "url(#paint1_linear_3056_64139)" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M14.8564 14.4247L11.1982 10.858L0.402344 21.3851C0.803995 21.7967 1.45898 21.8463 2.20382 21.4347L14.8564 14.4247Z", fill: "url(#paint2_linear_3056_64139)" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M14.8564 7.29168L2.20382 0.281753C1.45898 -0.12569 0.803995 -0.0760808 0.402344 0.335586L11.1982 10.8584L14.8564 7.29168Z", fill: "url(#paint3_linear_3056_64139)" }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint0_linear_3056_64139", x1: "10.2446", y1: "20.3924", x2: "-3.92268", y2: "5.86187", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#00A0FF" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.0066", stopColor: "#00A1FF" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.2601", stopColor: "#00BEFF" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.5122", stopColor: "#00D2FF" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.7604", stopColor: "#00DFFF" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#00E3FF" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint1_linear_3056_64139", x1: "20.6694", y1: "10.8564", x2: "-0.287368", y2: "10.8564", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FFE000" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.4087", stopColor: "#FFBD00" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.7754", stopColor: "#FFA500" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#FF9C00" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint2_linear_3056_64139", x1: "12.8672", y1: "8.91909", x2: "-6.34474", y2: "-10.7854", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#FF3A44" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#C31162" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id: "paint3_linear_3056_64139", x1: "-2.3152", y1: "27.5985", x2: "6.26378", y2: "18.7996", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { stopColor: "#32A071" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.0685", stopColor: "#2DA771" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.4762", stopColor: "#15CF74" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "0.8009", stopColor: "#06E775" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("stop", { offset: "1", stopColor: "#00F076" })
    ] })
  ] })
] }), Refresh = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M16 6.66667C18.5777 6.66667 20.9092 7.70989 22.5997 9.40035C23.0645 9.86516 23.8245 10.6902 24.4854 11.4189C24.812 11.7791 25.1084 12.109 25.3232 12.3489C25.4306 12.4689 25.5174 12.5662 25.5773 12.6334L25.6697 12.7372C26.1586 13.2878 26.116 12.489 26.6667 12C27.2173 11.511 28.1521 11.5166 27.6632 10.966L27.5681 10.8592C27.5071 10.7907 27.4189 10.6919 27.3101 10.5704C27.0926 10.3274 26.7922 9.99298 26.4606 9.6274C25.805 8.90453 25.003 8.03245 24.4853 7.51474C22.3152 5.34461 19.3134 4 16 4C9.3726 4 4 9.3726 4 16C4 22.6274 9.3726 28 16 28C19.3134 28 22.3152 26.6554 24.4853 24.4853L25.4281 23.5424L23.5424 21.6568L22.5996 22.5997C20.9092 24.2901 18.5777 25.3333 16 25.3333C10.8454 25.3333 6.66667 21.1546 6.66667 16C6.66667 10.8454 10.8454 6.66667 16 6.66667Z", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M26.6667 5.18522C27.403 5.18522 28 5.78218 28 6.51855V11.8519C28 12.5883 27.403 13.1852 26.6667 13.1852H21.3333C20.597 13.1852 20 12.5883 20 11.8519C20 11.1155 20.597 10.5186 21.3333 10.5186H25.3333V6.51855C25.3333 5.78218 25.9303 5.18522 26.6667 5.18522Z", fill: "white" })
] }), Line = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M18.5853 10.089C18.731 10.0948 18.8688 10.1568 18.9698 10.2619C19.0708 10.367 19.1272 10.5071 19.1272 10.6529C19.1272 10.7987 19.0708 10.9388 18.9698 11.044C18.8688 11.1491 18.731 11.211 18.5853 11.2168H17.0157V12.223H18.5853C18.6612 12.22 18.7368 12.2323 18.8078 12.2592C18.8787 12.2862 18.9435 12.3272 18.9982 12.3797C19.0529 12.4323 19.0964 12.4954 19.1262 12.5652C19.1559 12.635 19.1712 12.7101 19.1712 12.786C19.1712 12.8619 19.1559 12.937 19.1262 13.0068C19.0964 13.0766 19.0529 13.1397 18.9982 13.1923C18.9435 13.2449 18.8787 13.2859 18.8078 13.3128C18.7368 13.3397 18.6612 13.3521 18.5853 13.349H16.4513C16.3026 13.3481 16.1602 13.2885 16.0552 13.1831C15.9502 13.0778 15.891 12.9352 15.8906 12.7865V8.51936C15.8906 8.2108 16.1428 7.9559 16.454 7.9559H18.588C18.7375 7.95626 18.8806 8.01596 18.9861 8.12188C19.0915 8.22781 19.1505 8.37127 19.1501 8.5207C19.1498 8.67014 19.0901 8.81332 18.9842 8.91874C18.8782 9.02416 18.7348 9.08318 18.5853 9.08282H17.0157V10.089H18.5853ZM15.1375 12.7865C15.1368 12.9356 15.077 13.0784 14.9712 13.1835C14.8654 13.2886 14.7223 13.3475 14.5731 13.3472C14.4848 13.3492 14.3972 13.3299 14.3179 13.2909C14.2385 13.252 14.1696 13.1947 14.117 13.1236L11.932 10.157V12.7865C11.9222 12.9288 11.8587 13.0622 11.7544 13.1595C11.65 13.2569 11.5126 13.3111 11.3699 13.3111C11.2272 13.3111 11.0898 13.2569 10.9855 13.1595C10.8811 13.0622 10.8176 12.9288 10.8078 12.7865V8.51936C10.8076 8.37094 10.8662 8.22848 10.9708 8.1232C11.0754 8.01792 11.2175 7.9584 11.3659 7.95769C11.5403 7.95769 11.7013 8.05071 11.8086 8.18486L14.0106 11.1632V8.51936C14.0106 8.2108 14.2628 7.9559 14.574 7.9559C14.8826 7.9559 15.1375 8.2108 15.1375 8.51936V12.7865ZM10.0028 12.7865C10.0021 12.9358 9.9424 13.0787 9.83666 13.1841C9.73093 13.2895 9.58779 13.3488 9.43849 13.349C9.28975 13.3481 9.14739 13.2885 9.04237 13.1831C8.93736 13.0778 8.87818 12.9352 8.87771 12.7865V8.51936C8.87771 8.2108 9.12993 7.9559 9.44118 7.9559C9.75063 7.9559 10.0028 8.2108 10.0028 8.51936V12.7865ZM7.7973 13.349H5.6633C5.51431 13.3481 5.37167 13.2886 5.26623 13.1833C5.16078 13.078 5.10101 12.9355 5.09984 12.7865V8.51936C5.09984 8.2108 5.35474 7.9559 5.6633 7.9559C5.97455 7.9559 6.22676 8.2108 6.22676 8.51936V12.223H7.7973C7.94274 12.2288 8.08029 12.2907 8.18114 12.3956C8.28199 12.5006 8.33832 12.6405 8.33832 12.786C8.33832 12.9316 8.28199 13.0715 8.18114 13.1764C8.08029 13.2814 7.94274 13.3432 7.7973 13.349ZM22.7308 10.4924C22.7308 5.68864 17.9146 1.7793 11.9982 1.7793C6.08187 1.7793 1.26562 5.68864 1.26562 10.4924C1.26562 14.7952 5.08464 18.4005 10.2408 19.0856C10.5905 19.1589 11.0663 19.3163 11.187 19.6133C11.2943 19.8825 11.2577 20.2984 11.221 20.5792L11.0743 21.4915C11.0341 21.7607 10.8597 22.5522 12.0125 22.0684C13.1672 21.5863 18.1981 18.4211 20.4519 15.83C21.9938 14.1406 22.7308 12.4099 22.7308 10.4924Z", fill: "black" }) }), Email = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.9144 5.43634C20.2721 5.1004 20.0343 4.5 19.5436 4.5H4.44289C3.95427 4.5 3.71551 5.09604 4.069 5.43337L11.0644 12.1091C11.5499 12.5724 12.3128 12.5754 12.8019 12.116L19.9144 5.43634ZM4.0415 7.00657C3.6383 6.62699 2.97656 6.91285 2.97656 7.46661V17.6948C2.97656 18.6918 3.7848 19.5 4.7818 19.5H19.2202C20.2172 19.5 21.0254 18.6918 21.0254 17.6948V7.46661C21.0254 6.91285 20.3637 6.62699 19.9605 7.00657L13.2384 13.335C12.5433 13.9895 11.4587 13.9895 10.7636 13.335L4.0415 7.00657Z", fill: "black" }) }), EmailBlack = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M5.2 5H18.8C19.735 5 20.5 5.7875 20.5 6.75V17.25C20.5 18.2125 19.735 19 18.8 19H5.2C4.265 19 3.5 18.2125 3.5 17.25V6.75C3.5 5.7875 4.265 5 5.2 5Z", stroke: "#121212", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M20.5 6.75L12 12.875L3.5 6.75", stroke: "#121212", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Phone = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "25", height: "25", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M8.64525 12.562C9.45205 14.2281 10.7993 15.5718 12.4674 16.3743C12.5905 16.4326 12.7266 16.4578 12.8624 16.4475C12.9981 16.4372 13.1288 16.3917 13.2417 16.3155L15.6918 14.6789C15.8001 14.6054 15.9251 14.5606 16.0554 14.5486C16.1856 14.5367 16.3168 14.5578 16.4366 14.6103L21.0233 16.5802C21.18 16.6454 21.311 16.7604 21.396 16.9074C21.481 17.0543 21.5153 17.2252 21.4937 17.3936C21.3483 18.5282 20.7945 19.571 19.9358 20.3269C19.0772 21.0827 17.9726 21.4997 16.8287 21.5C13.2937 21.5 9.90348 20.0957 7.40387 17.5961C4.90427 15.0965 3.5 11.7063 3.5 8.17134C3.50026 7.02743 3.91732 5.9228 4.67314 5.06415C5.42897 4.20551 6.47176 3.65168 7.6064 3.50631C7.77481 3.48468 7.94566 3.51901 8.09265 3.60401C8.23963 3.68901 8.3546 3.81998 8.41984 3.97673L10.3897 8.57316C10.441 8.69111 10.4624 8.81984 10.4521 8.94802C10.4419 9.0762 10.4003 9.1999 10.3309 9.3082L8.69426 11.7975C8.62139 11.9101 8.57862 12.0395 8.57004 12.1733C8.56147 12.3072 8.58736 12.441 8.64525 12.562Z", fill: "black" }) }), Apple = () => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M13.2715 6.34615C14.2826 6.34615 15.5501 5.70534 16.3049 4.85092C16.9884 4.0766 17.4869 2.99523 17.4869 1.91386C17.4869 1.76701 17.4726 1.62015 17.4441 1.5C16.3191 1.54005 14.9662 2.20757 14.1545 3.10203C13.5136 3.7829 12.9297 4.85092 12.9297 5.94564C12.9297 6.10585 12.9582 6.26605 12.9725 6.31945C13.0437 6.3328 13.1576 6.34615 13.2715 6.34615ZM9.71128 22.5C11.0927 22.5 11.705 21.6322 13.4282 21.6322C15.1798 21.6322 15.5643 22.4733 17.1024 22.4733C18.6119 22.4733 19.623 21.165 20.5772 19.8833C21.6452 18.4148 22.0867 16.973 22.1152 16.9062C22.0155 16.8795 19.1246 15.7715 19.1246 12.6608C19.1246 9.96408 21.4031 8.7492 21.5313 8.65575C20.0218 6.62651 17.729 6.57311 17.1024 6.57311C15.4077 6.57311 14.0263 7.53433 13.1576 7.53433C12.2177 7.53433 10.9787 6.62651 9.51191 6.62651C6.72068 6.62651 3.88672 8.78925 3.88672 12.8744C3.88672 15.411 4.94055 18.0944 6.23648 19.8299C7.34728 21.2985 8.31567 22.5 9.71128 22.5Z", fill: "black" }) }), switchLoginType$1 = new BroadcastChannel("SWITCH_LOGIN_TYPE"), antIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOutlined$1, { style: { fontSize: 24 }, spin: !0 }), appLinkUrl = "http://bossjob.com/app";
function guid() {
  return "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
    const t = Math.random() * 16 | 0;
    return (e == "x" ? t : t & 3 | 8).toString(16);
  });
}
let timer = null;
const QrCode = (e, t) => {
  var N;
  const { lang: r, open: i } = e, { getStarted: n } = r, [a, s] = useState(""), [l, o] = useState({}), [c, f] = useState(!1), [x, m] = useState(null), A = useRef(null), M = useRef(null), { sendEventWithLoginData: d, defaultLoginCallBack: C } = useGetStarted(), {
    scannedSuccessfully: u,
    pleaseConfirmLoginOnAPP: g,
    pleaseRefreshQrCode: p,
    // clickToRefresh,
    accountMismatch: y,
    loginWithQRCode: E,
    welcomeBack: T
  } = n, Z = ((N = window == null ? void 0 : window.location) == null ? void 0 : N.pathname) || "", G = useRef(1);
  useEffect(() => {
    if (!i)
      return;
    const z = (getCookie("loginType") || "jobSeeker") === "recruiter" ? 2 : 1;
    G.current = z, switchLoginType$1.onmessage = (b) => {
      if (b.message.type === "SWITCH_LOGIN_TYPE") {
        const S = b.message.data === "recruiter" ? 2 : 1;
        G.current = S;
      }
    };
  }, [i, Z]);
  const { openNotification: I } = useNotificationContext();
  useImperativeHandle(
    t,
    () => ({
      getQrCodeFun: D
    }),
    []
  ), useEffect(() => (i || (clearInterval(timer), o(null), m(null)), () => clearInterval(timer)), [i]), useEffect(() => {
    x != null && x.status && (x.token = x.access_token, V(x));
  }, [x]);
  const V = (P) => {
    fetchUserService().then((z) => {
      const b = { ...(z == null ? void 0 : z.data) || {}, ...P };
      setCookiesWithLoginData(b), d(b), setTimeout(() => {
        C(b);
      }, 200);
    });
  }, Y = () => {
    timer && clearInterval(timer), timer = setInterval(() => {
      R(), (/* @__PURE__ */ new Date()).getTime() > new Date(M.current).getTime() && (clearInterval(timer), f(!0));
    }, 1500);
  }, D = () => {
    clearInterval(timer);
    const P = guid();
    A.current = P, M.current = dayjs(/* @__PURE__ */ new Date()).add(3, "minute").format("YYYY-MM-DD HH:mm:ss");
    const z = {
      generate_uuid: P,
      expiration_time: M.current
    };
    getQrCode(z).then(() => {
      s(
        JSON.stringify({
          qrcode_uuid: P,
          // source: 'web',
          status_id: 1,
          qr_expired_at: M.current,
          website_login: "app_scan_code"
        })
      ), Y();
    });
  }, R = () => {
    qrCodePolling({
      qrcode_uuid: A.current,
      role: G.current
    }).then((P) => {
      const { status: z, role_id: b } = P.data;
      if (z === 2) {
        if (b !== G.current) {
          I({
            type: "error",
            message: null,
            description: y
          }), B();
          return;
        }
        o(P.data);
      } else if (z === 4)
        if (clearInterval(timer), G.current == 2) {
          const k = linkToHunt({
            sessionid: P.data.session,
            sessionType: "recruiter"
          });
          window.location.replace(k);
        } else
          m(P.data);
      else
        z === 3 && B();
    });
  }, B = () => {
    clearInterval(timer), o({}), D();
  }, j = () => {
    D(), f(!1);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: l != null && l.avatar ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.userScanned, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: l.avatar, className: styles$3.userScannedAvatar }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.scannedHeader, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: styles$3.scannedTitle, children: T }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: styles$3.scannedName, title: l.first_name + " " + l.last_name, children: [
        l.first_name,
        " ",
        l.last_name
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.scannedSuccessful, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessIcon, {}),
      u
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.scannedInfo, children: g })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.codeTitle, children: [
      " ",
      E
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.codeTitleSed, children: n.loginWithQRCodeTip }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.qrCode, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.qrCodeBox, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.qrPollingCode, children: a ? /* @__PURE__ */ jsxRuntimeExports.jsx(QrCodeDraw, { text: a }) : null }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.circle, children: /* @__PURE__ */ jsxRuntimeExports.jsx(default_1, { indicator: antIcon }) })
      ] }),
      c && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.overTime, onClick: () => j(), children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: p }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Refresh, {})
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.QRHelpWrapper, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Popover$1,
        {
          style: { left: 100 },
          overlayClassName: styles$3.overlayAntStyle,
          placement: "right",
          trigger: ["click", "hover"],
          zIndex: 99999,
          content: /* @__PURE__ */ jsxRuntimeExports.jsx(HowToScan, { getStarted: n }),
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: styles$3.QRHelp, children: [
            n.howToScanQRCode,
            " ?"
          ] })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Popover$1,
        {
          overlayClassName: styles$3.overlayAntStyle,
          placement: "right",
          trigger: ["click", "hover"],
          zIndex: 99999,
          content: /* @__PURE__ */ jsxRuntimeExports.jsx(DownApp, { getStarted: n }),
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: styles$3.QRHelp, children: [
            n.notHaveTheApp,
            " ?"
          ] })
        }
      )
    ] })
  ] }) });
}, SuccessIcon = (e) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: "M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5ZM11.8291 16.1658C11.6428 16.3747 11.3775 16.4959 11.0976 16.5001C10.8177 16.5042 10.5489 16.3908 10.3565 16.1875L6.90527 12.5405L8.35794 11.1658L11.061 14.0222L15.9339 8.55865L17.4265 9.88988L11.8291 16.1658Z",
        fill: "#2A9F47"
      }
    )
  }
), DownApp = ({ getStarted: e }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { padding: "16px" }, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.qrDownAppText, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: e == null ? void 0 : e.downloadApp }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.qrDownAppImg, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(QrCodeDraw, { width: 104, height: 104, alt: "app down", text: appLinkUrl }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.rightButtons, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.buttonWrapper, onClick: () => {
        window.open(appLinkUrl);
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.icon, children: /* @__PURE__ */ jsxRuntimeExports.jsx(GoogleColor, {}) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.textWrapper, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.label, children: "Get it on" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.title, children: "Google Play" })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.buttonWrapper, onClick: () => {
        window.open(appLinkUrl);
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.icon, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AppleColor, {}) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.textWrapper, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.label, children: "Download on the" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.title, children: "Apple Store" })
        ] })
      ] })
    ] })
  ] })
] }), HowToScan = ({ getStarted: e }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.howToScanWrapper, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.howToScanTitle, children: e == null ? void 0 : e.menuLoginToVersion }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.howToScanImg, children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: scannedImg, alt: "" }) })
] }), QrCodeComponent = forwardRef(QrCode), Computer = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "86", height: "44", viewBox: "0 0 86 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1", y: "-1", width: "84", height: "42", rx: "11", transform: "matrix(1 0 0 -1 0 42)", fill: "#F8F9FA" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1", y: "-1", width: "84", height: "42", rx: "11", transform: "matrix(1 0 0 -1 0 42)", stroke: "#F5F6F7", strokeWidth: "2" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.45 32.8594C27.8918 32.8594 28.25 32.5012 28.25 32.0594V31.6594C28.25 31.2175 27.8918 30.8594 27.45 30.8594H24.3594V28.6406H25.5625C28.3628 28.6406 29.7629 28.6406 30.8325 28.0957C31.7733 27.6163 32.5382 26.8514 33.0175 25.9106C33.5625 24.841 33.5625 23.4409 33.5625 20.6406V19.1406C33.5625 16.3404 33.5625 14.9402 33.0175 13.8707C32.5382 12.9299 31.7733 12.165 30.8325 11.6856C29.7629 11.1406 28.3628 11.1406 25.5625 11.1406H18.4375C15.6372 11.1406 14.2371 11.1406 13.1675 11.6856C12.2267 12.165 11.4618 12.9299 10.9825 13.8707C10.4375 14.9402 10.4375 16.3404 10.4375 19.1406V20.6406C10.4375 23.4409 10.4375 24.841 10.9825 25.9106C11.4618 26.8514 12.2267 27.6163 13.1675 28.0957C14.2371 28.6406 15.6372 28.6406 18.4375 28.6406H19.6406V30.8594H16.55C16.1082 30.8594 15.75 31.2175 15.75 31.6594V32.0594C15.75 32.5012 16.1082 32.8594 16.55 32.8594H27.45ZM25.5625 13.1406H18.4375C17.0044 13.1406 16.0498 13.1422 15.3164 13.2021C14.6063 13.2601 14.2814 13.3627 14.0755 13.4676C13.511 13.7552 13.0521 14.2142 12.7645 14.7787C12.6596 14.9845 12.557 15.3094 12.499 16.0195C12.4391 16.7529 12.4375 17.7075 12.4375 19.1406V20.6406C12.4375 22.0738 12.4391 23.0283 12.499 23.7618C12.557 24.4718 12.6596 24.7968 12.7645 25.0026C13.0521 25.5671 13.511 26.026 14.0755 26.3136C14.2814 26.4185 14.6063 26.5211 15.3164 26.5791C16.0498 26.6391 17.0044 26.6406 18.4375 26.6406H25.5625C26.9956 26.6406 27.9502 26.6391 28.6836 26.5791C29.3937 26.5211 29.7186 26.4185 29.9245 26.3136C30.489 26.026 30.9479 25.5671 31.2355 25.0026C31.3404 24.7968 31.443 24.4718 31.501 23.7618C31.5609 23.0283 31.5625 22.0738 31.5625 20.6406V19.1406C31.5625 17.7075 31.5609 16.7529 31.501 16.0195C31.443 15.3094 31.3404 14.9845 31.2355 14.7787C30.9479 14.2142 30.489 13.7552 29.9245 13.4676C29.7186 13.3627 29.3937 13.2601 28.6836 13.2021C27.9502 13.1422 26.9956 13.1406 25.5625 13.1406Z", fill: "#C3C7CB" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "44", y: "2", width: "40", height: "40", rx: "10", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M57.4128 19.2812C57.523 19.2957 57.6862 19.3 58.4 19.3C59.1138 19.3 59.277 19.2957 59.3872 19.2812C60.3744 19.1512 61.1512 18.3744 61.2812 17.3872C61.2957 17.277 61.3 17.1138 61.3 16.4C61.3 15.6862 61.2957 15.523 61.2812 15.4128C61.1512 14.4256 60.3744 13.6488 59.3872 13.5188C59.277 13.5043 59.1138 13.5 58.4 13.5C57.6862 13.5 57.523 13.5043 57.4128 13.5188C56.4256 13.6488 55.6488 14.4256 55.5188 15.4128C55.5043 15.523 55.5 15.6862 55.5 16.4C55.5 17.1138 55.5043 17.277 55.5188 17.3872C55.6488 18.3744 56.4256 19.1512 57.4128 19.2812ZM53.5359 15.1518C53.5 15.4247 53.5 15.7498 53.5 16.4C53.5 17.0502 53.5 17.3753 53.5359 17.6482C53.7841 19.5329 55.2671 21.0159 57.1518 21.2641C57.4247 21.3 57.7498 21.3 58.4 21.3C59.0502 21.3 59.3753 21.3 59.6482 21.2641C61.5329 21.0159 63.0159 19.5329 63.2641 17.6482C63.3 17.3753 63.3 17.0502 63.3 16.4C63.3 15.7498 63.3 15.4247 63.2641 15.1518C63.0159 13.2671 61.5329 11.7841 59.6482 11.5359C59.3753 11.5 59.0502 11.5 58.4 11.5C57.7498 11.5 57.4247 11.5 57.1518 11.5359C55.2671 11.7841 53.7841 13.2671 53.5359 15.1518ZM57 16.4C57 16.0277 57 15.8416 57.0489 15.691C57.1479 15.3865 57.3865 15.1479 57.691 15.0489C57.8416 15 58.0277 15 58.4 15C58.7723 15 58.9584 15 59.109 15.0489C59.4135 15.1479 59.6521 15.3865 59.7511 15.691C59.8 15.8416 59.8 16.0277 59.8 16.4C59.8 16.7723 59.8 16.9584 59.7511 17.109C59.6521 17.4135 59.4135 17.6521 59.109 17.7511C58.9584 17.8 58.7723 17.8 58.4 17.8C58.0277 17.8 57.8416 17.8 57.691 17.7511C57.3865 17.6521 57.1479 17.4135 57.0489 17.109C57 16.9584 57 16.7723 57 16.4ZM57.0489 26.891C57 27.0416 57 27.2278 57 27.6C57 27.9723 57 28.1584 57.0489 28.309C57.1479 28.6135 57.3865 28.8522 57.691 28.9511C57.8416 29 58.0277 29 58.4 29C58.7723 29 58.9584 29 59.109 28.9511C59.4135 28.8522 59.6521 28.6135 59.7511 28.309C59.8 28.1584 59.8 27.9723 59.8 27.6C59.8 27.2278 59.8 27.0416 59.7511 26.891C59.6521 26.5866 59.4135 26.3479 59.109 26.249C58.9584 26.2 58.7723 26.2 58.4 26.2C58.0277 26.2 57.8416 26.2 57.691 26.249C57.3865 26.3479 57.1479 26.5866 57.0489 26.891ZM71.0008 25.0608C71 25.0804 71 25.1036 71 25.1501C71 25.1965 71 25.2197 71.0008 25.2393C71.0213 25.7608 71.4393 26.1788 71.9607 26.1993C71.9804 26.2001 72.0036 26.2001 72.05 26.2001C72.0964 26.2001 72.1196 26.2001 72.1393 26.1993C72.6607 26.1788 73.0787 25.7608 73.0992 25.2393C73.1 25.2197 73.1 25.1965 73.1 25.1501C73.1 25.1036 73.1 25.0804 73.0992 25.0608C73.0787 24.5393 72.6607 24.1213 72.1393 24.1008C72.1196 24.1001 72.0964 24.1001 72.05 24.1001C72.0036 24.1001 71.9804 24.1001 71.9607 24.1008C71.4393 24.1213 71.0213 24.5393 71.0008 25.0608ZM66.1001 25.1501C66.1001 25.1037 66.1001 25.0805 66.1009 25.0608C66.1214 24.5394 66.5394 24.1214 67.0608 24.1009C67.0805 24.1001 67.1037 24.1001 67.1501 24.1001C67.1965 24.1001 67.2197 24.1001 67.2394 24.1009C67.7608 24.1214 68.1788 24.5394 68.1993 25.0608C68.2001 25.0805 68.2001 25.1037 68.2001 25.1501C68.2001 25.1965 68.2001 25.2197 68.1993 25.2394C68.1788 25.7608 67.7608 26.1788 67.2394 26.1993C67.2197 26.2001 67.1965 26.2001 67.1501 26.2001C67.1037 26.2001 67.0805 26.2001 67.0608 26.1993C66.5394 26.1788 66.1214 25.7608 66.1009 25.2394C66.1001 25.2197 66.1001 25.1965 66.1001 25.1501ZM66.1001 30.05C66.1001 30.0036 66.1001 29.9804 66.1008 29.9607C66.1213 29.4393 66.5393 29.0213 67.0608 29.0008C67.0804 29 67.1036 29 67.1501 29C67.1965 29 67.2197 29 67.2393 29.0008C67.7608 29.0213 68.1788 29.4393 68.1993 29.9607C68.2001 29.9804 68.2001 30.0036 68.2001 30.05C68.2001 30.0964 68.2001 30.1196 68.1993 30.1393C68.1788 30.6607 67.7608 31.0787 67.2393 31.0992C67.2197 31.1 67.1965 31.1 67.1501 31.1C67.1036 31.1 67.0804 31.1 67.0608 31.0992C66.5393 31.0787 66.1213 30.6607 66.1008 30.1393C66.1001 30.1196 66.1001 30.0964 66.1001 30.05ZM68.55 27.6C68.55 27.5536 68.55 27.5303 68.5508 27.5107C68.5712 26.9893 68.9893 26.5712 69.5107 26.5508C69.5303 26.55 69.5536 26.55 69.6 26.55C69.6464 26.55 69.6696 26.55 69.6892 26.5508C70.2107 26.5712 70.6287 26.9893 70.6492 27.5107C70.65 27.5303 70.65 27.5536 70.65 27.6C70.65 27.6464 70.65 27.6696 70.6492 27.6892C70.6287 28.2107 70.2107 28.6287 69.6892 28.6492C69.6696 28.65 69.6464 28.65 69.6 28.65C69.5536 28.65 69.5303 28.65 69.5107 28.6492C68.9893 28.6287 68.5712 28.2107 68.5508 27.6892C68.55 27.6696 68.55 27.6464 68.55 27.6ZM71.0008 29.9607C71 29.9804 71 30.0036 71 30.05C71 30.0964 71 30.1196 71.0008 30.1393C71.0213 30.6607 71.4393 31.0787 71.9607 31.0992C71.9804 31.1 72.0036 31.1 72.05 31.1C72.0964 31.1 72.1196 31.1 72.1393 31.0992C72.6607 31.0787 73.0787 30.6607 73.0992 30.1393C73.1 30.1196 73.1 30.0964 73.1 30.05C73.1 30.0036 73.1 29.9804 73.0992 29.9607C73.0787 29.4393 72.6607 29.0213 72.1393 29.0008C72.1196 29 72.0964 29 72.05 29C72.0036 29 71.9804 29 71.9607 29.0008C71.4393 29.0213 71.0213 29.4393 71.0008 29.9607ZM68.249 15.691C68.2 15.8416 68.2 16.0277 68.2 16.4C68.2 16.7723 68.2 16.9584 68.249 17.109C68.3479 17.4135 68.5866 17.6521 68.891 17.7511C69.0416 17.8 69.2278 17.8 69.6 17.8C69.9723 17.8 70.1584 17.8 70.309 17.7511C70.6135 17.6521 70.8522 17.4135 70.9511 17.109C71 16.9584 71 16.7723 71 16.4C71 16.0277 71 15.8416 70.9511 15.691C70.8522 15.3865 70.6135 15.1479 70.309 15.0489C70.1584 15 69.9723 15 69.6 15C69.2278 15 69.0416 15 68.891 15.0489C68.5866 15.1479 68.3479 15.3865 68.249 15.691ZM57.4128 30.4812C57.523 30.4957 57.6862 30.5 58.4 30.5C59.1138 30.5 59.277 30.4957 59.3872 30.4812C60.3744 30.3512 61.1512 29.5744 61.2812 28.5872C61.2957 28.477 61.3 28.3138 61.3 27.6C61.3 26.8863 61.2957 26.7231 61.2812 26.6129C61.1512 25.6256 60.3744 24.8488 59.3872 24.7188C59.277 24.7043 59.1138 24.7 58.4 24.7C57.6862 24.7 57.523 24.7043 57.4128 24.7188C56.4256 24.8488 55.6488 25.6256 55.5188 26.6129C55.5043 26.7231 55.5 26.8863 55.5 27.6C55.5 28.3138 55.5043 28.477 55.5188 28.5872C55.6488 29.5744 56.4256 30.3512 57.4128 30.4812ZM53.5359 26.3518C53.5 26.6247 53.5 26.9498 53.5 27.6C53.5 28.2502 53.5 28.5753 53.5359 28.8482C53.7841 30.7329 55.2671 32.216 57.1518 32.4641C57.4247 32.5 57.7498 32.5 58.4 32.5C59.0502 32.5 59.3753 32.5 59.6482 32.4641C61.5329 32.216 63.0159 30.7329 63.2641 28.8482C63.3 28.5753 63.3 28.2502 63.3 27.6C63.3 26.9498 63.3 26.6247 63.2641 26.3518C63.0159 24.4671 61.5329 22.9841 59.6482 22.736C59.3753 22.7 59.0502 22.7 58.4 22.7C57.7498 22.7 57.4247 22.7 57.1518 22.736C55.2671 22.9841 53.7841 24.4671 53.5359 26.3518ZM69.6 19.3C68.8863 19.3 68.7231 19.2957 68.6129 19.2812C67.6256 19.1512 66.8488 18.3744 66.7188 17.3872C66.7043 17.277 66.7 17.1138 66.7 16.4C66.7 15.6862 66.7043 15.523 66.7188 15.4128C66.8488 14.4256 67.6256 13.6488 68.6129 13.5188C68.7231 13.5043 68.8863 13.5 69.6 13.5C70.3138 13.5 70.477 13.5043 70.5872 13.5188C71.5744 13.6488 72.3512 14.4256 72.4812 15.4128C72.4957 15.523 72.5 15.6862 72.5 16.4C72.5 17.1138 72.4957 17.277 72.4812 17.3872C72.3512 18.3744 71.5744 19.1512 70.5872 19.2812C70.477 19.2957 70.3138 19.3 69.6 19.3ZM64.7 16.4C64.7 15.7498 64.7 15.4247 64.736 15.1518C64.9841 13.2671 66.4671 11.7841 68.3518 11.5359C68.6247 11.5 68.9498 11.5 69.6 11.5C70.2502 11.5 70.5753 11.5 70.8482 11.5359C72.7329 11.7841 74.216 13.2671 74.4641 15.1518C74.5 15.4247 74.5 15.7498 74.5 16.4C74.5 17.0502 74.5 17.3753 74.4641 17.6482C74.216 19.5329 72.7329 21.0159 70.8482 21.2641C70.5753 21.3 70.2502 21.3 69.6 21.3C68.9498 21.3 68.6247 21.3 68.3518 21.2641C66.4671 21.0159 64.9841 19.5329 64.736 17.6482C64.7 17.3753 64.7 17.0502 64.7 16.4Z", fill: "#111212" })
] }), QRCode = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("svg", { width: "86", height: "44", viewBox: "0 0 86 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1", y: "-1", width: "84", height: "42", rx: "11", transform: "matrix(1 0 0 -1 0 42)", fill: "#F8F9FA" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { x: "1", y: "-1", width: "84", height: "42", rx: "11", transform: "matrix(1 0 0 -1 0 42)", stroke: "#F5F6F7", strokeWidth: "2" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { width: "40", height: "40", rx: "10", transform: "matrix(1 0 0 -1 2 42)", fill: "white" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.45 32.8594C27.8918 32.8594 28.25 32.5012 28.25 32.0594V31.6594C28.25 31.2175 27.8918 30.8594 27.45 30.8594H24.3594V28.6406H25.5625C28.3628 28.6406 29.7629 28.6406 30.8325 28.0957C31.7733 27.6163 32.5382 26.8514 33.0175 25.9106C33.5625 24.841 33.5625 23.4409 33.5625 20.6406V19.1406C33.5625 16.3404 33.5625 14.9402 33.0175 13.8707C32.5382 12.9299 31.7733 12.165 30.8325 11.6856C29.7629 11.1406 28.3628 11.1406 25.5625 11.1406H18.4375C15.6372 11.1406 14.2371 11.1406 13.1675 11.6856C12.2267 12.165 11.4618 12.9299 10.9825 13.8707C10.4375 14.9402 10.4375 16.3404 10.4375 19.1406V20.6406C10.4375 23.4409 10.4375 24.841 10.9825 25.9106C11.4618 26.8514 12.2267 27.6163 13.1675 28.0957C14.2371 28.6406 15.6372 28.6406 18.4375 28.6406H19.6406V30.8594H16.55C16.1082 30.8594 15.75 31.2175 15.75 31.6594V32.0594C15.75 32.5012 16.1082 32.8594 16.55 32.8594H27.45ZM25.5625 13.1406H18.4375C17.0044 13.1406 16.0498 13.1422 15.3164 13.2021C14.6063 13.2601 14.2814 13.3627 14.0755 13.4676C13.511 13.7552 13.0521 14.2142 12.7645 14.7787C12.6596 14.9845 12.557 15.3094 12.499 16.0195C12.4391 16.7529 12.4375 17.7075 12.4375 19.1406V20.6406C12.4375 22.0738 12.4391 23.0283 12.499 23.7618C12.557 24.4718 12.6596 24.7968 12.7645 25.0026C13.0521 25.5671 13.511 26.026 14.0755 26.3136C14.2814 26.4185 14.6063 26.5211 15.3164 26.5791C16.0498 26.6391 17.0044 26.6406 18.4375 26.6406H25.5625C26.9956 26.6406 27.9502 26.6391 28.6836 26.5791C29.3937 26.5211 29.7186 26.4185 29.9245 26.3136C30.489 26.026 30.9479 25.5671 31.2355 25.0026C31.3404 24.7968 31.443 24.4718 31.501 23.7618C31.5609 23.0283 31.5625 22.0738 31.5625 20.6406V19.1406C31.5625 17.7075 31.5609 16.7529 31.501 16.0195C31.443 15.3094 31.3404 14.9845 31.2355 14.7787C30.9479 14.2142 30.489 13.7552 29.9245 13.4676C29.7186 13.3627 29.3937 13.2601 28.6836 13.2021C27.9502 13.1422 26.9956 13.1406 25.5625 13.1406Z", fill: "#111212" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M57.4128 19.2812C57.523 19.2957 57.6862 19.3 58.4 19.3C59.1138 19.3 59.277 19.2957 59.3872 19.2812C60.3744 19.1512 61.1512 18.3744 61.2812 17.3872C61.2957 17.277 61.3 17.1138 61.3 16.4C61.3 15.6862 61.2957 15.523 61.2812 15.4128C61.1512 14.4256 60.3744 13.6488 59.3872 13.5188C59.277 13.5043 59.1138 13.5 58.4 13.5C57.6862 13.5 57.523 13.5043 57.4128 13.5188C56.4256 13.6488 55.6488 14.4256 55.5188 15.4128C55.5043 15.523 55.5 15.6862 55.5 16.4C55.5 17.1138 55.5043 17.277 55.5188 17.3872C55.6488 18.3744 56.4256 19.1512 57.4128 19.2812ZM53.5359 15.1518C53.5 15.4247 53.5 15.7498 53.5 16.4C53.5 17.0502 53.5 17.3753 53.5359 17.6482C53.7841 19.5329 55.2671 21.0159 57.1518 21.2641C57.4247 21.3 57.7498 21.3 58.4 21.3C59.0502 21.3 59.3753 21.3 59.6482 21.2641C61.5329 21.0159 63.0159 19.5329 63.2641 17.6482C63.3 17.3753 63.3 17.0502 63.3 16.4C63.3 15.7498 63.3 15.4247 63.2641 15.1518C63.0159 13.2671 61.5329 11.7841 59.6482 11.5359C59.3753 11.5 59.0502 11.5 58.4 11.5C57.7498 11.5 57.4247 11.5 57.1518 11.5359C55.2671 11.7841 53.7841 13.2671 53.5359 15.1518ZM57 16.4C57 16.0277 57 15.8416 57.0489 15.691C57.1479 15.3865 57.3865 15.1479 57.691 15.0489C57.8416 15 58.0277 15 58.4 15C58.7723 15 58.9584 15 59.109 15.0489C59.4135 15.1479 59.6521 15.3865 59.7511 15.691C59.8 15.8416 59.8 16.0277 59.8 16.4C59.8 16.7723 59.8 16.9584 59.7511 17.109C59.6521 17.4135 59.4135 17.6521 59.109 17.7511C58.9584 17.8 58.7723 17.8 58.4 17.8C58.0277 17.8 57.8416 17.8 57.691 17.7511C57.3865 17.6521 57.1479 17.4135 57.0489 17.109C57 16.9584 57 16.7723 57 16.4ZM57.0489 26.891C57 27.0416 57 27.2278 57 27.6C57 27.9723 57 28.1584 57.0489 28.309C57.1479 28.6135 57.3865 28.8522 57.691 28.9511C57.8416 29 58.0277 29 58.4 29C58.7723 29 58.9584 29 59.109 28.9511C59.4135 28.8522 59.6521 28.6135 59.7511 28.309C59.8 28.1584 59.8 27.9723 59.8 27.6C59.8 27.2278 59.8 27.0416 59.7511 26.891C59.6521 26.5866 59.4135 26.3479 59.109 26.249C58.9584 26.2 58.7723 26.2 58.4 26.2C58.0277 26.2 57.8416 26.2 57.691 26.249C57.3865 26.3479 57.1479 26.5866 57.0489 26.891ZM71.0007 25.0608C71 25.0804 71 25.1036 71 25.15C71 25.1965 71 25.2197 71.0007 25.2393C71.0212 25.7607 71.4392 26.1788 71.9607 26.1993C71.9803 26.2 72.0035 26.2 72.05 26.2C72.0964 26.2 72.1196 26.2 72.1392 26.1993C72.6607 26.1788 73.0787 25.7607 73.0992 25.2393C73.1 25.2197 73.1 25.1965 73.1 25.15C73.1 25.1036 73.1 25.0804 73.0992 25.0608C73.0787 24.5393 72.6607 24.1213 72.1392 24.1008C72.1196 24.1 72.0964 24.1 72.05 24.1C72.0035 24.1 71.9803 24.1 71.9607 24.1008C71.4392 24.1213 71.0212 24.5393 71.0007 25.0608ZM66.1001 25.1501C66.1001 25.1036 66.1001 25.0804 66.1008 25.0608C66.1213 24.5393 66.5393 24.1213 67.0608 24.1008C67.0804 24.1001 67.1036 24.1001 67.1501 24.1001C67.1965 24.1001 67.2197 24.1001 67.2393 24.1008C67.7608 24.1213 68.1788 24.5393 68.1993 25.0608C68.2001 25.0804 68.2001 25.1036 68.2001 25.1501C68.2001 25.1965 68.2001 25.2197 68.1993 25.2393C68.1788 25.7608 67.7608 26.1788 67.2393 26.1993C67.2197 26.2001 67.1965 26.2001 67.1501 26.2001C67.1036 26.2001 67.0804 26.2001 67.0608 26.1993C66.5393 26.1788 66.1213 25.7608 66.1008 25.2393C66.1001 25.2197 66.1001 25.1965 66.1001 25.1501ZM66.1 30.05C66.1 30.0035 66.1 29.9803 66.1008 29.9607C66.1213 29.4392 66.5393 29.0212 67.0608 29.0007C67.0804 29 67.1036 29 67.15 29C67.1965 29 67.2197 29 67.2393 29.0007C67.7607 29.0212 68.1788 29.4392 68.1993 29.9607C68.2 29.9803 68.2 30.0035 68.2 30.05C68.2 30.0964 68.2 30.1196 68.1993 30.1392C68.1788 30.6607 67.7607 31.0787 67.2393 31.0992C67.2197 31.1 67.1965 31.1 67.15 31.1C67.1036 31.1 67.0804 31.1 67.0608 31.0992C66.5393 31.0787 66.1213 30.6607 66.1008 30.1392C66.1 30.1196 66.1 30.0964 66.1 30.05ZM68.5499 27.5999C68.5499 27.5535 68.5499 27.5303 68.5507 27.5107C68.5712 26.9892 68.9892 26.5712 69.5107 26.5507C69.5303 26.5499 69.5535 26.5499 69.5999 26.5499C69.6464 26.5499 69.6696 26.5499 69.6892 26.5507C70.2107 26.5712 70.6287 26.9892 70.6492 27.5107C70.6499 27.5303 70.6499 27.5535 70.6499 27.5999C70.6499 27.6464 70.6499 27.6696 70.6492 27.6892C70.6287 28.2107 70.2107 28.6287 69.6892 28.6492C69.6696 28.6499 69.6464 28.6499 69.5999 28.6499C69.5535 28.6499 69.5303 28.6499 69.5107 28.6492C68.9892 28.6287 68.5712 28.2107 68.5507 27.6892C68.5499 27.6696 68.5499 27.6464 68.5499 27.5999ZM71.0007 29.9607C71 29.9803 71 30.0035 71 30.05C71 30.0964 71 30.1196 71.0007 30.1392C71.0212 30.6607 71.4392 31.0787 71.9607 31.0992C71.9803 31.1 72.0035 31.1 72.05 31.1C72.0964 31.1 72.1196 31.1 72.1392 31.0992C72.6607 31.0787 73.0787 30.6607 73.0992 30.1392C73.1 30.1196 73.1 30.0964 73.1 30.05C73.1 30.0035 73.1 29.9803 73.0992 29.9607C73.0787 29.4392 72.6607 29.0212 72.1392 29.0007C72.1196 29 72.0964 29 72.05 29C72.0035 29 71.9803 29 71.9607 29.0007C71.4392 29.0212 71.0212 29.4392 71.0007 29.9607ZM68.249 15.691C68.2 15.8416 68.2 16.0277 68.2 16.4C68.2 16.7723 68.2 16.9584 68.249 17.109C68.3479 17.4135 68.5866 17.6521 68.891 17.7511C69.0416 17.8 69.2278 17.8 69.6 17.8C69.9723 17.8 70.1584 17.8 70.309 17.7511C70.6135 17.6521 70.8522 17.4135 70.9511 17.109C71 16.9584 71 16.7723 71 16.4C71 16.0277 71 15.8416 70.9511 15.691C70.8522 15.3865 70.6135 15.1479 70.309 15.0489C70.1584 15 69.9723 15 69.6 15C69.2278 15 69.0416 15 68.891 15.0489C68.5866 15.1479 68.3479 15.3865 68.249 15.691ZM57.4128 30.4812C57.523 30.4957 57.6862 30.5 58.4 30.5C59.1138 30.5 59.277 30.4957 59.3872 30.4812C60.3744 30.3512 61.1512 29.5744 61.2812 28.5872C61.2957 28.477 61.3 28.3138 61.3 27.6C61.3 26.8863 61.2957 26.7231 61.2812 26.6129C61.1512 25.6256 60.3744 24.8488 59.3872 24.7188C59.277 24.7043 59.1138 24.7 58.4 24.7C57.6862 24.7 57.523 24.7043 57.4128 24.7188C56.4256 24.8488 55.6488 25.6256 55.5188 26.6129C55.5043 26.7231 55.5 26.8863 55.5 27.6C55.5 28.3138 55.5043 28.477 55.5188 28.5872C55.6488 29.5744 56.4256 30.3512 57.4128 30.4812ZM53.5359 26.3518C53.5 26.6247 53.5 26.9498 53.5 27.6C53.5 28.2502 53.5 28.5753 53.5359 28.8482C53.7841 30.7329 55.2671 32.216 57.1518 32.4641C57.4247 32.5 57.7498 32.5 58.4 32.5C59.0502 32.5 59.3753 32.5 59.6482 32.4641C61.5329 32.216 63.0159 30.7329 63.2641 28.8482C63.3 28.5753 63.3 28.2502 63.3 27.6C63.3 26.9498 63.3 26.6247 63.2641 26.3518C63.0159 24.4671 61.5329 22.9841 59.6482 22.736C59.3753 22.7 59.0502 22.7 58.4 22.7C57.7498 22.7 57.4247 22.7 57.1518 22.736C55.2671 22.9841 53.7841 24.4671 53.5359 26.3518ZM69.6 19.3C68.8863 19.3 68.7231 19.2957 68.6129 19.2812C67.6256 19.1512 66.8488 18.3744 66.7188 17.3872C66.7043 17.277 66.7 17.1138 66.7 16.4C66.7 15.6862 66.7043 15.523 66.7188 15.4128C66.8488 14.4256 67.6256 13.6488 68.6129 13.5188C68.7231 13.5043 68.8863 13.5 69.6 13.5C70.3138 13.5 70.477 13.5043 70.5872 13.5188C71.5744 13.6488 72.3512 14.4256 72.4812 15.4128C72.4957 15.523 72.5 15.6862 72.5 16.4C72.5 17.1138 72.4957 17.277 72.4812 17.3872C72.3512 18.3744 71.5744 19.1512 70.5872 19.2812C70.477 19.2957 70.3138 19.3 69.6 19.3ZM64.7 16.4C64.7 15.7498 64.7 15.4247 64.736 15.1518C64.9841 13.2671 66.4671 11.7841 68.3518 11.5359C68.6247 11.5 68.9498 11.5 69.6 11.5C70.2502 11.5 70.5753 11.5 70.8482 11.5359C72.7329 11.7841 74.216 13.2671 74.4641 15.1518C74.5 15.4247 74.5 15.7498 74.5 16.4C74.5 17.0502 74.5 17.3753 74.4641 17.6482C74.216 19.5329 72.7329 21.0159 70.8482 21.2641C70.5753 21.3 70.2502 21.3 69.6 21.3C68.9498 21.3 68.6247 21.3 68.3518 21.2641C66.4671 21.0159 64.9841 19.5329 64.736 17.6482C64.7 17.3753 64.7 17.0502 64.7 16.4Z", fill: "#C3C7CB" }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M326.584 29.2274C326.22 29.5909 325.631 29.5909 325.268 29.2274L324.773 28.7321C324.409 28.3687 324.409 27.7795 324.773 27.416L330.189 22L324.773 16.584C324.409 16.2205 324.409 15.6313 324.773 15.2679L325.268 14.7726C325.631 14.4091 326.221 14.4091 326.584 14.7726L332 20.1886L337.416 14.7726C337.779 14.4091 338.369 14.4091 338.732 14.7726L339.227 15.2679C339.591 15.6313 339.591 16.2205 339.227 16.584L333.811 22L339.227 27.416C339.591 27.7795 339.591 28.3687 339.227 28.7321L338.732 29.2274C338.369 29.5909 337.78 29.5909 337.416 29.2274L332 23.8113L326.584 29.2274Z", fill: "#C3C7CB" })
] }), codePopver = (e) => {
  const { dictionary: t, isModal: r = !1, qrCode: i, setQrCode: n } = e, { getStarted: a } = t, { loginUsingSocialMediaOTP: s, loginUsingQRCode: l } = a, o = i ? Computer : QRCode, c = /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: styles$3.codeImg,
      onClick: () => {
        n(!i);
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(o, {})
    }
  ), f = i ? s : l;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      style: { alignSelf: r ? "flex-start" : "flex-end" },
      className: `${styles$3.code} ${r ? styles$3.codePage : ""}`,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { placement: r ? "right" : "left", title: f, children: c })
    }
  );
}, useSessionWithBanner = (e) => {
  useEffect(() => {
    ["1", "3"].includes(`${e}`) && sessionStorage.setItem("noNeedFirebaseToken", "true");
  }, [e]);
};
var lottie$1 = { exports: {} };
(function(module, exports) {
  typeof navigator < "u" && function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
      _useWebWorker = !!t;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(t) {
      locationHref = t;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(e) {
      return document.createElement(e);
    }
    function extendPrototype(e, t) {
      var r, i = e.length, n;
      for (r = 0; r < i; r += 1) {
        n = e[r].prototype;
        for (var a in n)
          Object.prototype.hasOwnProperty.call(n, a) && (t.prototype[a] = n[a]);
      }
    }
    function getDescriptor(e, t) {
      return Object.getOwnPropertyDescriptor(e, t);
    }
    function createProxyFunction(e) {
      function t() {
      }
      return t.prototype = e, t;
    }
    var audioControllerFactory = function() {
      function e(t) {
        this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
      }
      return e.prototype = {
        addAudio: function(r) {
          this.audios.push(r);
        },
        pause: function() {
          var r, i = this.audios.length;
          for (r = 0; r < i; r += 1)
            this.audios[r].pause();
        },
        resume: function() {
          var r, i = this.audios.length;
          for (r = 0; r < i; r += 1)
            this.audios[r].resume();
        },
        setRate: function(r) {
          var i, n = this.audios.length;
          for (i = 0; i < n; i += 1)
            this.audios[i].setRate(r);
        },
        createAudio: function(r) {
          return this.audioFactory ? this.audioFactory(r) : window.Howl ? new window.Howl({
            src: [r]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(r) {
          this.audioFactory = r;
        },
        setVolume: function(r) {
          this._volume = r, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var r, i = this.audios.length;
          for (r = 0; r < i; r += 1)
            this.audios[r].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new e();
      };
    }(), createTypedArray = function() {
      function e(r, i) {
        var n = 0, a = [], s;
        switch (r) {
          case "int16":
          case "uint8c":
            s = 1;
            break;
          default:
            s = 1.1;
            break;
        }
        for (n = 0; n < i; n += 1)
          a.push(s);
        return a;
      }
      function t(r, i) {
        return r === "float32" ? new Float32Array(i) : r === "int16" ? new Int16Array(i) : r === "uint8c" ? new Uint8ClampedArray(i) : e(r, i);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? t : e;
    }();
    function createSizedArray(e) {
      return Array.apply(null, {
        length: e
      });
    }
    function _typeof$6(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(r) {
        return typeof r;
      } : _typeof$6 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$6(e);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], t, r = e.length;
      for (t = 0; t < r; t += 1)
        BMMath[e[t]] = Math[e[t]];
    })(), BMMath.random = Math.random, BMMath.abs = function(e) {
      var t = _typeof$6(e);
      if (t === "object" && e.length) {
        var r = createSizedArray(e.length), i, n = e.length;
        for (i = 0; i < n; i += 1)
          r[i] = Math.abs(e[i]);
        return r;
      }
      return Math.abs(e);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(e) {
      e.style.position = "absolute", e.style.top = 0, e.style.left = 0, e.style.display = "block", e.style.transformOrigin = "0 0", e.style.webkitTransformOrigin = "0 0", e.style.backfaceVisibility = "visible", e.style.webkitBackfaceVisibility = "visible", e.style.transformStyle = "preserve-3d", e.style.webkitTransformStyle = "preserve-3d", e.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(e, t, r, i) {
      this.type = e, this.currentTime = t, this.totalTime = r, this.direction = i < 0 ? -1 : 1;
    }
    function BMCompleteEvent(e, t) {
      this.type = e, this.direction = t < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(e, t, r, i) {
      this.type = e, this.currentLoop = r, this.totalLoops = t, this.direction = i < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(e, t, r) {
      this.type = e, this.firstFrame = t, this.totalFrames = r;
    }
    function BMDestroyEvent(e, t) {
      this.type = e, this.target = t;
    }
    function BMRenderFrameErrorEvent(e, t) {
      this.type = "renderFrameError", this.nativeError = e, this.currentTime = t;
    }
    function BMConfigErrorEvent(e) {
      this.type = "configError", this.nativeError = e;
    }
    var createElementID = function() {
      var e = 0;
      return function() {
        return e += 1, idPrefix$1 + "__lottie_element_" + e;
      };
    }();
    function HSVtoRGB(e, t, r) {
      var i, n, a, s, l, o, c, f;
      switch (s = Math.floor(e * 6), l = e * 6 - s, o = r * (1 - t), c = r * (1 - l * t), f = r * (1 - (1 - l) * t), s % 6) {
        case 0:
          i = r, n = f, a = o;
          break;
        case 1:
          i = c, n = r, a = o;
          break;
        case 2:
          i = o, n = r, a = f;
          break;
        case 3:
          i = o, n = c, a = r;
          break;
        case 4:
          i = f, n = o, a = r;
          break;
        case 5:
          i = r, n = o, a = c;
          break;
      }
      return [i, n, a];
    }
    function RGBtoHSV(e, t, r) {
      var i = Math.max(e, t, r), n = Math.min(e, t, r), a = i - n, s, l = i === 0 ? 0 : a / i, o = i / 255;
      switch (i) {
        case n:
          s = 0;
          break;
        case e:
          s = t - r + a * (t < r ? 6 : 0), s /= 6 * a;
          break;
        case t:
          s = r - e + a * 2, s /= 6 * a;
          break;
        case r:
          s = e - t + a * 4, s /= 6 * a;
          break;
      }
      return [s, l, o];
    }
    function addSaturationToRGB(e, t) {
      var r = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return r[1] += t, r[1] > 1 ? r[1] = 1 : r[1] <= 0 && (r[1] = 0), HSVtoRGB(r[0], r[1], r[2]);
    }
    function addBrightnessToRGB(e, t) {
      var r = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return r[2] += t, r[2] > 1 ? r[2] = 1 : r[2] < 0 && (r[2] = 0), HSVtoRGB(r[0], r[1], r[2]);
    }
    function addHueToRGB(e, t) {
      var r = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return r[0] += t / 360, r[0] > 1 ? r[0] -= 1 : r[0] < 0 && (r[0] += 1), HSVtoRGB(r[0], r[1], r[2]);
    }
    var rgbToHex = function() {
      var e = [], t, r;
      for (t = 0; t < 256; t += 1)
        r = t.toString(16), e[t] = r.length === 1 ? "0" + r : r;
      return function(i, n, a) {
        return i < 0 && (i = 0), n < 0 && (n = 0), a < 0 && (a = 0), "#" + e[i] + e[n] + e[a];
      };
    }(), setSubframeEnabled = function(t) {
      subframeEnabled = !!t;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(t) {
      expressionsPlugin = t;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(t) {
      expressionsInterfaces = t;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(t) {
      defaultCurveSegments = t;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(t) {
      idPrefix$1 = t;
    };
    function createNS(e) {
      return document.createElementNS(svgNS, e);
    }
    function _typeof$5(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(r) {
        return typeof r;
      } : _typeof$5 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$5(e);
    }
    var dataManager = function() {
      var e = 1, t = [], r, i, n = {
        onmessage: function() {
        },
        postMessage: function(A) {
          r({
            data: A
          });
        }
      }, a = {
        postMessage: function(A) {
          n.onmessage({
            data: A
          });
        }
      };
      function s(m) {
        if (window.Worker && window.Blob && getWebWorker()) {
          var A = new Blob(["var _workerSelf = self; self.onmessage = ", m.toString()], {
            type: "text/javascript"
          }), M = URL.createObjectURL(A);
          return new Worker(M);
        }
        return r = m, n;
      }
      function l() {
        i || (i = s(function(A) {
          function M() {
            function C(j, N) {
              var P, z, b = j.length, k, S, F, Q;
              for (z = 0; z < b; z += 1)
                if (P = j[z], "ks" in P && !P.completed) {
                  if (P.completed = !0, P.hasMask) {
                    var L = P.masksProperties;
                    for (S = L.length, k = 0; k < S; k += 1)
                      if (L[k].pt.k.i)
                        E(L[k].pt.k);
                      else
                        for (Q = L[k].pt.k.length, F = 0; F < Q; F += 1)
                          L[k].pt.k[F].s && E(L[k].pt.k[F].s[0]), L[k].pt.k[F].e && E(L[k].pt.k[F].e[0]);
                  }
                  P.ty === 0 ? (P.layers = p(P.refId, N), C(P.layers, N)) : P.ty === 4 ? y(P.shapes) : P.ty === 5 && R(P);
                }
            }
            function u(j, N) {
              if (j) {
                var P = 0, z = j.length;
                for (P = 0; P < z; P += 1)
                  j[P].t === 1 && (j[P].data.layers = p(j[P].data.refId, N), C(j[P].data.layers, N));
              }
            }
            function g(j, N) {
              for (var P = 0, z = N.length; P < z; ) {
                if (N[P].id === j)
                  return N[P];
                P += 1;
              }
              return null;
            }
            function p(j, N) {
              var P = g(j, N);
              return P ? P.layers.__used ? JSON.parse(JSON.stringify(P.layers)) : (P.layers.__used = !0, P.layers) : null;
            }
            function y(j) {
              var N, P = j.length, z, b;
              for (N = P - 1; N >= 0; N -= 1)
                if (j[N].ty === "sh")
                  if (j[N].ks.k.i)
                    E(j[N].ks.k);
                  else
                    for (b = j[N].ks.k.length, z = 0; z < b; z += 1)
                      j[N].ks.k[z].s && E(j[N].ks.k[z].s[0]), j[N].ks.k[z].e && E(j[N].ks.k[z].e[0]);
                else
                  j[N].ty === "gr" && y(j[N].it);
            }
            function E(j) {
              var N, P = j.i.length;
              for (N = 0; N < P; N += 1)
                j.i[N][0] += j.v[N][0], j.i[N][1] += j.v[N][1], j.o[N][0] += j.v[N][0], j.o[N][1] += j.v[N][1];
            }
            function T(j, N) {
              var P = N ? N.split(".") : [100, 100, 100];
              return j[0] > P[0] ? !0 : P[0] > j[0] ? !1 : j[1] > P[1] ? !0 : P[1] > j[1] ? !1 : j[2] > P[2] ? !0 : P[2] > j[2] ? !1 : null;
            }
            var Z = function() {
              var j = [4, 4, 14];
              function N(z) {
                var b = z.t.d;
                z.t.d = {
                  k: [{
                    s: b,
                    t: 0
                  }]
                };
              }
              function P(z) {
                var b, k = z.length;
                for (b = 0; b < k; b += 1)
                  z[b].ty === 5 && N(z[b]);
              }
              return function(z) {
                if (T(j, z.v) && (P(z.layers), z.assets)) {
                  var b, k = z.assets.length;
                  for (b = 0; b < k; b += 1)
                    z.assets[b].layers && P(z.assets[b].layers);
                }
              };
            }(), G = function() {
              var j = [4, 7, 99];
              return function(N) {
                if (N.chars && !T(j, N.v)) {
                  var P, z = N.chars.length;
                  for (P = 0; P < z; P += 1) {
                    var b = N.chars[P];
                    b.data && b.data.shapes && (y(b.data.shapes), b.data.ip = 0, b.data.op = 99999, b.data.st = 0, b.data.sr = 1, b.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, N.chars[P].t || (b.data.shapes.push({
                      ty: "no"
                    }), b.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(), I = function() {
              var j = [5, 7, 15];
              function N(z) {
                var b = z.t.p;
                typeof b.a == "number" && (b.a = {
                  a: 0,
                  k: b.a
                }), typeof b.p == "number" && (b.p = {
                  a: 0,
                  k: b.p
                }), typeof b.r == "number" && (b.r = {
                  a: 0,
                  k: b.r
                });
              }
              function P(z) {
                var b, k = z.length;
                for (b = 0; b < k; b += 1)
                  z[b].ty === 5 && N(z[b]);
              }
              return function(z) {
                if (T(j, z.v) && (P(z.layers), z.assets)) {
                  var b, k = z.assets.length;
                  for (b = 0; b < k; b += 1)
                    z.assets[b].layers && P(z.assets[b].layers);
                }
              };
            }(), V = function() {
              var j = [4, 1, 9];
              function N(z) {
                var b, k = z.length, S, F;
                for (b = 0; b < k; b += 1)
                  if (z[b].ty === "gr")
                    N(z[b].it);
                  else if (z[b].ty === "fl" || z[b].ty === "st")
                    if (z[b].c.k && z[b].c.k[0].i)
                      for (F = z[b].c.k.length, S = 0; S < F; S += 1)
                        z[b].c.k[S].s && (z[b].c.k[S].s[0] /= 255, z[b].c.k[S].s[1] /= 255, z[b].c.k[S].s[2] /= 255, z[b].c.k[S].s[3] /= 255), z[b].c.k[S].e && (z[b].c.k[S].e[0] /= 255, z[b].c.k[S].e[1] /= 255, z[b].c.k[S].e[2] /= 255, z[b].c.k[S].e[3] /= 255);
                    else
                      z[b].c.k[0] /= 255, z[b].c.k[1] /= 255, z[b].c.k[2] /= 255, z[b].c.k[3] /= 255;
              }
              function P(z) {
                var b, k = z.length;
                for (b = 0; b < k; b += 1)
                  z[b].ty === 4 && N(z[b].shapes);
              }
              return function(z) {
                if (T(j, z.v) && (P(z.layers), z.assets)) {
                  var b, k = z.assets.length;
                  for (b = 0; b < k; b += 1)
                    z.assets[b].layers && P(z.assets[b].layers);
                }
              };
            }(), Y = function() {
              var j = [4, 4, 18];
              function N(z) {
                var b, k = z.length, S, F;
                for (b = k - 1; b >= 0; b -= 1)
                  if (z[b].ty === "sh")
                    if (z[b].ks.k.i)
                      z[b].ks.k.c = z[b].closed;
                    else
                      for (F = z[b].ks.k.length, S = 0; S < F; S += 1)
                        z[b].ks.k[S].s && (z[b].ks.k[S].s[0].c = z[b].closed), z[b].ks.k[S].e && (z[b].ks.k[S].e[0].c = z[b].closed);
                  else
                    z[b].ty === "gr" && N(z[b].it);
              }
              function P(z) {
                var b, k, S = z.length, F, Q, L, W;
                for (k = 0; k < S; k += 1) {
                  if (b = z[k], b.hasMask) {
                    var q = b.masksProperties;
                    for (Q = q.length, F = 0; F < Q; F += 1)
                      if (q[F].pt.k.i)
                        q[F].pt.k.c = q[F].cl;
                      else
                        for (W = q[F].pt.k.length, L = 0; L < W; L += 1)
                          q[F].pt.k[L].s && (q[F].pt.k[L].s[0].c = q[F].cl), q[F].pt.k[L].e && (q[F].pt.k[L].e[0].c = q[F].cl);
                  }
                  b.ty === 4 && N(b.shapes);
                }
              }
              return function(z) {
                if (T(j, z.v) && (P(z.layers), z.assets)) {
                  var b, k = z.assets.length;
                  for (b = 0; b < k; b += 1)
                    z.assets[b].layers && P(z.assets[b].layers);
                }
              };
            }();
            function D(j) {
              j.__complete || (V(j), Z(j), G(j), I(j), Y(j), C(j.layers, j.assets), u(j.chars, j.assets), j.__complete = !0);
            }
            function R(j) {
              j.t.a.length === 0 && "m" in j.t.p;
            }
            var B = {};
            return B.completeData = D, B.checkColors = V, B.checkChars = G, B.checkPathProperties = I, B.checkShapes = Y, B.completeLayers = C, B;
          }
          if (a.dataManager || (a.dataManager = M()), a.assetLoader || (a.assetLoader = function() {
            function C(g) {
              var p = g.getResponseHeader("content-type");
              return p && g.responseType === "json" && p.indexOf("json") !== -1 || g.response && _typeof$5(g.response) === "object" ? g.response : g.response && typeof g.response == "string" ? JSON.parse(g.response) : g.responseText ? JSON.parse(g.responseText) : null;
            }
            function u(g, p, y, E) {
              var T, Z = new XMLHttpRequest();
              try {
                Z.responseType = "json";
              } catch {
              }
              Z.onreadystatechange = function() {
                if (Z.readyState === 4)
                  if (Z.status === 200)
                    T = C(Z), y(T);
                  else
                    try {
                      T = C(Z), y(T);
                    } catch (G) {
                      E && E(G);
                    }
              };
              try {
                Z.open(["G", "E", "T"].join(""), g, !0);
              } catch {
                Z.open(["G", "E", "T"].join(""), p + "/" + g, !0);
              }
              Z.send();
            }
            return {
              load: u
            };
          }()), A.data.type === "loadAnimation")
            a.assetLoader.load(A.data.path, A.data.fullPath, function(C) {
              a.dataManager.completeData(C), a.postMessage({
                id: A.data.id,
                payload: C,
                status: "success"
              });
            }, function() {
              a.postMessage({
                id: A.data.id,
                status: "error"
              });
            });
          else if (A.data.type === "complete") {
            var d = A.data.animation;
            a.dataManager.completeData(d), a.postMessage({
              id: A.data.id,
              payload: d,
              status: "success"
            });
          } else
            A.data.type === "loadData" && a.assetLoader.load(A.data.path, A.data.fullPath, function(C) {
              a.postMessage({
                id: A.data.id,
                payload: C,
                status: "success"
              });
            }, function() {
              a.postMessage({
                id: A.data.id,
                status: "error"
              });
            });
        }), i.onmessage = function(m) {
          var A = m.data, M = A.id, d = t[M];
          t[M] = null, A.status === "success" ? d.onComplete(A.payload) : d.onError && d.onError();
        });
      }
      function o(m, A) {
        e += 1;
        var M = "processId_" + e;
        return t[M] = {
          onComplete: m,
          onError: A
        }, M;
      }
      function c(m, A, M) {
        l();
        var d = o(A, M);
        i.postMessage({
          type: "loadAnimation",
          path: m,
          fullPath: window.location.origin + window.location.pathname,
          id: d
        });
      }
      function f(m, A, M) {
        l();
        var d = o(A, M);
        i.postMessage({
          type: "loadData",
          path: m,
          fullPath: window.location.origin + window.location.pathname,
          id: d
        });
      }
      function x(m, A, M) {
        l();
        var d = o(A, M);
        i.postMessage({
          type: "complete",
          animation: m,
          id: d
        });
      }
      return {
        loadAnimation: c,
        loadData: f,
        completeAnimation: x
      };
    }(), ImagePreloader = function() {
      var e = function() {
        var u = createTag("canvas");
        u.width = 1, u.height = 1;
        var g = u.getContext("2d");
        return g.fillStyle = "rgba(0,0,0,0)", g.fillRect(0, 0, 1, 1), u;
      }();
      function t() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function r() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function i(u, g, p) {
        var y = "";
        if (u.e)
          y = u.p;
        else if (g) {
          var E = u.p;
          E.indexOf("images/") !== -1 && (E = E.split("/")[1]), y = g + E;
        } else
          y = p, y += u.u ? u.u : "", y += u.p;
        return y;
      }
      function n(u) {
        var g = 0, p = setInterval((function() {
          var y = u.getBBox();
          (y.width || g > 500) && (this._imageLoaded(), clearInterval(p)), g += 1;
        }).bind(this), 50);
      }
      function a(u) {
        var g = i(u, this.assetsPath, this.path), p = createNS("image");
        isSafari ? this.testImageLoaded(p) : p.addEventListener("load", this._imageLoaded, !1), p.addEventListener("error", (function() {
          y.img = e, this._imageLoaded();
        }).bind(this), !1), p.setAttributeNS("http://www.w3.org/1999/xlink", "href", g), this._elementHelper.append ? this._elementHelper.append(p) : this._elementHelper.appendChild(p);
        var y = {
          img: p,
          assetData: u
        };
        return y;
      }
      function s(u) {
        var g = i(u, this.assetsPath, this.path), p = createTag("img");
        p.crossOrigin = "anonymous", p.addEventListener("load", this._imageLoaded, !1), p.addEventListener("error", (function() {
          y.img = e, this._imageLoaded();
        }).bind(this), !1), p.src = g;
        var y = {
          img: p,
          assetData: u
        };
        return y;
      }
      function l(u) {
        var g = {
          assetData: u
        }, p = i(u, this.assetsPath, this.path);
        return dataManager.loadData(p, (function(y) {
          g.img = y, this._footageLoaded();
        }).bind(this), (function() {
          g.img = {}, this._footageLoaded();
        }).bind(this)), g;
      }
      function o(u, g) {
        this.imagesLoadedCb = g;
        var p, y = u.length;
        for (p = 0; p < y; p += 1)
          u[p].layers || (!u[p].t || u[p].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(u[p]))) : u[p].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(u[p]))));
      }
      function c(u) {
        this.path = u || "";
      }
      function f(u) {
        this.assetsPath = u || "";
      }
      function x(u) {
        for (var g = 0, p = this.images.length; g < p; ) {
          if (this.images[g].assetData === u)
            return this.images[g].img;
          g += 1;
        }
        return null;
      }
      function m() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function A() {
        return this.totalImages === this.loadedAssets;
      }
      function M() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function d(u, g) {
        u === "svg" ? (this._elementHelper = g, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function C() {
        this._imageLoaded = t.bind(this), this._footageLoaded = r.bind(this), this.testImageLoaded = n.bind(this), this.createFootageData = l.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return C.prototype = {
        loadAssets: o,
        setAssetsPath: f,
        setPath: c,
        loadedImages: A,
        loadedFootages: M,
        destroy: m,
        getAsset: x,
        createImgData: s,
        createImageData: a,
        imageLoaded: t,
        footageLoaded: r,
        setCacheType: d
      }, C;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = {
      triggerEvent: function(t, r) {
        if (this._cbs[t])
          for (var i = this._cbs[t], n = 0; n < i.length; n += 1)
            i[n](r);
      },
      addEventListener: function(t, r) {
        return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(r), (function() {
          this.removeEventListener(t, r);
        }).bind(this);
      },
      removeEventListener: function(t, r) {
        if (!r)
          this._cbs[t] = null;
        else if (this._cbs[t]) {
          for (var i = 0, n = this._cbs[t].length; i < n; )
            this._cbs[t][i] === r && (this._cbs[t].splice(i, 1), i -= 1, n -= 1), i += 1;
          this._cbs[t].length || (this._cbs[t] = null);
        }
      }
    };
    var markerParser = function() {
      function e(t) {
        for (var r = t.split(`\r
`), i = {}, n, a = 0, s = 0; s < r.length; s += 1)
          n = r[s].split(":"), n.length === 2 && (i[n[0]] = n[1].trim(), a += 1);
        if (a === 0)
          throw new Error();
        return i;
      }
      return function(t) {
        for (var r = [], i = 0; i < t.length; i += 1) {
          var n = t[i], a = {
            time: n.tm,
            duration: n.dr
          };
          try {
            a.payload = JSON.parse(t[i].cm);
          } catch {
            try {
              a.payload = e(t[i].cm);
            } catch {
              a.payload = {
                name: t[i].cm
              };
            }
          }
          r.push(a);
        }
        return r;
      };
    }(), ProjectInterface = function() {
      function e(t) {
        this.compositions.push(t);
      }
      return function() {
        function t(r) {
          for (var i = 0, n = this.compositions.length; i < n; ) {
            if (this.compositions[i].data && this.compositions[i].data.nm === r)
              return this.compositions[i].prepareFrame && this.compositions[i].data.xt && this.compositions[i].prepareFrame(this.currentFrame), this.compositions[i].compInterface;
            i += 1;
          }
          return null;
        }
        return t.compositions = [], t.currentFrame = 0, t.registerComposition = e, t;
      };
    }(), renderers = {}, registerRenderer = function(t, r) {
      renderers[t] = r;
    };
    function getRenderer(e) {
      return renderers[e];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas)
        return "canvas";
      for (var e in renderers)
        if (renderers[e])
          return e;
      return "";
    }
    function _typeof$4(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(r) {
        return typeof r;
      } : _typeof$4 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$4(e);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(e) {
      (e.wrapper || e.container) && (this.wrapper = e.wrapper || e.container);
      var t = "svg";
      e.animType ? t = e.animType : e.renderer && (t = e.renderer);
      var r = getRenderer(t);
      this.renderer = new r(this, e.rendererSettings), this.imagePreloader.setCacheType(t, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = t, e.loop === "" || e.loop === null || e.loop === void 0 || e.loop === !0 ? this.loop = !0 : e.loop === !1 ? this.loop = !1 : this.loop = parseInt(e.loop, 10), this.autoplay = "autoplay" in e ? e.autoplay : !0, this.name = e.name ? e.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(e, "autoloadSegments") ? e.autoloadSegments : !0, this.assetsPath = e.assetsPath, this.initialSegment = e.initialSegment, e.audioFactory && this.audioController.setAudioFactory(e.audioFactory), e.animationData ? this.setupAnimation(e.animationData) : e.path && (e.path.lastIndexOf("\\") !== -1 ? this.path = e.path.substr(0, e.path.lastIndexOf("\\") + 1) : this.path = e.path.substr(0, e.path.lastIndexOf("/") + 1), this.fileName = e.path.substr(e.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(e.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(e) {
      dataManager.completeAnimation(e, this.configAnimation);
    }, AnimationItem.prototype.setData = function(e, t) {
      t && _typeof$4(t) !== "object" && (t = JSON.parse(t));
      var r = {
        wrapper: e,
        animationData: t
      }, i = e.attributes;
      r.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", r.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var n = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
      n === "false" ? r.loop = !1 : n === "true" ? r.loop = !0 : n !== "" && (r.loop = parseInt(n, 10));
      var a = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : i.getNamedItem("bm-autoplay") ? i.getNamedItem("bm-autoplay").value : !0;
      r.autoplay = a !== "false", r.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "";
      var s = i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "";
      s === "false" && (r.prerender = !1), r.path ? this.setParams(r) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(e) {
      e.op > this.animationData.op && (this.animationData.op = e.op, this.totalFrames = Math.floor(e.op - this.animationData.ip));
      var t = this.animationData.layers, r, i = t.length, n = e.layers, a, s = n.length;
      for (a = 0; a < s; a += 1)
        for (r = 0; r < i; ) {
          if (t[r].id === n[a].id) {
            t[r] = n[a];
            break;
          }
          r += 1;
        }
      if ((e.chars || e.fonts) && (this.renderer.globalData.fontManager.addChars(e.chars), this.renderer.globalData.fontManager.addFonts(e.fonts, this.renderer.globalData.defs)), e.assets)
        for (i = e.assets.length, r = 0; r < i; r += 1)
          this.animationData.assets.push(e.assets[r]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(e) {
      this.animationData = e;
      var t = getExpressionsPlugin();
      t && t.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var e = this.animationData.segments;
      if (!e || e.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var t = e.shift();
      this.timeCompleted = t.time * this.frameRate;
      var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(r, this.includeLayers.bind(this), (function() {
        this.trigger("data_failed");
      }).bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      var e = this.animationData.segments;
      e || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(e) {
      if (this.renderer)
        try {
          this.animationData = e, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(e), e.assets || (e.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(e.assets), this.markers = markerParser(e.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (t) {
          this.triggerConfigError(t);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var e = getExpressionsPlugin();
        e && e.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
          this.trigger("DOMLoaded");
        }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(e, t) {
      var r = typeof e == "number" ? e : void 0, i = typeof t == "number" ? t : void 0;
      this.renderer.updateContainerSize(r, i);
    }, AnimationItem.prototype.setSubframe = function(e) {
      this.isSubframeEnabled = !!e;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (e) {
          this.triggerRenderFrameError(e);
        }
    }, AnimationItem.prototype.play = function(e) {
      e && this.name !== e || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(e) {
      e && this.name !== e || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(e) {
      e && this.name !== e || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(e) {
      e && this.name !== e || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(e) {
      for (var t, r = 0; r < this.markers.length; r += 1)
        if (t = this.markers[r], t.payload && t.payload.name === e)
          return t;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(e, t, r) {
      if (!(r && this.name !== r)) {
        var i = Number(e);
        if (isNaN(i)) {
          var n = this.getMarkerData(e);
          n && this.goToAndStop(n.time, !0);
        } else
          t ? this.setCurrentRawFrameValue(e) : this.setCurrentRawFrameValue(e * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(e, t, r) {
      if (!(r && this.name !== r)) {
        var i = Number(e);
        if (isNaN(i)) {
          var n = this.getMarkerData(e);
          n && (n.duration ? this.playSegments([n.time, n.time + n.duration], !0) : this.goToAndStop(n.time, !0));
        } else
          this.goToAndStop(i, t, r);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(e) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var t = this.currentRawFrame + e * this.frameModifier, r = !1;
        t >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(t > this.totalFrames ? t % this.totalFrames : 0) || (r = !0, t = this.totalFrames - 1) : t >= this.totalFrames ? (this.playCount += 1, this.checkSegments(t % this.totalFrames) || (this.setCurrentRawFrameValue(t % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(t) : t < 0 ? this.checkSegments(t % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + t % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (r = !0, t = 0)) : this.setCurrentRawFrameValue(t), r && (this.setCurrentRawFrameValue(t), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(e, t) {
      this.playCount = 0, e[1] < e[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = e[0] - e[1], this.timeCompleted = this.totalFrames, this.firstFrame = e[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - t)) : e[1] > e[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = e[1] - e[0], this.timeCompleted = this.totalFrames, this.firstFrame = e[0], this.setCurrentRawFrameValue(1e-3 + t)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(e, t) {
      var r = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < e ? r = e : this.currentRawFrame + this.firstFrame > t && (r = t - e)), this.firstFrame = e, this.totalFrames = t - e, this.timeCompleted = this.totalFrames, r !== -1 && this.goToAndStop(r, !0);
    }, AnimationItem.prototype.playSegments = function(e, t) {
      if (t && (this.segments.length = 0), _typeof$4(e[0]) === "object") {
        var r, i = e.length;
        for (r = 0; r < i; r += 1)
          this.segments.push(e[r]);
      } else
        this.segments.push(e);
      this.segments.length && t && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(e) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), e && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(e) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), e), !0) : !1;
    }, AnimationItem.prototype.destroy = function(e) {
      e && this.name !== e || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(e) {
      this.currentRawFrame = e, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(e) {
      this.playSpeed = e, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(e) {
      this.playDirection = e < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(e) {
      this.loop = e;
    }, AnimationItem.prototype.setVolume = function(e, t) {
      t && this.name !== t || this.audioController.setVolume(e);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(e) {
      e && this.name !== e || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(e) {
      e && this.name !== e || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(e) {
      var t = "";
      if (e.e)
        t = e.p;
      else if (this.assetsPath) {
        var r = e.p;
        r.indexOf("images/") !== -1 && (r = r.split("/")[1]), t = this.assetsPath + r;
      } else
        t = this.path, t += e.u ? e.u : "", t += e.p;
      return t;
    }, AnimationItem.prototype.getAssetData = function(e) {
      for (var t = 0, r = this.assets.length; t < r; ) {
        if (e === this.assets[t].id)
          return this.assets[t];
        t += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(e) {
      return e ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(e, t, r) {
      try {
        var i = this.renderer.getElementByPath(e);
        i.updateDocumentData(t, r);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(e) {
      if (this._cbs && this._cbs[e])
        switch (e) {
          case "enterFrame":
            this.triggerEvent(e, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(e, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(e, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(e, new BMCompleteEvent(e, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(e, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(e, new BMDestroyEvent(e, this));
            break;
          default:
            this.triggerEvent(e);
        }
      e === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameMult)), e === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult)), e === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(e, this.frameMult)), e === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames)), e === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(e, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(e) {
      var t = new BMRenderFrameErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    }, AnimationItem.prototype.triggerConfigError = function(e) {
      var t = new BMConfigErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    };
    var animationManager = function() {
      var e = {}, t = [], r = 0, i = 0, n = 0, a = !0, s = !1;
      function l(N) {
        for (var P = 0, z = N.target; P < i; )
          t[P].animation === z && (t.splice(P, 1), P -= 1, i -= 1, z.isPaused || x()), P += 1;
      }
      function o(N, P) {
        if (!N)
          return null;
        for (var z = 0; z < i; ) {
          if (t[z].elem === N && t[z].elem !== null)
            return t[z].animation;
          z += 1;
        }
        var b = new AnimationItem();
        return m(b, N), b.setData(N, P), b;
      }
      function c() {
        var N, P = t.length, z = [];
        for (N = 0; N < P; N += 1)
          z.push(t[N].animation);
        return z;
      }
      function f() {
        n += 1, V();
      }
      function x() {
        n -= 1;
      }
      function m(N, P) {
        N.addEventListener("destroy", l), N.addEventListener("_active", f), N.addEventListener("_idle", x), t.push({
          elem: P,
          animation: N
        }), i += 1;
      }
      function A(N) {
        var P = new AnimationItem();
        return m(P, null), P.setParams(N), P;
      }
      function M(N, P) {
        var z;
        for (z = 0; z < i; z += 1)
          t[z].animation.setSpeed(N, P);
      }
      function d(N, P) {
        var z;
        for (z = 0; z < i; z += 1)
          t[z].animation.setDirection(N, P);
      }
      function C(N) {
        var P;
        for (P = 0; P < i; P += 1)
          t[P].animation.play(N);
      }
      function u(N) {
        var P = N - r, z;
        for (z = 0; z < i; z += 1)
          t[z].animation.advanceTime(P);
        r = N, n && !s ? window.requestAnimationFrame(u) : a = !0;
      }
      function g(N) {
        r = N, window.requestAnimationFrame(u);
      }
      function p(N) {
        var P;
        for (P = 0; P < i; P += 1)
          t[P].animation.pause(N);
      }
      function y(N, P, z) {
        var b;
        for (b = 0; b < i; b += 1)
          t[b].animation.goToAndStop(N, P, z);
      }
      function E(N) {
        var P;
        for (P = 0; P < i; P += 1)
          t[P].animation.stop(N);
      }
      function T(N) {
        var P;
        for (P = 0; P < i; P += 1)
          t[P].animation.togglePause(N);
      }
      function Z(N) {
        var P;
        for (P = i - 1; P >= 0; P -= 1)
          t[P].animation.destroy(N);
      }
      function G(N, P, z) {
        var b = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), k, S = b.length;
        for (k = 0; k < S; k += 1)
          z && b[k].setAttribute("data-bm-type", z), o(b[k], N);
        if (P && S === 0) {
          z || (z = "svg");
          var F = document.getElementsByTagName("body")[0];
          F.innerText = "";
          var Q = createTag("div");
          Q.style.width = "100%", Q.style.height = "100%", Q.setAttribute("data-bm-type", z), F.appendChild(Q), o(Q, N);
        }
      }
      function I() {
        var N;
        for (N = 0; N < i; N += 1)
          t[N].animation.resize();
      }
      function V() {
        !s && n && a && (window.requestAnimationFrame(g), a = !1);
      }
      function Y() {
        s = !0;
      }
      function D() {
        s = !1, V();
      }
      function R(N, P) {
        var z;
        for (z = 0; z < i; z += 1)
          t[z].animation.setVolume(N, P);
      }
      function B(N) {
        var P;
        for (P = 0; P < i; P += 1)
          t[P].animation.mute(N);
      }
      function j(N) {
        var P;
        for (P = 0; P < i; P += 1)
          t[P].animation.unmute(N);
      }
      return e.registerAnimation = o, e.loadAnimation = A, e.setSpeed = M, e.setDirection = d, e.play = C, e.pause = p, e.stop = E, e.togglePause = T, e.searchAnimations = G, e.resize = I, e.goToAndStop = y, e.destroy = Z, e.freeze = Y, e.unfreeze = D, e.setVolume = R, e.mute = B, e.unmute = j, e.getRegisteredAnimations = c, e;
    }(), BezierFactory = function() {
      var e = {};
      e.getBezierEasing = r;
      var t = {};
      function r(g, p, y, E, T) {
        var Z = T || ("bez_" + g + "_" + p + "_" + y + "_" + E).replace(/\./g, "p");
        if (t[Z])
          return t[Z];
        var G = new u([g, p, y, E]);
        return t[Z] = G, G;
      }
      var i = 4, n = 1e-3, a = 1e-7, s = 10, l = 11, o = 1 / (l - 1), c = typeof Float32Array == "function";
      function f(g, p) {
        return 1 - 3 * p + 3 * g;
      }
      function x(g, p) {
        return 3 * p - 6 * g;
      }
      function m(g) {
        return 3 * g;
      }
      function A(g, p, y) {
        return ((f(p, y) * g + x(p, y)) * g + m(p)) * g;
      }
      function M(g, p, y) {
        return 3 * f(p, y) * g * g + 2 * x(p, y) * g + m(p);
      }
      function d(g, p, y, E, T) {
        var Z, G, I = 0;
        do
          G = p + (y - p) / 2, Z = A(G, E, T) - g, Z > 0 ? y = G : p = G;
        while (Math.abs(Z) > a && ++I < s);
        return G;
      }
      function C(g, p, y, E) {
        for (var T = 0; T < i; ++T) {
          var Z = M(p, y, E);
          if (Z === 0)
            return p;
          var G = A(p, y, E) - g;
          p -= G / Z;
        }
        return p;
      }
      function u(g) {
        this._p = g, this._mSampleValues = c ? new Float32Array(l) : new Array(l), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return u.prototype = {
        get: function(p) {
          var y = this._p[0], E = this._p[1], T = this._p[2], Z = this._p[3];
          return this._precomputed || this._precompute(), y === E && T === Z ? p : p === 0 ? 0 : p === 1 ? 1 : A(this._getTForX(p), E, Z);
        },
        // Private part
        _precompute: function() {
          var p = this._p[0], y = this._p[1], E = this._p[2], T = this._p[3];
          this._precomputed = !0, (p !== y || E !== T) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var p = this._p[0], y = this._p[2], E = 0; E < l; ++E)
            this._mSampleValues[E] = A(E * o, p, y);
        },
        /**
             * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
             */
        _getTForX: function(p) {
          for (var y = this._p[0], E = this._p[2], T = this._mSampleValues, Z = 0, G = 1, I = l - 1; G !== I && T[G] <= p; ++G)
            Z += o;
          --G;
          var V = (p - T[G]) / (T[G + 1] - T[G]), Y = Z + V * o, D = M(Y, y, E);
          return D >= n ? C(p, Y, y, E) : D === 0 ? Y : d(p, Z, Z + o, y, E);
        }
      }, e;
    }(), pooling = function() {
      function e(t) {
        return t.concat(createSizedArray(t.length));
      }
      return {
        double: e
      };
    }(), poolFactory = function() {
      return function(e, t, r) {
        var i = 0, n = e, a = createSizedArray(n), s = {
          newElement: l,
          release: o
        };
        function l() {
          var c;
          return i ? (i -= 1, c = a[i]) : c = t(), c;
        }
        function o(c) {
          i === n && (a = pooling.double(a), n *= 2), r && r(c), a[i] = c, i += 1;
        }
        return s;
      };
    }(), bezierLengthPool = function() {
      function e() {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments())
        };
      }
      return poolFactory(8, e);
    }(), segmentsLengthPool = function() {
      function e() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function t(r) {
        var i, n = r.lengths.length;
        for (i = 0; i < n; i += 1)
          bezierLengthPool.release(r.lengths[i]);
        r.lengths.length = 0;
      }
      return poolFactory(8, e, t);
    }();
    function bezFunction() {
      var e = Math;
      function t(m, A, M, d, C, u) {
        var g = m * d + A * C + M * u - C * d - u * m - M * A;
        return g > -1e-3 && g < 1e-3;
      }
      function r(m, A, M, d, C, u, g, p, y) {
        if (M === 0 && u === 0 && y === 0)
          return t(m, A, d, C, g, p);
        var E = e.sqrt(e.pow(d - m, 2) + e.pow(C - A, 2) + e.pow(u - M, 2)), T = e.sqrt(e.pow(g - m, 2) + e.pow(p - A, 2) + e.pow(y - M, 2)), Z = e.sqrt(e.pow(g - d, 2) + e.pow(p - C, 2) + e.pow(y - u, 2)), G;
        return E > T ? E > Z ? G = E - T - Z : G = Z - T - E : Z > T ? G = Z - T - E : G = T - E - Z, G > -1e-4 && G < 1e-4;
      }
      var i = function() {
        return function(m, A, M, d) {
          var C = getDefaultCurveSegments(), u, g, p, y, E, T = 0, Z, G = [], I = [], V = bezierLengthPool.newElement();
          for (p = M.length, u = 0; u < C; u += 1) {
            for (E = u / (C - 1), Z = 0, g = 0; g < p; g += 1)
              y = bmPow(1 - E, 3) * m[g] + 3 * bmPow(1 - E, 2) * E * M[g] + 3 * (1 - E) * bmPow(E, 2) * d[g] + bmPow(E, 3) * A[g], G[g] = y, I[g] !== null && (Z += bmPow(G[g] - I[g], 2)), I[g] = G[g];
            Z && (Z = bmSqrt(Z), T += Z), V.percents[u] = E, V.lengths[u] = T;
          }
          return V.addedLength = T, V;
        };
      }();
      function n(m) {
        var A = segmentsLengthPool.newElement(), M = m.c, d = m.v, C = m.o, u = m.i, g, p = m._length, y = A.lengths, E = 0;
        for (g = 0; g < p - 1; g += 1)
          y[g] = i(d[g], d[g + 1], C[g], u[g + 1]), E += y[g].addedLength;
        return M && p && (y[g] = i(d[g], d[0], C[g], u[0]), E += y[g].addedLength), A.totalLength = E, A;
      }
      function a(m) {
        this.segmentLength = 0, this.points = new Array(m);
      }
      function s(m, A) {
        this.partialLength = m, this.point = A;
      }
      var l = function() {
        var m = {};
        return function(A, M, d, C) {
          var u = (A[0] + "_" + A[1] + "_" + M[0] + "_" + M[1] + "_" + d[0] + "_" + d[1] + "_" + C[0] + "_" + C[1]).replace(/\./g, "p");
          if (!m[u]) {
            var g = getDefaultCurveSegments(), p, y, E, T, Z, G = 0, I, V, Y = null;
            A.length === 2 && (A[0] !== M[0] || A[1] !== M[1]) && t(A[0], A[1], M[0], M[1], A[0] + d[0], A[1] + d[1]) && t(A[0], A[1], M[0], M[1], M[0] + C[0], M[1] + C[1]) && (g = 2);
            var D = new a(g);
            for (E = d.length, p = 0; p < g; p += 1) {
              for (V = createSizedArray(E), Z = p / (g - 1), I = 0, y = 0; y < E; y += 1)
                T = bmPow(1 - Z, 3) * A[y] + 3 * bmPow(1 - Z, 2) * Z * (A[y] + d[y]) + 3 * (1 - Z) * bmPow(Z, 2) * (M[y] + C[y]) + bmPow(Z, 3) * M[y], V[y] = T, Y !== null && (I += bmPow(V[y] - Y[y], 2));
              I = bmSqrt(I), G += I, D.points[p] = new s(I, V), Y = V;
            }
            D.segmentLength = G, m[u] = D;
          }
          return m[u];
        };
      }();
      function o(m, A) {
        var M = A.percents, d = A.lengths, C = M.length, u = bmFloor((C - 1) * m), g = m * A.addedLength, p = 0;
        if (u === C - 1 || u === 0 || g === d[u])
          return M[u];
        for (var y = d[u] > g ? -1 : 1, E = !0; E; )
          if (d[u] <= g && d[u + 1] > g ? (p = (g - d[u]) / (d[u + 1] - d[u]), E = !1) : u += y, u < 0 || u >= C - 1) {
            if (u === C - 1)
              return M[u];
            E = !1;
          }
        return M[u] + (M[u + 1] - M[u]) * p;
      }
      function c(m, A, M, d, C, u) {
        var g = o(C, u), p = 1 - g, y = e.round((p * p * p * m[0] + (g * p * p + p * g * p + p * p * g) * M[0] + (g * g * p + p * g * g + g * p * g) * d[0] + g * g * g * A[0]) * 1e3) / 1e3, E = e.round((p * p * p * m[1] + (g * p * p + p * g * p + p * p * g) * M[1] + (g * g * p + p * g * g + g * p * g) * d[1] + g * g * g * A[1]) * 1e3) / 1e3;
        return [y, E];
      }
      var f = createTypedArray("float32", 8);
      function x(m, A, M, d, C, u, g) {
        C < 0 ? C = 0 : C > 1 && (C = 1);
        var p = o(C, g);
        u = u > 1 ? 1 : u;
        var y = o(u, g), E, T = m.length, Z = 1 - p, G = 1 - y, I = Z * Z * Z, V = p * Z * Z * 3, Y = p * p * Z * 3, D = p * p * p, R = Z * Z * G, B = p * Z * G + Z * p * G + Z * Z * y, j = p * p * G + Z * p * y + p * Z * y, N = p * p * y, P = Z * G * G, z = p * G * G + Z * y * G + Z * G * y, b = p * y * G + Z * y * y + p * G * y, k = p * y * y, S = G * G * G, F = y * G * G + G * y * G + G * G * y, Q = y * y * G + G * y * y + y * G * y, L = y * y * y;
        for (E = 0; E < T; E += 1)
          f[E * 4] = e.round((I * m[E] + V * M[E] + Y * d[E] + D * A[E]) * 1e3) / 1e3, f[E * 4 + 1] = e.round((R * m[E] + B * M[E] + j * d[E] + N * A[E]) * 1e3) / 1e3, f[E * 4 + 2] = e.round((P * m[E] + z * M[E] + b * d[E] + k * A[E]) * 1e3) / 1e3, f[E * 4 + 3] = e.round((S * m[E] + F * M[E] + Q * d[E] + L * A[E]) * 1e3) / 1e3;
        return f;
      }
      return {
        getSegmentsLength: n,
        getNewSegment: x,
        getPointInSegment: c,
        buildBezierData: l,
        pointOnLine2D: t,
        pointOnLine3D: r
      };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(e, t) {
      var r = this.offsetTime, i;
      this.propType === "multidimensional" && (i = createTypedArray("float32", this.pv.length));
      for (var n = t.lastIndex, a = n, s = this.keyframes.length - 1, l = !0, o, c, f; l; ) {
        if (o = this.keyframes[a], c = this.keyframes[a + 1], a === s - 1 && e >= c.t - r) {
          o.h && (o = c), n = 0;
          break;
        }
        if (c.t - r > e) {
          n = a;
          break;
        }
        a < s - 1 ? a += 1 : (n = 0, l = !1);
      }
      f = this.keyframesMetadata[a] || {};
      var x, m, A, M, d, C, u = c.t - r, g = o.t - r, p;
      if (o.to) {
        f.bezierData || (f.bezierData = bez.buildBezierData(o.s, c.s || o.e, o.to, o.ti));
        var y = f.bezierData;
        if (e >= u || e < g) {
          var E = e >= u ? y.points.length - 1 : 0;
          for (m = y.points[E].point.length, x = 0; x < m; x += 1)
            i[x] = y.points[E].point[x];
        } else {
          f.__fnct ? C = f.__fnct : (C = BezierFactory.getBezierEasing(o.o.x, o.o.y, o.i.x, o.i.y, o.n).get, f.__fnct = C), A = C((e - g) / (u - g));
          var T = y.segmentLength * A, Z, G = t.lastFrame < e && t._lastKeyframeIndex === a ? t._lastAddedLength : 0;
          for (d = t.lastFrame < e && t._lastKeyframeIndex === a ? t._lastPoint : 0, l = !0, M = y.points.length; l; ) {
            if (G += y.points[d].partialLength, T === 0 || A === 0 || d === y.points.length - 1) {
              for (m = y.points[d].point.length, x = 0; x < m; x += 1)
                i[x] = y.points[d].point[x];
              break;
            } else if (T >= G && T < G + y.points[d + 1].partialLength) {
              for (Z = (T - G) / y.points[d + 1].partialLength, m = y.points[d].point.length, x = 0; x < m; x += 1)
                i[x] = y.points[d].point[x] + (y.points[d + 1].point[x] - y.points[d].point[x]) * Z;
              break;
            }
            d < M - 1 ? d += 1 : l = !1;
          }
          t._lastPoint = d, t._lastAddedLength = G - y.points[d].partialLength, t._lastKeyframeIndex = a;
        }
      } else {
        var I, V, Y, D, R;
        if (s = o.s.length, p = c.s || o.e, this.sh && o.h !== 1)
          if (e >= u)
            i[0] = p[0], i[1] = p[1], i[2] = p[2];
          else if (e <= g)
            i[0] = o.s[0], i[1] = o.s[1], i[2] = o.s[2];
          else {
            var B = createQuaternion(o.s), j = createQuaternion(p), N = (e - g) / (u - g);
            quaternionToEuler(i, slerp(B, j, N));
          }
        else
          for (a = 0; a < s; a += 1)
            o.h !== 1 && (e >= u ? A = 1 : e < g ? A = 0 : (o.o.x.constructor === Array ? (f.__fnct || (f.__fnct = []), f.__fnct[a] ? C = f.__fnct[a] : (I = o.o.x[a] === void 0 ? o.o.x[0] : o.o.x[a], V = o.o.y[a] === void 0 ? o.o.y[0] : o.o.y[a], Y = o.i.x[a] === void 0 ? o.i.x[0] : o.i.x[a], D = o.i.y[a] === void 0 ? o.i.y[0] : o.i.y[a], C = BezierFactory.getBezierEasing(I, V, Y, D).get, f.__fnct[a] = C)) : f.__fnct ? C = f.__fnct : (I = o.o.x, V = o.o.y, Y = o.i.x, D = o.i.y, C = BezierFactory.getBezierEasing(I, V, Y, D).get, o.keyframeMetadata = C), A = C((e - g) / (u - g)))), p = c.s || o.e, R = o.h === 1 ? o.s[a] : o.s[a] + (p[a] - o.s[a]) * A, this.propType === "multidimensional" ? i[a] = R : i = R;
      }
      return t.lastIndex = n, i;
    }
    function slerp(e, t, r) {
      var i = [], n = e[0], a = e[1], s = e[2], l = e[3], o = t[0], c = t[1], f = t[2], x = t[3], m, A, M, d, C;
      return A = n * o + a * c + s * f + l * x, A < 0 && (A = -A, o = -o, c = -c, f = -f, x = -x), 1 - A > 1e-6 ? (m = Math.acos(A), M = Math.sin(m), d = Math.sin((1 - r) * m) / M, C = Math.sin(r * m) / M) : (d = 1 - r, C = r), i[0] = d * n + C * o, i[1] = d * a + C * c, i[2] = d * s + C * f, i[3] = d * l + C * x, i;
    }
    function quaternionToEuler(e, t) {
      var r = t[0], i = t[1], n = t[2], a = t[3], s = Math.atan2(2 * i * a - 2 * r * n, 1 - 2 * i * i - 2 * n * n), l = Math.asin(2 * r * i + 2 * n * a), o = Math.atan2(2 * r * a - 2 * i * n, 1 - 2 * r * r - 2 * n * n);
      e[0] = s / degToRads, e[1] = l / degToRads, e[2] = o / degToRads;
    }
    function createQuaternion(e) {
      var t = e[0] * degToRads, r = e[1] * degToRads, i = e[2] * degToRads, n = Math.cos(t / 2), a = Math.cos(r / 2), s = Math.cos(i / 2), l = Math.sin(t / 2), o = Math.sin(r / 2), c = Math.sin(i / 2), f = n * a * s - l * o * c, x = l * o * s + n * a * c, m = l * a * s + n * o * c, A = n * o * s - l * a * c;
      return [x, m, A, f];
    }
    function getValueAtCurrentTime() {
      var e = this.comp.renderedFrame - this.offsetTime, t = this.keyframes[0].t - this.offsetTime, r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(e === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= r && e >= r || this._caching.lastFrame < t && e < t))) {
        this._caching.lastFrame >= e && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var i = this.interpolateValue(e, this._caching);
        this.pv = i;
      }
      return this._caching.lastFrame = e, this.pv;
    }
    function setVValue(e) {
      var t;
      if (this.propType === "unidimensional")
        t = e * this.mult, mathAbs(this.v - t) > 1e-5 && (this.v = t, this._mdf = !0);
      else
        for (var r = 0, i = this.v.length; r < i; )
          t = e[r] * this.mult, mathAbs(this.v[r] - t) > 1e-5 && (this.v[r] = t, this._mdf = !0), r += 1;
    }
    function processEffectsSequence() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var e, t = this.effectsSequence.length, r = this.kf ? this.pv : this.data.k;
        for (e = 0; e < t; e += 1)
          r = this.effectsSequence[e](r);
        this.setVValue(r), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(e) {
      this.effectsSequence.push(e), this.container.addDynamicProperty(this);
    }
    function ValueProperty(e, t, r, i) {
      this.propType = "unidimensional", this.mult = r || 1, this.data = t, this.v = r ? t.k * r : t.k, this.pv = t.k, this._mdf = !1, this.elem = e, this.container = i, this.comp = e.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(e, t, r, i) {
      this.propType = "multidimensional", this.mult = r || 1, this.data = t, this._mdf = !1, this.elem = e, this.container = i, this.comp = e.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var n, a = t.k.length;
      for (this.v = createTypedArray("float32", a), this.pv = createTypedArray("float32", a), this.vel = createTypedArray("float32", a), n = 0; n < a; n += 1)
        this.v[n] = t.k[n] * this.mult, this.pv[n] = t.k[n];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(e, t, r, i) {
      this.propType = "unidimensional", this.keyframes = t.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.frameId = -1, this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = t, this.mult = r || 1, this.elem = e, this.container = i, this.comp = e.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(e, t, r, i) {
      this.propType = "multidimensional";
      var n, a = t.k.length, s, l, o, c;
      for (n = 0; n < a - 1; n += 1)
        t.k[n].to && t.k[n].s && t.k[n + 1] && t.k[n + 1].s && (s = t.k[n].s, l = t.k[n + 1].s, o = t.k[n].to, c = t.k[n].ti, (s.length === 2 && !(s[0] === l[0] && s[1] === l[1]) && bez.pointOnLine2D(s[0], s[1], l[0], l[1], s[0] + o[0], s[1] + o[1]) && bez.pointOnLine2D(s[0], s[1], l[0], l[1], l[0] + c[0], l[1] + c[1]) || s.length === 3 && !(s[0] === l[0] && s[1] === l[1] && s[2] === l[2]) && bez.pointOnLine3D(s[0], s[1], s[2], l[0], l[1], l[2], s[0] + o[0], s[1] + o[1], s[2] + o[2]) && bez.pointOnLine3D(s[0], s[1], s[2], l[0], l[1], l[2], l[0] + c[0], l[1] + c[1], l[2] + c[2])) && (t.k[n].to = null, t.k[n].ti = null), s[0] === l[0] && s[1] === l[1] && o[0] === 0 && o[1] === 0 && c[0] === 0 && c[1] === 0 && (s.length === 2 || s[2] === l[2] && o[2] === 0 && c[2] === 0) && (t.k[n].to = null, t.k[n].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = t, this.keyframes = t.k, this.keyframesMetadata = [], this.offsetTime = e.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = r || 1, this.elem = e, this.container = i, this.comp = e.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var f = t.k[0].s.length;
      for (this.v = createTypedArray("float32", f), this.pv = createTypedArray("float32", f), n = 0; n < f; n += 1)
        this.v[n] = initFrame, this.pv[n] = initFrame;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: createTypedArray("float32", f)
      }, this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
      function e(r, i, n, a, s) {
        i.sid && (i = r.globalData.slotManager.getProp(i));
        var l;
        if (!i.k.length)
          l = new ValueProperty(r, i, a, s);
        else if (typeof i.k[0] == "number")
          l = new MultiDimensionalProperty(r, i, a, s);
        else
          switch (n) {
            case 0:
              l = new KeyframedValueProperty(r, i, a, s);
              break;
            case 1:
              l = new KeyframedMultidimensionalProperty(r, i, a, s);
              break;
          }
        return l.effectsSequence.length && s.addDynamicProperty(l), l;
      }
      var t = {
        getProp: e
      };
      return t;
    }();
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var t, r = this.dynamicProperties.length;
        for (t = 0; t < r; t += 1)
          this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(t) {
        this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var pointPool = function() {
      function e() {
        return createTypedArray("float32", 2);
      }
      return poolFactory(8, e);
    }();
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(e, t) {
      this.c = e, this.setLength(t);
      for (var r = 0; r < t; )
        this.v[r] = pointPool.newElement(), this.o[r] = pointPool.newElement(), this.i[r] = pointPool.newElement(), r += 1;
    }, ShapePath.prototype.setLength = function(e) {
      for (; this._maxLength < e; )
        this.doubleArrayLength();
      this._length = e;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(e, t, r, i, n) {
      var a;
      switch (this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), r) {
        case "v":
          a = this.v;
          break;
        case "i":
          a = this.i;
          break;
        case "o":
          a = this.o;
          break;
        default:
          a = [];
          break;
      }
      (!a[i] || a[i] && !n) && (a[i] = pointPool.newElement()), a[i][0] = e, a[i][1] = t;
    }, ShapePath.prototype.setTripleAt = function(e, t, r, i, n, a, s, l) {
      this.setXYAt(e, t, "v", s, l), this.setXYAt(r, i, "o", s, l), this.setXYAt(n, a, "i", s, l);
    }, ShapePath.prototype.reverse = function() {
      var e = new ShapePath();
      e.setPathData(this.c, this._length);
      var t = this.v, r = this.o, i = this.i, n = 0;
      this.c && (e.setTripleAt(t[0][0], t[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1), n = 1);
      var a = this._length - 1, s = this._length, l;
      for (l = n; l < s; l += 1)
        e.setTripleAt(t[a][0], t[a][1], i[a][0], i[a][1], r[a][0], r[a][1], l, !1), a -= 1;
      return e;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = function() {
      function e() {
        return new ShapePath();
      }
      function t(n) {
        var a = n._length, s;
        for (s = 0; s < a; s += 1)
          pointPool.release(n.v[s]), pointPool.release(n.i[s]), pointPool.release(n.o[s]), n.v[s] = null, n.i[s] = null, n.o[s] = null;
        n._length = 0, n.c = !1;
      }
      function r(n) {
        var a = i.newElement(), s, l = n._length === void 0 ? n.v.length : n._length;
        for (a.setLength(l), a.c = n.c, s = 0; s < l; s += 1)
          a.setTripleAt(n.v[s][0], n.v[s][1], n.o[s][0], n.o[s][1], n.i[s][0], n.i[s][1], s);
        return a;
      }
      var i = poolFactory(4, e, t);
      return i.clone = r, i;
    }();
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(e) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = e, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var e;
      for (e = 0; e < this._length; e += 1)
        shapePool.release(this.shapes[e]);
      this._length = 0;
    };
    var shapeCollectionPool = function() {
      var e = {
        newShapeCollection: n,
        release: a
      }, t = 0, r = 4, i = createSizedArray(r);
      function n() {
        var s;
        return t ? (t -= 1, s = i[t]) : s = new ShapeCollection(), s;
      }
      function a(s) {
        var l, o = s._length;
        for (l = 0; l < o; l += 1)
          shapePool.release(s.shapes[l]);
        s._length = 0, t === r && (i = pooling.double(i), r *= 2), i[t] = s, t += 1;
      }
      return e;
    }(), ShapePropertyFactory = function() {
      var e = -999999;
      function t(u, g, p) {
        var y = p.lastIndex, E, T, Z, G, I, V, Y, D, R, B = this.keyframes;
        if (u < B[0].t - this.offsetTime)
          E = B[0].s[0], Z = !0, y = 0;
        else if (u >= B[B.length - 1].t - this.offsetTime)
          E = B[B.length - 1].s ? B[B.length - 1].s[0] : B[B.length - 2].e[0], Z = !0;
        else {
          for (var j = y, N = B.length - 1, P = !0, z, b, k; P && (z = B[j], b = B[j + 1], !(b.t - this.offsetTime > u)); )
            j < N - 1 ? j += 1 : P = !1;
          if (k = this.keyframesMetadata[j] || {}, Z = z.h === 1, y = j, !Z) {
            if (u >= b.t - this.offsetTime)
              D = 1;
            else if (u < z.t - this.offsetTime)
              D = 0;
            else {
              var S;
              k.__fnct ? S = k.__fnct : (S = BezierFactory.getBezierEasing(z.o.x, z.o.y, z.i.x, z.i.y).get, k.__fnct = S), D = S((u - (z.t - this.offsetTime)) / (b.t - this.offsetTime - (z.t - this.offsetTime)));
            }
            T = b.s ? b.s[0] : z.e[0];
          }
          E = z.s[0];
        }
        for (V = g._length, Y = E.i[0].length, p.lastIndex = y, G = 0; G < V; G += 1)
          for (I = 0; I < Y; I += 1)
            R = Z ? E.i[G][I] : E.i[G][I] + (T.i[G][I] - E.i[G][I]) * D, g.i[G][I] = R, R = Z ? E.o[G][I] : E.o[G][I] + (T.o[G][I] - E.o[G][I]) * D, g.o[G][I] = R, R = Z ? E.v[G][I] : E.v[G][I] + (T.v[G][I] - E.v[G][I]) * D, g.v[G][I] = R;
      }
      function r() {
        var u = this.comp.renderedFrame - this.offsetTime, g = this.keyframes[0].t - this.offsetTime, p = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, y = this._caching.lastFrame;
        return y !== e && (y < g && u < g || y > p && u > p) || (this._caching.lastIndex = y < u ? this._caching.lastIndex : 0, this.interpolateShape(u, this.pv, this._caching)), this._caching.lastFrame = u, this.pv;
      }
      function i() {
        this.paths = this.localShapeCollection;
      }
      function n(u, g) {
        if (u._length !== g._length || u.c !== g.c)
          return !1;
        var p, y = u._length;
        for (p = 0; p < y; p += 1)
          if (u.v[p][0] !== g.v[p][0] || u.v[p][1] !== g.v[p][1] || u.o[p][0] !== g.o[p][0] || u.o[p][1] !== g.o[p][1] || u.i[p][0] !== g.i[p][0] || u.i[p][1] !== g.i[p][1])
            return !1;
        return !0;
      }
      function a(u) {
        n(this.v, u) || (this.v = shapePool.clone(u), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function s() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var u;
          this.kf ? u = this.pv : this.data.ks ? u = this.data.ks.k : u = this.data.pt.k;
          var g, p = this.effectsSequence.length;
          for (g = 0; g < p; g += 1)
            u = this.effectsSequence[g](u);
          this.setVValue(u), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function l(u, g, p) {
        this.propType = "shape", this.comp = u.comp, this.container = u, this.elem = u, this.data = g, this.k = !1, this.kf = !1, this._mdf = !1;
        var y = p === 3 ? g.pt.k : g.ks.k;
        this.v = shapePool.clone(y), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = i, this.effectsSequence = [];
      }
      function o(u) {
        this.effectsSequence.push(u), this.container.addDynamicProperty(this);
      }
      l.prototype.interpolateShape = t, l.prototype.getValue = s, l.prototype.setVValue = a, l.prototype.addEffect = o;
      function c(u, g, p) {
        this.propType = "shape", this.comp = u.comp, this.elem = u, this.container = u, this.offsetTime = u.data.st, this.keyframes = p === 3 ? g.pt.k : g.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var y = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, y), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = e, this.reset = i, this._caching = {
          lastFrame: e,
          lastIndex: 0
        }, this.effectsSequence = [r.bind(this)];
      }
      c.prototype.getValue = s, c.prototype.interpolateShape = t, c.prototype.setVValue = a, c.prototype.addEffect = o;
      var f = function() {
        var u = roundCorner;
        function g(p, y) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = y.d, this.elem = p, this.comp = p.comp, this.frameId = -1, this.initDynamicPropertyContainer(p), this.p = PropertyFactory.getProp(p, y.p, 1, 0, this), this.s = PropertyFactory.getProp(p, y.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return g.prototype = {
          reset: i,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var y = this.p.v[0], E = this.p.v[1], T = this.s.v[0] / 2, Z = this.s.v[1] / 2, G = this.d !== 3, I = this.v;
            I.v[0][0] = y, I.v[0][1] = E - Z, I.v[1][0] = G ? y + T : y - T, I.v[1][1] = E, I.v[2][0] = y, I.v[2][1] = E + Z, I.v[3][0] = G ? y - T : y + T, I.v[3][1] = E, I.i[0][0] = G ? y - T * u : y + T * u, I.i[0][1] = E - Z, I.i[1][0] = G ? y + T : y - T, I.i[1][1] = E - Z * u, I.i[2][0] = G ? y + T * u : y - T * u, I.i[2][1] = E + Z, I.i[3][0] = G ? y - T : y + T, I.i[3][1] = E + Z * u, I.o[0][0] = G ? y + T * u : y - T * u, I.o[0][1] = E - Z, I.o[1][0] = G ? y + T : y - T, I.o[1][1] = E + Z * u, I.o[2][0] = G ? y - T * u : y + T * u, I.o[2][1] = E + Z, I.o[3][0] = G ? y - T : y + T, I.o[3][1] = E - Z * u;
          }
        }, extendPrototype([DynamicPropertyContainer], g), g;
      }(), x = function() {
        function u(g, p) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = g, this.comp = g.comp, this.data = p, this.frameId = -1, this.d = p.d, this.initDynamicPropertyContainer(g), p.sy === 1 ? (this.ir = PropertyFactory.getProp(g, p.ir, 0, 0, this), this.is = PropertyFactory.getProp(g, p.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(g, p.pt, 0, 0, this), this.p = PropertyFactory.getProp(g, p.p, 1, 0, this), this.r = PropertyFactory.getProp(g, p.r, 0, degToRads, this), this.or = PropertyFactory.getProp(g, p.or, 0, 0, this), this.os = PropertyFactory.getProp(g, p.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return u.prototype = {
          reset: i,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var p = Math.floor(this.pt.v) * 2, y = Math.PI * 2 / p, E = !0, T = this.or.v, Z = this.ir.v, G = this.os.v, I = this.is.v, V = 2 * Math.PI * T / (p * 2), Y = 2 * Math.PI * Z / (p * 2), D, R, B, j, N = -Math.PI / 2;
            N += this.r.v;
            var P = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, D = 0; D < p; D += 1) {
              R = E ? T : Z, B = E ? G : I, j = E ? V : Y;
              var z = R * Math.cos(N), b = R * Math.sin(N), k = z === 0 && b === 0 ? 0 : b / Math.sqrt(z * z + b * b), S = z === 0 && b === 0 ? 0 : -z / Math.sqrt(z * z + b * b);
              z += +this.p.v[0], b += +this.p.v[1], this.v.setTripleAt(z, b, z - k * j * B * P, b - S * j * B * P, z + k * j * B * P, b + S * j * B * P, D, !0), E = !E, N += y * P;
            }
          },
          convertPolygonToPath: function() {
            var p = Math.floor(this.pt.v), y = Math.PI * 2 / p, E = this.or.v, T = this.os.v, Z = 2 * Math.PI * E / (p * 4), G, I = -Math.PI * 0.5, V = this.data.d === 3 ? -1 : 1;
            for (I += this.r.v, this.v._length = 0, G = 0; G < p; G += 1) {
              var Y = E * Math.cos(I), D = E * Math.sin(I), R = Y === 0 && D === 0 ? 0 : D / Math.sqrt(Y * Y + D * D), B = Y === 0 && D === 0 ? 0 : -Y / Math.sqrt(Y * Y + D * D);
              Y += +this.p.v[0], D += +this.p.v[1], this.v.setTripleAt(Y, D, Y - R * Z * T * V, D - B * Z * T * V, Y + R * Z * T * V, D + B * Z * T * V, G, !0), I += y * V;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, extendPrototype([DynamicPropertyContainer], u), u;
      }(), m = function() {
        function u(g, p) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = g, this.comp = g.comp, this.frameId = -1, this.d = p.d, this.initDynamicPropertyContainer(g), this.p = PropertyFactory.getProp(g, p.p, 1, 0, this), this.s = PropertyFactory.getProp(g, p.s, 1, 0, this), this.r = PropertyFactory.getProp(g, p.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return u.prototype = {
          convertRectToPath: function() {
            var p = this.p.v[0], y = this.p.v[1], E = this.s.v[0] / 2, T = this.s.v[1] / 2, Z = bmMin(E, T, this.r.v), G = Z * (1 - roundCorner);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(p + E, y - T + Z, p + E, y - T + Z, p + E, y - T + G, 0, !0), this.v.setTripleAt(p + E, y + T - Z, p + E, y + T - G, p + E, y + T - Z, 1, !0), Z !== 0 ? (this.v.setTripleAt(p + E - Z, y + T, p + E - Z, y + T, p + E - G, y + T, 2, !0), this.v.setTripleAt(p - E + Z, y + T, p - E + G, y + T, p - E + Z, y + T, 3, !0), this.v.setTripleAt(p - E, y + T - Z, p - E, y + T - Z, p - E, y + T - G, 4, !0), this.v.setTripleAt(p - E, y - T + Z, p - E, y - T + G, p - E, y - T + Z, 5, !0), this.v.setTripleAt(p - E + Z, y - T, p - E + Z, y - T, p - E + G, y - T, 6, !0), this.v.setTripleAt(p + E - Z, y - T, p + E - G, y - T, p + E - Z, y - T, 7, !0)) : (this.v.setTripleAt(p - E, y + T, p - E + G, y + T, p - E, y + T, 2), this.v.setTripleAt(p - E, y - T, p - E, y - T + G, p - E, y - T, 3))) : (this.v.setTripleAt(p + E, y - T + Z, p + E, y - T + G, p + E, y - T + Z, 0, !0), Z !== 0 ? (this.v.setTripleAt(p + E - Z, y - T, p + E - Z, y - T, p + E - G, y - T, 1, !0), this.v.setTripleAt(p - E + Z, y - T, p - E + G, y - T, p - E + Z, y - T, 2, !0), this.v.setTripleAt(p - E, y - T + Z, p - E, y - T + Z, p - E, y - T + G, 3, !0), this.v.setTripleAt(p - E, y + T - Z, p - E, y + T - G, p - E, y + T - Z, 4, !0), this.v.setTripleAt(p - E + Z, y + T, p - E + Z, y + T, p - E + G, y + T, 5, !0), this.v.setTripleAt(p + E - Z, y + T, p + E - G, y + T, p + E - Z, y + T, 6, !0), this.v.setTripleAt(p + E, y + T - Z, p + E, y + T - Z, p + E, y + T - G, 7, !0)) : (this.v.setTripleAt(p - E, y - T, p - E + G, y - T, p - E, y - T, 1, !0), this.v.setTripleAt(p - E, y + T, p - E, y + T - G, p - E, y + T, 2, !0), this.v.setTripleAt(p + E, y + T, p + E - G, y + T, p + E, y + T, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: i
        }, extendPrototype([DynamicPropertyContainer], u), u;
      }();
      function A(u, g, p) {
        var y;
        if (p === 3 || p === 4) {
          var E = p === 3 ? g.pt : g.ks, T = E.k;
          T.length ? y = new c(u, g, p) : y = new l(u, g, p);
        } else
          p === 5 ? y = new m(u, g) : p === 6 ? y = new f(u, g) : p === 7 && (y = new x(u, g));
        return y.k && u.addDynamicProperty(y), y;
      }
      function M() {
        return l;
      }
      function d() {
        return c;
      }
      var C = {};
      return C.getShapeProp = A, C.getConstructorFunction = M, C.getKeyframedConstructorFunction = d, C;
    }();
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var Matrix = function() {
      var e = Math.cos, t = Math.sin, r = Math.tan, i = Math.round;
      function n() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function a(z) {
        if (z === 0)
          return this;
        var b = e(z), k = t(z);
        return this._t(b, -k, 0, 0, k, b, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function s(z) {
        if (z === 0)
          return this;
        var b = e(z), k = t(z);
        return this._t(1, 0, 0, 0, 0, b, -k, 0, 0, k, b, 0, 0, 0, 0, 1);
      }
      function l(z) {
        if (z === 0)
          return this;
        var b = e(z), k = t(z);
        return this._t(b, 0, k, 0, 0, 1, 0, 0, -k, 0, b, 0, 0, 0, 0, 1);
      }
      function o(z) {
        if (z === 0)
          return this;
        var b = e(z), k = t(z);
        return this._t(b, -k, 0, 0, k, b, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function c(z, b) {
        return this._t(1, b, z, 1, 0, 0);
      }
      function f(z, b) {
        return this.shear(r(z), r(b));
      }
      function x(z, b) {
        var k = e(b), S = t(b);
        return this._t(k, S, 0, 0, -S, k, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r(z), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(k, -S, 0, 0, S, k, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function m(z, b, k) {
        return !k && k !== 0 && (k = 1), z === 1 && b === 1 && k === 1 ? this : this._t(z, 0, 0, 0, 0, b, 0, 0, 0, 0, k, 0, 0, 0, 0, 1);
      }
      function A(z, b, k, S, F, Q, L, W, q, _, ee, se, ae, re, me, $) {
        return this.props[0] = z, this.props[1] = b, this.props[2] = k, this.props[3] = S, this.props[4] = F, this.props[5] = Q, this.props[6] = L, this.props[7] = W, this.props[8] = q, this.props[9] = _, this.props[10] = ee, this.props[11] = se, this.props[12] = ae, this.props[13] = re, this.props[14] = me, this.props[15] = $, this;
      }
      function M(z, b, k) {
        return k = k || 0, z !== 0 || b !== 0 || k !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, z, b, k, 1) : this;
      }
      function d(z, b, k, S, F, Q, L, W, q, _, ee, se, ae, re, me, $) {
        var O = this.props;
        if (z === 1 && b === 0 && k === 0 && S === 0 && F === 0 && Q === 1 && L === 0 && W === 0 && q === 0 && _ === 0 && ee === 1 && se === 0)
          return O[12] = O[12] * z + O[15] * ae, O[13] = O[13] * Q + O[15] * re, O[14] = O[14] * ee + O[15] * me, O[15] *= $, this._identityCalculated = !1, this;
        var ge = O[0], he = O[1], le = O[2], ce = O[3], K = O[4], ue = O[5], ie = O[6], Ae = O[7], te = O[8], U = O[9], ne = O[10], oe = O[11], Ze = O[12], Se = O[13], xe = O[14], ze = O[15];
        return O[0] = ge * z + he * F + le * q + ce * ae, O[1] = ge * b + he * Q + le * _ + ce * re, O[2] = ge * k + he * L + le * ee + ce * me, O[3] = ge * S + he * W + le * se + ce * $, O[4] = K * z + ue * F + ie * q + Ae * ae, O[5] = K * b + ue * Q + ie * _ + Ae * re, O[6] = K * k + ue * L + ie * ee + Ae * me, O[7] = K * S + ue * W + ie * se + Ae * $, O[8] = te * z + U * F + ne * q + oe * ae, O[9] = te * b + U * Q + ne * _ + oe * re, O[10] = te * k + U * L + ne * ee + oe * me, O[11] = te * S + U * W + ne * se + oe * $, O[12] = Ze * z + Se * F + xe * q + ze * ae, O[13] = Ze * b + Se * Q + xe * _ + ze * re, O[14] = Ze * k + Se * L + xe * ee + ze * me, O[15] = Ze * S + Se * W + xe * se + ze * $, this._identityCalculated = !1, this;
      }
      function C(z) {
        var b = z.props;
        return this.transform(b[0], b[1], b[2], b[3], b[4], b[5], b[6], b[7], b[8], b[9], b[10], b[11], b[12], b[13], b[14], b[15]);
      }
      function u() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function g(z) {
        for (var b = 0; b < 16; ) {
          if (z.props[b] !== this.props[b])
            return !1;
          b += 1;
        }
        return !0;
      }
      function p(z) {
        var b;
        for (b = 0; b < 16; b += 1)
          z.props[b] = this.props[b];
        return z;
      }
      function y(z) {
        var b;
        for (b = 0; b < 16; b += 1)
          this.props[b] = z[b];
      }
      function E(z, b, k) {
        return {
          x: z * this.props[0] + b * this.props[4] + k * this.props[8] + this.props[12],
          y: z * this.props[1] + b * this.props[5] + k * this.props[9] + this.props[13],
          z: z * this.props[2] + b * this.props[6] + k * this.props[10] + this.props[14]
        };
      }
      function T(z, b, k) {
        return z * this.props[0] + b * this.props[4] + k * this.props[8] + this.props[12];
      }
      function Z(z, b, k) {
        return z * this.props[1] + b * this.props[5] + k * this.props[9] + this.props[13];
      }
      function G(z, b, k) {
        return z * this.props[2] + b * this.props[6] + k * this.props[10] + this.props[14];
      }
      function I() {
        var z = this.props[0] * this.props[5] - this.props[1] * this.props[4], b = this.props[5] / z, k = -this.props[1] / z, S = -this.props[4] / z, F = this.props[0] / z, Q = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / z, L = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / z, W = new Matrix();
        return W.props[0] = b, W.props[1] = k, W.props[4] = S, W.props[5] = F, W.props[12] = Q, W.props[13] = L, W;
      }
      function V(z) {
        var b = this.getInverseMatrix();
        return b.applyToPointArray(z[0], z[1], z[2] || 0);
      }
      function Y(z) {
        var b, k = z.length, S = [];
        for (b = 0; b < k; b += 1)
          S[b] = V(z[b]);
        return S;
      }
      function D(z, b, k) {
        var S = createTypedArray("float32", 6);
        if (this.isIdentity())
          S[0] = z[0], S[1] = z[1], S[2] = b[0], S[3] = b[1], S[4] = k[0], S[5] = k[1];
        else {
          var F = this.props[0], Q = this.props[1], L = this.props[4], W = this.props[5], q = this.props[12], _ = this.props[13];
          S[0] = z[0] * F + z[1] * L + q, S[1] = z[0] * Q + z[1] * W + _, S[2] = b[0] * F + b[1] * L + q, S[3] = b[0] * Q + b[1] * W + _, S[4] = k[0] * F + k[1] * L + q, S[5] = k[0] * Q + k[1] * W + _;
        }
        return S;
      }
      function R(z, b, k) {
        var S;
        return this.isIdentity() ? S = [z, b, k] : S = [z * this.props[0] + b * this.props[4] + k * this.props[8] + this.props[12], z * this.props[1] + b * this.props[5] + k * this.props[9] + this.props[13], z * this.props[2] + b * this.props[6] + k * this.props[10] + this.props[14]], S;
      }
      function B(z, b) {
        if (this.isIdentity())
          return z + "," + b;
        var k = this.props;
        return Math.round((z * k[0] + b * k[4] + k[12]) * 100) / 100 + "," + Math.round((z * k[1] + b * k[5] + k[13]) * 100) / 100;
      }
      function j() {
        for (var z = 0, b = this.props, k = "matrix3d(", S = 1e4; z < 16; )
          k += i(b[z] * S) / S, k += z === 15 ? ")" : ",", z += 1;
        return k;
      }
      function N(z) {
        var b = 1e4;
        return z < 1e-6 && z > 0 || z > -1e-6 && z < 0 ? i(z * b) / b : z;
      }
      function P() {
        var z = this.props, b = N(z[0]), k = N(z[1]), S = N(z[4]), F = N(z[5]), Q = N(z[12]), L = N(z[13]);
        return "matrix(" + b + "," + k + "," + S + "," + F + "," + Q + "," + L + ")";
      }
      return function() {
        this.reset = n, this.rotate = a, this.rotateX = s, this.rotateY = l, this.rotateZ = o, this.skew = f, this.skewFromAxis = x, this.shear = c, this.scale = m, this.setTransform = A, this.translate = M, this.transform = d, this.multiply = C, this.applyToPoint = E, this.applyToX = T, this.applyToY = Z, this.applyToZ = G, this.applyToPointArray = R, this.applyToTriplePoints = D, this.applyToPointStringified = B, this.toCSS = j, this.to2dCSS = P, this.clone = p, this.cloneFromProps = y, this.equals = g, this.inversePoints = Y, this.inversePoint = V, this.getInverseMatrix = I, this._t = this.transform, this.isIdentity = u, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(r) {
        return typeof r;
      } : _typeof$3 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$3(e);
    }
    var lottie = {};
    function setLocation(e) {
      setLocationHref(e);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(e) {
      setSubframeEnabled(e);
    }
    function setPrefix(e) {
      setIdPrefix(e);
    }
    function loadAnimation(e) {
      return animationManager.loadAnimation(e);
    }
    function setQuality(e) {
      if (typeof e == "string")
        switch (e) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
            break;
        }
      else
        !isNaN(e) && e > 1 && setDefaultCurveSegments(e);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(e, t) {
      e === "expressions" && setExpressionsPlugin(t);
    }
    function getFactory(e) {
      switch (e) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(e) {
      for (var t = queryString.split("&"), r = 0; r < t.length; r += 1) {
        var i = t[r].split("=");
        if (decodeURIComponent(i[0]) == e)
          return decodeURIComponent(i[1]);
      }
      return null;
    }
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
        src: ""
      };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (e) {
    }
    var ShapeModifiers = function() {
      var e = {}, t = {};
      e.registerModifier = r, e.getModifier = i;
      function r(n, a) {
        t[n] || (t[n] = a);
      }
      function i(n, a, s) {
        return new t[n](a, s);
      }
      return e;
    }();
    function ShapeModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(e) {
      if (!this.closed) {
        e.sh.container.addDynamicProperty(e.sh);
        var t = {
          shape: e.sh,
          data: e,
          localShapeCollection: shapeCollectionPool.newShapeCollection()
        };
        this.shapes.push(t), this.addShapeToModifier(t), this._isAnimated && e.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(e, t) {
      this.shapes = [], this.elem = e, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
    function TrimModifier() {
    }
    extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(e, t) {
      this.s = PropertyFactory.getProp(e, t.s, 0, 0.01, this), this.e = PropertyFactory.getProp(e, t.e, 0, 0.01, this), this.o = PropertyFactory.getProp(e, t.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = t.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(e) {
      e.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(e, t, r, i, n) {
      var a = [];
      t <= 1 ? a.push({
        s: e,
        e: t
      }) : e >= 1 ? a.push({
        s: e - 1,
        e: t - 1
      }) : (a.push({
        s: e,
        e: 1
      }), a.push({
        s: 0,
        e: t - 1
      }));
      var s = [], l, o = a.length, c;
      for (l = 0; l < o; l += 1)
        if (c = a[l], !(c.e * n < i || c.s * n > i + r)) {
          var f, x;
          c.s * n <= i ? f = 0 : f = (c.s * n - i) / r, c.e * n >= i + r ? x = 1 : x = (c.e * n - i) / r, s.push([f, x]);
        }
      return s.length || s.push([0, 0]), s;
    }, TrimModifier.prototype.releasePathsData = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        segmentsLengthPool.release(e[t]);
      return e.length = 0, e;
    }, TrimModifier.prototype.processShapes = function(e) {
      var t, r;
      if (this._mdf || e) {
        var i = this.o.v % 360 / 360;
        if (i < 0 && (i += 1), this.s.v > 1 ? t = 1 + i : this.s.v < 0 ? t = 0 + i : t = this.s.v + i, this.e.v > 1 ? r = 1 + i : this.e.v < 0 ? r = 0 + i : r = this.e.v + i, t > r) {
          var n = t;
          t = r, r = n;
        }
        t = Math.round(t * 1e4) * 1e-4, r = Math.round(r * 1e4) * 1e-4, this.sValue = t, this.eValue = r;
      } else
        t = this.sValue, r = this.eValue;
      var a, s, l = this.shapes.length, o, c, f, x, m, A = 0;
      if (r === t)
        for (s = 0; s < l; s += 1)
          this.shapes[s].localShapeCollection.releaseShapes(), this.shapes[s].shape._mdf = !0, this.shapes[s].shape.paths = this.shapes[s].localShapeCollection, this._mdf && (this.shapes[s].pathsData.length = 0);
      else if (r === 1 && t === 0 || r === 0 && t === 1) {
        if (this._mdf)
          for (s = 0; s < l; s += 1)
            this.shapes[s].pathsData.length = 0, this.shapes[s].shape._mdf = !0;
      } else {
        var M = [], d, C;
        for (s = 0; s < l; s += 1)
          if (d = this.shapes[s], !d.shape._mdf && !this._mdf && !e && this.m !== 2)
            d.shape.paths = d.localShapeCollection;
          else {
            if (a = d.shape.paths, c = a._length, m = 0, !d.shape._mdf && d.pathsData.length)
              m = d.totalShapeLength;
            else {
              for (f = this.releasePathsData(d.pathsData), o = 0; o < c; o += 1)
                x = bez.getSegmentsLength(a.shapes[o]), f.push(x), m += x.totalLength;
              d.totalShapeLength = m, d.pathsData = f;
            }
            A += m, d.shape._mdf = !0;
          }
        var u = t, g = r, p = 0, y;
        for (s = l - 1; s >= 0; s -= 1)
          if (d = this.shapes[s], d.shape._mdf) {
            for (C = d.localShapeCollection, C.releaseShapes(), this.m === 2 && l > 1 ? (y = this.calculateShapeEdges(t, r, d.totalShapeLength, p, A), p += d.totalShapeLength) : y = [[u, g]], c = y.length, o = 0; o < c; o += 1) {
              u = y[o][0], g = y[o][1], M.length = 0, g <= 1 ? M.push({
                s: d.totalShapeLength * u,
                e: d.totalShapeLength * g
              }) : u >= 1 ? M.push({
                s: d.totalShapeLength * (u - 1),
                e: d.totalShapeLength * (g - 1)
              }) : (M.push({
                s: d.totalShapeLength * u,
                e: d.totalShapeLength
              }), M.push({
                s: 0,
                e: d.totalShapeLength * (g - 1)
              }));
              var E = this.addShapes(d, M[0]);
              if (M[0].s !== M[0].e) {
                if (M.length > 1) {
                  var T = d.shape.paths.shapes[d.shape.paths._length - 1];
                  if (T.c) {
                    var Z = E.pop();
                    this.addPaths(E, C), E = this.addShapes(d, M[1], Z);
                  } else
                    this.addPaths(E, C), E = this.addShapes(d, M[1]);
                }
                this.addPaths(E, C);
              }
            }
            d.shape.paths = C;
          }
      }
    }, TrimModifier.prototype.addPaths = function(e, t) {
      var r, i = e.length;
      for (r = 0; r < i; r += 1)
        t.addShape(e[r]);
    }, TrimModifier.prototype.addSegment = function(e, t, r, i, n, a, s) {
      n.setXYAt(t[0], t[1], "o", a), n.setXYAt(r[0], r[1], "i", a + 1), s && n.setXYAt(e[0], e[1], "v", a), n.setXYAt(i[0], i[1], "v", a + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(e, t, r, i) {
      t.setXYAt(e[1], e[5], "o", r), t.setXYAt(e[2], e[6], "i", r + 1), i && t.setXYAt(e[0], e[4], "v", r), t.setXYAt(e[3], e[7], "v", r + 1);
    }, TrimModifier.prototype.addShapes = function(e, t, r) {
      var i = e.pathsData, n = e.shape.paths.shapes, a, s = e.shape.paths._length, l, o, c = 0, f, x, m, A, M = [], d, C = !0;
      for (r ? (x = r._length, d = r._length) : (r = shapePool.newElement(), x = 0, d = 0), M.push(r), a = 0; a < s; a += 1) {
        for (m = i[a].lengths, r.c = n[a].c, o = n[a].c ? m.length : m.length + 1, l = 1; l < o; l += 1)
          if (f = m[l - 1], c + f.addedLength < t.s)
            c += f.addedLength, r.c = !1;
          else if (c > t.e) {
            r.c = !1;
            break;
          } else
            t.s <= c && t.e >= c + f.addedLength ? (this.addSegment(n[a].v[l - 1], n[a].o[l - 1], n[a].i[l], n[a].v[l], r, x, C), C = !1) : (A = bez.getNewSegment(n[a].v[l - 1], n[a].v[l], n[a].o[l - 1], n[a].i[l], (t.s - c) / f.addedLength, (t.e - c) / f.addedLength, m[l - 1]), this.addSegmentFromArray(A, r, x, C), C = !1, r.c = !1), c += f.addedLength, x += 1;
        if (n[a].c && m.length) {
          if (f = m[l - 1], c <= t.e) {
            var u = m[l - 1].addedLength;
            t.s <= c && t.e >= c + u ? (this.addSegment(n[a].v[l - 1], n[a].o[l - 1], n[a].i[0], n[a].v[0], r, x, C), C = !1) : (A = bez.getNewSegment(n[a].v[l - 1], n[a].v[0], n[a].o[l - 1], n[a].i[0], (t.s - c) / u, (t.e - c) / u, m[l - 1]), this.addSegmentFromArray(A, r, x, C), C = !1, r.c = !1);
          } else
            r.c = !1;
          c += f.addedLength, x += 1;
        }
        if (r._length && (r.setXYAt(r.v[d][0], r.v[d][1], "i", d), r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], "o", r._length - 1)), c > t.e)
          break;
        a < s - 1 && (r = shapePool.newElement(), C = !0, M.push(r), x = 0);
      }
      return M;
    };
    function PuckerAndBloatModifier() {
    }
    extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(e, t) {
      var r = t / 100, i = [0, 0], n = e._length, a = 0;
      for (a = 0; a < n; a += 1)
        i[0] += e.v[a][0], i[1] += e.v[a][1];
      i[0] /= n, i[1] /= n;
      var s = shapePool.newElement();
      s.c = e.c;
      var l, o, c, f, x, m;
      for (a = 0; a < n; a += 1)
        l = e.v[a][0] + (i[0] - e.v[a][0]) * r, o = e.v[a][1] + (i[1] - e.v[a][1]) * r, c = e.o[a][0] + (i[0] - e.o[a][0]) * -r, f = e.o[a][1] + (i[1] - e.o[a][1]) * -r, x = e.i[a][0] + (i[0] - e.i[a][0]) * -r, m = e.i[a][1] + (i[1] - e.i[a][1]) * -r, s.setTripleAt(l, o, c, f, x, m, a);
      return s;
    }, PuckerAndBloatModifier.prototype.processShapes = function(e) {
      var t, r, i = this.shapes.length, n, a, s = this.amount.v;
      if (s !== 0) {
        var l, o;
        for (r = 0; r < i; r += 1) {
          if (l = this.shapes[r], o = l.localShapeCollection, !(!l.shape._mdf && !this._mdf && !e))
            for (o.releaseShapes(), l.shape._mdf = !0, t = l.shape.paths.shapes, a = l.shape.paths._length, n = 0; n < a; n += 1)
              o.addShape(this.processPath(t[n], s));
          l.shape.paths = l.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var e = [0, 0];
      function t(o) {
        var c = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || c, this.a && o.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && o.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && o.skewFromAxis(-this.sk.v, this.sa.v), this.r ? o.rotate(-this.r.v) : o.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? o.translate(this.px.v, this.py.v, -this.pz.v) : o.translate(this.px.v, this.py.v, 0) : o.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function r(o) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || o) {
            var c;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var f, x;
              if (c = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (f = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / c, 0), x = this.p.getValueAtTime(this.p.keyframes[0].t / c, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (f = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / c, 0), x = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / c, 0)) : (f = this.p.pv, x = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / c, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                f = [], x = [];
                var m = this.px, A = this.py;
                m._caching.lastFrame + m.offsetTime <= m.keyframes[0].t ? (f[0] = m.getValueAtTime((m.keyframes[0].t + 0.01) / c, 0), f[1] = A.getValueAtTime((A.keyframes[0].t + 0.01) / c, 0), x[0] = m.getValueAtTime(m.keyframes[0].t / c, 0), x[1] = A.getValueAtTime(A.keyframes[0].t / c, 0)) : m._caching.lastFrame + m.offsetTime >= m.keyframes[m.keyframes.length - 1].t ? (f[0] = m.getValueAtTime(m.keyframes[m.keyframes.length - 1].t / c, 0), f[1] = A.getValueAtTime(A.keyframes[A.keyframes.length - 1].t / c, 0), x[0] = m.getValueAtTime((m.keyframes[m.keyframes.length - 1].t - 0.01) / c, 0), x[1] = A.getValueAtTime((A.keyframes[A.keyframes.length - 1].t - 0.01) / c, 0)) : (f = [m.pv, A.pv], x[0] = m.getValueAtTime((m._caching.lastFrame + m.offsetTime - 0.01) / c, m.offsetTime), x[1] = A.getValueAtTime((A._caching.lastFrame + A.offsetTime - 0.01) / c, A.offsetTime));
              } else
                x = e, f = x;
              this.v.rotate(-Math.atan2(f[1] - x[1], f[0] - x[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function i() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function n() {
      }
      function a(o) {
        this._addDynamicProperty(o), this.elem.addDynamicProperty(o), this._isDirty = !0;
      }
      function s(o, c, f) {
        if (this.elem = o, this.frameId = -1, this.propType = "transform", this.data = c, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(f || o), c.p && c.p.s ? (this.px = PropertyFactory.getProp(o, c.p.x, 0, 0, this), this.py = PropertyFactory.getProp(o, c.p.y, 0, 0, this), c.p.z && (this.pz = PropertyFactory.getProp(o, c.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(o, c.p || {
          k: [0, 0, 0]
        }, 1, 0, this), c.rx) {
          if (this.rx = PropertyFactory.getProp(o, c.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(o, c.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(o, c.rz, 0, degToRads, this), c.or.k[0].ti) {
            var x, m = c.or.k.length;
            for (x = 0; x < m; x += 1)
              c.or.k[x].to = null, c.or.k[x].ti = null;
          }
          this.or = PropertyFactory.getProp(o, c.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(o, c.r || {
            k: 0
          }, 0, degToRads, this);
        c.sk && (this.sk = PropertyFactory.getProp(o, c.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(o, c.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(o, c.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = PropertyFactory.getProp(o, c.s || {
          k: [100, 100, 100]
        }, 1, 0.01, this), c.o ? this.o = PropertyFactory.getProp(o, c.o, 0, 0.01, o) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      s.prototype = {
        applyToMatrix: t,
        getValue: r,
        precalculateMatrix: i,
        autoOrient: n
      }, extendPrototype([DynamicPropertyContainer], s), s.prototype.addDynamicProperty = a, s.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
      function l(o, c, f) {
        return new s(o, c, f);
      }
      return {
        getTransformProperty: l
      };
    }();
    function RepeaterModifier() {
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(e, t.c, 0, null, this), this.o = PropertyFactory.getProp(e, t.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(e, t.tr, this), this.so = PropertyFactory.getProp(e, t.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(e, t.tr.eo, 0, 0.01, this), this.data = t, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(e, t, r, i, n, a) {
      var s = a ? -1 : 1, l = i.s.v[0] + (1 - i.s.v[0]) * (1 - n), o = i.s.v[1] + (1 - i.s.v[1]) * (1 - n);
      e.translate(i.p.v[0] * s * n, i.p.v[1] * s * n, i.p.v[2]), t.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), t.rotate(-i.r.v * s * n), t.translate(i.a.v[0], i.a.v[1], i.a.v[2]), r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), r.scale(a ? 1 / l : l, a ? 1 / o : o), r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
    }, RepeaterModifier.prototype.init = function(e, t, r, i) {
      for (this.elem = e, this.arr = t, this.pos = r, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t[r]); r > 0; )
        r -= 1, this._elements.unshift(t[r]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        e[t]._processed = !1, e[t].ty === "gr" && this.resetElements(e[t].it);
    }, RepeaterModifier.prototype.cloneElements = function(e) {
      var t = JSON.parse(JSON.stringify(e));
      return this.resetElements(t), t;
    }, RepeaterModifier.prototype.changeGroupRender = function(e, t) {
      var r, i = e.length;
      for (r = 0; r < i; r += 1)
        e[r]._render = t, e[r].ty === "gr" && this.changeGroupRender(e[r].it, t);
    }, RepeaterModifier.prototype.processShapes = function(e) {
      var t, r, i, n, a, s = !1;
      if (this._mdf || e) {
        var l = Math.ceil(this.c.v);
        if (this._groups.length < l) {
          for (; this._groups.length < l; ) {
            var o = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            o.it.push({
              a: {
                a: 0,
                ix: 1,
                k: [0, 0]
              },
              nm: "Transform",
              o: {
                a: 0,
                ix: 7,
                k: 100
              },
              p: {
                a: 0,
                ix: 2,
                k: [0, 0]
              },
              r: {
                a: 1,
                ix: 6,
                k: [{
                  s: 0,
                  e: 0,
                  t: 0
                }, {
                  s: 0,
                  e: 0,
                  t: 1
                }]
              },
              s: {
                a: 0,
                ix: 3,
                k: [100, 100]
              },
              sa: {
                a: 0,
                ix: 5,
                k: 0
              },
              sk: {
                a: 0,
                ix: 4,
                k: 0
              },
              ty: "tr"
            }), this.arr.splice(0, 0, o), this._groups.splice(0, 0, o), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), s = !0;
        }
        a = 0;
        var c;
        for (i = 0; i <= this._groups.length - 1; i += 1) {
          if (c = a < l, this._groups[i]._render = c, this.changeGroupRender(this._groups[i].it, c), !c) {
            var f = this.elemsData[i].it, x = f[f.length - 1];
            x.transform.op.v !== 0 ? (x.transform.op._mdf = !0, x.transform.op.v = 0) : x.transform.op._mdf = !1;
          }
          a += 1;
        }
        this._currentCopies = l;
        var m = this.o.v, A = m % 1, M = m > 0 ? Math.floor(m) : Math.ceil(m), d = this.pMatrix.props, C = this.rMatrix.props, u = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var g = 0;
        if (m > 0) {
          for (; g < M; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), g += 1;
          A && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, A, !1), g += A);
        } else if (m < 0) {
          for (; g > M; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), g -= 1;
          A && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -A, !0), g -= A);
        }
        i = this.data.m === 1 ? 0 : this._currentCopies - 1, n = this.data.m === 1 ? 1 : -1, a = this._currentCopies;
        for (var p, y; a; ) {
          if (t = this.elemsData[i].it, r = t[t.length - 1].transform.mProps.v.props, y = r.length, t[t.length - 1].transform.mProps._mdf = !0, t[t.length - 1].transform.op._mdf = !0, t[t.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)), g !== 0) {
            for ((i !== 0 && n === 1 || i !== this._currentCopies - 1 && n === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(C[0], C[1], C[2], C[3], C[4], C[5], C[6], C[7], C[8], C[9], C[10], C[11], C[12], C[13], C[14], C[15]), this.matrix.transform(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7], u[8], u[9], u[10], u[11], u[12], u[13], u[14], u[15]), this.matrix.transform(d[0], d[1], d[2], d[3], d[4], d[5], d[6], d[7], d[8], d[9], d[10], d[11], d[12], d[13], d[14], d[15]), p = 0; p < y; p += 1)
              r[p] = this.matrix.props[p];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), p = 0; p < y; p += 1)
              r[p] = this.matrix.props[p];
          g += 1, a -= 1, i += n;
        }
      } else
        for (a = this._currentCopies, i = 0, n = 1; a; )
          t = this.elemsData[i].it, r = t[t.length - 1].transform.mProps.v.props, t[t.length - 1].transform.mProps._mdf = !1, t[t.length - 1].transform.op._mdf = !1, a -= 1, i += n;
      return s;
    }, RepeaterModifier.prototype.addShape = function() {
    };
    function RoundCornersModifier() {
    }
    extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(e, t.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(e, t) {
      var r = shapePool.newElement();
      r.c = e.c;
      var i, n = e._length, a, s, l, o, c, f, x = 0, m, A, M, d, C, u;
      for (i = 0; i < n; i += 1)
        a = e.v[i], l = e.o[i], s = e.i[i], a[0] === l[0] && a[1] === l[1] && a[0] === s[0] && a[1] === s[1] ? (i === 0 || i === n - 1) && !e.c ? (r.setTripleAt(a[0], a[1], l[0], l[1], s[0], s[1], x), x += 1) : (i === 0 ? o = e.v[n - 1] : o = e.v[i - 1], c = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2)), f = c ? Math.min(c / 2, t) / c : 0, C = a[0] + (o[0] - a[0]) * f, m = C, u = a[1] - (a[1] - o[1]) * f, A = u, M = m - (m - a[0]) * roundCorner, d = A - (A - a[1]) * roundCorner, r.setTripleAt(m, A, M, d, C, u, x), x += 1, i === n - 1 ? o = e.v[0] : o = e.v[i + 1], c = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2)), f = c ? Math.min(c / 2, t) / c : 0, M = a[0] + (o[0] - a[0]) * f, m = M, d = a[1] + (o[1] - a[1]) * f, A = d, C = m - (m - a[0]) * roundCorner, u = A - (A - a[1]) * roundCorner, r.setTripleAt(m, A, M, d, C, u, x), x += 1) : (r.setTripleAt(e.v[i][0], e.v[i][1], e.o[i][0], e.o[i][1], e.i[i][0], e.i[i][1], x), x += 1);
      return r;
    }, RoundCornersModifier.prototype.processShapes = function(e) {
      var t, r, i = this.shapes.length, n, a, s = this.rd.v;
      if (s !== 0) {
        var l, o;
        for (r = 0; r < i; r += 1) {
          if (l = this.shapes[r], o = l.localShapeCollection, !(!l.shape._mdf && !this._mdf && !e))
            for (o.releaseShapes(), l.shape._mdf = !0, t = l.shape.paths.shapes, a = l.shape.paths._length, n = 0; n < a; n += 1)
              o.addShape(this.processPath(t[n], s));
          l.shape.paths = l.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function floatEqual(e, t) {
      return Math.abs(e - t) * 1e5 <= Math.min(Math.abs(e), Math.abs(t));
    }
    function floatZero(e) {
      return Math.abs(e) <= 1e-5;
    }
    function lerp(e, t, r) {
      return e * (1 - r) + t * r;
    }
    function lerpPoint(e, t, r) {
      return [lerp(e[0], t[0], r), lerp(e[1], t[1], r)];
    }
    function quadRoots(e, t, r) {
      if (e === 0)
        return [];
      var i = t * t - 4 * e * r;
      if (i < 0)
        return [];
      var n = -t / (2 * e);
      if (i === 0)
        return [n];
      var a = Math.sqrt(i) / (2 * e);
      return [n - a, n + a];
    }
    function polynomialCoefficients(e, t, r, i) {
      return [-e + 3 * t - 3 * r + i, 3 * e - 6 * t + 3 * r, -3 * e + 3 * t, e];
    }
    function singlePoint(e) {
      return new PolynomialBezier(e, e, e, e, !1);
    }
    function PolynomialBezier(e, t, r, i, n) {
      n && pointEqual(e, t) && (t = lerpPoint(e, i, 1 / 3)), n && pointEqual(r, i) && (r = lerpPoint(e, i, 2 / 3));
      var a = polynomialCoefficients(e[0], t[0], r[0], i[0]), s = polynomialCoefficients(e[1], t[1], r[1], i[1]);
      this.a = [a[0], s[0]], this.b = [a[1], s[1]], this.c = [a[2], s[2]], this.d = [a[3], s[3]], this.points = [e, t, r, i];
    }
    PolynomialBezier.prototype.point = function(e) {
      return [((this.a[0] * e + this.b[0]) * e + this.c[0]) * e + this.d[0], ((this.a[1] * e + this.b[1]) * e + this.c[1]) * e + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(e) {
      return [(3 * e * this.a[0] + 2 * this.b[0]) * e + this.c[0], (3 * e * this.a[1] + 2 * this.b[1]) * e + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[1], t[0]);
    }, PolynomialBezier.prototype.normalAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[0], t[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var e = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(e))
        return [];
      var t = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / e, r = t * t - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / e;
      if (r < 0)
        return [];
      var i = Math.sqrt(r);
      return floatZero(i) ? i > 0 && i < 1 ? [t] : [] : [t - i, t + i].filter(function(n) {
        return n > 0 && n < 1;
      });
    }, PolynomialBezier.prototype.split = function(e) {
      if (e <= 0)
        return [singlePoint(this.points[0]), this];
      if (e >= 1)
        return [this, singlePoint(this.points[this.points.length - 1])];
      var t = lerpPoint(this.points[0], this.points[1], e), r = lerpPoint(this.points[1], this.points[2], e), i = lerpPoint(this.points[2], this.points[3], e), n = lerpPoint(t, r, e), a = lerpPoint(r, i, e), s = lerpPoint(n, a, e);
      return [new PolynomialBezier(this.points[0], t, n, s, !0), new PolynomialBezier(s, a, i, this.points[3], !0)];
    };
    function extrema(e, t) {
      var r = e.points[0][t], i = e.points[e.points.length - 1][t];
      if (r > i) {
        var n = i;
        i = r, r = n;
      }
      for (var a = quadRoots(3 * e.a[t], 2 * e.b[t], e.c[t]), s = 0; s < a.length; s += 1)
        if (a[s] > 0 && a[s] < 1) {
          var l = e.point(a[s])[t];
          l < r ? r = l : l > i && (i = l);
        }
      return {
        min: r,
        max: i
      };
    }
    PolynomialBezier.prototype.bounds = function() {
      return {
        x: extrema(this, 0),
        y: extrema(this, 1)
      };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var e = this.bounds();
      return {
        left: e.x.min,
        right: e.x.max,
        top: e.y.min,
        bottom: e.y.max,
        width: e.x.max - e.x.min,
        height: e.y.max - e.y.min,
        cx: (e.x.max + e.x.min) / 2,
        cy: (e.y.max + e.y.min) / 2
      };
    };
    function intersectData(e, t, r) {
      var i = e.boundingBox();
      return {
        cx: i.cx,
        cy: i.cy,
        width: i.width,
        height: i.height,
        bez: e,
        t: (t + r) / 2,
        t1: t,
        t2: r
      };
    }
    function splitData(e) {
      var t = e.bez.split(0.5);
      return [intersectData(t[0], e.t1, e.t), intersectData(t[1], e.t, e.t2)];
    }
    function boxIntersect(e, t) {
      return Math.abs(e.cx - t.cx) * 2 < e.width + t.width && Math.abs(e.cy - t.cy) * 2 < e.height + t.height;
    }
    function intersectsImpl(e, t, r, i, n, a) {
      if (boxIntersect(e, t)) {
        if (r >= a || e.width <= i && e.height <= i && t.width <= i && t.height <= i) {
          n.push([e.t, t.t]);
          return;
        }
        var s = splitData(e), l = splitData(t);
        intersectsImpl(s[0], l[0], r + 1, i, n, a), intersectsImpl(s[0], l[1], r + 1, i, n, a), intersectsImpl(s[1], l[0], r + 1, i, n, a), intersectsImpl(s[1], l[1], r + 1, i, n, a);
      }
    }
    PolynomialBezier.prototype.intersections = function(e, t, r) {
      t === void 0 && (t = 2), r === void 0 && (r = 7);
      var i = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(e, 0, 1), 0, t, i, r), i;
    }, PolynomialBezier.shapeSegment = function(e, t) {
      var r = (t + 1) % e.length();
      return new PolynomialBezier(e.v[t], e.o[t], e.i[r], e.v[r], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(e, t) {
      var r = (t + 1) % e.length();
      return new PolynomialBezier(e.v[r], e.i[r], e.o[t], e.v[t], !0);
    };
    function crossProduct(e, t) {
      return [e[1] * t[2] - e[2] * t[1], e[2] * t[0] - e[0] * t[2], e[0] * t[1] - e[1] * t[0]];
    }
    function lineIntersection(e, t, r, i) {
      var n = [e[0], e[1], 1], a = [t[0], t[1], 1], s = [r[0], r[1], 1], l = [i[0], i[1], 1], o = crossProduct(crossProduct(n, a), crossProduct(s, l));
      return floatZero(o[2]) ? null : [o[0] / o[2], o[1] / o[2]];
    }
    function polarOffset(e, t, r) {
      return [e[0] + Math.cos(t) * r, e[1] - Math.sin(t) * r];
    }
    function pointDistance(e, t) {
      return Math.hypot(e[0] - t[0], e[1] - t[1]);
    }
    function pointEqual(e, t) {
      return floatEqual(e[0], t[0]) && floatEqual(e[1], t[1]);
    }
    function ZigZagModifier() {
    }
    extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(e, t.s, 0, null, this), this.frequency = PropertyFactory.getProp(e, t.r, 0, null, this), this.pointsType = PropertyFactory.getProp(e, t.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(e, t, r, i, n, a, s) {
      var l = r - Math.PI / 2, o = r + Math.PI / 2, c = t[0] + Math.cos(r) * i * n, f = t[1] - Math.sin(r) * i * n;
      e.setTripleAt(c, f, c + Math.cos(l) * a, f - Math.sin(l) * a, c + Math.cos(o) * s, f - Math.sin(o) * s, e.length());
    }
    function getPerpendicularVector(e, t) {
      var r = [t[0] - e[0], t[1] - e[1]], i = -Math.PI * 0.5, n = [Math.cos(i) * r[0] - Math.sin(i) * r[1], Math.sin(i) * r[0] + Math.cos(i) * r[1]];
      return n;
    }
    function getProjectingAngle(e, t) {
      var r = t === 0 ? e.length() - 1 : t - 1, i = (t + 1) % e.length(), n = e.v[r], a = e.v[i], s = getPerpendicularVector(n, a);
      return Math.atan2(0, 1) - Math.atan2(s[1], s[0]);
    }
    function zigZagCorner(e, t, r, i, n, a, s) {
      var l = getProjectingAngle(t, r), o = t.v[r % t._length], c = t.v[r === 0 ? t._length - 1 : r - 1], f = t.v[(r + 1) % t._length], x = a === 2 ? Math.sqrt(Math.pow(o[0] - c[0], 2) + Math.pow(o[1] - c[1], 2)) : 0, m = a === 2 ? Math.sqrt(Math.pow(o[0] - f[0], 2) + Math.pow(o[1] - f[1], 2)) : 0;
      setPoint(e, t.v[r % t._length], l, s, i, m / ((n + 1) * 2), x / ((n + 1) * 2));
    }
    function zigZagSegment(e, t, r, i, n, a) {
      for (var s = 0; s < i; s += 1) {
        var l = (s + 1) / (i + 1), o = n === 2 ? Math.sqrt(Math.pow(t.points[3][0] - t.points[0][0], 2) + Math.pow(t.points[3][1] - t.points[0][1], 2)) : 0, c = t.normalAngle(l), f = t.point(l);
        setPoint(e, f, c, a, r, o / ((i + 1) * 2), o / ((i + 1) * 2)), a = -a;
      }
      return a;
    }
    ZigZagModifier.prototype.processPath = function(e, t, r, i) {
      var n = e._length, a = shapePool.newElement();
      if (a.c = e.c, e.c || (n -= 1), n === 0)
        return a;
      var s = -1, l = PolynomialBezier.shapeSegment(e, 0);
      zigZagCorner(a, e, 0, t, r, i, s);
      for (var o = 0; o < n; o += 1)
        s = zigZagSegment(a, l, t, r, i, -s), o === n - 1 && !e.c ? l = null : l = PolynomialBezier.shapeSegment(e, (o + 1) % n), zigZagCorner(a, e, o + 1, t, r, i, s);
      return a;
    }, ZigZagModifier.prototype.processShapes = function(e) {
      var t, r, i = this.shapes.length, n, a, s = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), o = this.pointsType.v;
      if (s !== 0) {
        var c, f;
        for (r = 0; r < i; r += 1) {
          if (c = this.shapes[r], f = c.localShapeCollection, !(!c.shape._mdf && !this._mdf && !e))
            for (f.releaseShapes(), c.shape._mdf = !0, t = c.shape.paths.shapes, a = c.shape.paths._length, n = 0; n < a; n += 1)
              f.addShape(this.processPath(t[n], s, l, o));
          c.shape.paths = c.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function linearOffset(e, t, r) {
      var i = Math.atan2(t[0] - e[0], t[1] - e[1]);
      return [polarOffset(e, i, r), polarOffset(t, i, r)];
    }
    function offsetSegment(e, t) {
      var r, i, n, a, s, l, o;
      o = linearOffset(e.points[0], e.points[1], t), r = o[0], i = o[1], o = linearOffset(e.points[1], e.points[2], t), n = o[0], a = o[1], o = linearOffset(e.points[2], e.points[3], t), s = o[0], l = o[1];
      var c = lineIntersection(r, i, n, a);
      c === null && (c = i);
      var f = lineIntersection(s, l, n, a);
      return f === null && (f = s), new PolynomialBezier(r, c, f, l);
    }
    function joinLines(e, t, r, i, n) {
      var a = t.points[3], s = r.points[0];
      if (i === 3 || pointEqual(a, s))
        return a;
      if (i === 2) {
        var l = -t.tangentAngle(1), o = -r.tangentAngle(0) + Math.PI, c = lineIntersection(a, polarOffset(a, l + Math.PI / 2, 100), s, polarOffset(s, l + Math.PI / 2, 100)), f = c ? pointDistance(c, a) : pointDistance(a, s) / 2, x = polarOffset(a, l, 2 * f * roundCorner);
        return e.setXYAt(x[0], x[1], "o", e.length() - 1), x = polarOffset(s, o, 2 * f * roundCorner), e.setTripleAt(s[0], s[1], s[0], s[1], x[0], x[1], e.length()), s;
      }
      var m = pointEqual(a, t.points[2]) ? t.points[0] : t.points[2], A = pointEqual(s, r.points[1]) ? r.points[3] : r.points[1], M = lineIntersection(m, a, s, A);
      return M && pointDistance(M, a) < n ? (e.setTripleAt(M[0], M[1], M[0], M[1], M[0], M[1], e.length()), M) : a;
    }
    function getIntersection(e, t) {
      var r = e.intersections(t);
      return r.length && floatEqual(r[0][0], 1) && r.shift(), r.length ? r[0] : null;
    }
    function pruneSegmentIntersection(e, t) {
      var r = e.slice(), i = t.slice(), n = getIntersection(e[e.length - 1], t[0]);
      return n && (r[e.length - 1] = e[e.length - 1].split(n[0])[0], i[0] = t[0].split(n[1])[1]), e.length > 1 && t.length > 1 && (n = getIntersection(e[0], t[t.length - 1]), n) ? [[e[0].split(n[0])[0]], [t[t.length - 1].split(n[1])[1]]] : [r, i];
    }
    function pruneIntersections(e) {
      for (var t, r = 1; r < e.length; r += 1)
        t = pruneSegmentIntersection(e[r - 1], e[r]), e[r - 1] = t[0], e[r] = t[1];
      return e.length > 1 && (t = pruneSegmentIntersection(e[e.length - 1], e[0]), e[e.length - 1] = t[0], e[0] = t[1]), e;
    }
    function offsetSegmentSplit(e, t) {
      var r = e.inflectionPoints(), i, n, a, s;
      if (r.length === 0)
        return [offsetSegment(e, t)];
      if (r.length === 1 || floatEqual(r[1], 1))
        return a = e.split(r[0]), i = a[0], n = a[1], [offsetSegment(i, t), offsetSegment(n, t)];
      a = e.split(r[0]), i = a[0];
      var l = (r[1] - r[0]) / (1 - r[0]);
      return a = a[1].split(l), s = a[0], n = a[1], [offsetSegment(i, t), offsetSegment(s, t), offsetSegment(n, t)];
    }
    function OffsetPathModifier() {
    }
    extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(e, t.ml, 0, null, this), this.lineJoin = t.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(e, t, r, i) {
      var n = shapePool.newElement();
      n.c = e.c;
      var a = e.length();
      e.c || (a -= 1);
      var s, l, o, c = [];
      for (s = 0; s < a; s += 1)
        o = PolynomialBezier.shapeSegment(e, s), c.push(offsetSegmentSplit(o, t));
      if (!e.c)
        for (s = a - 1; s >= 0; s -= 1)
          o = PolynomialBezier.shapeSegmentInverted(e, s), c.push(offsetSegmentSplit(o, t));
      c = pruneIntersections(c);
      var f = null, x = null;
      for (s = 0; s < c.length; s += 1) {
        var m = c[s];
        for (x && (f = joinLines(n, x, m[0], r, i)), x = m[m.length - 1], l = 0; l < m.length; l += 1)
          o = m[l], f && pointEqual(o.points[0], f) ? n.setXYAt(o.points[1][0], o.points[1][1], "o", n.length() - 1) : n.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], n.length()), n.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], n.length()), f = o.points[3];
      }
      return c.length && joinLines(n, x, c[0][0], r, i), n;
    }, OffsetPathModifier.prototype.processShapes = function(e) {
      var t, r, i = this.shapes.length, n, a, s = this.amount.v, l = this.miterLimit.v, o = this.lineJoin;
      if (s !== 0) {
        var c, f;
        for (r = 0; r < i; r += 1) {
          if (c = this.shapes[r], f = c.localShapeCollection, !(!c.shape._mdf && !this._mdf && !e))
            for (f.releaseShapes(), c.shape._mdf = !0, t = c.shape.paths.shapes, a = c.shape.paths._length, n = 0; n < a; n += 1)
              f.addShape(this.processPath(t[n], s, o, l));
          c.shape.paths = c.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function getFontProperties(e) {
      for (var t = e.fStyle ? e.fStyle.split(" ") : [], r = "normal", i = "normal", n = t.length, a, s = 0; s < n; s += 1)
        switch (a = t[s].toLowerCase(), a) {
          case "italic":
            i = "italic";
            break;
          case "bold":
            r = "700";
            break;
          case "black":
            r = "900";
            break;
          case "medium":
            r = "500";
            break;
          case "regular":
          case "normal":
            r = "400";
            break;
          case "light":
          case "thin":
            r = "200";
            break;
        }
      return {
        style: i,
        weight: e.fWeight || r
      };
    }
    var FontManager = function() {
      var e = 5e3, t = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      }, r = [];
      r = r.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var i = 127988, n = 917631, a = 917601, s = 917626, l = 65039, o = 8205, c = 127462, f = 127487, x = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function m(N) {
        var P = N.split(","), z, b = P.length, k = [];
        for (z = 0; z < b; z += 1)
          P[z] !== "sans-serif" && P[z] !== "monospace" && k.push(P[z]);
        return k.join(",");
      }
      function A(N, P) {
        var z = createTag("span");
        z.setAttribute("aria-hidden", !0), z.style.fontFamily = P;
        var b = createTag("span");
        b.innerText = "giItT1WQy@!-/#", z.style.position = "absolute", z.style.left = "-10000px", z.style.top = "-10000px", z.style.fontSize = "300px", z.style.fontVariant = "normal", z.style.fontStyle = "normal", z.style.fontWeight = "normal", z.style.letterSpacing = "0", z.appendChild(b), document.body.appendChild(z);
        var k = b.offsetWidth;
        return b.style.fontFamily = m(N) + ", " + P, {
          node: b,
          w: k,
          parent: z
        };
      }
      function M() {
        var N, P = this.fonts.length, z, b, k = P;
        for (N = 0; N < P; N += 1)
          this.fonts[N].loaded ? k -= 1 : this.fonts[N].fOrigin === "n" || this.fonts[N].origin === 0 ? this.fonts[N].loaded = !0 : (z = this.fonts[N].monoCase.node, b = this.fonts[N].monoCase.w, z.offsetWidth !== b ? (k -= 1, this.fonts[N].loaded = !0) : (z = this.fonts[N].sansCase.node, b = this.fonts[N].sansCase.w, z.offsetWidth !== b && (k -= 1, this.fonts[N].loaded = !0)), this.fonts[N].loaded && (this.fonts[N].sansCase.parent.parentNode.removeChild(this.fonts[N].sansCase.parent), this.fonts[N].monoCase.parent.parentNode.removeChild(this.fonts[N].monoCase.parent)));
        k !== 0 && Date.now() - this.initTime < e ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function d(N, P) {
        var z = document.body && P ? "svg" : "canvas", b, k = getFontProperties(N);
        if (z === "svg") {
          var S = createNS("text");
          S.style.fontSize = "100px", S.setAttribute("font-family", N.fFamily), S.setAttribute("font-style", k.style), S.setAttribute("font-weight", k.weight), S.textContent = "1", N.fClass ? (S.style.fontFamily = "inherit", S.setAttribute("class", N.fClass)) : S.style.fontFamily = N.fFamily, P.appendChild(S), b = S;
        } else {
          var F = new OffscreenCanvas(500, 500).getContext("2d");
          F.font = k.style + " " + k.weight + " 100px " + N.fFamily, b = F;
        }
        function Q(L) {
          return z === "svg" ? (b.textContent = L, b.getComputedTextLength()) : b.measureText(L).width;
        }
        return {
          measureText: Q
        };
      }
      function C(N, P) {
        if (!N) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = N.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, N.list.forEach(function(ee) {
            ee.helper = d(ee), ee.cache = {};
          }), this.fonts = N.list;
          return;
        }
        var z = N.list, b, k = z.length, S = k;
        for (b = 0; b < k; b += 1) {
          var F = !0, Q, L;
          if (z[b].loaded = !1, z[b].monoCase = A(z[b].fFamily, "monospace"), z[b].sansCase = A(z[b].fFamily, "sans-serif"), !z[b].fPath)
            z[b].loaded = !0, S -= 1;
          else if (z[b].fOrigin === "p" || z[b].origin === 3) {
            if (Q = document.querySelectorAll('style[f-forigin="p"][f-family="' + z[b].fFamily + '"], style[f-origin="3"][f-family="' + z[b].fFamily + '"]'), Q.length > 0 && (F = !1), F) {
              var W = createTag("style");
              W.setAttribute("f-forigin", z[b].fOrigin), W.setAttribute("f-origin", z[b].origin), W.setAttribute("f-family", z[b].fFamily), W.type = "text/css", W.innerText = "@font-face {font-family: " + z[b].fFamily + "; font-style: normal; src: url('" + z[b].fPath + "');}", P.appendChild(W);
            }
          } else if (z[b].fOrigin === "g" || z[b].origin === 1) {
            for (Q = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), L = 0; L < Q.length; L += 1)
              Q[L].href.indexOf(z[b].fPath) !== -1 && (F = !1);
            if (F) {
              var q = createTag("link");
              q.setAttribute("f-forigin", z[b].fOrigin), q.setAttribute("f-origin", z[b].origin), q.type = "text/css", q.rel = "stylesheet", q.href = z[b].fPath, document.body.appendChild(q);
            }
          } else if (z[b].fOrigin === "t" || z[b].origin === 2) {
            for (Q = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), L = 0; L < Q.length; L += 1)
              z[b].fPath === Q[L].src && (F = !1);
            if (F) {
              var _ = createTag("link");
              _.setAttribute("f-forigin", z[b].fOrigin), _.setAttribute("f-origin", z[b].origin), _.setAttribute("rel", "stylesheet"), _.setAttribute("href", z[b].fPath), P.appendChild(_);
            }
          }
          z[b].helper = d(z[b], P), z[b].cache = {}, this.fonts.push(z[b]);
        }
        S === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function u(N) {
        if (N) {
          this.chars || (this.chars = []);
          var P, z = N.length, b, k = this.chars.length, S;
          for (P = 0; P < z; P += 1) {
            for (b = 0, S = !1; b < k; )
              this.chars[b].style === N[P].style && this.chars[b].fFamily === N[P].fFamily && this.chars[b].ch === N[P].ch && (S = !0), b += 1;
            S || (this.chars.push(N[P]), k += 1);
          }
        }
      }
      function g(N, P, z) {
        for (var b = 0, k = this.chars.length; b < k; ) {
          if (this.chars[b].ch === N && this.chars[b].style === P && this.chars[b].fFamily === z)
            return this.chars[b];
          b += 1;
        }
        return (typeof N == "string" && N.charCodeAt(0) !== 13 || !N) && console && console.warn && !this._warned && (this._warned = !0), t;
      }
      function p(N, P, z) {
        var b = this.getFontByName(P), k = N;
        if (!b.cache[k]) {
          var S = b.helper;
          if (N === " ") {
            var F = S.measureText("|" + N + "|"), Q = S.measureText("||");
            b.cache[k] = (F - Q) / 100;
          } else
            b.cache[k] = S.measureText(N) / 100;
        }
        return b.cache[k] * z;
      }
      function y(N) {
        for (var P = 0, z = this.fonts.length; P < z; ) {
          if (this.fonts[P].fName === N)
            return this.fonts[P];
          P += 1;
        }
        return this.fonts[0];
      }
      function E(N) {
        var P = 0, z = N.charCodeAt(0);
        if (z >= 55296 && z <= 56319) {
          var b = N.charCodeAt(1);
          b >= 56320 && b <= 57343 && (P = (z - 55296) * 1024 + b - 56320 + 65536);
        }
        return P;
      }
      function T(N, P) {
        var z = N.toString(16) + P.toString(16);
        return x.indexOf(z) !== -1;
      }
      function Z(N) {
        return N === o;
      }
      function G(N) {
        return N === l;
      }
      function I(N) {
        var P = E(N);
        return P >= c && P <= f;
      }
      function V(N) {
        return I(N.substr(0, 2)) && I(N.substr(2, 2));
      }
      function Y(N) {
        return r.indexOf(N) !== -1;
      }
      function D(N, P) {
        var z = E(N.substr(P, 2));
        if (z !== i)
          return !1;
        var b = 0;
        for (P += 2; b < 5; ) {
          if (z = E(N.substr(P, 2)), z < a || z > s)
            return !1;
          b += 1, P += 2;
        }
        return E(N.substr(P, 2)) === n;
      }
      function R() {
        this.isLoaded = !0;
      }
      var B = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      B.isModifier = T, B.isZeroWidthJoiner = Z, B.isFlagEmoji = V, B.isRegionalCode = I, B.isCombinedCharacter = Y, B.isRegionalFlag = D, B.isVariationSelector = G, B.BLACK_FLAG_CODE_POINT = i;
      var j = {
        addChars: u,
        addFonts: C,
        getCharData: g,
        getFontByName: y,
        measureText: p,
        checkLoadedFonts: M,
        setIsLoaded: R
      };
      return B.prototype = j, B;
    }();
    function SlotManager(e) {
      this.animationData = e;
    }
    SlotManager.prototype.getProp = function(e) {
      return this.animationData.slots && this.animationData.slots[e.sid] ? Object.assign(e, this.animationData.slots[e.sid].p) : e;
    };
    function slotFactory(e) {
      return new SlotManager(e);
    }
    function RenderableElement() {
    }
    RenderableElement.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) === -1 && this.renderableComponents.push(t);
      },
      removeRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
      },
      prepareRenderableFrame: function(t) {
        this.checkLayerLimits(t);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
         * @function
         * Initializes frame related properties.
         *
         * @param {number} num
         * current frame number in Layer's time
         *
         */
      checkLayerLimits: function(t) {
        this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var t, r = this.renderableComponents.length;
        for (t = 0; t < r; t += 1)
          this.renderableComponents[t].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }
    };
    var getBlendMode = function() {
      var e = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(t) {
        return e[t] || "";
      };
    }();
    function SliderEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function AngleEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function ColorEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, r);
    }
    function PointEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, r);
    }
    function LayerIndexEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function MaskIndexEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function CheckboxEffect(e, t, r) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, r);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(e, t) {
      var r = e.ef || [];
      this.effectElements = [];
      var i, n = r.length, a;
      for (i = 0; i < n; i += 1)
        a = new GroupEffect(r[i], t), this.effectElements.push(a);
    }
    function GroupEffect(e, t) {
      this.init(e, t);
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(e, t) {
      this.data = e, this.effectElements = [], this.initDynamicPropertyContainer(t);
      var r, i = this.data.ef.length, n, a = this.data.ef;
      for (r = 0; r < i; r += 1) {
        switch (n = null, a[r].ty) {
          case 0:
            n = new SliderEffect(a[r], t, this);
            break;
          case 1:
            n = new AngleEffect(a[r], t, this);
            break;
          case 2:
            n = new ColorEffect(a[r], t, this);
            break;
          case 3:
            n = new PointEffect(a[r], t, this);
            break;
          case 4:
          case 7:
            n = new CheckboxEffect(a[r], t, this);
            break;
          case 10:
            n = new LayerIndexEffect(a[r], t, this);
            break;
          case 11:
            n = new MaskIndexEffect(a[r], t, this);
            break;
          case 5:
            n = new EffectsManager(a[r], t);
            break;
          default:
            n = new NoValueEffect(a[r]);
            break;
        }
        n && this.effectElements.push(n);
      }
    };
    function BaseElement() {
    }
    BaseElement.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var t = 0, r = this.data.masksProperties.length; t < r; ) {
          if (this.data.masksProperties[t].mode !== "n" && this.data.masksProperties[t].cl !== !1)
            return !0;
          t += 1;
        }
        return !1;
      },
      initExpressions: function() {
        var t = getExpressionInterfaces();
        if (t) {
          var r = t("layer"), i = t("effects"), n = t("shape"), a = t("text"), s = t("comp");
          this.layerInterface = r(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
          var l = i.createEffectsInterface(this, this.layerInterface);
          this.layerInterface.registerEffectsInterface(l), this.data.ty === 0 || this.data.xt ? this.compInterface = s(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = n(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = a(this), this.layerInterface.text = this.layerInterface.textInterface);
        }
      },
      setBlendMode: function() {
        var t = getBlendMode(this.data.bm), r = this.baseElement || this.layerElement;
        r.style["mix-blend-mode"] = t;
      },
      initBaseData: function(t, r, i) {
        this.globalData = r, this.comp = i, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function FrameElement() {
    }
    FrameElement.prototype = {
      /**
         * @function
         * Initializes frame related properties.
         *
         */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
         * @function
         * Calculates all dynamic values
         *
         * @param {number} num
         * current frame number in Layer's time
         * @param {boolean} isVisible
         * if layers is currently in range
         *
         */
      prepareProperties: function(t, r) {
        var i, n = this.dynamicProperties.length;
        for (i = 0; i < n; i += 1)
          (r || this._isParent && this.dynamicProperties[i].propType === "transform") && (this.dynamicProperties[i].getValue(), this.dynamicProperties[i]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && this.dynamicProperties.push(t);
      }
    };
    function FootageElement(e, t, r) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.footageData = t.imageLoader.getAsset(this.assetData), this.initBaseData(e, t, r);
    }
    FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var e = getExpressionInterfaces();
      if (e) {
        var t = e("footage");
        this.layerInterface = t(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    };
    function AudioElement(e, t, r) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.initBaseData(e, t, r), this._isPlaying = !1, this._canPlay = !1;
      var i = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      }, this.lv = PropertyFactory.getProp(this, e.au && e.au.lv ? e.au.lv : {
        k: [100]
      }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(e) {
      if (this.prepareRenderableFrame(e, !0), this.prepareProperties(e, !0), this.tm._placeholder)
        this._currentTime = e / this.data.sr;
      else {
        var t = this.tm.v;
        this._currentTime = t;
      }
      this._volume = this.lv.v[0];
      var r = this._volume * this._volumeMultiplier;
      this._previousVolume !== r && (this._previousVolume = r, this.audio.volume(r));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(e) {
      this.audio.rate(e);
    }, AudioElement.prototype.volume = function(e) {
      this._volumeMultiplier = e, this._previousVolume = e * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    };
    function BaseRenderer() {
    }
    BaseRenderer.prototype.checkLayers = function(e) {
      var t, r = this.layers.length, i;
      for (this.completeLayers = !0, t = r - 1; t >= 0; t -= 1)
        this.elements[t] || (i = this.layers[t], i.ip - i.st <= e - this.layers[t].st && i.op - i.st > e - this.layers[t].st && this.buildItem(t)), this.completeLayers = this.elements[t] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(e) {
      switch (e.ty) {
        case 2:
          return this.createImage(e);
        case 0:
          return this.createComp(e);
        case 1:
          return this.createSolid(e);
        case 3:
          return this.createNull(e);
        case 4:
          return this.createShape(e);
        case 5:
          return this.createText(e);
        case 6:
          return this.createAudio(e);
        case 13:
          return this.createCamera(e);
        case 15:
          return this.createFootage(e);
        default:
          return this.createNull(e);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(e) {
      return new AudioElement(e, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(e) {
      return new FootageElement(e, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.buildItem(e);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(e) {
      this.completeLayers = !1;
      var t, r = e.length, i, n = this.layers.length;
      for (t = 0; t < r; t += 1)
        for (i = 0; i < n; ) {
          if (this.layers[i].id === e[t].id) {
            this.layers[i] = e[t];
            break;
          }
          i += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(e) {
      this.globalData.projectInterface = e;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(e, t, r) {
      for (var i = this.elements, n = this.layers, a = 0, s = n.length; a < s; )
        n[a].ind == t && (!i[a] || i[a] === !0 ? (this.buildItem(a), this.addPendingElement(e)) : (r.push(i[a]), i[a].setAsParent(), n[a].parent !== void 0 ? this.buildElementParenting(e, n[a].parent, r) : e.setHierarchy(r))), a += 1;
    }, BaseRenderer.prototype.addPendingElement = function(e) {
      this.pendingElements.push(e);
    }, BaseRenderer.prototype.searchExtraCompositions = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        if (e[t].xt) {
          var i = this.createComp(e[t]);
          i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
        }
    }, BaseRenderer.prototype.getElementById = function(e) {
      var t, r = this.elements.length;
      for (t = 0; t < r; t += 1)
        if (this.elements[t].data.ind === e)
          return this.elements[t];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(e) {
      var t = e.shift(), r;
      if (typeof t == "number")
        r = this.elements[t];
      else {
        var i, n = this.elements.length;
        for (i = 0; i < n; i += 1)
          if (this.elements[i].data.nm === t) {
            r = this.elements[i];
            break;
          }
      }
      return e.length === 0 ? r : r.getElementByPath(e);
    }, BaseRenderer.prototype.setupGlobalData = function(e, t) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(e), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, t), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = e.fr, this.globalData.nm = e.nm, this.globalData.compSize = {
        w: e.w,
        h: e.h
      };
    };
    var effectTypes = {
      TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {
    }
    TransformElement.prototype = {
      initTransform: function() {
        var t = new Matrix();
        this.finalTransform = {
          mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
            o: 0
          },
          _matMdf: !1,
          _localMatMdf: !1,
          _opMdf: !1,
          mat: t,
          localMat: t,
          localOpacity: 1
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var t, r = this.finalTransform.mat, i = 0, n = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; i < n; ) {
              if (this.hierarchy[i].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              i += 1;
            }
          if (this.finalTransform._matMdf)
            for (t = this.finalTransform.mProp.v.props, r.cloneFromProps(t), i = 0; i < n; i += 1)
              r.multiply(this.hierarchy[i].finalTransform.mProp.v);
        }
        this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
      },
      renderLocalTransform: function() {
        if (this.localTransforms) {
          var t = 0, r = this.localTransforms.length;
          if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
            for (; t < r; )
              this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
          if (this.finalTransform._localMatMdf) {
            var i = this.finalTransform.localMat;
            for (this.localTransforms[0].matrix.clone(i), t = 1; t < r; t += 1) {
              var n = this.localTransforms[t].matrix;
              i.multiply(n);
            }
            i.multiply(this.finalTransform.mat);
          }
          if (this.finalTransform._opMdf) {
            var a = this.finalTransform.localOpacity;
            for (t = 0; t < r; t += 1)
              a *= this.localTransforms[t].opacity * 0.01;
            this.finalTransform.localOpacity = a;
          }
        }
      },
      searchEffectTransforms: function() {
        if (this.renderableEffectsManager) {
          var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
          if (t.length) {
            this.localTransforms = [], this.finalTransform.localMat = new Matrix();
            var r = 0, i = t.length;
            for (r = 0; r < i; r += 1)
              this.localTransforms.push(t[r]);
          }
        }
      },
      globalToLocal: function(t) {
        var r = [];
        r.push(this.finalTransform);
        for (var i = !0, n = this.comp; i; )
          n.finalTransform ? (n.data.hasMask && r.splice(0, 0, n.finalTransform), n = n.comp) : i = !1;
        var a, s = r.length, l;
        for (a = 0; a < s; a += 1)
          l = r[a].mat.applyToPointArray(0, 0, 0), t = [t[0] - l[0], t[1] - l[1], 0];
        return t;
      },
      mHelper: new Matrix()
    };
    function MaskElement(e, t, r) {
      this.data = e, this.element = t, this.globalData = r, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var i = this.globalData.defs, n, a = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(a), this.solidPath = "";
      var s, l = this.masksProperties, o = 0, c = [], f, x, m = createElementID(), A, M, d, C, u = "clipPath", g = "clip-path";
      for (n = 0; n < a; n += 1)
        if ((l[n].mode !== "a" && l[n].mode !== "n" || l[n].inv || l[n].o.k !== 100 || l[n].o.x) && (u = "mask", g = "mask"), (l[n].mode === "s" || l[n].mode === "i") && o === 0 ? (A = createNS("rect"), A.setAttribute("fill", "#ffffff"), A.setAttribute("width", this.element.comp.data.w || 0), A.setAttribute("height", this.element.comp.data.h || 0), c.push(A)) : A = null, s = createNS("path"), l[n].mode === "n")
          this.viewData[n] = {
            op: PropertyFactory.getProp(this.element, l[n].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, l[n], 3),
            elem: s,
            lastPath: ""
          }, i.appendChild(s);
        else {
          o += 1, s.setAttribute("fill", l[n].mode === "s" ? "#000000" : "#ffffff"), s.setAttribute("clip-rule", "nonzero");
          var p;
          if (l[n].x.k !== 0 ? (u = "mask", g = "mask", C = PropertyFactory.getProp(this.element, l[n].x, 0, null, this.element), p = createElementID(), M = createNS("filter"), M.setAttribute("id", p), d = createNS("feMorphology"), d.setAttribute("operator", "erode"), d.setAttribute("in", "SourceGraphic"), d.setAttribute("radius", "0"), M.appendChild(d), i.appendChild(M), s.setAttribute("stroke", l[n].mode === "s" ? "#000000" : "#ffffff")) : (d = null, C = null), this.storedData[n] = {
            elem: s,
            x: C,
            expan: d,
            lastPath: "",
            lastOperator: "",
            filterId: p,
            lastRadius: 0
          }, l[n].mode === "i") {
            x = c.length;
            var y = createNS("g");
            for (f = 0; f < x; f += 1)
              y.appendChild(c[f]);
            var E = createNS("mask");
            E.setAttribute("mask-type", "alpha"), E.setAttribute("id", m + "_" + o), E.appendChild(s), i.appendChild(E), y.setAttribute("mask", "url(" + getLocationHref() + "#" + m + "_" + o + ")"), c.length = 0, c.push(y);
          } else
            c.push(s);
          l[n].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[n] = {
            elem: s,
            lastPath: "",
            op: PropertyFactory.getProp(this.element, l[n].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, l[n], 3),
            invRect: A
          }, this.viewData[n].prop.k || this.drawPath(l[n], this.viewData[n].prop.v, this.viewData[n]);
        }
      for (this.maskElement = createNS(u), a = c.length, n = 0; n < a; n += 1)
        this.maskElement.appendChild(c[n]);
      o > 0 && (this.maskElement.setAttribute("id", m), this.element.maskedElement.setAttribute(g, "url(" + getLocationHref() + "#" + m + ")"), i.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(e) {
      return this.viewData[e].prop;
    }, MaskElement.prototype.renderFrame = function(e) {
      var t = this.element.finalTransform.mat, r, i = this.masksProperties.length;
      for (r = 0; r < i; r += 1)
        if ((this.viewData[r].prop._mdf || e) && this.drawPath(this.masksProperties[r], this.viewData[r].prop.v, this.viewData[r]), (this.viewData[r].op._mdf || e) && this.viewData[r].elem.setAttribute("fill-opacity", this.viewData[r].op.v), this.masksProperties[r].mode !== "n" && (this.viewData[r].invRect && (this.element.finalTransform.mProp._mdf || e) && this.viewData[r].invRect.setAttribute("transform", t.getInverseMatrix().to2dCSS()), this.storedData[r].x && (this.storedData[r].x._mdf || e))) {
          var n = this.storedData[r].expan;
          this.storedData[r].x.v < 0 ? (this.storedData[r].lastOperator !== "erode" && (this.storedData[r].lastOperator = "erode", this.storedData[r].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[r].filterId + ")")), n.setAttribute("radius", -this.storedData[r].x.v)) : (this.storedData[r].lastOperator !== "dilate" && (this.storedData[r].lastOperator = "dilate", this.storedData[r].elem.setAttribute("filter", null)), this.storedData[r].elem.setAttribute("stroke-width", this.storedData[r].x.v * 2));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var e = "M0,0 ";
      return e += " h" + this.globalData.compSize.w, e += " v" + this.globalData.compSize.h, e += " h-" + this.globalData.compSize.w, e += " v-" + this.globalData.compSize.h + " ", e;
    }, MaskElement.prototype.drawPath = function(e, t, r) {
      var i = " M" + t.v[0][0] + "," + t.v[0][1], n, a;
      for (a = t._length, n = 1; n < a; n += 1)
        i += " C" + t.o[n - 1][0] + "," + t.o[n - 1][1] + " " + t.i[n][0] + "," + t.i[n][1] + " " + t.v[n][0] + "," + t.v[n][1];
      if (t.c && a > 1 && (i += " C" + t.o[n - 1][0] + "," + t.o[n - 1][1] + " " + t.i[0][0] + "," + t.i[0][1] + " " + t.v[0][0] + "," + t.v[0][1]), r.lastPath !== i) {
        var s = "";
        r.elem && (t.c && (s = e.inv ? this.solidPath + i : i), r.elem.setAttribute("d", s)), r.lastPath = i;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var e = {};
      e.createFilter = t, e.createAlphaToLuminanceFilter = r;
      function t(i, n) {
        var a = createNS("filter");
        return a.setAttribute("id", i), n !== !0 && (a.setAttribute("filterUnits", "objectBoundingBox"), a.setAttribute("x", "0%"), a.setAttribute("y", "0%"), a.setAttribute("width", "100%"), a.setAttribute("height", "100%")), a;
      }
      function r() {
        var i = createNS("feColorMatrix");
        return i.setAttribute("type", "matrix"), i.setAttribute("color-interpolation-filters", "sRGB"), i.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), i;
      }
      return e;
    }(), featureSupport = function() {
      var e = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: typeof OffscreenCanvas < "u"
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (e.maskType = !1), /firefox/i.test(navigator.userAgent) && (e.svgLumaHidden = !1), e;
    }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(e) {
      var t, r = "SourceGraphic", i = e.data.ef ? e.data.ef.length : 0, n = createElementID(), a = filtersFactory.createFilter(n, !0), s = 0;
      this.filters = [];
      var l;
      for (t = 0; t < i; t += 1) {
        l = null;
        var o = e.data.ef[t].ty;
        if (registeredEffects$1[o]) {
          var c = registeredEffects$1[o].effect;
          l = new c(a, e.effectsManager.effectElements[t], e, idPrefix + s, r), r = idPrefix + s, registeredEffects$1[o].countsAsEffect && (s += 1);
        }
        l && this.filters.push(l);
      }
      s && (e.globalData.defs.appendChild(a), e.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + n + ")")), this.filters.length && e.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(e) {
      var t, r = this.filters.length;
      for (t = 0; t < r; t += 1)
        this.filters[t].renderFrame(e);
    }, SVGEffects.prototype.getEffects = function(e) {
      var t, r = this.filters.length, i = [];
      for (t = 0; t < r; t += 1)
        this.filters[t].type === e && i.push(this.filters[t]);
      return i;
    };
    function registerEffect$1(e, t, r) {
      registeredEffects$1[e] = {
        effect: t,
        countsAsEffect: r
      };
    }
    function SVGBaseElement() {
    }
    SVGBaseElement.prototype = {
      initRendererElement: function() {
        this.layerElement = createNS("g");
      },
      createContainerElements: function() {
        this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var t = null;
        if (this.data.td) {
          this.matteMasks = {};
          var r = createNS("g");
          r.setAttribute("id", this.layerId), r.appendChild(this.layerElement), t = r, this.globalData.defs.appendChild(r);
        } else
          this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var i = createNS("clipPath"), n = createNS("path");
          n.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var a = createElementID();
          if (i.setAttribute("id", a), i.appendChild(n), this.globalData.defs.appendChild(i), this.checkMasks()) {
            var s = createNS("g");
            s.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), s.appendChild(this.layerElement), this.transformedElement = s, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
      },
      getMatte: function(t) {
        if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
          var r = this.layerId + "_" + t, i, n, a, s;
          if (t === 1 || t === 3) {
            var l = createNS("mask");
            l.setAttribute("id", r), l.setAttribute("mask-type", t === 3 ? "luminance" : "alpha"), a = createNS("use"), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), l.appendChild(a), this.globalData.defs.appendChild(l), !featureSupport.maskType && t === 1 && (l.setAttribute("mask-type", "luminance"), i = createElementID(), n = filtersFactory.createFilter(i), this.globalData.defs.appendChild(n), n.appendChild(filtersFactory.createAlphaToLuminanceFilter()), s = createNS("g"), s.appendChild(a), l.appendChild(s), s.setAttribute("filter", "url(" + getLocationHref() + "#" + i + ")"));
          } else if (t === 2) {
            var o = createNS("mask");
            o.setAttribute("id", r), o.setAttribute("mask-type", "alpha");
            var c = createNS("g");
            o.appendChild(c), i = createElementID(), n = filtersFactory.createFilter(i);
            var f = createNS("feComponentTransfer");
            f.setAttribute("in", "SourceGraphic"), n.appendChild(f);
            var x = createNS("feFuncA");
            x.setAttribute("type", "table"), x.setAttribute("tableValues", "1.0 0.0"), f.appendChild(x), this.globalData.defs.appendChild(n);
            var m = createNS("rect");
            m.setAttribute("width", this.comp.data.w), m.setAttribute("height", this.comp.data.h), m.setAttribute("x", "0"), m.setAttribute("y", "0"), m.setAttribute("fill", "#ffffff"), m.setAttribute("opacity", "0"), c.setAttribute("filter", "url(" + getLocationHref() + "#" + i + ")"), c.appendChild(m), a = createNS("use"), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), c.appendChild(a), featureSupport.maskType || (o.setAttribute("mask-type", "luminance"), n.appendChild(filtersFactory.createAlphaToLuminanceFilter()), s = createNS("g"), c.appendChild(m), s.appendChild(this.layerElement), c.appendChild(s)), this.globalData.defs.appendChild(o);
          }
          this.matteMasks[t] = r;
        }
        return this.matteMasks[t];
      },
      setMatte: function(t) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
      }
    };
    function HierarchyElement() {
    }
    HierarchyElement.prototype = {
      /**
         * @function
         * Initializes hierarchy properties
         *
         */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
         * @function
         * Sets layer's hierarchy.
         * @param {array} hierarch
         * layer's parent list
         *
         */
      setHierarchy: function(t) {
        this.hierarchy = t;
      },
      /**
         * @function
         * Sets layer as parent.
         *
         */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
         * @function
         * Searches layer's parenting chain
         *
         */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function RenderableDOMElement() {
    }
    (function() {
      var e = {
        initElement: function(r, i, n) {
          this.initFrame(), this.initBaseData(r, i, n), this.initTransform(r, i, n), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var r = this.baseElement || this.layerElement;
            r.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var r = this.baseElement || this.layerElement;
              r.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(r) {
          this._mdf = !1, this.prepareRenderableFrame(r), this.prepareProperties(r, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      extendPrototype([RenderableElement, createProxyFunction(e)], RenderableDOMElement);
    })();
    function IImageElement(e, t, r) {
      this.assetData = t.getAssetData(e.refId), this.assetData && this.assetData.sid && (this.assetData = t.slotManager.getProp(this.assetData)), this.initElement(e, t, r), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function ProcessedElement(e, t) {
      this.elem = e, this.pos = t;
    }
    function IShapeElement() {
    }
    IShapeElement.prototype = {
      addShapeToModifiers: function(t) {
        var r, i = this.shapeModifiers.length;
        for (r = 0; r < i; r += 1)
          this.shapeModifiers[r].addShape(t);
      },
      isShapeInAnimatedModifiers: function(t) {
        for (var r = 0, i = this.shapeModifiers.length; r < i; )
          if (this.shapeModifiers[r].isAnimatedWithShape(t))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (this.shapeModifiers.length) {
          var t, r = this.shapes.length;
          for (t = 0; t < r; t += 1)
            this.shapes[t].sh.reset();
          r = this.shapeModifiers.length;
          var i;
          for (t = r - 1; t >= 0 && (i = this.shapeModifiers[t].processShapes(this._isFirstFrame), !i); t -= 1)
            ;
        }
      },
      searchProcessedElement: function(t) {
        for (var r = this.processedElements, i = 0, n = r.length; i < n; ) {
          if (r[i].elem === t)
            return r[i].pos;
          i += 1;
        }
        return 0;
      },
      addProcessedElement: function(t, r) {
        for (var i = this.processedElements, n = i.length; n; )
          if (n -= 1, i[n].elem === t) {
            i[n].pos = r;
            return;
          }
        i.push(new ProcessedElement(t, r));
      },
      prepareFrame: function(t) {
        this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
      }
    };
    var lineCapEnum = {
      1: "butt",
      2: "round",
      3: "square"
    }, lineJoinEnum = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    function SVGShapeData(e, t, r) {
      this.caches = [], this.styles = [], this.transformers = e, this.lStr = "", this.sh = r, this.lvl = t, this._isAnimated = !!r.k;
      for (var i = 0, n = e.length; i < n; ) {
        if (e[i].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        i += 1;
      }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function SVGStyleData(e, t) {
      this.data = e, this.type = e.ty, this.d = "", this.lvl = t, this._mdf = !1, this.closed = e.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function DashProperty(e, t, r, i) {
      this.elem = e, this.frameId = -1, this.dataProps = createSizedArray(t.length), this.renderer = r, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", t.length ? t.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i);
      var n, a = t.length || 0, s;
      for (n = 0; n < a; n += 1)
        s = PropertyFactory.getProp(e, t[n].v, 0, 0, this), this.k = s.k || this.k, this.dataProps[n] = {
          n: t[n].n,
          p: s
        };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(e) {
      if (!(this.elem.globalData.frameId === this.frameId && !e) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || e, this._mdf)) {
        var t = 0, r = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), t = 0; t < r; t += 1)
          this.dataProps[t].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[t].p.v : this.dashArray[t] = this.dataProps[t].p.v : this.dashoffset[0] = this.dataProps[t].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty);
    function SVGStrokeStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = r, this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
    function SVGFillStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = r;
    }
    extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
    function SVGNoStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.style = r;
    }
    extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
    function GradientProperty(e, t, r) {
      this.data = t, this.c = createTypedArray("uint8c", t.p * 4);
      var i = t.k.k[0].s ? t.k.k[0].s.length - t.p * 4 : t.k.k.length - t.p * 4;
      this.o = createTypedArray("float32", i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i, this.initDynamicPropertyContainer(r), this.prop = PropertyFactory.getProp(e, t.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    GradientProperty.prototype.comparePoints = function(e, t) {
      for (var r = 0, i = this.o.length / 2, n; r < i; ) {
        if (n = Math.abs(e[r * 4] - e[t * 4 + r * 2]), n > 0.01)
          return !1;
        r += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var e = 0, t = this.data.k.k.length; e < t; ) {
          if (!this.comparePoints(this.data.k.k[e].s, this.data.p))
            return !1;
          e += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(e) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || e) {
        var t, r = this.data.p * 4, i, n;
        for (t = 0; t < r; t += 1)
          i = t % 4 === 0 ? 100 : 255, n = Math.round(this.prop.v[t] * i), this.c[t] !== n && (this.c[t] = n, this._cmdf = !e);
        if (this.o.length)
          for (r = this.prop.v.length, t = this.data.p * 4; t < r; t += 1)
            i = t % 2 === 0 ? 100 : 1, n = t % 2 === 0 ? Math.round(this.prop.v[t] * 100) : this.prop.v[t], this.o[t - this.data.p * 4] !== n && (this.o[t - this.data.p * 4] = n, this._omdf = !e);
        this._mdf = !e;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty);
    function SVGGradientFillStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.initGradientData(e, t, r);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(e, t, r) {
      this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.s = PropertyFactory.getProp(e, t.s, 1, null, this), this.e = PropertyFactory.getProp(e, t.e, 1, null, this), this.h = PropertyFactory.getProp(e, t.h || {
        k: 0
      }, 0, 0.01, this), this.a = PropertyFactory.getProp(e, t.a || {
        k: 0
      }, 0, degToRads, this), this.g = new GradientProperty(e, t.g, this), this.style = r, this.stops = [], this.setGradientData(r.pElem, t), this.setGradientOpacity(t, r), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(e, t) {
      var r = createElementID(), i = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
      i.setAttribute("id", r), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
      var n = [], a, s, l;
      for (l = t.g.p * 4, s = 0; s < l; s += 4)
        a = createNS("stop"), i.appendChild(a), n.push(a);
      e.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r + ")"), this.gf = i, this.cst = n;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(e, t) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var r, i, n, a = createNS("mask"), s = createNS("path");
        a.appendChild(s);
        var l = createElementID(), o = createElementID();
        a.setAttribute("id", o);
        var c = createNS(e.t === 1 ? "linearGradient" : "radialGradient");
        c.setAttribute("id", l), c.setAttribute("spreadMethod", "pad"), c.setAttribute("gradientUnits", "userSpaceOnUse"), n = e.g.k.k[0].s ? e.g.k.k[0].s.length : e.g.k.k.length;
        var f = this.stops;
        for (i = e.g.p * 4; i < n; i += 2)
          r = createNS("stop"), r.setAttribute("stop-color", "rgb(255,255,255)"), c.appendChild(r), f.push(r);
        s.setAttribute(e.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + l + ")"), e.ty === "gs" && (s.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), s.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), e.lj === 1 && s.setAttribute("stroke-miterlimit", e.ml)), this.of = c, this.ms = a, this.ost = f, this.maskId = o, t.msElem = s;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(e, t, r) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.initGradientData(e, t, r), this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(e, t, r) {
      this.transform = {
        mProps: e,
        op: t,
        container: r
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function(t, r, i, n) {
      if (r === 0)
        return "";
      var a = t.o, s = t.i, l = t.v, o, c = " M" + n.applyToPointStringified(l[0][0], l[0][1]);
      for (o = 1; o < r; o += 1)
        c += " C" + n.applyToPointStringified(a[o - 1][0], a[o - 1][1]) + " " + n.applyToPointStringified(s[o][0], s[o][1]) + " " + n.applyToPointStringified(l[o][0], l[o][1]);
      return i && r && (c += " C" + n.applyToPointStringified(a[o - 1][0], a[o - 1][1]) + " " + n.applyToPointStringified(s[0][0], s[0][1]) + " " + n.applyToPointStringified(l[0][0], l[0][1]), c += "z"), c;
    }, SVGElementsRenderer = function() {
      var e = new Matrix(), t = new Matrix(), r = {
        createRenderFunction: i
      };
      function i(x) {
        switch (x.ty) {
          case "fl":
            return l;
          case "gf":
            return c;
          case "gs":
            return o;
          case "st":
            return f;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return s;
          case "tr":
            return n;
          case "no":
            return a;
          default:
            return null;
        }
      }
      function n(x, m, A) {
        (A || m.transform.op._mdf) && m.transform.container.setAttribute("opacity", m.transform.op.v), (A || m.transform.mProps._mdf) && m.transform.container.setAttribute("transform", m.transform.mProps.v.to2dCSS());
      }
      function a() {
      }
      function s(x, m, A) {
        var M, d, C, u, g, p, y = m.styles.length, E = m.lvl, T, Z, G, I;
        for (p = 0; p < y; p += 1) {
          if (u = m.sh._mdf || A, m.styles[p].lvl < E) {
            for (Z = t.reset(), G = E - m.styles[p].lvl, I = m.transformers.length - 1; !u && G > 0; )
              u = m.transformers[I].mProps._mdf || u, G -= 1, I -= 1;
            if (u)
              for (G = E - m.styles[p].lvl, I = m.transformers.length - 1; G > 0; )
                Z.multiply(m.transformers[I].mProps.v), G -= 1, I -= 1;
          } else
            Z = e;
          if (T = m.sh.paths, d = T._length, u) {
            for (C = "", M = 0; M < d; M += 1)
              g = T.shapes[M], g && g._length && (C += buildShapeString(g, g._length, g.c, Z));
            m.caches[p] = C;
          } else
            C = m.caches[p];
          m.styles[p].d += x.hd === !0 ? "" : C, m.styles[p]._mdf = u || m.styles[p]._mdf;
        }
      }
      function l(x, m, A) {
        var M = m.style;
        (m.c._mdf || A) && M.pElem.setAttribute("fill", "rgb(" + bmFloor(m.c.v[0]) + "," + bmFloor(m.c.v[1]) + "," + bmFloor(m.c.v[2]) + ")"), (m.o._mdf || A) && M.pElem.setAttribute("fill-opacity", m.o.v);
      }
      function o(x, m, A) {
        c(x, m, A), f(x, m, A);
      }
      function c(x, m, A) {
        var M = m.gf, d = m.g._hasOpacity, C = m.s.v, u = m.e.v;
        if (m.o._mdf || A) {
          var g = x.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          m.style.pElem.setAttribute(g, m.o.v);
        }
        if (m.s._mdf || A) {
          var p = x.t === 1 ? "x1" : "cx", y = p === "x1" ? "y1" : "cy";
          M.setAttribute(p, C[0]), M.setAttribute(y, C[1]), d && !m.g._collapsable && (m.of.setAttribute(p, C[0]), m.of.setAttribute(y, C[1]));
        }
        var E, T, Z, G;
        if (m.g._cmdf || A) {
          E = m.cst;
          var I = m.g.c;
          for (Z = E.length, T = 0; T < Z; T += 1)
            G = E[T], G.setAttribute("offset", I[T * 4] + "%"), G.setAttribute("stop-color", "rgb(" + I[T * 4 + 1] + "," + I[T * 4 + 2] + "," + I[T * 4 + 3] + ")");
        }
        if (d && (m.g._omdf || A)) {
          var V = m.g.o;
          for (m.g._collapsable ? E = m.cst : E = m.ost, Z = E.length, T = 0; T < Z; T += 1)
            G = E[T], m.g._collapsable || G.setAttribute("offset", V[T * 2] + "%"), G.setAttribute("stop-opacity", V[T * 2 + 1]);
        }
        if (x.t === 1)
          (m.e._mdf || A) && (M.setAttribute("x2", u[0]), M.setAttribute("y2", u[1]), d && !m.g._collapsable && (m.of.setAttribute("x2", u[0]), m.of.setAttribute("y2", u[1])));
        else {
          var Y;
          if ((m.s._mdf || m.e._mdf || A) && (Y = Math.sqrt(Math.pow(C[0] - u[0], 2) + Math.pow(C[1] - u[1], 2)), M.setAttribute("r", Y), d && !m.g._collapsable && m.of.setAttribute("r", Y)), m.e._mdf || m.h._mdf || m.a._mdf || A) {
            Y || (Y = Math.sqrt(Math.pow(C[0] - u[0], 2) + Math.pow(C[1] - u[1], 2)));
            var D = Math.atan2(u[1] - C[1], u[0] - C[0]), R = m.h.v;
            R >= 1 ? R = 0.99 : R <= -1 && (R = -0.99);
            var B = Y * R, j = Math.cos(D + m.a.v) * B + C[0], N = Math.sin(D + m.a.v) * B + C[1];
            M.setAttribute("fx", j), M.setAttribute("fy", N), d && !m.g._collapsable && (m.of.setAttribute("fx", j), m.of.setAttribute("fy", N));
          }
        }
      }
      function f(x, m, A) {
        var M = m.style, d = m.d;
        d && (d._mdf || A) && d.dashStr && (M.pElem.setAttribute("stroke-dasharray", d.dashStr), M.pElem.setAttribute("stroke-dashoffset", d.dashoffset[0])), m.c && (m.c._mdf || A) && M.pElem.setAttribute("stroke", "rgb(" + bmFloor(m.c.v[0]) + "," + bmFloor(m.c.v[1]) + "," + bmFloor(m.c.v[2]) + ")"), (m.o._mdf || A) && M.pElem.setAttribute("stroke-opacity", m.o.v), (m.w._mdf || A) && (M.pElem.setAttribute("stroke-width", m.w.v), M.msElem && M.msElem.setAttribute("stroke-width", m.w.v));
      }
      return r;
    }();
    function SVGShapeElement(e, t, r) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(e, t, r), this.prevViewData = [];
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var e, t = this.shapes.length, r, i, n = this.stylesList.length, a, s = [], l = !1;
      for (i = 0; i < n; i += 1) {
        for (a = this.stylesList[i], l = !1, s.length = 0, e = 0; e < t; e += 1)
          r = this.shapes[e], r.styles.indexOf(a) !== -1 && (s.push(r), l = r._isAnimated || l);
        s.length > 1 && l && this.setShapesAsAnimated(s);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        e[t].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(e, t) {
      var r, i = new SVGStyleData(e, t), n = i.pElem;
      if (e.ty === "st")
        r = new SVGStrokeStyleData(this, e, i);
      else if (e.ty === "fl")
        r = new SVGFillStyleData(this, e, i);
      else if (e.ty === "gf" || e.ty === "gs") {
        var a = e.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
        r = new a(this, e, i), this.globalData.defs.appendChild(r.gf), r.maskId && (this.globalData.defs.appendChild(r.ms), this.globalData.defs.appendChild(r.of), n.setAttribute("mask", "url(" + getLocationHref() + "#" + r.maskId + ")"));
      } else
        e.ty === "no" && (r = new SVGNoStyleData(this, e, i));
      return (e.ty === "st" || e.ty === "gs") && (n.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), n.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), n.setAttribute("fill-opacity", "0"), e.lj === 1 && n.setAttribute("stroke-miterlimit", e.ml)), e.r === 2 && n.setAttribute("fill-rule", "evenodd"), e.ln && n.setAttribute("id", e.ln), e.cl && n.setAttribute("class", e.cl), e.bm && (n.style["mix-blend-mode"] = getBlendMode(e.bm)), this.stylesList.push(i), this.addToAnimatedContents(e, r), r;
    }, SVGShapeElement.prototype.createGroupElement = function(e) {
      var t = new ShapeGroupData();
      return e.ln && t.gr.setAttribute("id", e.ln), e.cl && t.gr.setAttribute("class", e.cl), e.bm && (t.gr.style["mix-blend-mode"] = getBlendMode(e.bm)), t;
    }, SVGShapeElement.prototype.createTransformElement = function(e, t) {
      var r = TransformPropertyFactory.getTransformProperty(this, e, this), i = new SVGTransformData(r, r.o, t);
      return this.addToAnimatedContents(e, i), i;
    }, SVGShapeElement.prototype.createShapeElement = function(e, t, r) {
      var i = 4;
      e.ty === "rc" ? i = 5 : e.ty === "el" ? i = 6 : e.ty === "sr" && (i = 7);
      var n = ShapePropertyFactory.getShapeProp(this, e, i, this), a = new SVGShapeData(t, r, n);
      return this.shapes.push(a), this.addShapeToModifiers(a), this.addToAnimatedContents(e, a), a;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(e, t) {
      for (var r = 0, i = this.animatedContents.length; r < i; ) {
        if (this.animatedContents[r].element === t)
          return;
        r += 1;
      }
      this.animatedContents.push({
        fn: SVGElementsRenderer.createRenderFunction(e),
        element: t,
        data: e
      });
    }, SVGShapeElement.prototype.setElementStyles = function(e) {
      var t = e.styles, r, i = this.stylesList.length;
      for (r = 0; r < i; r += 1)
        this.stylesList[r].closed || t.push(this.stylesList[r]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(e, t, r, i, n, a, s) {
      var l = [].concat(a), o, c = e.length - 1, f, x, m = [], A = [], M, d, C;
      for (o = c; o >= 0; o -= 1) {
        if (C = this.searchProcessedElement(e[o]), C ? t[o] = r[C - 1] : e[o]._render = s, e[o].ty === "fl" || e[o].ty === "st" || e[o].ty === "gf" || e[o].ty === "gs" || e[o].ty === "no")
          C ? t[o].style.closed = !1 : t[o] = this.createStyleElement(e[o], n), e[o]._render && t[o].style.pElem.parentNode !== i && i.appendChild(t[o].style.pElem), m.push(t[o].style);
        else if (e[o].ty === "gr") {
          if (!C)
            t[o] = this.createGroupElement(e[o]);
          else
            for (x = t[o].it.length, f = 0; f < x; f += 1)
              t[o].prevViewData[f] = t[o].it[f];
          this.searchShapes(e[o].it, t[o].it, t[o].prevViewData, t[o].gr, n + 1, l, s), e[o]._render && t[o].gr.parentNode !== i && i.appendChild(t[o].gr);
        } else
          e[o].ty === "tr" ? (C || (t[o] = this.createTransformElement(e[o], i)), M = t[o].transform, l.push(M)) : e[o].ty === "sh" || e[o].ty === "rc" || e[o].ty === "el" || e[o].ty === "sr" ? (C || (t[o] = this.createShapeElement(e[o], l, n)), this.setElementStyles(t[o])) : e[o].ty === "tm" || e[o].ty === "rd" || e[o].ty === "ms" || e[o].ty === "pb" || e[o].ty === "zz" || e[o].ty === "op" ? (C ? (d = t[o], d.closed = !1) : (d = ShapeModifiers.getModifier(e[o].ty), d.init(this, e[o]), t[o] = d, this.shapeModifiers.push(d)), A.push(d)) : e[o].ty === "rp" && (C ? (d = t[o], d.closed = !0) : (d = ShapeModifiers.getModifier(e[o].ty), t[o] = d, d.init(this, e, o, t), this.shapeModifiers.push(d), s = !1), A.push(d));
        this.addProcessedElement(e[o], o + 1);
      }
      for (c = m.length, o = 0; o < c; o += 1)
        m[o].closed = !0;
      for (c = A.length, o = 0; o < c; o += 1)
        A[o].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].reset();
      for (this.renderShape(), e = 0; e < t; e += 1)
        (this.stylesList[e]._mdf || this._isFirstFrame) && (this.stylesList[e].msElem && (this.stylesList[e].msElem.setAttribute("d", this.stylesList[e].d), this.stylesList[e].d = "M0 0" + this.stylesList[e].d), this.stylesList[e].pElem.setAttribute("d", this.stylesList[e].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var e, t = this.animatedContents.length, r;
      for (e = 0; e < t; e += 1)
        r = this.animatedContents[e], (this._isFirstFrame || r.element._isAnimated) && r.data !== !0 && r.fn(r.data, r.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function LetterProps(e, t, r, i, n, a) {
      this.o = e, this.sw = t, this.sc = r, this.fc = i, this.m = n, this.p = a, this._mdf = {
        o: !0,
        sw: !!t,
        sc: !!r,
        fc: !!i,
        m: !0,
        p: !0
      };
    }
    LetterProps.prototype.update = function(e, t, r, i, n, a) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var s = !1;
      return this.o !== e && (this.o = e, this._mdf.o = !0, s = !0), this.sw !== t && (this.sw = t, this._mdf.sw = !0, s = !0), this.sc !== r && (this.sc = r, this._mdf.sc = !0, s = !0), this.fc !== i && (this.fc = i, this._mdf.fc = !0, s = !0), this.m !== n && (this.m = n, this._mdf.m = !0, s = !0), a.length && (this.p[0] !== a[0] || this.p[1] !== a[1] || this.p[4] !== a[4] || this.p[5] !== a[5] || this.p[12] !== a[12] || this.p[13] !== a[13]) && (this.p = a, this._mdf.p = !0, s = !0), s;
    };
    function TextProperty(e, t) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, t.d && t.d.sid && (t.d = e.globalData.slotManager.getProp(t.d)), this.data = t, this.elem = e, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(e, t) {
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      return e;
    }, TextProperty.prototype.setCurrentData = function(e) {
      e.__complete || this.completeTextData(e), this.currentData = e, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(e) {
      this.effectsSequence.push(e), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(e) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !e)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var t = this.currentData, r = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var i, n = this.effectsSequence.length, a = e || this.data.d.k[this.keysIndex].s;
        for (i = 0; i < n; i += 1)
          r !== this.keysIndex ? a = this.effectsSequence[i](a, a.t) : a = this.effectsSequence[i](this.currentData, a.t);
        t !== a && this.setCurrentData(a), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var e = this.data.d.k, t = this.elem.comp.renderedFrame, r = 0, i = e.length; r <= i - 1 && !(r === i - 1 || e[r + 1].t > t); )
        r += 1;
      return this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(e) {
      for (var t = [], r = 0, i = e.length, n, a, s = !1, l = !1, o = ""; r < i; )
        s = l, l = !1, n = e.charCodeAt(r), o = e.charAt(r), FontManager.isCombinedCharacter(n) ? s = !0 : n >= 55296 && n <= 56319 ? FontManager.isRegionalFlag(e, r) ? o = e.substr(r, 14) : (a = e.charCodeAt(r + 1), a >= 56320 && a <= 57343 && (FontManager.isModifier(n, a) ? (o = e.substr(r, 2), s = !0) : FontManager.isFlagEmoji(e.substr(r, 4)) ? o = e.substr(r, 4) : o = e.substr(r, 2))) : n > 56319 ? (a = e.charCodeAt(r + 1), FontManager.isVariationSelector(n) && (s = !0)) : FontManager.isZeroWidthJoiner(n) && (s = !0, l = !0), s ? (t[t.length - 1] += o, s = !1) : t.push(o), r += o.length;
      return t;
    }, TextProperty.prototype.completeTextData = function(e) {
      e.__complete = !0;
      var t = this.elem.globalData.fontManager, r = this.data, i = [], n, a, s, l = 0, o, c = r.m.g, f = 0, x = 0, m = 0, A = [], M = 0, d = 0, C, u, g = t.getFontByName(e.f), p, y = 0, E = getFontProperties(g);
      e.fWeight = E.weight, e.fStyle = E.style, e.finalSize = e.s, e.finalText = this.buildFinalText(e.t), a = e.finalText.length, e.finalLineHeight = e.lh;
      var T = e.tr / 1e3 * e.finalSize, Z;
      if (e.sz)
        for (var G = !0, I = e.sz[0], V = e.sz[1], Y, D; G; ) {
          D = this.buildFinalText(e.t), Y = 0, M = 0, a = D.length, T = e.tr / 1e3 * e.finalSize;
          var R = -1;
          for (n = 0; n < a; n += 1)
            Z = D[n].charCodeAt(0), s = !1, D[n] === " " ? R = n : (Z === 13 || Z === 3) && (M = 0, s = !0, Y += e.finalLineHeight || e.finalSize * 1.2), t.chars ? (p = t.getCharData(D[n], g.fStyle, g.fFamily), y = s ? 0 : p.w * e.finalSize / 100) : y = t.measureText(D[n], e.f, e.finalSize), M + y > I && D[n] !== " " ? (R === -1 ? a += 1 : n = R, Y += e.finalLineHeight || e.finalSize * 1.2, D.splice(n, R === n ? 1 : 0, "\r"), R = -1, M = 0) : (M += y, M += T);
          Y += g.ascent * e.finalSize / 100, this.canResize && e.finalSize > this.minimumFontSize && V < Y ? (e.finalSize -= 1, e.finalLineHeight = e.finalSize * e.lh / e.s) : (e.finalText = D, a = e.finalText.length, G = !1);
        }
      M = -T, y = 0;
      var B = 0, j;
      for (n = 0; n < a; n += 1)
        if (s = !1, j = e.finalText[n], Z = j.charCodeAt(0), Z === 13 || Z === 3 ? (B = 0, A.push(M), d = M > d ? M : d, M = -2 * T, o = "", s = !0, m += 1) : o = j, t.chars ? (p = t.getCharData(j, g.fStyle, t.getFontByName(e.f).fFamily), y = s ? 0 : p.w * e.finalSize / 100) : y = t.measureText(o, e.f, e.finalSize), j === " " ? B += y + T : (M += y + T + B, B = 0), i.push({
          l: y,
          an: y,
          add: f,
          n: s,
          anIndexes: [],
          val: o,
          line: m,
          animatorJustifyOffset: 0
        }), c == 2) {
          if (f += y, o === "" || o === " " || n === a - 1) {
            for ((o === "" || o === " ") && (f -= y); x <= n; )
              i[x].an = f, i[x].ind = l, i[x].extra = y, x += 1;
            l += 1, f = 0;
          }
        } else if (c == 3) {
          if (f += y, o === "" || n === a - 1) {
            for (o === "" && (f -= y); x <= n; )
              i[x].an = f, i[x].ind = l, i[x].extra = y, x += 1;
            f = 0, l += 1;
          }
        } else
          i[l].ind = l, i[l].extra = 0, l += 1;
      if (e.l = i, d = M > d ? M : d, A.push(M), e.sz)
        e.boxWidth = e.sz[0], e.justifyOffset = 0;
      else
        switch (e.boxWidth = d, e.j) {
          case 1:
            e.justifyOffset = -e.boxWidth;
            break;
          case 2:
            e.justifyOffset = -e.boxWidth / 2;
            break;
          default:
            e.justifyOffset = 0;
        }
      e.lineWidths = A;
      var N = r.a, P, z;
      u = N.length;
      var b, k, S = [];
      for (C = 0; C < u; C += 1) {
        for (P = N[C], P.a.sc && (e.strokeColorAnim = !0), P.a.sw && (e.strokeWidthAnim = !0), (P.a.fc || P.a.fh || P.a.fs || P.a.fb) && (e.fillColorAnim = !0), k = 0, b = P.s.b, n = 0; n < a; n += 1)
          z = i[n], z.anIndexes[C] = k, (b == 1 && z.val !== "" || b == 2 && z.val !== "" && z.val !== " " || b == 3 && (z.n || z.val == " " || n == a - 1) || b == 4 && (z.n || n == a - 1)) && (P.s.rn === 1 && S.push(k), k += 1);
        r.a[C].s.totalChars = k;
        var F = -1, Q;
        if (P.s.rn === 1)
          for (n = 0; n < a; n += 1)
            z = i[n], F != z.anIndexes[C] && (F = z.anIndexes[C], Q = S.splice(Math.floor(Math.random() * S.length), 1)[0]), z.anIndexes[C] = Q;
      }
      e.yOffset = e.finalLineHeight || e.finalSize * 1.2, e.ls = e.ls || 0, e.ascent = g.ascent * e.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(e, t) {
      t = t === void 0 ? this.keysIndex : t;
      var r = this.copyData({}, this.data.d.k[t].s);
      r = this.copyData(r, e), this.data.d.k[t].s = r, this.recalculate(t), this.setCurrentData(r), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(e) {
      var t = this.data.d.k[e].s;
      t.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(t);
    }, TextProperty.prototype.canResizeFont = function(e) {
      this.canResize = e, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(e) {
      this.minimumFontSize = Math.floor(e) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var e = Math.max, t = Math.min, r = Math.floor;
      function i(a, s) {
        this._currentTextLength = -1, this.k = !1, this.data = s, this.elem = a, this.comp = a.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(a), this.s = PropertyFactory.getProp(a, s.s || {
          k: 0
        }, 0, 0, this), "e" in s ? this.e = PropertyFactory.getProp(a, s.e, 0, 0, this) : this.e = {
          v: 100
        }, this.o = PropertyFactory.getProp(a, s.o || {
          k: 0
        }, 0, 0, this), this.xe = PropertyFactory.getProp(a, s.xe || {
          k: 0
        }, 0, 0, this), this.ne = PropertyFactory.getProp(a, s.ne || {
          k: 0
        }, 0, 0, this), this.sm = PropertyFactory.getProp(a, s.sm || {
          k: 100
        }, 0, 0, this), this.a = PropertyFactory.getProp(a, s.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      i.prototype = {
        getMult: function(s) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var l = 0, o = 0, c = 1, f = 1;
          this.ne.v > 0 ? l = this.ne.v / 100 : o = -this.ne.v / 100, this.xe.v > 0 ? c = 1 - this.xe.v / 100 : f = 1 + this.xe.v / 100;
          var x = BezierFactory.getBezierEasing(l, o, c, f).get, m = 0, A = this.finalS, M = this.finalE, d = this.data.sh;
          if (d === 2)
            M === A ? m = s >= M ? 1 : 0 : m = e(0, t(0.5 / (M - A) + (s - A) / (M - A), 1)), m = x(m);
          else if (d === 3)
            M === A ? m = s >= M ? 0 : 1 : m = 1 - e(0, t(0.5 / (M - A) + (s - A) / (M - A), 1)), m = x(m);
          else if (d === 4)
            M === A ? m = 0 : (m = e(0, t(0.5 / (M - A) + (s - A) / (M - A), 1)), m < 0.5 ? m *= 2 : m = 1 - 2 * (m - 0.5)), m = x(m);
          else if (d === 5) {
            if (M === A)
              m = 0;
            else {
              var C = M - A;
              s = t(e(0, s + 0.5 - A), M - A);
              var u = -C / 2 + s, g = C / 2;
              m = Math.sqrt(1 - u * u / (g * g));
            }
            m = x(m);
          } else
            d === 6 ? (M === A ? m = 0 : (s = t(e(0, s + 0.5 - A), M - A), m = (1 + Math.cos(Math.PI + Math.PI * 2 * s / (M - A))) / 2), m = x(m)) : (s >= r(A) && (s - A < 0 ? m = e(0, t(t(M, 1) - (A - s), 1)) : m = e(0, t(M - s, 1))), m = x(m));
          if (this.sm.v !== 100) {
            var p = this.sm.v * 0.01;
            p === 0 && (p = 1e-8);
            var y = 0.5 - p * 0.5;
            m < y ? m = 0 : (m = (m - y) / p, m > 1 && (m = 1));
          }
          return m * this.a.v;
        },
        getValue: function(s) {
          this.iterateDynamicProperties(), this._mdf = s || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, s && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var l = this.data.r === 2 ? 1 : 100 / this.data.totalChars, o = this.o.v / l, c = this.s.v / l + o, f = this.e.v / l + o;
          if (c > f) {
            var x = c;
            c = f, f = x;
          }
          this.finalS = c, this.finalE = f;
        }
      }, extendPrototype([DynamicPropertyContainer], i);
      function n(a, s, l) {
        return new i(a, s);
      }
      return {
        getTextSelectorProp: n
      };
    }();
    function TextAnimatorDataProperty(e, t, r) {
      var i = {
        propType: !1
      }, n = PropertyFactory.getProp, a = t.a;
      this.a = {
        r: a.r ? n(e, a.r, 0, degToRads, r) : i,
        rx: a.rx ? n(e, a.rx, 0, degToRads, r) : i,
        ry: a.ry ? n(e, a.ry, 0, degToRads, r) : i,
        sk: a.sk ? n(e, a.sk, 0, degToRads, r) : i,
        sa: a.sa ? n(e, a.sa, 0, degToRads, r) : i,
        s: a.s ? n(e, a.s, 1, 0.01, r) : i,
        a: a.a ? n(e, a.a, 1, 0, r) : i,
        o: a.o ? n(e, a.o, 0, 0.01, r) : i,
        p: a.p ? n(e, a.p, 1, 0, r) : i,
        sw: a.sw ? n(e, a.sw, 0, 0, r) : i,
        sc: a.sc ? n(e, a.sc, 1, 0, r) : i,
        fc: a.fc ? n(e, a.fc, 1, 0, r) : i,
        fh: a.fh ? n(e, a.fh, 0, 0, r) : i,
        fs: a.fs ? n(e, a.fs, 0, 0.01, r) : i,
        fb: a.fb ? n(e, a.fb, 0, 0.01, r) : i,
        t: a.t ? n(e, a.t, 0, 0, r) : i
      }, this.s = TextSelectorProp.getTextSelectorProp(e, t.s, r), this.s.t = t.s.t;
    }
    function TextAnimatorProperty(e, t, r) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = e, this._renderType = t, this._elem = r, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var e, t = this._textData.a.length, r, i = PropertyFactory.getProp;
      for (e = 0; e < t; e += 1)
        r = this._textData.a[e], this._animatorsData[e] = new TextAnimatorDataProperty(this._elem, r, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: i(this._elem, this._textData.p.a, 0, 0, this),
        f: i(this._elem, this._textData.p.f, 0, 0, this),
        l: i(this._elem, this._textData.p.l, 0, 0, this),
        r: i(this._elem, this._textData.p.r, 0, 0, this),
        p: i(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(e, t) {
      if (this.lettersChangedFlag = t, !(!this._mdf && !this._isFirstFrame && !t && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var r = this._moreOptions.alignment.v, i = this._animatorsData, n = this._textData, a = this.mHelper, s = this._renderType, l = this.renderedLetters.length, o, c, f, x, m = e.l, A, M, d, C, u, g, p, y, E, T, Z, G, I, V, Y;
        if (this._hasMaskedPath) {
          if (Y = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var D = Y.v;
            this._pathData.r.v && (D = D.reverse()), A = {
              tLength: 0,
              segments: []
            }, x = D._length - 1;
            var R;
            for (G = 0, f = 0; f < x; f += 1)
              R = bez.buildBezierData(D.v[f], D.v[f + 1], [D.o[f][0] - D.v[f][0], D.o[f][1] - D.v[f][1]], [D.i[f + 1][0] - D.v[f + 1][0], D.i[f + 1][1] - D.v[f + 1][1]]), A.tLength += R.segmentLength, A.segments.push(R), G += R.segmentLength;
            f = x, Y.v.c && (R = bez.buildBezierData(D.v[f], D.v[0], [D.o[f][0] - D.v[f][0], D.o[f][1] - D.v[f][1]], [D.i[0][0] - D.v[0][0], D.i[0][1] - D.v[0][1]]), A.tLength += R.segmentLength, A.segments.push(R), G += R.segmentLength), this._pathData.pi = A;
          }
          if (A = this._pathData.pi, M = this._pathData.f.v, p = 0, g = 1, C = 0, u = !0, T = A.segments, M < 0 && Y.v.c)
            for (A.tLength < Math.abs(M) && (M = -Math.abs(M) % A.tLength), p = T.length - 1, E = T[p].points, g = E.length - 1; M < 0; )
              M += E[g].partialLength, g -= 1, g < 0 && (p -= 1, E = T[p].points, g = E.length - 1);
          E = T[p].points, y = E[g - 1], d = E[g], Z = d.partialLength;
        }
        x = m.length, o = 0, c = 0;
        var B = e.finalSize * 1.2 * 0.714, j = !0, N, P, z, b, k;
        b = i.length;
        var S, F = -1, Q, L, W, q = M, _ = p, ee = g, se = -1, ae, re, me, $, O, ge, he, le, ce = "", K = this.defaultPropsArray, ue;
        if (e.j === 2 || e.j === 1) {
          var ie = 0, Ae = 0, te = e.j === 2 ? -0.5 : -1, U = 0, ne = !0;
          for (f = 0; f < x; f += 1)
            if (m[f].n) {
              for (ie && (ie += Ae); U < f; )
                m[U].animatorJustifyOffset = ie, U += 1;
              ie = 0, ne = !0;
            } else {
              for (z = 0; z < b; z += 1)
                N = i[z].a, N.t.propType && (ne && e.j === 2 && (Ae += N.t.v * te), P = i[z].s, S = P.getMult(m[f].anIndexes[z], n.a[z].s.totalChars), S.length ? ie += N.t.v * S[0] * te : ie += N.t.v * S * te);
              ne = !1;
            }
          for (ie && (ie += Ae); U < f; )
            m[U].animatorJustifyOffset = ie, U += 1;
        }
        for (f = 0; f < x; f += 1) {
          if (a.reset(), ae = 1, m[f].n)
            o = 0, c += e.yOffset, c += j ? 1 : 0, M = q, j = !1, this._hasMaskedPath && (p = _, g = ee, E = T[p].points, y = E[g - 1], d = E[g], Z = d.partialLength, C = 0), ce = "", le = "", ge = "", ue = "", K = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (se !== m[f].line) {
                switch (e.j) {
                  case 1:
                    M += G - e.lineWidths[m[f].line];
                    break;
                  case 2:
                    M += (G - e.lineWidths[m[f].line]) / 2;
                    break;
                }
                se = m[f].line;
              }
              F !== m[f].ind && (m[F] && (M += m[F].extra), M += m[f].an / 2, F = m[f].ind), M += r[0] * m[f].an * 5e-3;
              var oe = 0;
              for (z = 0; z < b; z += 1)
                N = i[z].a, N.p.propType && (P = i[z].s, S = P.getMult(m[f].anIndexes[z], n.a[z].s.totalChars), S.length ? oe += N.p.v[0] * S[0] : oe += N.p.v[0] * S), N.a.propType && (P = i[z].s, S = P.getMult(m[f].anIndexes[z], n.a[z].s.totalChars), S.length ? oe += N.a.v[0] * S[0] : oe += N.a.v[0] * S);
              for (u = !0, this._pathData.a.v && (M = m[0].an * 0.5 + (G - this._pathData.f.v - m[0].an * 0.5 - m[m.length - 1].an * 0.5) * F / (x - 1), M += this._pathData.f.v); u; )
                C + Z >= M + oe || !E ? (I = (M + oe - C) / d.partialLength, L = y.point[0] + (d.point[0] - y.point[0]) * I, W = y.point[1] + (d.point[1] - y.point[1]) * I, a.translate(-r[0] * m[f].an * 5e-3, -(r[1] * B) * 0.01), u = !1) : E && (C += d.partialLength, g += 1, g >= E.length && (g = 0, p += 1, T[p] ? E = T[p].points : Y.v.c ? (g = 0, p = 0, E = T[p].points) : (C -= d.partialLength, E = null)), E && (y = d, d = E[g], Z = d.partialLength));
              Q = m[f].an / 2 - m[f].add, a.translate(-Q, 0, 0);
            } else
              Q = m[f].an / 2 - m[f].add, a.translate(-Q, 0, 0), a.translate(-r[0] * m[f].an * 5e-3, -r[1] * B * 0.01, 0);
            for (z = 0; z < b; z += 1)
              N = i[z].a, N.t.propType && (P = i[z].s, S = P.getMult(m[f].anIndexes[z], n.a[z].s.totalChars), (o !== 0 || e.j !== 0) && (this._hasMaskedPath ? S.length ? M += N.t.v * S[0] : M += N.t.v * S : S.length ? o += N.t.v * S[0] : o += N.t.v * S));
            for (e.strokeWidthAnim && (me = e.sw || 0), e.strokeColorAnim && (e.sc ? re = [e.sc[0], e.sc[1], e.sc[2]] : re = [0, 0, 0]), e.fillColorAnim && e.fc && ($ = [e.fc[0], e.fc[1], e.fc[2]]), z = 0; z < b; z += 1)
              N = i[z].a, N.a.propType && (P = i[z].s, S = P.getMult(m[f].anIndexes[z], n.a[z].s.totalChars), S.length ? a.translate(-N.a.v[0] * S[0], -N.a.v[1] * S[1], N.a.v[2] * S[2]) : a.translate(-N.a.v[0] * S, -N.a.v[1] * S, N.a.v[2] * S));
            for (z = 0; z < b; z += 1)
              N = i[z].a, N.s.propType && (P = i[z].s, S = P.getMult(m[f].anIndexes[z], n.a[z].s.totalChars), S.length ? a.scale(1 + (N.s.v[0] - 1) * S[0], 1 + (N.s.v[1] - 1) * S[1], 1) : a.scale(1 + (N.s.v[0] - 1) * S, 1 + (N.s.v[1] - 1) * S, 1));
            for (z = 0; z < b; z += 1) {
              if (N = i[z].a, P = i[z].s, S = P.getMult(m[f].anIndexes[z], n.a[z].s.totalChars), N.sk.propType && (S.length ? a.skewFromAxis(-N.sk.v * S[0], N.sa.v * S[1]) : a.skewFromAxis(-N.sk.v * S, N.sa.v * S)), N.r.propType && (S.length ? a.rotateZ(-N.r.v * S[2]) : a.rotateZ(-N.r.v * S)), N.ry.propType && (S.length ? a.rotateY(N.ry.v * S[1]) : a.rotateY(N.ry.v * S)), N.rx.propType && (S.length ? a.rotateX(N.rx.v * S[0]) : a.rotateX(N.rx.v * S)), N.o.propType && (S.length ? ae += (N.o.v * S[0] - ae) * S[0] : ae += (N.o.v * S - ae) * S), e.strokeWidthAnim && N.sw.propType && (S.length ? me += N.sw.v * S[0] : me += N.sw.v * S), e.strokeColorAnim && N.sc.propType)
                for (O = 0; O < 3; O += 1)
                  S.length ? re[O] += (N.sc.v[O] - re[O]) * S[0] : re[O] += (N.sc.v[O] - re[O]) * S;
              if (e.fillColorAnim && e.fc) {
                if (N.fc.propType)
                  for (O = 0; O < 3; O += 1)
                    S.length ? $[O] += (N.fc.v[O] - $[O]) * S[0] : $[O] += (N.fc.v[O] - $[O]) * S;
                N.fh.propType && (S.length ? $ = addHueToRGB($, N.fh.v * S[0]) : $ = addHueToRGB($, N.fh.v * S)), N.fs.propType && (S.length ? $ = addSaturationToRGB($, N.fs.v * S[0]) : $ = addSaturationToRGB($, N.fs.v * S)), N.fb.propType && (S.length ? $ = addBrightnessToRGB($, N.fb.v * S[0]) : $ = addBrightnessToRGB($, N.fb.v * S));
              }
            }
            for (z = 0; z < b; z += 1)
              N = i[z].a, N.p.propType && (P = i[z].s, S = P.getMult(m[f].anIndexes[z], n.a[z].s.totalChars), this._hasMaskedPath ? S.length ? a.translate(0, N.p.v[1] * S[0], -N.p.v[2] * S[1]) : a.translate(0, N.p.v[1] * S, -N.p.v[2] * S) : S.length ? a.translate(N.p.v[0] * S[0], N.p.v[1] * S[1], -N.p.v[2] * S[2]) : a.translate(N.p.v[0] * S, N.p.v[1] * S, -N.p.v[2] * S));
            if (e.strokeWidthAnim && (ge = me < 0 ? 0 : me), e.strokeColorAnim && (he = "rgb(" + Math.round(re[0] * 255) + "," + Math.round(re[1] * 255) + "," + Math.round(re[2] * 255) + ")"), e.fillColorAnim && e.fc && (le = "rgb(" + Math.round($[0] * 255) + "," + Math.round($[1] * 255) + "," + Math.round($[2] * 255) + ")"), this._hasMaskedPath) {
              if (a.translate(0, -e.ls), a.translate(0, r[1] * B * 0.01 + c, 0), this._pathData.p.v) {
                V = (d.point[1] - y.point[1]) / (d.point[0] - y.point[0]);
                var Ze = Math.atan(V) * 180 / Math.PI;
                d.point[0] < y.point[0] && (Ze += 180), a.rotate(-Ze * Math.PI / 180);
              }
              a.translate(L, W, 0), M -= r[0] * m[f].an * 5e-3, m[f + 1] && F !== m[f + 1].ind && (M += m[f].an / 2, M += e.tr * 1e-3 * e.finalSize);
            } else {
              switch (a.translate(o, c, 0), e.ps && a.translate(e.ps[0], e.ps[1] + e.ascent, 0), e.j) {
                case 1:
                  a.translate(m[f].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[m[f].line]), 0, 0);
                  break;
                case 2:
                  a.translate(m[f].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[m[f].line]) / 2, 0, 0);
                  break;
              }
              a.translate(0, -e.ls), a.translate(Q, 0, 0), a.translate(r[0] * m[f].an * 5e-3, r[1] * B * 0.01, 0), o += m[f].l + e.tr * 1e-3 * e.finalSize;
            }
            s === "html" ? ce = a.toCSS() : s === "svg" ? ce = a.to2dCSS() : K = [a.props[0], a.props[1], a.props[2], a.props[3], a.props[4], a.props[5], a.props[6], a.props[7], a.props[8], a.props[9], a.props[10], a.props[11], a.props[12], a.props[13], a.props[14], a.props[15]], ue = ae;
          }
          l <= f ? (k = new LetterProps(ue, ge, he, le, ce, K), this.renderedLetters.push(k), l += 1, this.lettersChangedFlag = !0) : (k = this.renderedLetters[f], this.lettersChangedFlag = k.update(ue, ge, he, le, ce, K) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
    function ITextElement() {
    }
    ITextElement.prototype.initElement = function(e, t, r) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(e, t, r), this.textProperty = new TextProperty(this, e.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(e.t, this.renderType, this), this.initTransform(e, t, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(e) {
      this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(e, t) {
      var r, i = t.length, n, a = "";
      for (r = 0; r < i; r += 1)
        t[r].ty === "sh" && (n = t[r].ks.k, a += buildShapeString(n, n.i.length, !0, e));
      return a;
    }, ITextElement.prototype.updateDocumentData = function(e, t) {
      this.textProperty.updateDocumentData(e, t);
    }, ITextElement.prototype.canResizeFont = function(e) {
      this.textProperty.canResizeFont(e);
    }, ITextElement.prototype.setMinimumFontSize = function(e) {
      this.textProperty.setMinimumFontSize(e);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(e, t, r, i, n) {
      switch (e.ps && t.translate(e.ps[0], e.ps[1] + e.ascent, 0), t.translate(0, -e.ls, 0), e.j) {
        case 1:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[r]), 0, 0);
          break;
        case 2:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[r]) / 2, 0, 0);
          break;
      }
      t.translate(i, n, 0);
    }, ITextElement.prototype.buildColor = function(e) {
      return "rgb(" + Math.round(e[0] * 255) + "," + Math.round(e[1] * 255) + "," + Math.round(e[2] * 255) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = {
      shapes: []
    };
    function SVGTextLottieElement(e, t, r) {
      this.textSpans = [], this.renderType = "svg", this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(e) {
      for (var t = 0, r = e.length, i = [], n = ""; t < r; )
        e[t] === String.fromCharCode(13) || e[t] === String.fromCharCode(3) ? (i.push(n), n = "") : n += e[t], t += 1;
      return i.push(n), i;
    }, SVGTextLottieElement.prototype.buildShapeData = function(e, t) {
      if (e.shapes && e.shapes.length) {
        var r = e.shapes[0];
        if (r.it) {
          var i = r.it[r.it.length - 1];
          i.s && (i.s.k[0] = t, i.s.k[1] = t);
        }
      }
      return e;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var e, t, r = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(r ? r.l.length : 0), r.fc ? this.layerElement.setAttribute("fill", this.buildColor(r.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)), this.layerElement.setAttribute("stroke-width", r.sw)), this.layerElement.setAttribute("font-size", r.finalSize);
      var i = this.globalData.fontManager.getFontByName(r.f);
      if (i.fClass)
        this.layerElement.setAttribute("class", i.fClass);
      else {
        this.layerElement.setAttribute("font-family", i.fFamily);
        var n = r.fWeight, a = r.fStyle;
        this.layerElement.setAttribute("font-style", a), this.layerElement.setAttribute("font-weight", n);
      }
      this.layerElement.setAttribute("aria-label", r.t);
      var s = r.l || [], l = !!this.globalData.fontManager.chars;
      t = s.length;
      var o, c = this.mHelper, f = "", x = this.data.singleShape, m = 0, A = 0, M = !0, d = r.tr * 1e-3 * r.finalSize;
      if (x && !l && !r.sz) {
        var C = this.textContainer, u = "start";
        switch (r.j) {
          case 1:
            u = "end";
            break;
          case 2:
            u = "middle";
            break;
          default:
            u = "start";
            break;
        }
        C.setAttribute("text-anchor", u), C.setAttribute("letter-spacing", d);
        var g = this.buildTextContents(r.finalText);
        for (t = g.length, A = r.ps ? r.ps[1] + r.ascent : 0, e = 0; e < t; e += 1)
          o = this.textSpans[e].span || createNS("tspan"), o.textContent = g[e], o.setAttribute("x", 0), o.setAttribute("y", A), o.style.display = "inherit", C.appendChild(o), this.textSpans[e] || (this.textSpans[e] = {
            span: null,
            glyph: null
          }), this.textSpans[e].span = o, A += r.finalLineHeight;
        this.layerElement.appendChild(C);
      } else {
        var p = this.textSpans.length, y;
        for (e = 0; e < t; e += 1) {
          if (this.textSpans[e] || (this.textSpans[e] = {
            span: null,
            childSpan: null,
            glyph: null
          }), !l || !x || e === 0) {
            if (o = p > e ? this.textSpans[e].span : createNS(l ? "g" : "text"), p <= e) {
              if (o.setAttribute("stroke-linecap", "butt"), o.setAttribute("stroke-linejoin", "round"), o.setAttribute("stroke-miterlimit", "4"), this.textSpans[e].span = o, l) {
                var E = createNS("g");
                o.appendChild(E), this.textSpans[e].childSpan = E;
              }
              this.textSpans[e].span = o, this.layerElement.appendChild(o);
            }
            o.style.display = "inherit";
          }
          if (c.reset(), x && (s[e].n && (m = -d, A += r.yOffset, A += M ? 1 : 0, M = !1), this.applyTextPropertiesToMatrix(r, c, s[e].line, m, A), m += s[e].l || 0, m += d), l) {
            y = this.globalData.fontManager.getCharData(r.finalText[e], i.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily);
            var T;
            if (y.t === 1)
              T = new SVGCompElement(y.data, this.globalData, this);
            else {
              var Z = emptyShapeData;
              y.data && y.data.shapes && (Z = this.buildShapeData(y.data, r.finalSize)), T = new SVGShapeElement(Z, this.globalData, this);
            }
            if (this.textSpans[e].glyph) {
              var G = this.textSpans[e].glyph;
              this.textSpans[e].childSpan.removeChild(G.layerElement), G.destroy();
            }
            this.textSpans[e].glyph = T, T._debug = !0, T.prepareFrame(0), T.renderFrame(), this.textSpans[e].childSpan.appendChild(T.layerElement), y.t === 1 && this.textSpans[e].childSpan.setAttribute("transform", "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")");
          } else
            x && o.setAttribute("transform", "translate(" + c.props[12] + "," + c.props[13] + ")"), o.textContent = s[e].val, o.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        x && o && o.setAttribute("d", f);
      }
      for (; e < this.textSpans.length; )
        this.textSpans[e].span.style.display = "none", e += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var e = this.layerElement.getBBox();
        this.bbox = {
          top: e.y,
          left: e.x,
          width: e.width,
          height: e.height
        };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var e, t = this.textSpans.length, r;
      for (this.renderedFrame = this.comp.renderedFrame, e = 0; e < t; e += 1)
        r = this.textSpans[e].glyph, r && (r.prepareFrame(this.comp.renderedFrame - this.data.st), r._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var e, t, r = this.textAnimator.renderedLetters, i = this.textProperty.currentData.l;
        t = i.length;
        var n, a, s;
        for (e = 0; e < t; e += 1)
          i[e].n || (n = r[e], a = this.textSpans[e].span, s = this.textSpans[e].glyph, s && s.renderFrame(), n._mdf.m && a.setAttribute("transform", n.m), n._mdf.o && a.setAttribute("opacity", n.o), n._mdf.sw && a.setAttribute("stroke-width", n.sw), n._mdf.sc && a.setAttribute("stroke", n.sc), n._mdf.fc && a.setAttribute("fill", n.fc));
      }
    };
    function ISolidElement(e, t, r) {
      this.initElement(e, t, r);
    }
    extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var e = createNS("rect");
      e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.layerElement.appendChild(e);
    };
    function NullElement(e, t, r) {
      this.initFrame(), this.initBaseData(e, t, r), this.initFrame(), this.initTransform(e, t, r), this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
    function SVGRendererBase() {
    }
    extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(e) {
      return new NullElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(e) {
      return new SVGShapeElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(e) {
      return new SVGTextLottieElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(e) {
      return new IImageElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(e) {
      return new ISolidElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(e) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + e.w + " " + e.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", e.w), this.svgElement.setAttribute("height", e.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var t = this.globalData.defs;
      this.setupGlobalData(e, t), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = e;
      var r = createNS("clipPath"), i = createNS("rect");
      i.setAttribute("width", e.w), i.setAttribute("height", e.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
      var n = createElementID();
      r.setAttribute("id", n), r.appendChild(i), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + n + ")"), t.appendChild(r), this.layers = e.layers, this.elements = createSizedArray(e.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(e) {
      var t = 0, r = this.layers.length;
      for (t = 0; t < r; t += 1)
        if (this.layers[t].ind === e)
          return t;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        t[e] = !0;
        var r = this.createItem(this.layers[e]);
        if (t[e] = r, getExpressionsPlugin() && (this.layers[e].ty === 0 && this.globalData.projectInterface.registerComposition(r), r.initExpressions()), this.appendElementInPos(r, e), this.layers[e].tt) {
          var i = "tp" in this.layers[e] ? this.findIndexByInd(this.layers[e].tp) : e - 1;
          if (i === -1)
            return;
          if (!this.elements[i] || this.elements[i] === !0)
            this.buildItem(i), this.addPendingElement(r);
          else {
            var n = t[i], a = n.getMatte(this.layers[e].tt);
            r.setMatte(a);
          }
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        if (e.checkParenting(), e.data.tt)
          for (var t = 0, r = this.elements.length; t < r; ) {
            if (this.elements[t] === e) {
              var i = "tp" in e.data ? this.findIndexByInd(e.data.tp) : t - 1, n = this.elements[i], a = n.getMatte(this.layers[t].tt);
              e.setMatte(a);
              break;
            }
            t += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(e) {
      if (!(this.renderedFrame === e || this.destroyed)) {
        e === null ? e = this.renderedFrame : this.renderedFrame = e, this.globalData.frameNum = e, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = e, this.globalData._mdf = !1;
        var t, r = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), t = r - 1; t >= 0; t -= 1)
          (this.completeLayers || this.elements[t]) && this.elements[t].prepareFrame(e - this.layers[t].st);
        if (this.globalData._mdf)
          for (t = 0; t < r; t += 1)
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(e, t) {
      var r = e.getBaseElement();
      if (r) {
        for (var i = 0, n; i < t; )
          this.elements[i] && this.elements[i] !== !0 && this.elements[i].getBaseElement() && (n = this.elements[i].getBaseElement()), i += 1;
        n ? this.layerElement.insertBefore(r, n) : this.layerElement.appendChild(r);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function ICompElement() {
    }
    extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(e, t, r) {
      this.initFrame(), this.initBaseData(e, t, r), this.initTransform(e, t, r), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !t.progressiveLoad) && this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(e) {
      if (this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = e / this.data.sr;
        else {
          var t = this.tm.v;
          t === this.data.op && (t = this.data.op - 1), this.renderedFrame = t;
        }
        var r, i = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), r = i - 1; r >= 0; r -= 1)
          (this.completeLayers || this.elements[r]) && (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st), this.elements[r]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
    }, ICompElement.prototype.setElements = function(e) {
      this.elements = e;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function SVGCompElement(e, t, r) {
      this.layers = e.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, r), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function SVGRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var r = "";
      if (t && t.title) {
        var i = createNS("title"), n = createElementID();
        i.setAttribute("id", n), i.textContent = t.title, this.svgElement.appendChild(i), r += n;
      }
      if (t && t.description) {
        var a = createNS("desc"), s = createElementID();
        a.setAttribute("id", s), a.textContent = t.description, this.svgElement.appendChild(a), r += " " + s;
      }
      r && this.svgElement.setAttribute("aria-labelledby", r);
      var l = createNS("defs");
      this.svgElement.appendChild(l);
      var o = createNS("g");
      this.svgElement.appendChild(o), this.layerElement = o, this.renderConfig = {
        preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: t && t.contentVisibility || "visible",
        progressiveLoad: t && t.progressiveLoad || !1,
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        viewBoxOnly: t && t.viewBoxOnly || !1,
        viewBoxSize: t && t.viewBoxSize || !1,
        className: t && t.className || "",
        id: t && t.id || "",
        focusable: t && t.focusable,
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "100%",
          height: t && t.filterSize && t.filterSize.height || "100%",
          x: t && t.filterSize && t.filterSize.x || "0%",
          y: t && t.filterSize && t.filterSize.y || "0%"
        },
        width: t && t.width,
        height: t && t.height,
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: l,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
      addTransformSequence: function(t) {
        var r, i = t.length, n = "_";
        for (r = 0; r < i; r += 1)
          n += t[r].transform.key + "_";
        var a = this.sequences[n];
        return a || (a = {
          transforms: [].concat(t),
          finalTransform: new Matrix(),
          _mdf: !1
        }, this.sequences[n] = a, this.sequenceList.push(a)), a;
      },
      processSequence: function(t, r) {
        for (var i = 0, n = t.transforms.length, a = r; i < n && !r; ) {
          if (t.transforms[i].transform.mProps._mdf) {
            a = !0;
            break;
          }
          i += 1;
        }
        if (a)
          for (t.finalTransform.reset(), i = n - 1; i >= 0; i -= 1)
            t.finalTransform.multiply(t.transforms[i].transform.mProps.v);
        t._mdf = a;
      },
      processSequences: function(t) {
        var r, i = this.sequenceList.length;
        for (r = 0; r < i; r += 1)
          this.processSequence(this.sequenceList[r], t);
      },
      getNewKey: function() {
        return this.transform_key_count += 1, "_" + this.transform_key_count;
      }
    };
    var lumaLoader = function() {
      var t = "__lottie_element_luma_buffer", r = null, i = null, n = null;
      function a() {
        var o = createNS("svg"), c = createNS("filter"), f = createNS("feColorMatrix");
        return c.setAttribute("id", t), f.setAttribute("type", "matrix"), f.setAttribute("color-interpolation-filters", "sRGB"), f.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), c.appendChild(f), o.appendChild(c), o.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (o.style.display = "none"), o;
      }
      function s() {
        r || (n = a(), document.body.appendChild(n), r = createTag("canvas"), i = r.getContext("2d"), i.filter = "url(#" + t + ")", i.fillStyle = "rgba(0,0,0,0)", i.fillRect(0, 0, 1, 1));
      }
      function l(o) {
        return r || s(), r.width = o.width, r.height = o.height, i.filter = "url(#" + t + ")", r;
      }
      return {
        load: s,
        get: l
      };
    };
    function createCanvas(e, t) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(e, t);
      var r = createTag("canvas");
      return r.width = e, r.height = t, r;
    }
    var assetLoader = function() {
      return {
        loadLumaCanvas: lumaLoader.load,
        getLumaCanvas: lumaLoader.get,
        createCanvas
      };
    }(), registeredEffects = {};
    function CVEffects(e) {
      var t, r = e.data.ef ? e.data.ef.length : 0;
      this.filters = [];
      var i;
      for (t = 0; t < r; t += 1) {
        i = null;
        var n = e.data.ef[t].ty;
        if (registeredEffects[n]) {
          var a = registeredEffects[n].effect;
          i = new a(e.effectsManager.effectElements[t], e);
        }
        i && this.filters.push(i);
      }
      this.filters.length && e.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(e) {
      var t, r = this.filters.length;
      for (t = 0; t < r; t += 1)
        this.filters[t].renderFrame(e);
    }, CVEffects.prototype.getEffects = function(e) {
      var t, r = this.filters.length, i = [];
      for (t = 0; t < r; t += 1)
        this.filters[t].type === e && i.push(this.filters[t]);
      return i;
    };
    function registerEffect(e, t) {
      registeredEffects[e] = {
        effect: t
      };
    }
    function CVMaskElement(e, t) {
      this.data = e, this.element = t, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var r, i = this.masksProperties.length, n = !1;
      for (r = 0; r < i; r += 1)
        this.masksProperties[r].mode !== "n" && (n = !0), this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3);
      this.hasMasks = n, n && this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var e = this.element.finalTransform.mat, t = this.element.canvasContext, r, i = this.masksProperties.length, n, a, s;
        for (t.beginPath(), r = 0; r < i; r += 1)
          if (this.masksProperties[r].mode !== "n") {
            this.masksProperties[r].inv && (t.moveTo(0, 0), t.lineTo(this.element.globalData.compSize.w, 0), t.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), t.lineTo(0, this.element.globalData.compSize.h), t.lineTo(0, 0)), s = this.viewData[r].v, n = e.applyToPointArray(s.v[0][0], s.v[0][1], 0), t.moveTo(n[0], n[1]);
            var l, o = s._length;
            for (l = 1; l < o; l += 1)
              a = e.applyToTriplePoints(s.o[l - 1], s.i[l], s.v[l]), t.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
            a = e.applyToTriplePoints(s.o[l - 1], s.i[0], s.v[0]), t.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
          }
        this.element.globalData.renderer.save(!0), t.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    function CVBaseElement() {
    }
    var operationsMap = {
      1: "source-in",
      2: "source-out",
      3: "source-in",
      4: "source-out"
    };
    CVBaseElement.prototype = {
      createElements: function() {
      },
      initRendererElement: function() {
      },
      createContainerElements: function() {
        if (this.data.tt >= 1) {
          this.buffers = [];
          var t = this.globalData.canvasContext, r = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(r);
          var i = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(i), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
        }
        this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
      },
      createContent: function() {
      },
      setBlendMode: function() {
        var t = this.globalData;
        if (t.blendMode !== this.data.bm) {
          t.blendMode = this.data.bm;
          var r = getBlendMode(this.data.bm);
          t.canvasContext.globalCompositeOperation = r;
        }
      },
      createRenderableComponents: function() {
        this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
      },
      hideElement: function() {
        !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
      },
      showElement: function() {
        this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
      },
      clearCanvas: function(t) {
        t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
      },
      prepareLayer: function() {
        if (this.data.tt >= 1) {
          var t = this.buffers[0], r = t.getContext("2d");
          this.clearCanvas(r), r.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
        }
      },
      exitLayer: function() {
        if (this.data.tt >= 1) {
          var t = this.buffers[1], r = t.getContext("2d");
          this.clearCanvas(r), r.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
          var i = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
          if (i.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
            var n = assetLoader.getLumaCanvas(this.canvasContext.canvas), a = n.getContext("2d");
            a.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(n, 0, 0);
          }
          this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
        }
      },
      renderFrame: function(t) {
        if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !t)) {
          this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
          var r = this.data.ty === 0;
          this.prepareLayer(), this.globalData.renderer.save(r), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(r), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
        }
      },
      destroy: function() {
        this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
      },
      mHelper: new Matrix()
    }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(e, t, r, i) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var n = 4;
      t.ty === "rc" ? n = 5 : t.ty === "el" ? n = 6 : t.ty === "sr" && (n = 7), this.sh = ShapePropertyFactory.getShapeProp(e, t, n, e);
      var a, s = r.length, l;
      for (a = 0; a < s; a += 1)
        r[a].closed || (l = {
          transforms: i.addTransformSequence(r[a].transforms),
          trNodes: []
        }, this.styledShapes.push(l), r[a].elements.push(l));
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(e, t, r) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
      opacity: 1,
      _opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(e, t) {
      var r = {
        data: e,
        type: e.ty,
        preTransforms: this.transformsManager.addTransformSequence(t),
        transforms: [],
        elements: [],
        closed: e.hd === !0
      }, i = {};
      if (e.ty === "fl" || e.ty === "st" ? (i.c = PropertyFactory.getProp(this, e.c, 1, 255, this), i.c.k || (r.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")")) : (e.ty === "gf" || e.ty === "gs") && (i.s = PropertyFactory.getProp(this, e.s, 1, null, this), i.e = PropertyFactory.getProp(this, e.e, 1, null, this), i.h = PropertyFactory.getProp(this, e.h || {
        k: 0
      }, 0, 0.01, this), i.a = PropertyFactory.getProp(this, e.a || {
        k: 0
      }, 0, degToRads, this), i.g = new GradientProperty(this, e.g, this)), i.o = PropertyFactory.getProp(this, e.o, 0, 0.01, this), e.ty === "st" || e.ty === "gs") {
        if (r.lc = lineCapEnum[e.lc || 2], r.lj = lineJoinEnum[e.lj || 2], e.lj == 1 && (r.ml = e.ml), i.w = PropertyFactory.getProp(this, e.w, 0, null, this), i.w.k || (r.wi = i.w.v), e.d) {
          var n = new DashProperty(this, e.d, "canvas", this);
          i.d = n, i.d.k || (r.da = i.d.dashArray, r.do = i.d.dashoffset[0]);
        }
      } else
        r.r = e.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(r), i.style = r, i;
    }, CVShapeElement.prototype.createGroupElement = function() {
      var e = {
        it: [],
        prevViewData: []
      };
      return e;
    }, CVShapeElement.prototype.createTransformElement = function(e) {
      var t = {
        transform: {
          opacity: 1,
          _opMdf: !1,
          key: this.transformsManager.getNewKey(),
          op: PropertyFactory.getProp(this, e.o, 0, 0.01, this),
          mProps: TransformPropertyFactory.getTransformProperty(this, e, this)
        }
      };
      return t;
    }, CVShapeElement.prototype.createShapeElement = function(e) {
      var t = new CVShapeData(this, e, this.stylesList, this.transformsManager);
      return this.shapes.push(t), this.addShapeToModifiers(t), t;
    }, CVShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(e) {
      var t, r = this.stylesList.length;
      for (t = 0; t < r; t += 1)
        this.stylesList[t].closed || this.stylesList[t].transforms.push(e);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].closed || this.stylesList[e].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(e) {
      var t, r = e.length;
      for (t = 0; t < r; t += 1)
        e[t].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(e, t, r, i, n) {
      var a, s = e.length - 1, l, o, c = [], f = [], x, m, A, M = [].concat(n);
      for (a = s; a >= 0; a -= 1) {
        if (x = this.searchProcessedElement(e[a]), x ? t[a] = r[x - 1] : e[a]._shouldRender = i, e[a].ty === "fl" || e[a].ty === "st" || e[a].ty === "gf" || e[a].ty === "gs")
          x ? t[a].style.closed = !1 : t[a] = this.createStyleElement(e[a], M), c.push(t[a].style);
        else if (e[a].ty === "gr") {
          if (!x)
            t[a] = this.createGroupElement(e[a]);
          else
            for (o = t[a].it.length, l = 0; l < o; l += 1)
              t[a].prevViewData[l] = t[a].it[l];
          this.searchShapes(e[a].it, t[a].it, t[a].prevViewData, i, M);
        } else
          e[a].ty === "tr" ? (x || (A = this.createTransformElement(e[a]), t[a] = A), M.push(t[a]), this.addTransformToStyleList(t[a])) : e[a].ty === "sh" || e[a].ty === "rc" || e[a].ty === "el" || e[a].ty === "sr" ? x || (t[a] = this.createShapeElement(e[a])) : e[a].ty === "tm" || e[a].ty === "rd" || e[a].ty === "pb" || e[a].ty === "zz" || e[a].ty === "op" ? (x ? (m = t[a], m.closed = !1) : (m = ShapeModifiers.getModifier(e[a].ty), m.init(this, e[a]), t[a] = m, this.shapeModifiers.push(m)), f.push(m)) : e[a].ty === "rp" && (x ? (m = t[a], m.closed = !0) : (m = ShapeModifiers.getModifier(e[a].ty), t[a] = m, m.init(this, e, a, t), this.shapeModifiers.push(m), i = !1), f.push(m));
        this.addProcessedElement(e[a], a + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(c), s = f.length, a = 0; a < s; a += 1)
        f[a].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(e, t) {
      (e._opMdf || t.op._mdf || this._isFirstFrame) && (t.opacity = e.opacity, t.opacity *= t.op.v, t._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var e, t = this.stylesList.length, r, i, n, a, s, l, o = this.globalData.renderer, c = this.globalData.canvasContext, f, x;
      for (e = 0; e < t; e += 1)
        if (x = this.stylesList[e], f = x.type, !((f === "st" || f === "gs") && x.wi === 0 || !x.data._shouldRender || x.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
          for (o.save(), s = x.elements, f === "st" || f === "gs" ? (o.ctxStrokeStyle(f === "st" ? x.co : x.grd), o.ctxLineWidth(x.wi), o.ctxLineCap(x.lc), o.ctxLineJoin(x.lj), o.ctxMiterLimit(x.ml || 0)) : o.ctxFillStyle(f === "fl" ? x.co : x.grd), o.ctxOpacity(x.coOp), f !== "st" && f !== "gs" && c.beginPath(), o.ctxTransform(x.preTransforms.finalTransform.props), i = s.length, r = 0; r < i; r += 1) {
            for ((f === "st" || f === "gs") && (c.beginPath(), x.da && (c.setLineDash(x.da), c.lineDashOffset = x.do)), l = s[r].trNodes, a = l.length, n = 0; n < a; n += 1)
              l[n].t === "m" ? c.moveTo(l[n].p[0], l[n].p[1]) : l[n].t === "c" ? c.bezierCurveTo(l[n].pts[0], l[n].pts[1], l[n].pts[2], l[n].pts[3], l[n].pts[4], l[n].pts[5]) : c.closePath();
            (f === "st" || f === "gs") && (o.ctxStroke(), x.da && c.setLineDash(this.dashResetter));
          }
          f !== "st" && f !== "gs" && this.globalData.renderer.ctxFill(x.r), o.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(e, t, r, i) {
      var n, a = t.length - 1, s;
      for (s = e, n = a; n >= 0; n -= 1)
        t[n].ty === "tr" ? (s = r[n].transform, this.renderShapeTransform(e, s)) : t[n].ty === "sh" || t[n].ty === "el" || t[n].ty === "rc" || t[n].ty === "sr" ? this.renderPath(t[n], r[n]) : t[n].ty === "fl" ? this.renderFill(t[n], r[n], s) : t[n].ty === "st" ? this.renderStroke(t[n], r[n], s) : t[n].ty === "gf" || t[n].ty === "gs" ? this.renderGradientFill(t[n], r[n], s) : t[n].ty === "gr" ? this.renderShape(s, t[n].it, r[n].it) : t[n].ty;
      i && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(e, t) {
      if (this._isFirstFrame || t._mdf || e.transforms._mdf) {
        var r = e.trNodes, i = t.paths, n, a, s, l = i._length;
        r.length = 0;
        var o = e.transforms.finalTransform;
        for (s = 0; s < l; s += 1) {
          var c = i.shapes[s];
          if (c && c.v) {
            for (a = c._length, n = 1; n < a; n += 1)
              n === 1 && r.push({
                t: "m",
                p: o.applyToPointArray(c.v[0][0], c.v[0][1], 0)
              }), r.push({
                t: "c",
                pts: o.applyToTriplePoints(c.o[n - 1], c.i[n], c.v[n])
              });
            a === 1 && r.push({
              t: "m",
              p: o.applyToPointArray(c.v[0][0], c.v[0][1], 0)
            }), c.c && a && (r.push({
              t: "c",
              pts: o.applyToTriplePoints(c.o[n - 1], c.i[0], c.v[0])
            }), r.push({
              t: "z"
            }));
          }
        }
        e.trNodes = r;
      }
    }, CVShapeElement.prototype.renderPath = function(e, t) {
      if (e.hd !== !0 && e._shouldRender) {
        var r, i = t.styledShapes.length;
        for (r = 0; r < i; r += 1)
          this.renderStyledShape(t.styledShapes[r], t.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(e, t, r) {
      var i = t.style;
      (t.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = t.o.v * r.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(e, t, r) {
      var i = t.style, n;
      if (!i.grd || t.g._mdf || t.s._mdf || t.e._mdf || e.t !== 1 && (t.h._mdf || t.a._mdf)) {
        var a = this.globalData.canvasContext, s = t.s.v, l = t.e.v;
        if (e.t === 1)
          n = a.createLinearGradient(s[0], s[1], l[0], l[1]);
        else {
          var o = Math.sqrt(Math.pow(s[0] - l[0], 2) + Math.pow(s[1] - l[1], 2)), c = Math.atan2(l[1] - s[1], l[0] - s[0]), f = t.h.v;
          f >= 1 ? f = 0.99 : f <= -1 && (f = -0.99);
          var x = o * f, m = Math.cos(c + t.a.v) * x + s[0], A = Math.sin(c + t.a.v) * x + s[1];
          n = a.createRadialGradient(m, A, 0, s[0], s[1], o);
        }
        var M, d = e.g.p, C = t.g.c, u = 1;
        for (M = 0; M < d; M += 1)
          t.g._hasOpacity && t.g._collapsable && (u = t.g.o[M * 2 + 1]), n.addColorStop(C[M * 4] / 100, "rgba(" + C[M * 4 + 1] + "," + C[M * 4 + 2] + "," + C[M * 4 + 3] + "," + u + ")");
        i.grd = n;
      }
      i.coOp = t.o.v * r.opacity;
    }, CVShapeElement.prototype.renderStroke = function(e, t, r) {
      var i = t.style, n = t.d;
      n && (n._mdf || this._isFirstFrame) && (i.da = n.dashArray, i.do = n.dashoffset[0]), (t.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = t.o.v * r.opacity), (t.w._mdf || this._isFirstFrame) && (i.wi = t.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    };
    function CVTextElement(e, t, r) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
        fill: "rgba(0,0,0,0)",
        stroke: "rgba(0,0,0,0)",
        sWidth: 0,
        fValue: ""
      }, this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = !1;
      e.fc ? (t = !0, this.values.fill = this.buildColor(e.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = t;
      var r = !1;
      e.sc && (r = !0, this.values.stroke = this.buildColor(e.sc), this.values.sWidth = e.sw);
      var i = this.globalData.fontManager.getFontByName(e.f), n, a, s = e.l, l = this.mHelper;
      this.stroke = r, this.values.fValue = e.finalSize + "px " + this.globalData.fontManager.getFontByName(e.f).fFamily, a = e.finalText.length;
      var o, c, f, x, m, A, M, d, C, u, g = this.data.singleShape, p = e.tr * 1e-3 * e.finalSize, y = 0, E = 0, T = !0, Z = 0;
      for (n = 0; n < a; n += 1) {
        o = this.globalData.fontManager.getCharData(e.finalText[n], i.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), c = o && o.data || {}, l.reset(), g && s[n].n && (y = -p, E += e.yOffset, E += T ? 1 : 0, T = !1), m = c.shapes ? c.shapes[0].it : [], M = m.length, l.scale(e.finalSize / 100, e.finalSize / 100), g && this.applyTextPropertiesToMatrix(e, l, s[n].line, y, E), C = createSizedArray(M - 1);
        var G = 0;
        for (A = 0; A < M; A += 1)
          if (m[A].ty === "sh") {
            for (x = m[A].ks.k.i.length, d = m[A].ks.k, u = [], f = 1; f < x; f += 1)
              f === 1 && u.push(l.applyToX(d.v[0][0], d.v[0][1], 0), l.applyToY(d.v[0][0], d.v[0][1], 0)), u.push(l.applyToX(d.o[f - 1][0], d.o[f - 1][1], 0), l.applyToY(d.o[f - 1][0], d.o[f - 1][1], 0), l.applyToX(d.i[f][0], d.i[f][1], 0), l.applyToY(d.i[f][0], d.i[f][1], 0), l.applyToX(d.v[f][0], d.v[f][1], 0), l.applyToY(d.v[f][0], d.v[f][1], 0));
            u.push(l.applyToX(d.o[f - 1][0], d.o[f - 1][1], 0), l.applyToY(d.o[f - 1][0], d.o[f - 1][1], 0), l.applyToX(d.i[0][0], d.i[0][1], 0), l.applyToY(d.i[0][0], d.i[0][1], 0), l.applyToX(d.v[0][0], d.v[0][1], 0), l.applyToY(d.v[0][0], d.v[0][1], 0)), C[G] = u, G += 1;
          }
        g && (y += s[n].l, y += p), this.textSpans[Z] ? this.textSpans[Z].elem = C : this.textSpans[Z] = {
          elem: C
        }, Z += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var e = this.canvasContext;
      e.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var t, r, i, n, a, s, l = this.textAnimator.renderedLetters, o = this.textProperty.currentData.l;
      r = o.length;
      var c, f = null, x = null, m = null, A, M, d = this.globalData.renderer;
      for (t = 0; t < r; t += 1)
        if (!o[t].n) {
          if (c = l[t], c && (d.save(), d.ctxTransform(c.p), d.ctxOpacity(c.o)), this.fill) {
            for (c && c.fc ? f !== c.fc && (d.ctxFillStyle(c.fc), f = c.fc) : f !== this.values.fill && (f = this.values.fill, d.ctxFillStyle(this.values.fill)), A = this.textSpans[t].elem, n = A.length, this.globalData.canvasContext.beginPath(), i = 0; i < n; i += 1)
              for (M = A[i], s = M.length, this.globalData.canvasContext.moveTo(M[0], M[1]), a = 2; a < s; a += 6)
                this.globalData.canvasContext.bezierCurveTo(M[a], M[a + 1], M[a + 2], M[a + 3], M[a + 4], M[a + 5]);
            this.globalData.canvasContext.closePath(), d.ctxFill();
          }
          if (this.stroke) {
            for (c && c.sw ? m !== c.sw && (m = c.sw, d.ctxLineWidth(c.sw)) : m !== this.values.sWidth && (m = this.values.sWidth, d.ctxLineWidth(this.values.sWidth)), c && c.sc ? x !== c.sc && (x = c.sc, d.ctxStrokeStyle(c.sc)) : x !== this.values.stroke && (x = this.values.stroke, d.ctxStrokeStyle(this.values.stroke)), A = this.textSpans[t].elem, n = A.length, this.globalData.canvasContext.beginPath(), i = 0; i < n; i += 1)
              for (M = A[i], s = M.length, this.globalData.canvasContext.moveTo(M[0], M[1]), a = 2; a < s; a += 6)
                this.globalData.canvasContext.bezierCurveTo(M[a], M[a + 1], M[a + 2], M[a + 3], M[a + 4], M[a + 5]);
            this.globalData.canvasContext.closePath(), d.ctxStroke();
          }
          c && this.globalData.renderer.restore();
        }
    };
    function CVImageElement(e, t, r) {
      this.assetData = t.getAssetData(e.refId), this.img = t.imageLoader.getAsset(this.assetData), this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var e = createTag("canvas");
        e.width = this.assetData.w, e.height = this.assetData.h;
        var t = e.getContext("2d"), r = this.img.width, i = this.img.height, n = r / i, a = this.assetData.w / this.assetData.h, s, l, o = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        n > a && o === "xMidYMid slice" || n < a && o !== "xMidYMid slice" ? (l = i, s = l * a) : (s = r, l = s / a), t.drawImage(this.img, (r - s) / 2, (i - l) / 2, s, l, 0, 0, this.assetData.w, this.assetData.h), this.img = e;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    };
    function CVSolidElement(e, t, r) {
      this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    };
    function CanvasRendererBase() {
    }
    extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(e) {
      return new CVShapeElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(e) {
      return new CVTextElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(e) {
      return new CVImageElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(e) {
      return new CVSolidElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(e) {
      e[0] === 1 && e[1] === 0 && e[4] === 0 && e[5] === 1 && e[12] === 0 && e[13] === 0 || this.canvasContext.transform(e[0], e[1], e[4], e[5], e[12], e[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(e) {
      this.canvasContext.globalAlpha *= e < 0 ? 0 : e;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(e) {
      this.canvasContext.fillStyle = e;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(e) {
      this.canvasContext.strokeStyle = e;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(e) {
      this.canvasContext.lineWidth = e;
    }, CanvasRendererBase.prototype.ctxLineCap = function(e) {
      this.canvasContext.lineCap = e;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(e) {
      this.canvasContext.lineJoin = e;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(e) {
      this.canvasContext.miterLimit = e;
    }, CanvasRendererBase.prototype.ctxFill = function(e) {
      this.canvasContext.fill(e);
    }, CanvasRendererBase.prototype.ctxFillRect = function(e, t, r, i) {
      this.canvasContext.fillRect(e, t, r, i);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      this.contextData.reset();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(e) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      e && (this.globalData.blendMode = "source-over"), this.contextData.restore(e);
    }, CanvasRendererBase.prototype.configAnimation = function(e) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var t = this.animationItem.container.style;
        t.width = "100%", t.height = "100%";
        var r = "0px 0px 0px";
        t.transformOrigin = r, t.mozTransformOrigin = r, t.webkitTransformOrigin = r, t["-webkit-transform"] = r, t.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = e, this.layers = e.layers, this.transformCanvas = {
        w: e.w,
        h: e.h,
        sx: 0,
        sy: 0,
        tx: 0,
        ty: 0
      }, this.setupGlobalData(e, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(e.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(e, t) {
      this.reset();
      var r, i;
      e ? (r = e, i = t, this.canvasContext.canvas.width = r, this.canvasContext.canvas.height = i) : (this.animationItem.wrapper && this.animationItem.container ? (r = this.animationItem.wrapper.offsetWidth, i = this.animationItem.wrapper.offsetHeight) : (r = this.canvasContext.canvas.width, i = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r * this.renderConfig.dpr, this.canvasContext.canvas.height = i * this.renderConfig.dpr);
      var n, a;
      if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var s = this.renderConfig.preserveAspectRatio.split(" "), l = s[1] || "meet", o = s[0] || "xMidYMid", c = o.substr(0, 4), f = o.substr(4);
        n = r / i, a = this.transformCanvas.w / this.transformCanvas.h, a > n && l === "meet" || a < n && l === "slice" ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr)), c === "xMid" && (a < n && l === "meet" || a > n && l === "slice") ? this.transformCanvas.tx = (r - this.transformCanvas.w * (i / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : c === "xMax" && (a < n && l === "meet" || a > n && l === "slice") ? this.transformCanvas.tx = (r - this.transformCanvas.w * (i / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, f === "YMid" && (a > n && l === "meet" || a < n && l === "slice") ? this.transformCanvas.ty = (i - this.transformCanvas.h * (r / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : f === "YMax" && (a > n && l === "meet" || a < n && l === "slice") ? this.transformCanvas.ty = (i - this.transformCanvas.h * (r / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
      } else
        this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
      var e, t = this.layers ? this.layers.length : 0;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(e, t) {
      if (!(this.renderedFrame === e && this.renderConfig.clearCanvas === !0 && !t || this.destroyed || e === -1)) {
        this.renderedFrame = e, this.globalData.frameNum = e - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || t, this.globalData.projectInterface.currentFrame = e;
        var r, i = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), r = i - 1; r >= 0; r -= 1)
          (this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(e - this.layers[r].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r = i - 1; r >= 0; r -= 1)
            (this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        var r = this.createItem(this.layers[e], this, this.globalData);
        t[e] = r, r.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      this.stack = [], this.cArrPos = 0, this.cTr = new Matrix();
      var e, t = 15;
      for (e = 0; e < t; e += 1) {
        var r = new CanvasContext();
        this.stack[e] = r;
      }
      this._length = t, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
      var e = this._length * 2, t = 0;
      for (t = this._length; t < e; t += 1)
        this.stack[t] = new CanvasContext();
      this._length = e;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(e) {
      this.cArrPos -= 1;
      var t = this.stack[this.cArrPos], r = t.transform, i, n = this.cTr.props;
      for (i = 0; i < 16; i += 1)
        n[i] = r[i];
      if (e) {
        this.nativeContext.restore();
        var a = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = a.fillStyle, this.appliedStrokeStyle = a.strokeStyle, this.appliedLineWidth = a.lineWidth, this.appliedLineCap = a.lineCap, this.appliedLineJoin = a.lineJoin, this.appliedMiterLimit = a.miterLimit;
      }
      this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]), (e || t.opacity !== -1 && this.currentOpacity !== t.opacity) && (this.nativeContext.globalAlpha = t.opacity, this.currentOpacity = t.opacity), this.currentFillStyle = t.fillStyle, this.currentStrokeStyle = t.strokeStyle, this.currentLineWidth = t.lineWidth, this.currentLineCap = t.lineCap, this.currentLineJoin = t.lineJoin, this.currentMiterLimit = t.miterLimit;
    }, CVContextData.prototype.save = function(e) {
      e && this.nativeContext.save();
      var t = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var r = this.stack[this.cArrPos], i;
      for (i = 0; i < 16; i += 1)
        r.transform[i] = t[i];
      this.cArrPos += 1;
      var n = this.stack[this.cArrPos];
      n.opacity = r.opacity, n.fillStyle = r.fillStyle, n.strokeStyle = r.strokeStyle, n.lineWidth = r.lineWidth, n.lineCap = r.lineCap, n.lineJoin = r.lineJoin, n.miterLimit = r.miterLimit;
    }, CVContextData.prototype.setOpacity = function(e) {
      this.stack[this.cArrPos].opacity = e;
    }, CVContextData.prototype.setContext = function(e) {
      this.nativeContext = e;
    }, CVContextData.prototype.fillStyle = function(e) {
      this.stack[this.cArrPos].fillStyle !== e && (this.currentFillStyle = e, this.stack[this.cArrPos].fillStyle = e);
    }, CVContextData.prototype.strokeStyle = function(e) {
      this.stack[this.cArrPos].strokeStyle !== e && (this.currentStrokeStyle = e, this.stack[this.cArrPos].strokeStyle = e);
    }, CVContextData.prototype.lineWidth = function(e) {
      this.stack[this.cArrPos].lineWidth !== e && (this.currentLineWidth = e, this.stack[this.cArrPos].lineWidth = e);
    }, CVContextData.prototype.lineCap = function(e) {
      this.stack[this.cArrPos].lineCap !== e && (this.currentLineCap = e, this.stack[this.cArrPos].lineCap = e);
    }, CVContextData.prototype.lineJoin = function(e) {
      this.stack[this.cArrPos].lineJoin !== e && (this.currentLineJoin = e, this.stack[this.cArrPos].lineJoin = e);
    }, CVContextData.prototype.miterLimit = function(e) {
      this.stack[this.cArrPos].miterLimit !== e && (this.currentMiterLimit = e, this.stack[this.cArrPos].miterLimit = e);
    }, CVContextData.prototype.transform = function(e) {
      this.transformMat.cloneFromProps(e);
      var t = this.cTr;
      this.transformMat.multiply(t), t.cloneFromProps(this.transformMat.props);
      var r = t.props;
      this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]);
    }, CVContextData.prototype.opacity = function(e) {
      var t = this.stack[this.cArrPos].opacity;
      t *= e < 0 ? 0 : e, this.stack[this.cArrPos].opacity !== t && (this.currentOpacity !== e && (this.nativeContext.globalAlpha = e, this.currentOpacity = e), this.stack[this.cArrPos].opacity = t);
    }, CVContextData.prototype.fill = function(e) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(e);
    }, CVContextData.prototype.fillRect = function(e, t, r, i) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(e, t, r, i);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    };
    function CVCompElement(e, t, r) {
      this.completeLayers = !1, this.layers = e.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(e, t, r), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var e = this.canvasContext;
      e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip();
      var t, r = this.layers.length;
      for (t = r - 1; t >= 0; t -= 1)
        (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var e, t = this.layers.length;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function CanvasRenderer(e, t) {
      this.animationItem = e, this.renderConfig = {
        clearCanvas: t && t.clearCanvas !== void 0 ? t.clearCanvas : !0,
        context: t && t.context || null,
        progressiveLoad: t && t.progressiveLoad || !1,
        preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: t && t.contentVisibility || "visible",
        className: t && t.className || "",
        id: t && t.id || "",
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
        frameNum: -1,
        _mdf: !1,
        renderConfig: this.renderConfig,
        currentGlobalAlpha: -1
      }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function HBaseElement() {
    }
    HBaseElement.prototype = {
      checkBlendMode: function() {
      },
      initRendererElement: function() {
        this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
      },
      createContainerElements: function() {
        this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        var t = this.transformedElement ? this.transformedElement.style : {};
        if (this.finalTransform._matMdf) {
          var r = this.finalTransform.mat.toCSS();
          t.transform = r, t.webkitTransform = r;
        }
        this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
      },
      renderFrame: function() {
        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
      },
      destroy: function() {
        this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData);
      },
      addEffects: function() {
      },
      setMatte: function() {
      }
    }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(e, t, r) {
      this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var e;
      this.data.hasMask ? (e = createNS("rect"), e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (e = createTag("div"), e.style.width = this.data.sw + "px", e.style.height = this.data.sh + "px", e.style.backgroundColor = this.data.sc), this.layerElement.appendChild(e);
    };
    function HShapeElement(e, t, r) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(e, t, r), this.prevViewData = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      };
    }
    extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var e;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), e = this.svgElement;
      else {
        e = createNS("svg");
        var t = this.comp.data ? this.comp.data : this.globalData.compSize;
        e.setAttribute("width", t.w), e.setAttribute("height", t.h), e.appendChild(this.shapesContainer), this.layerElement.appendChild(e);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = e;
    }, HShapeElement.prototype.getTransformedPoint = function(e, t) {
      var r, i = e.length;
      for (r = 0; r < i; r += 1)
        t = e[r].mProps.v.applyToPointArray(t[0], t[1], 0);
      return t;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(e, t) {
      var r = e.sh.v, i = e.transformers, n, a = r._length, s, l, o, c;
      if (!(a <= 1)) {
        for (n = 0; n < a - 1; n += 1)
          s = this.getTransformedPoint(i, r.v[n]), l = this.getTransformedPoint(i, r.o[n]), o = this.getTransformedPoint(i, r.i[n + 1]), c = this.getTransformedPoint(i, r.v[n + 1]), this.checkBounds(s, l, o, c, t);
        r.c && (s = this.getTransformedPoint(i, r.v[n]), l = this.getTransformedPoint(i, r.o[n]), o = this.getTransformedPoint(i, r.i[0]), c = this.getTransformedPoint(i, r.v[0]), this.checkBounds(s, l, o, c, t));
      }
    }, HShapeElement.prototype.checkBounds = function(e, t, r, i, n) {
      this.getBoundsOfCurve(e, t, r, i);
      var a = this.shapeBoundingBox;
      n.x = bmMin(a.left, n.x), n.xMax = bmMax(a.right, n.xMax), n.y = bmMin(a.top, n.y), n.yMax = bmMax(a.bottom, n.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, HShapeElement.prototype.tempBoundingBox = {
      x: 0,
      xMax: 0,
      y: 0,
      yMax: 0,
      width: 0,
      height: 0
    }, HShapeElement.prototype.getBoundsOfCurve = function(e, t, r, i) {
      for (var n = [[e[0], i[0]], [e[1], i[1]]], a, s, l, o, c, f, x, m = 0; m < 2; ++m)
        s = 6 * e[m] - 12 * t[m] + 6 * r[m], a = -3 * e[m] + 9 * t[m] - 9 * r[m] + 3 * i[m], l = 3 * t[m] - 3 * e[m], s |= 0, a |= 0, l |= 0, a === 0 && s === 0 || (a === 0 ? (o = -l / s, o > 0 && o < 1 && n[m].push(this.calculateF(o, e, t, r, i, m))) : (c = s * s - 4 * l * a, c >= 0 && (f = (-s + bmSqrt(c)) / (2 * a), f > 0 && f < 1 && n[m].push(this.calculateF(f, e, t, r, i, m)), x = (-s - bmSqrt(c)) / (2 * a), x > 0 && x < 1 && n[m].push(this.calculateF(x, e, t, r, i, m)))));
      this.shapeBoundingBox.left = bmMin.apply(null, n[0]), this.shapeBoundingBox.top = bmMin.apply(null, n[1]), this.shapeBoundingBox.right = bmMax.apply(null, n[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, n[1]);
    }, HShapeElement.prototype.calculateF = function(e, t, r, i, n, a) {
      return bmPow(1 - e, 3) * t[a] + 3 * bmPow(1 - e, 2) * e * r[a] + 3 * (1 - e) * bmPow(e, 2) * i[a] + bmPow(e, 3) * n[a];
    }, HShapeElement.prototype.calculateBoundingBox = function(e, t) {
      var r, i = e.length;
      for (r = 0; r < i; r += 1)
        e[r] && e[r].sh ? this.calculateShapeBoundingBox(e[r], t) : e[r] && e[r].it ? this.calculateBoundingBox(e[r].it, t) : e[r] && e[r].style && e[r].w && this.expandStrokeBoundingBox(e[r].w, t);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(e, t) {
      var r = 0;
      if (e.keyframes) {
        for (var i = 0; i < e.keyframes.length; i += 1) {
          var n = e.keyframes[i].s;
          n > r && (r = n);
        }
        r *= e.mult;
      } else
        r = e.v * e.mult;
      t.x -= r, t.xMax += r, t.y -= r, t.yMax += r;
    }, HShapeElement.prototype.currentBoxContains = function(e) {
      return this.currentBBox.x <= e.x && this.currentBBox.y <= e.y && this.currentBBox.width + this.currentBBox.x >= e.x + e.width && this.currentBBox.height + this.currentBBox.y >= e.y + e.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var e = this.tempBoundingBox, t = 999999;
        if (e.x = t, e.xMax = -t, e.y = t, e.yMax = -t, this.calculateBoundingBox(this.itemsData, e), e.width = e.xMax < e.x ? 0 : e.xMax - e.x, e.height = e.yMax < e.y ? 0 : e.yMax - e.y, this.currentBoxContains(e))
          return;
        var r = !1;
        if (this.currentBBox.w !== e.width && (this.currentBBox.w = e.width, this.shapeCont.setAttribute("width", e.width), r = !0), this.currentBBox.h !== e.height && (this.currentBBox.h = e.height, this.shapeCont.setAttribute("height", e.height), r = !0), r || this.currentBBox.x !== e.x || this.currentBBox.y !== e.y) {
          this.currentBBox.w = e.width, this.currentBBox.h = e.height, this.currentBBox.x = e.x, this.currentBBox.y = e.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var i = this.shapeCont.style, n = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          i.transform = n, i.webkitTransform = n;
        }
      }
    };
    function HTextElement(e, t, r) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      }, this.renderType = "svg", this.isMasked = !1, this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var e = createNS("g");
        this.maskedElement.appendChild(e), this.innerElem = e;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = this.innerElem.style, r = e.fc ? this.buildColor(e.fc) : "rgba(0,0,0,0)";
      t.fill = r, t.color = r, e.sc && (t.stroke = this.buildColor(e.sc), t.strokeWidth = e.sw + "px");
      var i = this.globalData.fontManager.getFontByName(e.f);
      if (!this.globalData.fontManager.chars)
        if (t.fontSize = e.finalSize + "px", t.lineHeight = e.finalSize + "px", i.fClass)
          this.innerElem.className = i.fClass;
        else {
          t.fontFamily = i.fFamily;
          var n = e.fWeight, a = e.fStyle;
          t.fontStyle = a, t.fontWeight = n;
        }
      var s, l, o = e.l;
      l = o.length;
      var c, f, x, m = this.mHelper, A, M = "", d = 0;
      for (s = 0; s < l; s += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[d] ? c = this.textPaths[d] : (c = createNS("path"), c.setAttribute("stroke-linecap", lineCapEnum[1]), c.setAttribute("stroke-linejoin", lineJoinEnum[2]), c.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[d] ? (f = this.textSpans[d], x = f.children[0]) : (f = createTag("div"), f.style.lineHeight = 0, x = createNS("svg"), x.appendChild(c), styleDiv(f)))) : this.isMasked ? c = this.textPaths[d] ? this.textPaths[d] : createNS("text") : this.textSpans[d] ? (f = this.textSpans[d], c = this.textPaths[d]) : (f = createTag("span"), styleDiv(f), c = createTag("span"), styleDiv(c), f.appendChild(c)), this.globalData.fontManager.chars) {
          var C = this.globalData.fontManager.getCharData(e.finalText[s], i.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), u;
          if (C ? u = C.data : u = null, m.reset(), u && u.shapes && u.shapes.length && (A = u.shapes[0].it, m.scale(e.finalSize / 100, e.finalSize / 100), M = this.createPathShape(m, A), c.setAttribute("d", M)), this.isMasked)
            this.innerElem.appendChild(c);
          else {
            if (this.innerElem.appendChild(f), u && u.shapes) {
              document.body.appendChild(x);
              var g = x.getBBox();
              x.setAttribute("width", g.width + 2), x.setAttribute("height", g.height + 2), x.setAttribute("viewBox", g.x - 1 + " " + (g.y - 1) + " " + (g.width + 2) + " " + (g.height + 2));
              var p = x.style, y = "translate(" + (g.x - 1) + "px," + (g.y - 1) + "px)";
              p.transform = y, p.webkitTransform = y, o[s].yOffset = g.y - 1;
            } else
              x.setAttribute("width", 1), x.setAttribute("height", 1);
            f.appendChild(x);
          }
        } else if (c.textContent = o[s].val, c.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(c);
        else {
          this.innerElem.appendChild(f);
          var E = c.style, T = "translate3d(0," + -e.finalSize / 1.2 + "px,0)";
          E.transform = T, E.webkitTransform = T;
        }
        this.isMasked ? this.textSpans[d] = c : this.textSpans[d] = f, this.textSpans[d].style.display = "block", this.textPaths[d] = c, d += 1;
      }
      for (; d < this.textSpans.length; )
        this.textSpans[d].style.display = "none", d += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var e;
      if (this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), e = this.svgElement.style;
          var t = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          e.transform = t, e.webkitTransform = t;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
        var r, i, n = 0, a = this.textAnimator.renderedLetters, s = this.textProperty.currentData.l;
        i = s.length;
        var l, o, c;
        for (r = 0; r < i; r += 1)
          s[r].n ? n += 1 : (o = this.textSpans[r], c = this.textPaths[r], l = a[n], n += 1, l._mdf.m && (this.isMasked ? o.setAttribute("transform", l.m) : (o.style.webkitTransform = l.m, o.style.transform = l.m)), o.style.opacity = l.o, l.sw && l._mdf.sw && c.setAttribute("stroke-width", l.sw), l.sc && l._mdf.sc && c.setAttribute("stroke", l.sc), l.fc && l._mdf.fc && (c.setAttribute("fill", l.fc), c.style.color = l.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var f = this.innerElem.getBBox();
          this.currentBBox.w !== f.width && (this.currentBBox.w = f.width, this.svgElement.setAttribute("width", f.width)), this.currentBBox.h !== f.height && (this.currentBBox.h = f.height, this.svgElement.setAttribute("height", f.height));
          var x = 1;
          if (this.currentBBox.w !== f.width + x * 2 || this.currentBBox.h !== f.height + x * 2 || this.currentBBox.x !== f.x - x || this.currentBBox.y !== f.y - x) {
            this.currentBBox.w = f.width + x * 2, this.currentBBox.h = f.height + x * 2, this.currentBBox.x = f.x - x, this.currentBBox.y = f.y - x, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), e = this.svgElement.style;
            var m = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            e.transform = m, e.webkitTransform = m;
          }
        }
      }
    };
    function HCameraElement(e, t, r) {
      this.initFrame(), this.initBaseData(e, t, r), this.initHierarchy();
      var i = PropertyFactory.getProp;
      if (this.pe = i(this, e.pe, 0, 0, this), e.ks.p.s ? (this.px = i(this, e.ks.p.x, 1, 0, this), this.py = i(this, e.ks.p.y, 1, 0, this), this.pz = i(this, e.ks.p.z, 1, 0, this)) : this.p = i(this, e.ks.p, 1, 0, this), e.ks.a && (this.a = i(this, e.ks.a, 1, 0, this)), e.ks.or.k.length && e.ks.or.k[0].to) {
        var n, a = e.ks.or.k.length;
        for (n = 0; n < a; n += 1)
          e.ks.or.k[n].to = null, e.ks.or.k[n].ti = null;
      }
      this.or = i(this, e.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i(this, e.ks.rx, 0, degToRads, this), this.ry = i(this, e.ks.ry, 0, degToRads, this), this.rz = i(this, e.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = {
        mProp: this
      };
    }
    extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var e, t = this.comp.threeDElements.length, r, i, n;
      for (e = 0; e < t; e += 1)
        if (r = this.comp.threeDElements[e], r.type === "3d") {
          i = r.perspectiveElem.style, n = r.container.style;
          var a = this.pe.v + "px", s = "0px 0px 0px", l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          i.perspective = a, i.webkitPerspective = a, n.transformOrigin = s, n.mozTransformOrigin = s, n.webkitTransformOrigin = s, i.transform = l, i.webkitTransform = l;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var e = this._isFirstFrame, t, r;
      if (this.hierarchy)
        for (r = this.hierarchy.length, t = 0; t < r; t += 1)
          e = this.hierarchy[t].finalTransform.mProp._mdf || e;
      if (e || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (r = this.hierarchy.length - 1, t = r; t >= 0; t -= 1) {
            var i = this.hierarchy[t].finalTransform.mProp;
            this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]), this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]), this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v), this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]), this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var n;
          this.p ? n = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : n = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var a = Math.sqrt(Math.pow(n[0], 2) + Math.pow(n[1], 2) + Math.pow(n[2], 2)), s = [n[0] / a, n[1] / a, n[2] / a], l = Math.sqrt(s[2] * s[2] + s[0] * s[0]), o = Math.atan2(s[1], l), c = Math.atan2(s[0], -s[2]);
          this.mat.rotateY(c).rotateX(-o);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var f = !this._prevMat.equals(this.mat);
        if ((f || this.pe._mdf) && this.comp.threeDElements) {
          r = this.comp.threeDElements.length;
          var x, m, A;
          for (t = 0; t < r; t += 1)
            if (x = this.comp.threeDElements[t], x.type === "3d") {
              if (f) {
                var M = this.mat.toCSS();
                A = x.container.style, A.transform = M, A.webkitTransform = M;
              }
              this.pe._mdf && (m = x.perspectiveElem.style, m.perspective = this.pe.v + "px", m.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    };
    function HImageElement(e, t, r) {
      this.assetData = t.getAssetData(e.refId), this.initElement(e, t, r);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData), t = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(t), t.crossOrigin = "anonymous", t.src = e, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: t && t.className || "",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "400%",
          height: t && t.filterSize && t.filterSize.height || "400%",
          x: t && t.filterSize && t.filterSize.x || "-100%",
          y: t && t.filterSize && t.filterSize.y || "-100%"
        }
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, HybridRendererBase.prototype.appendElementInPos = function(e, t) {
      var r = e.getBaseElement();
      if (r) {
        var i = this.layers[t];
        if (!i.ddd || !this.supports3d)
          if (this.threeDElements)
            this.addTo3dContainer(r, t);
          else {
            for (var n = 0, a, s, l; n < t; )
              this.elements[n] && this.elements[n] !== !0 && this.elements[n].getBaseElement && (s = this.elements[n], l = this.layers[n].ddd ? this.getThreeDContainerByPos(n) : s.getBaseElement(), a = l || a), n += 1;
            a ? (!i.ddd || !this.supports3d) && this.layerElement.insertBefore(r, a) : (!i.ddd || !this.supports3d) && this.layerElement.appendChild(r);
          }
        else
          this.addTo3dContainer(r, t);
      }
    }, HybridRendererBase.prototype.createShape = function(e) {
      return this.supports3d ? new HShapeElement(e, this.globalData, this) : new SVGShapeElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(e) {
      return this.supports3d ? new HTextElement(e, this.globalData, this) : new SVGTextLottieElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(e) {
      return this.camera = new HCameraElement(e, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(e) {
      return this.supports3d ? new HImageElement(e, this.globalData, this) : new IImageElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(e) {
      return this.supports3d ? new HSolidElement(e, this.globalData, this) : new ISolidElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(e) {
      for (var t = 0, r = this.threeDElements.length; t < r; ) {
        if (this.threeDElements[t].startPos <= e && this.threeDElements[t].endPos >= e)
          return this.threeDElements[t].perspectiveElem;
        t += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(e, t) {
      var r = createTag("div"), i, n;
      styleDiv(r);
      var a = createTag("div");
      if (styleDiv(a), t === "3d") {
        i = r.style, i.width = this.globalData.compSize.w + "px", i.height = this.globalData.compSize.h + "px";
        var s = "50% 50%";
        i.webkitTransformOrigin = s, i.mozTransformOrigin = s, i.transformOrigin = s, n = a.style;
        var l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        n.transform = l, n.webkitTransform = l;
      }
      r.appendChild(a);
      var o = {
        container: a,
        perspectiveElem: r,
        startPos: e,
        endPos: e,
        type: t
      };
      return this.threeDElements.push(o), o;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var e, t = this.layers.length, r, i = "";
      for (e = 0; e < t; e += 1)
        this.layers[e].ddd && this.layers[e].ty !== 3 ? (i !== "3d" && (i = "3d", r = this.createThreeDContainer(e, "3d")), r.endPos = Math.max(r.endPos, e)) : (i !== "2d" && (i = "2d", r = this.createThreeDContainer(e, "2d")), r.endPos = Math.max(r.endPos, e));
      for (t = this.threeDElements.length, e = t - 1; e >= 0; e -= 1)
        this.resizerElem.appendChild(this.threeDElements[e].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(e, t) {
      for (var r = 0, i = this.threeDElements.length; r < i; ) {
        if (t <= this.threeDElements[r].endPos) {
          for (var n = this.threeDElements[r].startPos, a; n < t; )
            this.elements[n] && this.elements[n].getBaseElement && (a = this.elements[n].getBaseElement()), n += 1;
          a ? this.threeDElements[r].container.insertBefore(e, a) : this.threeDElements[r].container.appendChild(e);
          break;
        }
        r += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(e) {
      var t = createTag("div"), r = this.animationItem.wrapper, i = t.style;
      i.width = e.w + "px", i.height = e.h + "px", this.resizerElem = t, styleDiv(t), i.transformStyle = "flat", i.mozTransformStyle = "flat", i.webkitTransformStyle = "flat", this.renderConfig.className && t.setAttribute("class", this.renderConfig.className), r.appendChild(t), i.overflow = "hidden";
      var n = createNS("svg");
      n.setAttribute("width", "1"), n.setAttribute("height", "1"), styleDiv(n), this.resizerElem.appendChild(n);
      var a = createNS("defs");
      n.appendChild(a), this.data = e, this.setupGlobalData(e, n), this.globalData.defs = a, this.layers = e.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy && this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var e = this.animationItem.wrapper.offsetWidth, t = this.animationItem.wrapper.offsetHeight, r = e / t, i = this.globalData.compSize.w / this.globalData.compSize.h, n, a, s, l;
      i > r ? (n = e / this.globalData.compSize.w, a = e / this.globalData.compSize.w, s = 0, l = (t - this.globalData.compSize.h * (e / this.globalData.compSize.w)) / 2) : (n = t / this.globalData.compSize.h, a = t / this.globalData.compSize.h, s = (e - this.globalData.compSize.w * (t / this.globalData.compSize.h)) / 2, l = 0);
      var o = this.resizerElem.style;
      o.webkitTransform = "matrix3d(" + n + ",0,0,0,0," + a + ",0,0,0,0,1,0," + s + "," + l + ",0,1)", o.transform = o.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var e = this.globalData.compSize.w, t = this.globalData.compSize.h, r, i = this.threeDElements.length;
        for (r = 0; r < i; r += 1) {
          var n = this.threeDElements[r].perspectiveElem.style;
          n.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2)) + "px", n.perspective = n.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(e) {
      var t, r = e.length, i = createTag("div");
      for (t = 0; t < r; t += 1)
        if (e[t].xt) {
          var n = this.createComp(e[t], i, this.globalData.comp, null);
          n.initExpressions(), this.globalData.projectInterface.registerComposition(n);
        }
    };
    function HCompElement(e, t, r) {
      this.layers = e.layers, this.supports3d = !e.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, r), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(e, t) {
      for (var r = 0, i; r < t; )
        this.elements[r] && this.elements[r].getBaseElement && (i = this.elements[r].getBaseElement()), r += 1;
      i ? this.layerElement.insertBefore(e, i) : this.layerElement.appendChild(e);
    }, HCompElement.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    function HybridRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: t && t.className || "",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "400%",
          height: t && t.filterSize && t.filterSize.height || "400%",
          x: t && t.filterSize && t.filterSize.x || "-100%",
          y: t && t.filterSize && t.filterSize.y || "-100%"
        },
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    var CompExpressionInterface = function() {
      return function(e) {
        function t(r) {
          for (var i = 0, n = e.layers.length; i < n; ) {
            if (e.layers[i].nm === r || e.layers[i].ind === r)
              return e.elements[i].layerInterface;
            i += 1;
          }
          return null;
        }
        return Object.defineProperty(t, "_name", {
          value: e.data.nm
        }), t.layer = t, t.pixelAspect = 1, t.height = e.data.h || e.globalData.compSize.h, t.width = e.data.w || e.globalData.compSize.w, t.pixelAspect = 1, t.frameDuration = 1 / e.globalData.frameRate, t.displayStartTime = 0, t.numLayers = e.layers.length, t;
      };
    }();
    function _typeof$2(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(r) {
        return typeof r;
      } : _typeof$2 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$2(e);
    }
    function seedRandom(e, t) {
      var r = this, i = 256, n = 6, a = 52, s = "random", l = t.pow(i, n), o = t.pow(2, a), c = o * 2, f = i - 1, x;
      function m(p, y, E) {
        var T = [];
        y = y === !0 ? {
          entropy: !0
        } : y || {};
        var Z = C(d(y.entropy ? [p, g(e)] : p === null ? u() : p, 3), T), G = new A(T), I = function() {
          for (var Y = G.g(n), D = l, R = 0; Y < o; )
            Y = (Y + R) * i, D *= i, R = G.g(1);
          for (; Y >= c; )
            Y /= 2, D /= 2, R >>>= 1;
          return (Y + R) / D;
        };
        return I.int32 = function() {
          return G.g(4) | 0;
        }, I.quick = function() {
          return G.g(4) / 4294967296;
        }, I.double = I, C(g(G.S), e), (y.pass || E || function(V, Y, D, R) {
          return R && (R.S && M(R, G), V.state = function() {
            return M(G, {});
          }), D ? (t[s] = V, Y) : V;
        })(I, Z, "global" in y ? y.global : this == t, y.state);
      }
      t["seed" + s] = m;
      function A(p) {
        var y, E = p.length, T = this, Z = 0, G = T.i = T.j = 0, I = T.S = [];
        for (E || (p = [E++]); Z < i; )
          I[Z] = Z++;
        for (Z = 0; Z < i; Z++)
          I[Z] = I[G = f & G + p[Z % E] + (y = I[Z])], I[G] = y;
        T.g = function(V) {
          for (var Y, D = 0, R = T.i, B = T.j, j = T.S; V--; )
            Y = j[R = f & R + 1], D = D * i + j[f & (j[R] = j[B = f & B + Y]) + (j[B] = Y)];
          return T.i = R, T.j = B, D;
        };
      }
      function M(p, y) {
        return y.i = p.i, y.j = p.j, y.S = p.S.slice(), y;
      }
      function d(p, y) {
        var E = [], T = _typeof$2(p), Z;
        if (y && T == "object")
          for (Z in p)
            try {
              E.push(d(p[Z], y - 1));
            } catch {
            }
        return E.length ? E : T == "string" ? p : p + "\0";
      }
      function C(p, y) {
        for (var E = p + "", T, Z = 0; Z < E.length; )
          y[f & Z] = f & (T ^= y[f & Z] * 19) + E.charCodeAt(Z++);
        return g(y);
      }
      function u() {
        try {
          var p = new Uint8Array(i);
          return (r.crypto || r.msCrypto).getRandomValues(p), g(p);
        } catch {
          var y = r.navigator, E = y && y.plugins;
          return [+/* @__PURE__ */ new Date(), r, E, r.screen, g(e)];
        }
      }
      function g(p) {
        return String.fromCharCode.apply(0, p);
      }
      C(t.random(), e);
    }
    function initialize$2(e) {
      seedRandom([], e);
    }
    var propTypes = {
      SHAPE: "shape"
    };
    function _typeof$1(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(r) {
        return typeof r;
      } : _typeof$1 = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof$1(e);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      initialize$2(BMMath);
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(e) {
        return e.constructor === Array || e.constructor === Float32Array;
      }
      function isNumerable(e, t) {
        return e === "number" || t instanceof Number || e === "boolean" || e === "string";
      }
      function $bm_neg(e) {
        var t = _typeof$1(e);
        if (t === "number" || e instanceof Number || t === "boolean")
          return -e;
        if ($bm_isInstanceOfArray(e)) {
          var r, i = e.length, n = [];
          for (r = 0; r < i; r += 1)
            n[r] = -e[r];
          return n;
        }
        return e.propType ? e.v : -e;
      }
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(e, t) {
        var r = _typeof$1(e), i = _typeof$1(t);
        if (isNumerable(r, e) && isNumerable(i, t) || r === "string" || i === "string")
          return e + t;
        if ($bm_isInstanceOfArray(e) && isNumerable(i, t))
          return e = e.slice(0), e[0] += t, e;
        if (isNumerable(r, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e + t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var n = 0, a = e.length, s = t.length, l = []; n < a || n < s; )
            (typeof e[n] == "number" || e[n] instanceof Number) && (typeof t[n] == "number" || t[n] instanceof Number) ? l[n] = e[n] + t[n] : l[n] = t[n] === void 0 ? e[n] : e[n] || t[n], n += 1;
          return l;
        }
        return 0;
      }
      var add = sum;
      function sub(e, t) {
        var r = _typeof$1(e), i = _typeof$1(t);
        if (isNumerable(r, e) && isNumerable(i, t))
          return r === "string" && (e = parseInt(e, 10)), i === "string" && (t = parseInt(t, 10)), e - t;
        if ($bm_isInstanceOfArray(e) && isNumerable(i, t))
          return e = e.slice(0), e[0] -= t, e;
        if (isNumerable(r, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e - t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var n = 0, a = e.length, s = t.length, l = []; n < a || n < s; )
            (typeof e[n] == "number" || e[n] instanceof Number) && (typeof t[n] == "number" || t[n] instanceof Number) ? l[n] = e[n] - t[n] : l[n] = t[n] === void 0 ? e[n] : e[n] || t[n], n += 1;
          return l;
        }
        return 0;
      }
      function mul(e, t) {
        var r = _typeof$1(e), i = _typeof$1(t), n;
        if (isNumerable(r, e) && isNumerable(i, t))
          return e * t;
        var a, s;
        if ($bm_isInstanceOfArray(e) && isNumerable(i, t)) {
          for (s = e.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1)
            n[a] = e[a] * t;
          return n;
        }
        if (isNumerable(r, e) && $bm_isInstanceOfArray(t)) {
          for (s = t.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1)
            n[a] = e * t[a];
          return n;
        }
        return 0;
      }
      function div(e, t) {
        var r = _typeof$1(e), i = _typeof$1(t), n;
        if (isNumerable(r, e) && isNumerable(i, t))
          return e / t;
        var a, s;
        if ($bm_isInstanceOfArray(e) && isNumerable(i, t)) {
          for (s = e.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1)
            n[a] = e[a] / t;
          return n;
        }
        if (isNumerable(r, e) && $bm_isInstanceOfArray(t)) {
          for (s = t.length, n = createTypedArray("float32", s), a = 0; a < s; a += 1)
            n[a] = e / t[a];
          return n;
        }
        return 0;
      }
      function mod(e, t) {
        return typeof e == "string" && (e = parseInt(e, 10)), typeof t == "string" && (t = parseInt(t, 10)), e % t;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(e, t, r) {
        if (t > r) {
          var i = r;
          r = t, t = i;
        }
        return Math.min(Math.max(e, t), r);
      }
      function radiansToDegrees(e) {
        return e / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(e) {
        return e * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(e, t) {
        if (typeof e == "number" || e instanceof Number)
          return t = t || 0, Math.abs(e - t);
        t || (t = helperLengthArray);
        var r, i = Math.min(e.length, t.length), n = 0;
        for (r = 0; r < i; r += 1)
          n += Math.pow(t[r] - e[r], 2);
        return Math.sqrt(n);
      }
      function normalize(e) {
        return div(e, length(e));
      }
      function rgbToHsl(e) {
        var t = e[0], r = e[1], i = e[2], n = Math.max(t, r, i), a = Math.min(t, r, i), s, l, o = (n + a) / 2;
        if (n === a)
          s = 0, l = 0;
        else {
          var c = n - a;
          switch (l = o > 0.5 ? c / (2 - n - a) : c / (n + a), n) {
            case t:
              s = (r - i) / c + (r < i ? 6 : 0);
              break;
            case r:
              s = (i - t) / c + 2;
              break;
            case i:
              s = (t - r) / c + 4;
              break;
          }
          s /= 6;
        }
        return [s, l, o, e[3]];
      }
      function hue2rgb(e, t, r) {
        return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * 6 * r : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
      }
      function hslToRgb(e) {
        var t = e[0], r = e[1], i = e[2], n, a, s;
        if (r === 0)
          n = i, s = i, a = i;
        else {
          var l = i < 0.5 ? i * (1 + r) : i + r - i * r, o = 2 * i - l;
          n = hue2rgb(o, l, t + 1 / 3), a = hue2rgb(o, l, t), s = hue2rgb(o, l, t - 1 / 3);
        }
        return [n, a, s, e[3]];
      }
      function linear(e, t, r, i, n) {
        if ((i === void 0 || n === void 0) && (i = t, n = r, t = 0, r = 1), r < t) {
          var a = r;
          r = t, t = a;
        }
        if (e <= t)
          return i;
        if (e >= r)
          return n;
        var s = r === t ? 0 : (e - t) / (r - t);
        if (!i.length)
          return i + (n - i) * s;
        var l, o = i.length, c = createTypedArray("float32", o);
        for (l = 0; l < o; l += 1)
          c[l] = i[l] + (n[l] - i[l]) * s;
        return c;
      }
      function random(e, t) {
        if (t === void 0 && (e === void 0 ? (e = 0, t = 1) : (t = e, e = void 0)), t.length) {
          var r, i = t.length;
          e || (e = createTypedArray("float32", i));
          var n = createTypedArray("float32", i), a = BMMath.random();
          for (r = 0; r < i; r += 1)
            n[r] = e[r] + a * (t[r] - e[r]);
          return n;
        }
        e === void 0 && (e = 0);
        var s = BMMath.random();
        return e + s * (t - e);
      }
      function createPath(e, t, r, i) {
        var n, a = e.length, s = shapePool.newElement();
        s.setPathData(!!i, a);
        var l = [0, 0], o, c;
        for (n = 0; n < a; n += 1)
          o = t && t[n] ? t[n] : l, c = r && r[n] ? r[n] : l, s.setTripleAt(e[n][0], e[n][1], c[0] + e[n][0], c[1] + e[n][1], o[0] + e[n][0], o[1] + e[n][1], n, !0);
        return s;
      }
      function initiateExpression(elem, data, property) {
        function noOp(e) {
          return e;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
          get: function() {
            return thisProperty.v;
          }
        }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = (function e(t, r) {
          var i, n, a = this.pv.length ? this.pv.length : 1, s = createTypedArray("float32", a);
          t = 5;
          var l = Math.floor(time * t);
          for (i = 0, n = 0; i < l; ) {
            for (n = 0; n < a; n += 1)
              s[n] += -r + r * 2 * BMMath.random();
            i += 1;
          }
          var o = time * t, c = o - Math.floor(o), f = createTypedArray("float32", a);
          if (a > 1) {
            for (n = 0; n < a; n += 1)
              f[n] = this.pv[n] + s[n] + (-r + r * 2 * BMMath.random()) * c;
            return f;
          }
          return this.pv + s[0] + (-r + r * 2 * BMMath.random()) * c;
        }).bind(this);
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
        function loopInDuration(e, t) {
          return loopIn(e, t, !0);
        }
        function loopOutDuration(e, t) {
          return loopOut(e, t, !0);
        }
        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
        function lookAt(e, t) {
          var r = [t[0] - e[0], t[1] - e[1], t[2] - e[2]], i = Math.atan2(r[0], Math.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads, n = -Math.atan2(r[1], r[2]) / degToRads;
          return [n, i, 0];
        }
        function easeOut(e, t, r, i, n) {
          return applyEase(easeOutBez, e, t, r, i, n);
        }
        function easeIn(e, t, r, i, n) {
          return applyEase(easeInBez, e, t, r, i, n);
        }
        function ease(e, t, r, i, n) {
          return applyEase(easeInOutBez, e, t, r, i, n);
        }
        function applyEase(e, t, r, i, n, a) {
          n === void 0 ? (n = r, a = i) : t = (t - r) / (i - r), t > 1 ? t = 1 : t < 0 && (t = 0);
          var s = e(t);
          if ($bm_isInstanceOfArray(n)) {
            var l, o = n.length, c = createTypedArray("float32", o);
            for (l = 0; l < o; l += 1)
              c[l] = (a[l] - n[l]) * s + n[l];
            return c;
          }
          return (a - n) * s + n;
        }
        function nearestKey(e) {
          var t, r = data.k.length, i, n;
          if (!data.k.length || typeof data.k[0] == "number")
            i = 0, n = 0;
          else if (i = -1, e *= elem.comp.globalData.frameRate, e < data.k[0].t)
            i = 1, n = data.k[0].t;
          else {
            for (t = 0; t < r - 1; t += 1)
              if (e === data.k[t].t) {
                i = t + 1, n = data.k[t].t;
                break;
              } else if (e > data.k[t].t && e < data.k[t + 1].t) {
                e - data.k[t].t > data.k[t + 1].t - e ? (i = t + 2, n = data.k[t + 1].t) : (i = t + 1, n = data.k[t].t);
                break;
              }
            i === -1 && (i = t + 1, n = data.k[t].t);
          }
          var a = {};
          return a.index = i, a.time = n / elem.comp.globalData.frameRate, a;
        }
        function key(e) {
          var t, r, i;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + e);
          e -= 1, t = {
            time: data.k[e].t / elem.comp.globalData.frameRate,
            value: []
          };
          var n = Object.prototype.hasOwnProperty.call(data.k[e], "s") ? data.k[e].s : data.k[e - 1].e;
          for (i = n.length, r = 0; r < i; r += 1)
            t[r] = n[r], t.value[r] = n[r];
          return t;
        }
        function framesToTime(e, t) {
          return t || (t = elem.comp.globalData.frameRate), e / t;
        }
        function timeToFrames(e, t) {
          return !e && e !== 0 && (e = time), t || (t = elem.comp.globalData.frameRate), e * t;
        }
        function seedRandom(e) {
          BMMath.seedrandom(randSeed + e);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substring(e) : value.substring(e, t) : "";
        }
        function substr(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substr(e) : value.substr(e, t) : "";
        }
        function posterizeTime(e) {
          time = e === 0 ? 0 : Math.floor(time * e) / e, value = valueAtTime(time);
        }
        var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
        function executeExpression(e) {
          return value = e, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    }(), Expressions = function() {
      var e = {};
      e.initExpressions = t, e.resetFrame = ExpressionManager.resetFrame;
      function t(r) {
        var i = 0, n = [];
        function a() {
          i += 1;
        }
        function s() {
          i -= 1, i === 0 && o();
        }
        function l(c) {
          n.indexOf(c) === -1 && n.push(c);
        }
        function o() {
          var c, f = n.length;
          for (c = 0; c < f; c += 1)
            n[c].release();
          n.length = 0;
        }
        r.renderer.compInterface = CompExpressionInterface(r.renderer), r.renderer.globalData.projectInterface.registerComposition(r.renderer), r.renderer.globalData.pushExpression = a, r.renderer.globalData.popExpression = s, r.renderer.globalData.registerExpressionProperty = l;
      }
      return e;
    }(), MaskManagerInterface = function() {
      function e(r, i) {
        this._mask = r, this._data = i;
      }
      Object.defineProperty(e.prototype, "maskPath", {
        get: function() {
          return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
        }
      }), Object.defineProperty(e.prototype, "maskOpacity", {
        get: function() {
          return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
        }
      });
      var t = function(i) {
        var n = createSizedArray(i.viewData.length), a, s = i.viewData.length;
        for (a = 0; a < s; a += 1)
          n[a] = new e(i.viewData[a], i.masksProperties[a]);
        var l = function(c) {
          for (a = 0; a < s; ) {
            if (i.masksProperties[a].nm === c)
              return n[a];
            a += 1;
          }
          return null;
        };
        return l;
      };
      return t;
    }(), ExpressionPropertyInterface = function() {
      var e = {
        pv: 0,
        v: 0,
        mult: 1
      }, t = {
        pv: [0, 0, 0],
        v: [0, 0, 0],
        mult: 1
      };
      function r(s, l, o) {
        Object.defineProperty(s, "velocity", {
          get: function() {
            return l.getVelocityAtTime(l.comp.currentFrame);
          }
        }), s.numKeys = l.keyframes ? l.keyframes.length : 0, s.key = function(c) {
          if (!s.numKeys)
            return 0;
          var f = "";
          "s" in l.keyframes[c - 1] ? f = l.keyframes[c - 1].s : "e" in l.keyframes[c - 2] ? f = l.keyframes[c - 2].e : f = l.keyframes[c - 2].s;
          var x = o === "unidimensional" ? new Number(f) : Object.assign({}, f);
          return x.time = l.keyframes[c - 1].t / l.elem.comp.globalData.frameRate, x.value = o === "unidimensional" ? f[0] : f, x;
        }, s.valueAtTime = l.getValueAtTime, s.speedAtTime = l.getSpeedAtTime, s.velocityAtTime = l.getVelocityAtTime, s.propertyGroup = l.propertyGroup;
      }
      function i(s) {
        (!s || !("pv" in s)) && (s = e);
        var l = 1 / s.mult, o = s.pv * l, c = new Number(o);
        return c.value = o, r(c, s, "unidimensional"), function() {
          return s.k && s.getValue(), o = s.v * l, c.value !== o && (c = new Number(o), c.value = o, r(c, s, "unidimensional")), c;
        };
      }
      function n(s) {
        (!s || !("pv" in s)) && (s = t);
        var l = 1 / s.mult, o = s.data && s.data.l || s.pv.length, c = createTypedArray("float32", o), f = createTypedArray("float32", o);
        return c.value = f, r(c, s, "multidimensional"), function() {
          s.k && s.getValue();
          for (var x = 0; x < o; x += 1)
            f[x] = s.v[x] * l, c[x] = f[x];
          return c;
        };
      }
      function a() {
        return e;
      }
      return function(s) {
        return s ? s.propType === "unidimensional" ? i(s) : n(s) : a;
      };
    }(), TransformExpressionInterface = function() {
      return function(e) {
        function t(s) {
          switch (s) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return t.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return t.rotation;
            case "ADBE Rotate X":
              return t.xRotation;
            case "ADBE Rotate Y":
              return t.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return t.position;
            case "ADBE Position_0":
              return t.xPosition;
            case "ADBE Position_1":
              return t.yPosition;
            case "ADBE Position_2":
              return t.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return t.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return t.opacity;
            default:
              return null;
          }
        }
        Object.defineProperty(t, "rotation", {
          get: ExpressionPropertyInterface(e.r || e.rz)
        }), Object.defineProperty(t, "zRotation", {
          get: ExpressionPropertyInterface(e.rz || e.r)
        }), Object.defineProperty(t, "xRotation", {
          get: ExpressionPropertyInterface(e.rx)
        }), Object.defineProperty(t, "yRotation", {
          get: ExpressionPropertyInterface(e.ry)
        }), Object.defineProperty(t, "scale", {
          get: ExpressionPropertyInterface(e.s)
        });
        var r, i, n, a;
        return e.p ? a = ExpressionPropertyInterface(e.p) : (r = ExpressionPropertyInterface(e.px), i = ExpressionPropertyInterface(e.py), e.pz && (n = ExpressionPropertyInterface(e.pz))), Object.defineProperty(t, "position", {
          get: function() {
            return e.p ? a() : [r(), i(), n ? n() : 0];
          }
        }), Object.defineProperty(t, "xPosition", {
          get: ExpressionPropertyInterface(e.px)
        }), Object.defineProperty(t, "yPosition", {
          get: ExpressionPropertyInterface(e.py)
        }), Object.defineProperty(t, "zPosition", {
          get: ExpressionPropertyInterface(e.pz)
        }), Object.defineProperty(t, "anchorPoint", {
          get: ExpressionPropertyInterface(e.a)
        }), Object.defineProperty(t, "opacity", {
          get: ExpressionPropertyInterface(e.o)
        }), Object.defineProperty(t, "skew", {
          get: ExpressionPropertyInterface(e.sk)
        }), Object.defineProperty(t, "skewAxis", {
          get: ExpressionPropertyInterface(e.sa)
        }), Object.defineProperty(t, "orientation", {
          get: ExpressionPropertyInterface(e.or)
        }), t;
      };
    }(), LayerExpressionInterface = function() {
      function e(c) {
        var f = new Matrix();
        if (c !== void 0) {
          var x = this._elem.finalTransform.mProp.getValueAtTime(c);
          x.clone(f);
        } else {
          var m = this._elem.finalTransform.mProp;
          m.applyToMatrix(f);
        }
        return f;
      }
      function t(c, f) {
        var x = this.getMatrix(f);
        return x.props[12] = 0, x.props[13] = 0, x.props[14] = 0, this.applyPoint(x, c);
      }
      function r(c, f) {
        var x = this.getMatrix(f);
        return this.applyPoint(x, c);
      }
      function i(c, f) {
        var x = this.getMatrix(f);
        return x.props[12] = 0, x.props[13] = 0, x.props[14] = 0, this.invertPoint(x, c);
      }
      function n(c, f) {
        var x = this.getMatrix(f);
        return this.invertPoint(x, c);
      }
      function a(c, f) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var x, m = this._elem.hierarchy.length;
          for (x = 0; x < m; x += 1)
            this._elem.hierarchy[x].finalTransform.mProp.applyToMatrix(c);
        }
        return c.applyToPointArray(f[0], f[1], f[2] || 0);
      }
      function s(c, f) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var x, m = this._elem.hierarchy.length;
          for (x = 0; x < m; x += 1)
            this._elem.hierarchy[x].finalTransform.mProp.applyToMatrix(c);
        }
        return c.inversePoint(f);
      }
      function l(c) {
        var f = new Matrix();
        if (f.reset(), this._elem.finalTransform.mProp.applyToMatrix(f), this._elem.hierarchy && this._elem.hierarchy.length) {
          var x, m = this._elem.hierarchy.length;
          for (x = 0; x < m; x += 1)
            this._elem.hierarchy[x].finalTransform.mProp.applyToMatrix(f);
          return f.inversePoint(c);
        }
        return f.inversePoint(c);
      }
      function o() {
        return [1, 1, 1, 1];
      }
      return function(c) {
        var f;
        function x(d) {
          A.mask = new MaskManagerInterface(d, c);
        }
        function m(d) {
          A.effect = d;
        }
        function A(d) {
          switch (d) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return A.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return f;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return A.effect;
            case "ADBE Text Properties":
              return A.textInterface;
            default:
              return null;
          }
        }
        A.getMatrix = e, A.invertPoint = s, A.applyPoint = a, A.toWorld = r, A.toWorldVec = t, A.fromWorld = n, A.fromWorldVec = i, A.toComp = r, A.fromComp = l, A.sampleImage = o, A.sourceRectAtTime = c.sourceRectAtTime.bind(c), A._elem = c, f = TransformExpressionInterface(c.finalTransform.mProp);
        var M = getDescriptor(f, "anchorPoint");
        return Object.defineProperties(A, {
          hasParent: {
            get: function() {
              return c.hierarchy.length;
            }
          },
          parent: {
            get: function() {
              return c.hierarchy[0].layerInterface;
            }
          },
          rotation: getDescriptor(f, "rotation"),
          scale: getDescriptor(f, "scale"),
          position: getDescriptor(f, "position"),
          opacity: getDescriptor(f, "opacity"),
          anchorPoint: M,
          anchor_point: M,
          transform: {
            get: function() {
              return f;
            }
          },
          active: {
            get: function() {
              return c.isInRange;
            }
          }
        }), A.startTime = c.data.st, A.index = c.data.ind, A.source = c.data.refId, A.height = c.data.ty === 0 ? c.data.h : 100, A.width = c.data.ty === 0 ? c.data.w : 100, A.inPoint = c.data.ip / c.comp.globalData.frameRate, A.outPoint = c.data.op / c.comp.globalData.frameRate, A._name = c.data.nm, A.registerMaskInterface = x, A.registerEffectsInterface = m, A;
      };
    }(), propertyGroupFactory = function() {
      return function(e, t) {
        return function(r) {
          return r = r === void 0 ? 1 : r, r <= 0 ? e : t(r - 1);
        };
      };
    }(), PropertyInterface = function() {
      return function(e, t) {
        var r = {
          _name: e
        };
        function i(n) {
          return n = n === void 0 ? 1 : n, n <= 0 ? r : t(n - 1);
        }
        return i;
      };
    }(), EffectsExpressionInterface = function() {
      var e = {
        createEffectsInterface: t
      };
      function t(n, a) {
        if (n.effectsManager) {
          var s = [], l = n.data.ef, o, c = n.effectsManager.effectElements.length;
          for (o = 0; o < c; o += 1)
            s.push(r(l[o], n.effectsManager.effectElements[o], a, n));
          var f = n.data.ef || [], x = function(A) {
            for (o = 0, c = f.length; o < c; ) {
              if (A === f[o].nm || A === f[o].mn || A === f[o].ix)
                return s[o];
              o += 1;
            }
            return null;
          };
          return Object.defineProperty(x, "numProperties", {
            get: function() {
              return f.length;
            }
          }), x;
        }
        return null;
      }
      function r(n, a, s, l) {
        function o(A) {
          for (var M = n.ef, d = 0, C = M.length; d < C; ) {
            if (A === M[d].nm || A === M[d].mn || A === M[d].ix)
              return M[d].ty === 5 ? f[d] : f[d]();
            d += 1;
          }
          throw new Error();
        }
        var c = propertyGroupFactory(o, s), f = [], x, m = n.ef.length;
        for (x = 0; x < m; x += 1)
          n.ef[x].ty === 5 ? f.push(r(n.ef[x], a.effectElements[x], a.effectElements[x].propertyGroup, l)) : f.push(i(a.effectElements[x], n.ef[x].ty, l, c));
        return n.mn === "ADBE Color Control" && Object.defineProperty(o, "color", {
          get: function() {
            return f[0]();
          }
        }), Object.defineProperties(o, {
          numProperties: {
            get: function() {
              return n.np;
            }
          },
          _name: {
            value: n.nm
          },
          propertyGroup: {
            value: c
          }
        }), o.enabled = n.en !== 0, o.active = o.enabled, o;
      }
      function i(n, a, s, l) {
        var o = ExpressionPropertyInterface(n.p);
        function c() {
          return a === 10 ? s.comp.compInterface(n.p.v) : o();
        }
        return n.p.setGroupProperty && n.p.setGroupProperty(PropertyInterface("", l)), c;
      }
      return e;
    }(), ShapePathInterface = function() {
      return function(t, r, i) {
        var n = r.sh;
        function a(l) {
          return l === "Shape" || l === "shape" || l === "Path" || l === "path" || l === "ADBE Vector Shape" || l === 2 ? a.path : null;
        }
        var s = propertyGroupFactory(a, i);
        return n.setGroupProperty(PropertyInterface("Path", s)), Object.defineProperties(a, {
          path: {
            get: function() {
              return n.k && n.getValue(), n;
            }
          },
          shape: {
            get: function() {
              return n.k && n.getValue(), n;
            }
          },
          _name: {
            value: t.nm
          },
          ix: {
            value: t.ix
          },
          propertyIndex: {
            value: t.ix
          },
          mn: {
            value: t.mn
          },
          propertyGroup: {
            value: i
          }
        }), a;
      };
    }(), ShapeExpressionInterface = function() {
      function e(M, d, C) {
        var u = [], g, p = M ? M.length : 0;
        for (g = 0; g < p; g += 1)
          M[g].ty === "gr" ? u.push(r(M[g], d[g], C)) : M[g].ty === "fl" ? u.push(i(M[g], d[g], C)) : M[g].ty === "st" ? u.push(s(M[g], d[g], C)) : M[g].ty === "tm" ? u.push(l(M[g], d[g], C)) : M[g].ty === "tr" || (M[g].ty === "el" ? u.push(c(M[g], d[g], C)) : M[g].ty === "sr" ? u.push(f(M[g], d[g], C)) : M[g].ty === "sh" ? u.push(ShapePathInterface(M[g], d[g], C)) : M[g].ty === "rc" ? u.push(x(M[g], d[g], C)) : M[g].ty === "rd" ? u.push(m(M[g], d[g], C)) : M[g].ty === "rp" ? u.push(A(M[g], d[g], C)) : M[g].ty === "gf" ? u.push(n(M[g], d[g], C)) : u.push(a(M[g], d[g])));
        return u;
      }
      function t(M, d, C) {
        var u, g = function(E) {
          for (var T = 0, Z = u.length; T < Z; ) {
            if (u[T]._name === E || u[T].mn === E || u[T].propertyIndex === E || u[T].ix === E || u[T].ind === E)
              return u[T];
            T += 1;
          }
          return typeof E == "number" ? u[E - 1] : null;
        };
        g.propertyGroup = propertyGroupFactory(g, C), u = e(M.it, d.it, g.propertyGroup), g.numProperties = u.length;
        var p = o(M.it[M.it.length - 1], d.it[d.it.length - 1], g.propertyGroup);
        return g.transform = p, g.propertyIndex = M.cix, g._name = M.nm, g;
      }
      function r(M, d, C) {
        var u = function(E) {
          switch (E) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return u.content;
            default:
              return u.transform;
          }
        };
        u.propertyGroup = propertyGroupFactory(u, C);
        var g = t(M, d, u.propertyGroup), p = o(M.it[M.it.length - 1], d.it[d.it.length - 1], u.propertyGroup);
        return u.content = g, u.transform = p, Object.defineProperty(u, "_name", {
          get: function() {
            return M.nm;
          }
        }), u.numProperties = M.np, u.propertyIndex = M.ix, u.nm = M.nm, u.mn = M.mn, u;
      }
      function i(M, d, C) {
        function u(g) {
          return g === "Color" || g === "color" ? u.color : g === "Opacity" || g === "opacity" ? u.opacity : null;
        }
        return Object.defineProperties(u, {
          color: {
            get: ExpressionPropertyInterface(d.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(d.o)
          },
          _name: {
            value: M.nm
          },
          mn: {
            value: M.mn
          }
        }), d.c.setGroupProperty(PropertyInterface("Color", C)), d.o.setGroupProperty(PropertyInterface("Opacity", C)), u;
      }
      function n(M, d, C) {
        function u(g) {
          return g === "Start Point" || g === "start point" ? u.startPoint : g === "End Point" || g === "end point" ? u.endPoint : g === "Opacity" || g === "opacity" ? u.opacity : null;
        }
        return Object.defineProperties(u, {
          startPoint: {
            get: ExpressionPropertyInterface(d.s)
          },
          endPoint: {
            get: ExpressionPropertyInterface(d.e)
          },
          opacity: {
            get: ExpressionPropertyInterface(d.o)
          },
          type: {
            get: function() {
              return "a";
            }
          },
          _name: {
            value: M.nm
          },
          mn: {
            value: M.mn
          }
        }), d.s.setGroupProperty(PropertyInterface("Start Point", C)), d.e.setGroupProperty(PropertyInterface("End Point", C)), d.o.setGroupProperty(PropertyInterface("Opacity", C)), u;
      }
      function a() {
        function M() {
          return null;
        }
        return M;
      }
      function s(M, d, C) {
        var u = propertyGroupFactory(Z, C), g = propertyGroupFactory(T, u);
        function p(G) {
          Object.defineProperty(T, M.d[G].nm, {
            get: ExpressionPropertyInterface(d.d.dataProps[G].p)
          });
        }
        var y, E = M.d ? M.d.length : 0, T = {};
        for (y = 0; y < E; y += 1)
          p(y), d.d.dataProps[y].p.setGroupProperty(g);
        function Z(G) {
          return G === "Color" || G === "color" ? Z.color : G === "Opacity" || G === "opacity" ? Z.opacity : G === "Stroke Width" || G === "stroke width" ? Z.strokeWidth : null;
        }
        return Object.defineProperties(Z, {
          color: {
            get: ExpressionPropertyInterface(d.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(d.o)
          },
          strokeWidth: {
            get: ExpressionPropertyInterface(d.w)
          },
          dash: {
            get: function() {
              return T;
            }
          },
          _name: {
            value: M.nm
          },
          mn: {
            value: M.mn
          }
        }), d.c.setGroupProperty(PropertyInterface("Color", u)), d.o.setGroupProperty(PropertyInterface("Opacity", u)), d.w.setGroupProperty(PropertyInterface("Stroke Width", u)), Z;
      }
      function l(M, d, C) {
        function u(p) {
          return p === M.e.ix || p === "End" || p === "end" ? u.end : p === M.s.ix ? u.start : p === M.o.ix ? u.offset : null;
        }
        var g = propertyGroupFactory(u, C);
        return u.propertyIndex = M.ix, d.s.setGroupProperty(PropertyInterface("Start", g)), d.e.setGroupProperty(PropertyInterface("End", g)), d.o.setGroupProperty(PropertyInterface("Offset", g)), u.propertyIndex = M.ix, u.propertyGroup = C, Object.defineProperties(u, {
          start: {
            get: ExpressionPropertyInterface(d.s)
          },
          end: {
            get: ExpressionPropertyInterface(d.e)
          },
          offset: {
            get: ExpressionPropertyInterface(d.o)
          },
          _name: {
            value: M.nm
          }
        }), u.mn = M.mn, u;
      }
      function o(M, d, C) {
        function u(p) {
          return M.a.ix === p || p === "Anchor Point" ? u.anchorPoint : M.o.ix === p || p === "Opacity" ? u.opacity : M.p.ix === p || p === "Position" ? u.position : M.r.ix === p || p === "Rotation" || p === "ADBE Vector Rotation" ? u.rotation : M.s.ix === p || p === "Scale" ? u.scale : M.sk && M.sk.ix === p || p === "Skew" ? u.skew : M.sa && M.sa.ix === p || p === "Skew Axis" ? u.skewAxis : null;
        }
        var g = propertyGroupFactory(u, C);
        return d.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", g)), d.transform.mProps.p.setGroupProperty(PropertyInterface("Position", g)), d.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", g)), d.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", g)), d.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", g)), d.transform.mProps.sk && (d.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", g)), d.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", g))), d.transform.op.setGroupProperty(PropertyInterface("Opacity", g)), Object.defineProperties(u, {
          opacity: {
            get: ExpressionPropertyInterface(d.transform.mProps.o)
          },
          position: {
            get: ExpressionPropertyInterface(d.transform.mProps.p)
          },
          anchorPoint: {
            get: ExpressionPropertyInterface(d.transform.mProps.a)
          },
          scale: {
            get: ExpressionPropertyInterface(d.transform.mProps.s)
          },
          rotation: {
            get: ExpressionPropertyInterface(d.transform.mProps.r)
          },
          skew: {
            get: ExpressionPropertyInterface(d.transform.mProps.sk)
          },
          skewAxis: {
            get: ExpressionPropertyInterface(d.transform.mProps.sa)
          },
          _name: {
            value: M.nm
          }
        }), u.ty = "tr", u.mn = M.mn, u.propertyGroup = C, u;
      }
      function c(M, d, C) {
        function u(y) {
          return M.p.ix === y ? u.position : M.s.ix === y ? u.size : null;
        }
        var g = propertyGroupFactory(u, C);
        u.propertyIndex = M.ix;
        var p = d.sh.ty === "tm" ? d.sh.prop : d.sh;
        return p.s.setGroupProperty(PropertyInterface("Size", g)), p.p.setGroupProperty(PropertyInterface("Position", g)), Object.defineProperties(u, {
          size: {
            get: ExpressionPropertyInterface(p.s)
          },
          position: {
            get: ExpressionPropertyInterface(p.p)
          },
          _name: {
            value: M.nm
          }
        }), u.mn = M.mn, u;
      }
      function f(M, d, C) {
        function u(y) {
          return M.p.ix === y ? u.position : M.r.ix === y ? u.rotation : M.pt.ix === y ? u.points : M.or.ix === y || y === "ADBE Vector Star Outer Radius" ? u.outerRadius : M.os.ix === y ? u.outerRoundness : M.ir && (M.ir.ix === y || y === "ADBE Vector Star Inner Radius") ? u.innerRadius : M.is && M.is.ix === y ? u.innerRoundness : null;
        }
        var g = propertyGroupFactory(u, C), p = d.sh.ty === "tm" ? d.sh.prop : d.sh;
        return u.propertyIndex = M.ix, p.or.setGroupProperty(PropertyInterface("Outer Radius", g)), p.os.setGroupProperty(PropertyInterface("Outer Roundness", g)), p.pt.setGroupProperty(PropertyInterface("Points", g)), p.p.setGroupProperty(PropertyInterface("Position", g)), p.r.setGroupProperty(PropertyInterface("Rotation", g)), M.ir && (p.ir.setGroupProperty(PropertyInterface("Inner Radius", g)), p.is.setGroupProperty(PropertyInterface("Inner Roundness", g))), Object.defineProperties(u, {
          position: {
            get: ExpressionPropertyInterface(p.p)
          },
          rotation: {
            get: ExpressionPropertyInterface(p.r)
          },
          points: {
            get: ExpressionPropertyInterface(p.pt)
          },
          outerRadius: {
            get: ExpressionPropertyInterface(p.or)
          },
          outerRoundness: {
            get: ExpressionPropertyInterface(p.os)
          },
          innerRadius: {
            get: ExpressionPropertyInterface(p.ir)
          },
          innerRoundness: {
            get: ExpressionPropertyInterface(p.is)
          },
          _name: {
            value: M.nm
          }
        }), u.mn = M.mn, u;
      }
      function x(M, d, C) {
        function u(y) {
          return M.p.ix === y ? u.position : M.r.ix === y ? u.roundness : M.s.ix === y || y === "Size" || y === "ADBE Vector Rect Size" ? u.size : null;
        }
        var g = propertyGroupFactory(u, C), p = d.sh.ty === "tm" ? d.sh.prop : d.sh;
        return u.propertyIndex = M.ix, p.p.setGroupProperty(PropertyInterface("Position", g)), p.s.setGroupProperty(PropertyInterface("Size", g)), p.r.setGroupProperty(PropertyInterface("Rotation", g)), Object.defineProperties(u, {
          position: {
            get: ExpressionPropertyInterface(p.p)
          },
          roundness: {
            get: ExpressionPropertyInterface(p.r)
          },
          size: {
            get: ExpressionPropertyInterface(p.s)
          },
          _name: {
            value: M.nm
          }
        }), u.mn = M.mn, u;
      }
      function m(M, d, C) {
        function u(y) {
          return M.r.ix === y || y === "Round Corners 1" ? u.radius : null;
        }
        var g = propertyGroupFactory(u, C), p = d;
        return u.propertyIndex = M.ix, p.rd.setGroupProperty(PropertyInterface("Radius", g)), Object.defineProperties(u, {
          radius: {
            get: ExpressionPropertyInterface(p.rd)
          },
          _name: {
            value: M.nm
          }
        }), u.mn = M.mn, u;
      }
      function A(M, d, C) {
        function u(y) {
          return M.c.ix === y || y === "Copies" ? u.copies : M.o.ix === y || y === "Offset" ? u.offset : null;
        }
        var g = propertyGroupFactory(u, C), p = d;
        return u.propertyIndex = M.ix, p.c.setGroupProperty(PropertyInterface("Copies", g)), p.o.setGroupProperty(PropertyInterface("Offset", g)), Object.defineProperties(u, {
          copies: {
            get: ExpressionPropertyInterface(p.c)
          },
          offset: {
            get: ExpressionPropertyInterface(p.o)
          },
          _name: {
            value: M.nm
          }
        }), u.mn = M.mn, u;
      }
      return function(M, d, C) {
        var u;
        function g(y) {
          if (typeof y == "number")
            return y = y === void 0 ? 1 : y, y === 0 ? C : u[y - 1];
          for (var E = 0, T = u.length; E < T; ) {
            if (u[E]._name === y)
              return u[E];
            E += 1;
          }
          return null;
        }
        function p() {
          return C;
        }
        return g.propertyGroup = propertyGroupFactory(g, p), u = e(M, d, g.propertyGroup), g.numProperties = u.length, g._name = "Contents", g;
      };
    }(), TextExpressionInterface = function() {
      return function(e) {
        var t;
        function r(i) {
          switch (i) {
            case "ADBE Text Document":
              return r.sourceText;
            default:
              return null;
          }
        }
        return Object.defineProperty(r, "sourceText", {
          get: function() {
            e.textProperty.getValue();
            var n = e.textProperty.currentData.t;
            return (!t || n !== t.value) && (t = new String(n), t.value = n || new String(n), Object.defineProperty(t, "style", {
              get: function() {
                return {
                  fillColor: e.textProperty.currentData.fc
                };
              }
            })), t;
          }
        }), r;
      };
    }();
    function _typeof(e) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(r) {
        return typeof r;
      } : _typeof = function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, _typeof(e);
    }
    var FootageInterface = function() {
      var e = function(i) {
        var n = "", a = i.getFootageData();
        function s() {
          return n = "", a = i.getFootageData(), l;
        }
        function l(o) {
          if (a[o])
            return n = o, a = a[o], _typeof(a) === "object" ? l : a;
          var c = o.indexOf(n);
          if (c !== -1) {
            var f = parseInt(o.substr(c + n.length), 10);
            return a = a[f], _typeof(a) === "object" ? l : a;
          }
          return "";
        }
        return s;
      }, t = function(i) {
        function n(a) {
          return a === "Outline" ? n.outlineInterface() : null;
        }
        return n._name = "Outline", n.outlineInterface = e(i), n;
      };
      return function(r) {
        function i(n) {
          return n === "Data" ? i.dataInterface : null;
        }
        return i._name = "Data", i.dataInterface = t(r), i;
      };
    }(), interfaces = {
      layer: LayerExpressionInterface,
      effects: EffectsExpressionInterface,
      comp: CompExpressionInterface,
      shape: ShapeExpressionInterface,
      text: TextExpressionInterface,
      footage: FootageInterface
    };
    function getInterface(e) {
      return interfaces[e] || null;
    }
    var expressionHelpers = function() {
      function e(s, l, o) {
        l.x && (o.k = !0, o.x = !0, o.initiateExpression = ExpressionManager.initiateExpression, o.effectsSequence.push(o.initiateExpression(s, l, o).bind(o)));
      }
      function t(s) {
        return s *= this.elem.globalData.frameRate, s -= this.offsetTime, s !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < s ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(s, this._cachingAtTime), this._cachingAtTime.lastFrame = s), this._cachingAtTime.value;
      }
      function r(s) {
        var l = -0.01, o = this.getValueAtTime(s), c = this.getValueAtTime(s + l), f = 0;
        if (o.length) {
          var x;
          for (x = 0; x < o.length; x += 1)
            f += Math.pow(c[x] - o[x], 2);
          f = Math.sqrt(f) * 100;
        } else
          f = 0;
        return f;
      }
      function i(s) {
        if (this.vel !== void 0)
          return this.vel;
        var l = -1e-3, o = this.getValueAtTime(s), c = this.getValueAtTime(s + l), f;
        if (o.length) {
          f = createTypedArray("float32", o.length);
          var x;
          for (x = 0; x < o.length; x += 1)
            f[x] = (c[x] - o[x]) / l;
        } else
          f = (c - o) / l;
        return f;
      }
      function n() {
        return this.pv;
      }
      function a(s) {
        this.propertyGroup = s;
      }
      return {
        searchExpressions: e,
        getSpeedAtTime: r,
        getVelocityAtTime: i,
        getValueAtTime: t,
        getStaticValueAtTime: n,
        setGroupProperty: a
      };
    }();
    function addPropertyDecorator() {
      function e(m, A, M) {
        if (!this.k || !this.keyframes)
          return this.pv;
        m = m ? m.toLowerCase() : "";
        var d = this.comp.renderedFrame, C = this.keyframes, u = C[C.length - 1].t;
        if (d <= u)
          return this.pv;
        var g, p;
        M ? (A ? g = Math.abs(u - this.elem.comp.globalData.frameRate * A) : g = Math.max(0, u - this.elem.data.ip), p = u - g) : ((!A || A > C.length - 1) && (A = C.length - 1), p = C[C.length - 1 - A].t, g = u - p);
        var y, E, T;
        if (m === "pingpong") {
          var Z = Math.floor((d - p) / g);
          if (Z % 2 !== 0)
            return this.getValueAtTime((g - (d - p) % g + p) / this.comp.globalData.frameRate, 0);
        } else if (m === "offset") {
          var G = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), I = this.getValueAtTime(u / this.comp.globalData.frameRate, 0), V = this.getValueAtTime(((d - p) % g + p) / this.comp.globalData.frameRate, 0), Y = Math.floor((d - p) / g);
          if (this.pv.length) {
            for (T = new Array(G.length), E = T.length, y = 0; y < E; y += 1)
              T[y] = (I[y] - G[y]) * Y + V[y];
            return T;
          }
          return (I - G) * Y + V;
        } else if (m === "continue") {
          var D = this.getValueAtTime(u / this.comp.globalData.frameRate, 0), R = this.getValueAtTime((u - 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (T = new Array(D.length), E = T.length, y = 0; y < E; y += 1)
              T[y] = D[y] + (D[y] - R[y]) * ((d - u) / this.comp.globalData.frameRate) / 5e-4;
            return T;
          }
          return D + (D - R) * ((d - u) / 1e-3);
        }
        return this.getValueAtTime(((d - p) % g + p) / this.comp.globalData.frameRate, 0);
      }
      function t(m, A, M) {
        if (!this.k)
          return this.pv;
        m = m ? m.toLowerCase() : "";
        var d = this.comp.renderedFrame, C = this.keyframes, u = C[0].t;
        if (d >= u)
          return this.pv;
        var g, p;
        M ? (A ? g = Math.abs(this.elem.comp.globalData.frameRate * A) : g = Math.max(0, this.elem.data.op - u), p = u + g) : ((!A || A > C.length - 1) && (A = C.length - 1), p = C[A].t, g = p - u);
        var y, E, T;
        if (m === "pingpong") {
          var Z = Math.floor((u - d) / g);
          if (Z % 2 === 0)
            return this.getValueAtTime(((u - d) % g + u) / this.comp.globalData.frameRate, 0);
        } else if (m === "offset") {
          var G = this.getValueAtTime(u / this.comp.globalData.frameRate, 0), I = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), V = this.getValueAtTime((g - (u - d) % g + u) / this.comp.globalData.frameRate, 0), Y = Math.floor((u - d) / g) + 1;
          if (this.pv.length) {
            for (T = new Array(G.length), E = T.length, y = 0; y < E; y += 1)
              T[y] = V[y] - (I[y] - G[y]) * Y;
            return T;
          }
          return V - (I - G) * Y;
        } else if (m === "continue") {
          var D = this.getValueAtTime(u / this.comp.globalData.frameRate, 0), R = this.getValueAtTime((u + 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (T = new Array(D.length), E = T.length, y = 0; y < E; y += 1)
              T[y] = D[y] + (D[y] - R[y]) * (u - d) / 1e-3;
            return T;
          }
          return D + (D - R) * (u - d) / 1e-3;
        }
        return this.getValueAtTime((g - ((u - d) % g + u)) / this.comp.globalData.frameRate, 0);
      }
      function r(m, A) {
        if (!this.k)
          return this.pv;
        if (m = (m || 0.4) * 0.5, A = Math.floor(A || 5), A <= 1)
          return this.pv;
        var M = this.comp.renderedFrame / this.comp.globalData.frameRate, d = M - m, C = M + m, u = A > 1 ? (C - d) / (A - 1) : 1, g = 0, p = 0, y;
        this.pv.length ? y = createTypedArray("float32", this.pv.length) : y = 0;
        for (var E; g < A; ) {
          if (E = this.getValueAtTime(d + g * u), this.pv.length)
            for (p = 0; p < this.pv.length; p += 1)
              y[p] += E[p];
          else
            y += E;
          g += 1;
        }
        if (this.pv.length)
          for (p = 0; p < this.pv.length; p += 1)
            y[p] /= A;
        else
          y /= A;
        return y;
      }
      function i(m) {
        this._transformCachingAtTime || (this._transformCachingAtTime = {
          v: new Matrix()
        });
        var A = this._transformCachingAtTime.v;
        if (A.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var M = this.a.getValueAtTime(m);
          A.translate(-M[0] * this.a.mult, -M[1] * this.a.mult, M[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var d = this.s.getValueAtTime(m);
          A.scale(d[0] * this.s.mult, d[1] * this.s.mult, d[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var C = this.sk.getValueAtTime(m), u = this.sa.getValueAtTime(m);
          A.skewFromAxis(-C * this.sk.mult, u * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var g = this.r.getValueAtTime(m);
          A.rotate(-g * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var p = this.rz.getValueAtTime(m), y = this.ry.getValueAtTime(m), E = this.rx.getValueAtTime(m), T = this.or.getValueAtTime(m);
          A.rotateZ(-p * this.rz.mult).rotateY(y * this.ry.mult).rotateX(E * this.rx.mult).rotateZ(-T[2] * this.or.mult).rotateY(T[1] * this.or.mult).rotateX(T[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var Z = this.px.getValueAtTime(m), G = this.py.getValueAtTime(m);
          if (this.data.p.z) {
            var I = this.pz.getValueAtTime(m);
            A.translate(Z * this.px.mult, G * this.py.mult, -I * this.pz.mult);
          } else
            A.translate(Z * this.px.mult, G * this.py.mult, 0);
        } else {
          var V = this.p.getValueAtTime(m);
          A.translate(V[0] * this.p.mult, V[1] * this.p.mult, -V[2] * this.p.mult);
        }
        return A;
      }
      function n() {
        return this.v.clone(new Matrix());
      }
      var a = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(m, A, M) {
        var d = a(m, A, M);
        return d.dynamicProperties.length ? d.getValueAtTime = i.bind(d) : d.getValueAtTime = n.bind(d), d.setGroupProperty = expressionHelpers.setGroupProperty, d;
      };
      var s = PropertyFactory.getProp;
      PropertyFactory.getProp = function(m, A, M, d, C) {
        var u = s(m, A, M, d, C);
        u.kf ? u.getValueAtTime = expressionHelpers.getValueAtTime.bind(u) : u.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(u), u.setGroupProperty = expressionHelpers.setGroupProperty, u.loopOut = e, u.loopIn = t, u.smooth = r, u.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(u), u.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(u), u.numKeys = A.a === 1 ? A.k.length : 0, u.propertyIndex = A.ix;
        var g = 0;
        return M !== 0 && (g = createTypedArray("float32", A.a === 1 ? A.k[0].s.length : A.k.length)), u._cachingAtTime = {
          lastFrame: initialDefaultFrame,
          lastIndex: 0,
          value: g
        }, expressionHelpers.searchExpressions(m, A, u), u.k && C.addDynamicProperty(u), u;
      };
      function l(m) {
        return this._cachingAtTime || (this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        }), m *= this.elem.globalData.frameRate, m -= this.offsetTime, m !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < m ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = m, this.interpolateShape(m, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }
      var o = ShapePropertyFactory.getConstructorFunction(), c = ShapePropertyFactory.getKeyframedConstructorFunction();
      function f() {
      }
      f.prototype = {
        vertices: function(A, M) {
          this.k && this.getValue();
          var d = this.v;
          M !== void 0 && (d = this.getValueAtTime(M, 0));
          var C, u = d._length, g = d[A], p = d.v, y = createSizedArray(u);
          for (C = 0; C < u; C += 1)
            A === "i" || A === "o" ? y[C] = [g[C][0] - p[C][0], g[C][1] - p[C][1]] : y[C] = [g[C][0], g[C][1]];
          return y;
        },
        points: function(A) {
          return this.vertices("v", A);
        },
        inTangents: function(A) {
          return this.vertices("i", A);
        },
        outTangents: function(A) {
          return this.vertices("o", A);
        },
        isClosed: function() {
          return this.v.c;
        },
        pointOnPath: function(A, M) {
          var d = this.v;
          M !== void 0 && (d = this.getValueAtTime(M, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(d));
          for (var C = this._segmentsLength, u = C.lengths, g = C.totalLength * A, p = 0, y = u.length, E = 0, T; p < y; ) {
            if (E + u[p].addedLength > g) {
              var Z = p, G = d.c && p === y - 1 ? 0 : p + 1, I = (g - E) / u[p].addedLength;
              T = bez.getPointInSegment(d.v[Z], d.v[G], d.o[Z], d.i[G], I, u[p]);
              break;
            } else
              E += u[p].addedLength;
            p += 1;
          }
          return T || (T = d.c ? [d.v[0][0], d.v[0][1]] : [d.v[d._length - 1][0], d.v[d._length - 1][1]]), T;
        },
        vectorOnPath: function(A, M, d) {
          A == 1 ? A = this.v.c : A == 0 && (A = 0.999);
          var C = this.pointOnPath(A, M), u = this.pointOnPath(A + 1e-3, M), g = u[0] - C[0], p = u[1] - C[1], y = Math.sqrt(Math.pow(g, 2) + Math.pow(p, 2));
          if (y === 0)
            return [0, 0];
          var E = d === "tangent" ? [g / y, p / y] : [-p / y, g / y];
          return E;
        },
        tangentOnPath: function(A, M) {
          return this.vectorOnPath(A, M, "tangent");
        },
        normalOnPath: function(A, M) {
          return this.vectorOnPath(A, M, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime
      }, extendPrototype([f], o), extendPrototype([f], c), c.prototype.getValueAtTime = l, c.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var x = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(m, A, M, d, C) {
        var u = x(m, A, M, d, C);
        return u.propertyIndex = A.ix, u.lock = !1, M === 3 ? expressionHelpers.searchExpressions(m, A.pt, u) : M === 4 && expressionHelpers.searchExpressions(m, A.ks, u), u.k && m.addDynamicProperty(u), u;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      function e() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      }
      TextProperty.prototype.getExpressionValue = function(t, r) {
        var i = this.calculateExpression(r);
        if (t.t !== i) {
          var n = {};
          return this.copyData(n, t), n.t = i.toString(), n.__complete = !1, n;
        }
        return t;
      }, TextProperty.prototype.searchProperty = function() {
        var t = this.searchKeyframes(), r = this.searchExpressions();
        return this.kf = t || r, this.kf;
      }, TextProperty.prototype.searchExpressions = e;
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = {
      createMergeNode: function e(t, r) {
        var i = createNS("feMerge");
        i.setAttribute("result", t);
        var n, a;
        for (a = 0; a < r.length; a += 1)
          n = createNS("feMergeNode"), n.setAttribute("in", r[a]), i.appendChild(n), i.appendChild(n);
        return i;
      }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(e, t, r, i, n) {
      this.filterManager = t;
      var a = createNS("feColorMatrix");
      a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = a, a.setAttribute("result", i + "_tint_1"), e.appendChild(a), a = createNS("feColorMatrix"), a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", i + "_tint_2"), e.appendChild(a), this.matrixFilter = a;
      var s = this.createMergeNode(i, [n, i + "_tint_1", i + "_tint_2"]);
      e.appendChild(s);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + i + " 0"), this.matrixFilter.setAttribute("values", r[0] - t[0] + " 0 0 0 " + t[0] + " " + (r[1] - t[1]) + " 0 0 0 " + t[1] + " " + (r[2] - t[2]) + " 0 0 0 " + t[2] + " 0 0 0 1 0");
      }
    };
    function SVGFillFilter(e, t, r, i) {
      this.filterManager = t;
      var n = createNS("feColorMatrix");
      n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), n.setAttribute("result", i), e.appendChild(n), this.matrixFilter = n;
    }
    SVGFillFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[2].p.v, r = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + t[0] + " 0 0 0 0 " + t[1] + " 0 0 0 0 " + t[2] + " 0 0 0 " + r + " 0");
      }
    };
    function SVGStrokeEffect(e, t, r) {
      this.initialized = !1, this.filterManager = t, this.elem = r, this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
      var e = this.elem.layerElement.children || this.elem.layerElement.childNodes, t, r, i, n;
      for (this.filterManager.effectElements[1].p.v === 1 ? (n = this.elem.maskManager.masksProperties.length, i = 0) : (i = this.filterManager.effectElements[0].p.v - 1, n = i + 1), r = createNS("g"), r.setAttribute("fill", "none"), r.setAttribute("stroke-linecap", "round"), r.setAttribute("stroke-dashoffset", 1), i; i < n; i += 1)
        t = createNS("path"), r.appendChild(t), this.paths.push({
          p: t,
          m: i
        });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var a = createNS("mask"), s = createElementID();
        a.setAttribute("id", s), a.setAttribute("mask-type", "alpha"), a.appendChild(r), this.elem.globalData.defs.appendChild(a);
        var l = createNS("g");
        for (l.setAttribute("mask", "url(" + getLocationHref() + "#" + s + ")"); e[0]; )
          l.appendChild(e[0]);
        this.elem.layerElement.appendChild(l), this.masker = a, r.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (e = this.elem.layerElement.children || this.elem.layerElement.childNodes; e.length; )
            this.elem.layerElement.removeChild(e[0]);
        this.elem.layerElement.appendChild(r), this.elem.layerElement.removeAttribute("mask"), r.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = r;
    }, SVGStrokeEffect.prototype.renderFrame = function(e) {
      this.initialized || this.initialize();
      var t, r = this.paths.length, i, n;
      for (t = 0; t < r; t += 1)
        if (this.paths[t].m !== -1 && (i = this.elem.maskManager.viewData[this.paths[t].m], n = this.paths[t].p, (e || this.filterManager._mdf || i.prop._mdf) && n.setAttribute("d", i.lastPath), e || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || i.prop._mdf)) {
          var a;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, l = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, o = n.getTotalLength();
            a = "0 0 0 " + o * s + " ";
            var c = o * (l - s), f = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, x = Math.floor(c / f), m;
            for (m = 0; m < x; m += 1)
              a += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            a += "0 " + o * 10 + " 0 0";
          } else
            a = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          n.setAttribute("stroke-dasharray", a);
        }
      if ((e || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (e || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (e || this.filterManager.effectElements[3].p._mdf)) {
        var A = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(A[0] * 255) + "," + bmFloor(A[1] * 255) + "," + bmFloor(A[2] * 255) + ")");
      }
    };
    function SVGTritoneFilter(e, t, r, i) {
      this.filterManager = t;
      var n = createNS("feColorMatrix");
      n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "linearRGB"), n.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), e.appendChild(n);
      var a = createNS("feComponentTransfer");
      a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", i), this.matrixFilter = a;
      var s = createNS("feFuncR");
      s.setAttribute("type", "table"), a.appendChild(s), this.feFuncR = s;
      var l = createNS("feFuncG");
      l.setAttribute("type", "table"), a.appendChild(l), this.feFuncG = l;
      var o = createNS("feFuncB");
      o.setAttribute("type", "table"), a.appendChild(o), this.feFuncB = o, e.appendChild(a);
    }
    SVGTritoneFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v, n = i[0] + " " + r[0] + " " + t[0], a = i[1] + " " + r[1] + " " + t[1], s = i[2] + " " + r[2] + " " + t[2];
        this.feFuncR.setAttribute("tableValues", n), this.feFuncG.setAttribute("tableValues", a), this.feFuncB.setAttribute("tableValues", s);
      }
    };
    function SVGProLevelsFilter(e, t, r, i) {
      this.filterManager = t;
      var n = this.filterManager.effectElements, a = createNS("feComponentTransfer");
      (n[10].p.k || n[10].p.v !== 0 || n[11].p.k || n[11].p.v !== 1 || n[12].p.k || n[12].p.v !== 1 || n[13].p.k || n[13].p.v !== 0 || n[14].p.k || n[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", a)), (n[17].p.k || n[17].p.v !== 0 || n[18].p.k || n[18].p.v !== 1 || n[19].p.k || n[19].p.v !== 1 || n[20].p.k || n[20].p.v !== 0 || n[21].p.k || n[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", a)), (n[24].p.k || n[24].p.v !== 0 || n[25].p.k || n[25].p.v !== 1 || n[26].p.k || n[26].p.v !== 1 || n[27].p.k || n[27].p.v !== 0 || n[28].p.k || n[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", a)), (n[31].p.k || n[31].p.v !== 0 || n[32].p.k || n[32].p.v !== 1 || n[33].p.k || n[33].p.v !== 1 || n[34].p.k || n[34].p.v !== 0 || n[35].p.k || n[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", a)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (a.setAttribute("color-interpolation-filters", "sRGB"), e.appendChild(a)), (n[3].p.k || n[3].p.v !== 0 || n[4].p.k || n[4].p.v !== 1 || n[5].p.k || n[5].p.v !== 1 || n[6].p.k || n[6].p.v !== 0 || n[7].p.k || n[7].p.v !== 1) && (a = createNS("feComponentTransfer"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", i), e.appendChild(a), this.feFuncRComposed = this.createFeFunc("feFuncR", a), this.feFuncGComposed = this.createFeFunc("feFuncG", a), this.feFuncBComposed = this.createFeFunc("feFuncB", a));
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(e, t) {
      var r = createNS(e);
      return r.setAttribute("type", "table"), t.appendChild(r), r;
    }, SVGProLevelsFilter.prototype.getTableValue = function(e, t, r, i, n) {
      for (var a = 0, s = 256, l, o = Math.min(e, t), c = Math.max(e, t), f = Array.call(null, {
        length: s
      }), x, m = 0, A = n - i, M = t - e; a <= 256; )
        l = a / 256, l <= o ? x = M < 0 ? n : i : l >= c ? x = M < 0 ? i : n : x = i + A * Math.pow((l - e) / M, 1 / r), f[m] = x, m += 1, a += 256 / (s - 1);
      return f.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t, r = this.filterManager.effectElements;
        this.feFuncRComposed && (e || r[3].p._mdf || r[4].p._mdf || r[5].p._mdf || r[6].p._mdf || r[7].p._mdf) && (t = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v), this.feFuncRComposed.setAttribute("tableValues", t), this.feFuncGComposed.setAttribute("tableValues", t), this.feFuncBComposed.setAttribute("tableValues", t)), this.feFuncR && (e || r[10].p._mdf || r[11].p._mdf || r[12].p._mdf || r[13].p._mdf || r[14].p._mdf) && (t = this.getTableValue(r[10].p.v, r[11].p.v, r[12].p.v, r[13].p.v, r[14].p.v), this.feFuncR.setAttribute("tableValues", t)), this.feFuncG && (e || r[17].p._mdf || r[18].p._mdf || r[19].p._mdf || r[20].p._mdf || r[21].p._mdf) && (t = this.getTableValue(r[17].p.v, r[18].p.v, r[19].p.v, r[20].p.v, r[21].p.v), this.feFuncG.setAttribute("tableValues", t)), this.feFuncB && (e || r[24].p._mdf || r[25].p._mdf || r[26].p._mdf || r[27].p._mdf || r[28].p._mdf) && (t = this.getTableValue(r[24].p.v, r[25].p.v, r[26].p.v, r[27].p.v, r[28].p.v), this.feFuncB.setAttribute("tableValues", t)), this.feFuncA && (e || r[31].p._mdf || r[32].p._mdf || r[33].p._mdf || r[34].p._mdf || r[35].p._mdf) && (t = this.getTableValue(r[31].p.v, r[32].p.v, r[33].p.v, r[34].p.v, r[35].p.v), this.feFuncA.setAttribute("tableValues", t));
      }
    };
    function SVGDropShadowEffect(e, t, r, i, n) {
      var a = t.container.globalData.renderConfig.filterSize, s = t.data.fs || a;
      e.setAttribute("x", s.x || a.x), e.setAttribute("y", s.y || a.y), e.setAttribute("width", s.width || a.width), e.setAttribute("height", s.height || a.height), this.filterManager = t;
      var l = createNS("feGaussianBlur");
      l.setAttribute("in", "SourceAlpha"), l.setAttribute("result", i + "_drop_shadow_1"), l.setAttribute("stdDeviation", "0"), this.feGaussianBlur = l, e.appendChild(l);
      var o = createNS("feOffset");
      o.setAttribute("dx", "25"), o.setAttribute("dy", "0"), o.setAttribute("in", i + "_drop_shadow_1"), o.setAttribute("result", i + "_drop_shadow_2"), this.feOffset = o, e.appendChild(o);
      var c = createNS("feFlood");
      c.setAttribute("flood-color", "#00ff00"), c.setAttribute("flood-opacity", "1"), c.setAttribute("result", i + "_drop_shadow_3"), this.feFlood = c, e.appendChild(c);
      var f = createNS("feComposite");
      f.setAttribute("in", i + "_drop_shadow_3"), f.setAttribute("in2", i + "_drop_shadow_2"), f.setAttribute("operator", "in"), f.setAttribute("result", i + "_drop_shadow_4"), e.appendChild(f);
      var x = this.createMergeNode(i, [i + "_drop_shadow_4", n]);
      e.appendChild(x);
    }
    extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        if ((e || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), e || this.filterManager.effectElements[0].p._mdf) {
          var t = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(t[0] * 255), Math.round(t[1] * 255), Math.round(t[2] * 255)));
        }
        if ((e || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), e || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var r = this.filterManager.effectElements[3].p.v, i = (this.filterManager.effectElements[2].p.v - 90) * degToRads, n = r * Math.cos(i), a = r * Math.sin(i);
          this.feOffset.setAttribute("dx", n), this.feOffset.setAttribute("dy", a);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(e, t, r) {
      this.initialized = !1, this.filterManager = t, this.filterElem = e, this.elem = r, r.matteElement = createNS("g"), r.matteElement.appendChild(r.layerElement), r.matteElement.appendChild(r.transformedElement), r.baseElement = r.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(e) {
      for (var t = 0, r = _svgMatteSymbols.length; t < r; ) {
        if (_svgMatteSymbols[t] === e)
          return _svgMatteSymbols[t];
        t += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(e, t) {
      var r = e.layerElement.parentNode;
      if (r) {
        for (var i = r.children, n = 0, a = i.length; n < a && i[n] !== e.layerElement; )
          n += 1;
        var s;
        n <= a - 2 && (s = i[n + 1]);
        var l = createNS("use");
        l.setAttribute("href", "#" + t), s ? r.insertBefore(l, s) : r.appendChild(l);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(e, t) {
      if (!this.findSymbol(t)) {
        var r = createElementID(), i = createNS("mask");
        i.setAttribute("id", t.layerId), i.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(t);
        var n = e.globalData.defs;
        n.appendChild(i);
        var a = createNS("symbol");
        a.setAttribute("id", r), this.replaceInParent(t, r), a.appendChild(t.layerElement), n.appendChild(a);
        var s = createNS("use");
        s.setAttribute("href", "#" + r), i.appendChild(s), t.data.hd = !1, t.show();
      }
      e.setMatte(t.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var e = this.filterManager.effectElements[0].p.v, t = this.elem.comp.elements, r = 0, i = t.length; r < i; )
        t[r] && t[r].data.ind === e && this.setElementAsMask(this.elem, t[r]), r += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    };
    function SVGGaussianBlurEffect(e, t, r, i) {
      e.setAttribute("x", "-100%"), e.setAttribute("y", "-100%"), e.setAttribute("width", "300%"), e.setAttribute("height", "300%"), this.filterManager = t;
      var n = createNS("feGaussianBlur");
      n.setAttribute("result", i), e.appendChild(n), this.feGaussianBlur = n;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = 0.3, r = this.filterManager.effectElements[0].p.v * t, i = this.filterManager.effectElements[1].p.v, n = i == 3 ? 0 : r, a = i == 2 ? 0 : r;
        this.feGaussianBlur.setAttribute("stdDeviation", n + " " + a);
        var s = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", s);
      }
    };
    function TransformEffect() {
    }
    TransformEffect.prototype.init = function(e) {
      this.effectsManager = e, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(e) {
      if (this._opMdf = !1, this._mdf = !1, e || this.effectsManager._mdf) {
        var t = this.effectsManager.effectElements, r = t[0].p.v, i = t[1].p.v, n = t[2].p.v === 1, a = t[3].p.v, s = n ? a : t[4].p.v, l = t[5].p.v, o = t[6].p.v, c = t[7].p.v;
        this.matrix.reset(), this.matrix.translate(-r[0], -r[1], r[2]), this.matrix.scale(s * 0.01, a * 0.01, 1), this.matrix.rotate(-c * degToRads), this.matrix.skewFromAxis(-l * degToRads, (o + 90) * degToRads), this.matrix.translate(i[0], i[1], 0), this._mdf = !0, this.opacity !== t[8].p.v && (this.opacity = t[8].p.v, this._opMdf = !0);
      }
    };
    function SVGTransformEffect(e, t) {
      this.init(t);
    }
    extendPrototype([TransformEffect], SVGTransformEffect);
    function CVTransformEffect(e) {
      this.init(e);
    }
    return extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  });
})(lottie$1, lottie$1.exports);
var lottieExports = lottie$1.exports;
const lottie = /* @__PURE__ */ getDefaultExportFromCjs(lottieExports), bannner$2 = "_bannner_vdb14_1", bannerFlex$2 = "_bannerFlex_vdb14_14", bannerText$2 = "_bannerText_vdb14_20", styles$2 = {
  bannner: bannner$2,
  bannerFlex: bannerFlex$2,
  bannerText: bannerText$2
}, leftBannerDesc = (e) => {
  var r, i, n, a, s, l, o, c, f, x, m, A, M, d, C, u;
  const { lang: t } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.leftBannerDesc, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.leftBannerItem, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.leftBannerTitle, children: (i = (r = t == null ? void 0 : t.getStarted) == null ? void 0 : r.leftBanner) == null ? void 0 : i.free }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.leftBannerText, children: (a = (n = t == null ? void 0 : t.getStarted) == null ? void 0 : n.leftBanner) == null ? void 0 : a.lifetime })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.leftBannerItem, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.leftBannerTitle, children: (l = (s = t == null ? void 0 : t.getStarted) == null ? void 0 : s.leftBanner) == null ? void 0 : l.quick }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.leftBannerText, children: (c = (o = t == null ? void 0 : t.getStarted) == null ? void 0 : o.leftBanner) == null ? void 0 : c.production })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.leftBannerItem, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.leftBannerTitle, children: (x = (f = t == null ? void 0 : t.getStarted) == null ? void 0 : f.leftBanner) == null ? void 0 : x.aIAssisted }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.leftBannerText, children: (A = (m = t == null ? void 0 : t.getStarted) == null ? void 0 : m.leftBanner) == null ? void 0 : A.resumeEditing })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$3.leftBannerItem, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.leftBannerTitle, children: (d = (M = t == null ? void 0 : t.getStarted) == null ? void 0 : M.leftBanner) == null ? void 0 : d.aGoodResume }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$3.leftBannerText, children: (u = (C = t == null ? void 0 : t.getStarted) == null ? void 0 : C.leftBanner) == null ? void 0 : u.aGoodResumeDesc })
    ] })
  ] });
}, v = "5.9.6", fr = 20, ip = 0, op = 100, w = 400, h = 652, nm = "Resume login", ddd = 0, assets = [
  {
    id: "image_0",
    w: 800,
    h: 1304,
    u: "",
    p: "data:image/jpeg;base64,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",
    e: 1
  },
  {
    id: "comp_0",
    nm: "Frame 427322988",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Vector 1846",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 0,
                s: [
                  0
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 5.333,
                s: [
                  100
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 55.667,
                s: [
                  100
                ]
              },
              {
                t: 67.3333333333333,
                s: [
                  0
                ]
              }
            ],
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                t: 0,
                s: [
                  130.953,
                  12.079,
                  0
                ],
                to: [
                  137.667,
                  231.167,
                  0
                ],
                ti: [
                  -114.667,
                  -182.167,
                  0
                ]
              },
              {
                t: 60,
                s: [
                  132.953,
                  517.079,
                  0
                ]
              }
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              8.422,
                              5.015
                            ],
                            [
                              11.047,
                              9.39
                            ],
                            [
                              -18.203,
                              -5.235
                            ],
                            [
                              -12.833,
                              1.167
                            ]
                          ],
                          o: [
                            [
                              -12.453,
                              -4.235
                            ],
                            [
                              5.25,
                              10.25
                            ],
                            [
                              11.792,
                              3.392
                            ],
                            [
                              -19.21,
                              -2.06
                            ]
                          ],
                          v: [
                            [
                              -3.125,
                              6.156
                            ],
                            [
                              -33.25,
                              -2.844
                            ],
                            [
                              -6.5,
                              12.531
                            ],
                            [
                              18.875,
                              15.281
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 20,
                      s: [
                        {
                          i: [
                            [
                              6.348,
                              3.849
                            ],
                            [
                              6.348,
                              1.849
                            ],
                            [
                              -21.977,
                              -6.884
                            ],
                            [
                              -3.069,
                              4.516
                            ]
                          ],
                          o: [
                            [
                              -6.152,
                              -1.651
                            ],
                            [
                              -11.902,
                              5.349
                            ],
                            [
                              11.728,
                              3.594
                            ],
                            [
                              -6.819,
                              -7.984
                            ]
                          ],
                          v: [
                            [
                              -5.5,
                              12.531
                            ],
                            [
                              -18.75,
                              5.031
                            ],
                            [
                              -9.167,
                              23.281
                            ],
                            [
                              7.417,
                              17.364
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 42.333,
                      s: [
                        {
                          i: [
                            [
                              28.176,
                              6.814
                            ],
                            [
                              9.676,
                              -12.58
                            ],
                            [
                              -26.19,
                              -8.725
                            ],
                            [
                              -4.91,
                              -5.121
                            ]
                          ],
                          o: [
                            [
                              -16.074,
                              -2.436
                            ],
                            [
                              10.426,
                              1.67
                            ],
                            [
                              15.756,
                              4.854
                            ],
                            [
                              3.84,
                              -3.121
                            ]
                          ],
                          v: [
                            [
                              0.204,
                              -8.675
                            ],
                            [
                              -36.296,
                              -3.032
                            ],
                            [
                              -2.876,
                              4.035
                            ],
                            [
                              16.04,
                              16.259
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 60,
                      s: [
                        {
                          i: [
                            [
                              17.551,
                              12.826
                            ],
                            [
                              14.513,
                              14.26
                            ],
                            [
                              -29.524,
                              -10.181
                            ],
                            [
                              -12.833,
                              1.167
                            ]
                          ],
                          o: [
                            [
                              -19.68,
                              3.329
                            ],
                            [
                              5.25,
                              10.25
                            ],
                            [
                              11.6,
                              4
                            ],
                            [
                              -19.21,
                              -2.06
                            ]
                          ],
                          v: [
                            [
                              -2,
                              -1.719
                            ],
                            [
                              -45.25,
                              -17.469
                            ],
                            [
                              -7.75,
                              14.781
                            ],
                            [
                              45.25,
                              16.281
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0.028,
                      0.827,
                      0.906,
                      0.992,
                      0.514,
                      0.914,
                      0.953,
                      0.996,
                      1,
                      1,
                      1,
                      1
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    0,
                    33.623
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    -11.945,
                    -2.877
                  ],
                  ix: 6
                },
                t: 1,
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 1846",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Vector 1848",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 0,
                s: [
                  0
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 7,
                s: [
                  50
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 56,
                s: [
                  50
                ]
              },
              {
                t: 67.6666666666667,
                s: [
                  0
                ]
              }
            ],
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                t: 0,
                s: [
                  132.953,
                  37.079,
                  0
                ],
                to: [
                  137.667,
                  231.167,
                  0
                ],
                ti: [
                  -114.667,
                  -182.167,
                  0
                ]
              },
              {
                t: 60.3333333333333,
                s: [
                  142.953,
                  537.079,
                  0
                ]
              }
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        ef: [
          {
            ty: 29,
            nm: "高斯模糊",
            np: 5,
            mn: "ADBE Gaussian Blur 2",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 0,
                nm: "模糊度",
                mn: "ADBE Gaussian Blur 2-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 20,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "模糊方向",
                mn: "ADBE Gaussian Blur 2-0002",
                ix: 2,
                v: {
                  a: 0,
                  k: 1,
                  ix: 2
                }
              },
              {
                ty: 7,
                nm: "重复边缘像素",
                mn: "ADBE Gaussian Blur 2-0003",
                ix: 3,
                v: {
                  a: 0,
                  k: 0,
                  ix: 3
                }
              }
            ]
          }
        ],
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              8.422,
                              5.015
                            ],
                            [
                              11.047,
                              9.39
                            ],
                            [
                              -18.203,
                              -5.235
                            ],
                            [
                              -12.833,
                              1.167
                            ]
                          ],
                          o: [
                            [
                              -12.453,
                              -4.235
                            ],
                            [
                              5.25,
                              10.25
                            ],
                            [
                              11.792,
                              3.392
                            ],
                            [
                              -19.21,
                              -2.06
                            ]
                          ],
                          v: [
                            [
                              -3.125,
                              6.156
                            ],
                            [
                              -33.25,
                              -2.844
                            ],
                            [
                              -6.5,
                              12.531
                            ],
                            [
                              18.875,
                              15.281
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 20,
                      s: [
                        {
                          i: [
                            [
                              6.348,
                              3.849
                            ],
                            [
                              6.348,
                              1.849
                            ],
                            [
                              -21.977,
                              -6.884
                            ],
                            [
                              -3.069,
                              4.516
                            ]
                          ],
                          o: [
                            [
                              -6.152,
                              -1.651
                            ],
                            [
                              -11.902,
                              5.349
                            ],
                            [
                              11.728,
                              3.594
                            ],
                            [
                              -6.819,
                              -7.984
                            ]
                          ],
                          v: [
                            [
                              -5.5,
                              12.531
                            ],
                            [
                              -18.75,
                              5.031
                            ],
                            [
                              -9.167,
                              23.281
                            ],
                            [
                              7.417,
                              17.364
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 42.333,
                      s: [
                        {
                          i: [
                            [
                              28.176,
                              6.814
                            ],
                            [
                              9.676,
                              -12.58
                            ],
                            [
                              -26.19,
                              -8.725
                            ],
                            [
                              -4.91,
                              -5.121
                            ]
                          ],
                          o: [
                            [
                              -16.074,
                              -2.436
                            ],
                            [
                              10.426,
                              1.67
                            ],
                            [
                              15.756,
                              4.854
                            ],
                            [
                              3.84,
                              -3.121
                            ]
                          ],
                          v: [
                            [
                              0.204,
                              -8.675
                            ],
                            [
                              -36.296,
                              -3.032
                            ],
                            [
                              -2.876,
                              4.035
                            ],
                            [
                              16.04,
                              16.259
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 60,
                      s: [
                        {
                          i: [
                            [
                              17.551,
                              12.826
                            ],
                            [
                              14.513,
                              14.26
                            ],
                            [
                              -29.524,
                              -10.181
                            ],
                            [
                              -12.833,
                              1.167
                            ]
                          ],
                          o: [
                            [
                              -19.68,
                              3.329
                            ],
                            [
                              5.25,
                              10.25
                            ],
                            [
                              11.6,
                              4
                            ],
                            [
                              -19.21,
                              -2.06
                            ]
                          ],
                          v: [
                            [
                              -2,
                              -1.719
                            ],
                            [
                              -45.25,
                              -17.469
                            ],
                            [
                              -7.75,
                              14.781
                            ],
                            [
                              45.25,
                              16.281
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0.026,
                      0.164,
                      0.562,
                      1,
                      0.224,
                      0.51,
                      0.743,
                      1,
                      0.422,
                      0.856,
                      0.925,
                      1
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -8.354,
                    8.789
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    -9.52,
                    -2.293
                  ],
                  ix: 6
                },
                t: 1,
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 1848",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 1
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Vector 1844",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 0,
                s: [
                  0
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 8.333,
                s: [
                  100
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 65.333,
                s: [
                  100
                ]
              },
              {
                t: 77,
                s: [
                  0
                ]
              }
            ],
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                t: 0,
                s: [
                  27.819,
                  8.755,
                  0
                ],
                to: [
                  20.167,
                  200.667,
                  0
                ],
                ti: [
                  8.833,
                  -257.667,
                  0
                ]
              },
              {
                t: 72,
                s: [
                  327.819,
                  439.755,
                  0
                ]
              }
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              36,
                              7.25
                            ],
                            [
                              32.506,
                              -8.597
                            ],
                            [
                              -21.562,
                              7.316
                            ],
                            [
                              -2.583,
                              21.417
                            ]
                          ],
                          o: [
                            [
                              -13.819,
                              12.737
                            ],
                            [
                              8.417,
                              3.917
                            ],
                            [
                              33.6,
                              -11.4
                            ],
                            [
                              -6,
                              12
                            ]
                          ],
                          v: [
                            [
                              1.5,
                              16.508
                            ],
                            [
                              -37.5,
                              44.508
                            ],
                            [
                              8.75,
                              36.508
                            ],
                            [
                              21.5,
                              13.008
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 23.889,
                      s: [
                        {
                          i: [
                            [
                              36,
                              7.25
                            ],
                            [
                              17.164,
                              -11.073
                            ],
                            [
                              -21.562,
                              7.316
                            ],
                            [
                              -14.169,
                              17.927
                            ]
                          ],
                          o: [
                            [
                              -48.503,
                              4.594
                            ],
                            [
                              8.417,
                              3.917
                            ],
                            [
                              33.6,
                              -11.4
                            ],
                            [
                              -6,
                              12
                            ]
                          ],
                          v: [
                            [
                              21.667,
                              19.008
                            ],
                            [
                              -44.5,
                              42.675
                            ],
                            [
                              53.75,
                              31.008
                            ],
                            [
                              89.333,
                              5.675
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 50.565,
                      s: [
                        {
                          i: [
                            [
                              36,
                              7.25
                            ],
                            [
                              25.73,
                              -9.69
                            ],
                            [
                              -21.563,
                              7.316
                            ],
                            [
                              -7.701,
                              19.876
                            ]
                          ],
                          o: [
                            [
                              -30.355,
                              17.621
                            ],
                            [
                              8.417,
                              3.917
                            ],
                            [
                              33.6,
                              -11.4
                            ],
                            [
                              -6,
                              12
                            ]
                          ],
                          v: [
                            [
                              12.024,
                              12.712
                            ],
                            [
                              -38.317,
                              68.128
                            ],
                            [
                              18.625,
                              37.579
                            ],
                            [
                              93.618,
                              46.561
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 71.6666666666667,
                      s: [
                        {
                          i: [
                            [
                              36,
                              7.25
                            ],
                            [
                              32.506,
                              -8.597
                            ],
                            [
                              -21.562,
                              7.316
                            ],
                            [
                              -2.583,
                              21.417
                            ]
                          ],
                          o: [
                            [
                              -15.999,
                              27.927
                            ],
                            [
                              8.417,
                              3.917
                            ],
                            [
                              33.6,
                              -11.4
                            ],
                            [
                              -6,
                              12
                            ]
                          ],
                          v: [
                            [
                              3.5,
                              -7.492
                            ],
                            [
                              -58.5,
                              39.008
                            ],
                            [
                              8.75,
                              36.508
                            ],
                            [
                              58.5,
                              -41.992
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 5,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      0.283,
                      1,
                      1,
                      1,
                      0.565,
                      1,
                      1,
                      1,
                      0.782,
                      0.983,
                      0.977,
                      1,
                      0.999,
                      0.965,
                      0.954,
                      1
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -12.819,
                    -26.255
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    91.12,
                    -26.255
                  ],
                  ix: 6
                },
                t: 2,
                h: {
                  a: 0,
                  k: 0,
                  ix: 7
                },
                a: {
                  a: 0,
                  k: 0,
                  ix: 8
                },
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 1844",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Vector 1847",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 0,
                s: [
                  0
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 6.667,
                s: [
                  50
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 65.667,
                s: [
                  50
                ]
              },
              {
                t: 77.3333333333333,
                s: [
                  0
                ]
              }
            ],
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                t: 0,
                s: [
                  41.819,
                  28.755,
                  0
                ],
                to: [
                  20.167,
                  200.667,
                  0
                ],
                ti: [
                  8.833,
                  -257.667,
                  0
                ]
              },
              {
                t: 72,
                s: [
                  328.819,
                  472.755,
                  0
                ]
              }
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        ef: [
          {
            ty: 29,
            nm: "高斯模糊",
            np: 5,
            mn: "ADBE Gaussian Blur 2",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 0,
                nm: "模糊度",
                mn: "ADBE Gaussian Blur 2-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 56,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "模糊方向",
                mn: "ADBE Gaussian Blur 2-0002",
                ix: 2,
                v: {
                  a: 0,
                  k: 1,
                  ix: 2
                }
              },
              {
                ty: 7,
                nm: "重复边缘像素",
                mn: "ADBE Gaussian Blur 2-0003",
                ix: 3,
                v: {
                  a: 0,
                  k: 0,
                  ix: 3
                }
              }
            ]
          }
        ],
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 11.667,
                      s: [
                        {
                          i: [
                            [
                              36,
                              7.25
                            ],
                            [
                              32.506,
                              -8.597
                            ],
                            [
                              -21.562,
                              7.316
                            ],
                            [
                              -2.583,
                              21.417
                            ]
                          ],
                          o: [
                            [
                              -13.819,
                              12.737
                            ],
                            [
                              8.417,
                              3.917
                            ],
                            [
                              33.6,
                              -11.4
                            ],
                            [
                              -6,
                              12
                            ]
                          ],
                          v: [
                            [
                              1.5,
                              16.508
                            ],
                            [
                              -37.5,
                              44.508
                            ],
                            [
                              8.75,
                              36.508
                            ],
                            [
                              21.5,
                              13.008
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 31.667,
                      s: [
                        {
                          i: [
                            [
                              36,
                              7.25
                            ],
                            [
                              17.164,
                              -11.073
                            ],
                            [
                              -21.562,
                              7.316
                            ],
                            [
                              -14.169,
                              17.927
                            ]
                          ],
                          o: [
                            [
                              -48.503,
                              4.594
                            ],
                            [
                              8.417,
                              3.917
                            ],
                            [
                              33.6,
                              -11.4
                            ],
                            [
                              -6,
                              12
                            ]
                          ],
                          v: [
                            [
                              21.667,
                              19.008
                            ],
                            [
                              -44.5,
                              42.675
                            ],
                            [
                              53.75,
                              31.008
                            ],
                            [
                              89.333,
                              5.675
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 54,
                      s: [
                        {
                          i: [
                            [
                              36,
                              7.25
                            ],
                            [
                              25.73,
                              -9.69
                            ],
                            [
                              -21.563,
                              7.316
                            ],
                            [
                              -7.701,
                              19.876
                            ]
                          ],
                          o: [
                            [
                              -30.355,
                              17.621
                            ],
                            [
                              8.417,
                              3.917
                            ],
                            [
                              33.6,
                              -11.4
                            ],
                            [
                              -6,
                              12
                            ]
                          ],
                          v: [
                            [
                              12.024,
                              12.712
                            ],
                            [
                              -38.317,
                              68.128
                            ],
                            [
                              18.625,
                              37.579
                            ],
                            [
                              93.618,
                              46.561
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 71.6666666666667,
                      s: [
                        {
                          i: [
                            [
                              36,
                              7.25
                            ],
                            [
                              32.506,
                              -8.597
                            ],
                            [
                              -21.562,
                              7.316
                            ],
                            [
                              -2.583,
                              21.417
                            ]
                          ],
                          o: [
                            [
                              -15.999,
                              27.927
                            ],
                            [
                              8.417,
                              3.917
                            ],
                            [
                              33.6,
                              -11.4
                            ],
                            [
                              -6,
                              12
                            ]
                          ],
                          v: [
                            [
                              3.5,
                              -7.492
                            ],
                            [
                              -58.5,
                              39.008
                            ],
                            [
                              8.75,
                              36.508
                            ],
                            [
                              58.5,
                              -41.992
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 5,
                  k: {
                    a: 0,
                    k: [
                      0,
                      0.517,
                      0.577,
                      1,
                      0.179,
                      0.412,
                      0.53,
                      1,
                      0.358,
                      0.306,
                      0.483,
                      1,
                      0.679,
                      0.385,
                      0.61,
                      1,
                      1,
                      0.463,
                      0.737,
                      1
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -7.918,
                    -12.083
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    0,
                    10.725
                  ],
                  ix: 6
                },
                t: 1,
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 15.809,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 1847",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 1
      },
      {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Vector 1845",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 0,
                s: [
                  0
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 14.333,
                s: [
                  100
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 92,
                s: [
                  100
                ]
              },
              {
                t: 99.6666666666667,
                s: [
                  0
                ]
              }
            ],
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                t: 14.333,
                s: [
                  308.562,
                  38.337,
                  0
                ],
                to: [
                  179,
                  311,
                  0
                ],
                ti: [
                  -33,
                  -165,
                  0
                ]
              },
              {
                t: 97.3333333333333,
                s: [
                  38.562,
                  524.337,
                  0
                ]
              }
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 14.333,
                      s: [
                        {
                          i: [
                            [
                              16,
                              -3.4
                            ],
                            [
                              0.583,
                              6.333
                            ],
                            [
                              -12.334,
                              7.683
                            ],
                            [
                              -10.834,
                              2.876
                            ]
                          ],
                          o: [
                            [
                              -16,
                              3.4
                            ],
                            [
                              18.149,
                              1.982
                            ],
                            [
                              10.104,
                              4.356
                            ],
                            [
                              -8,
                              6.083
                            ]
                          ],
                          v: [
                            [
                              4.875,
                              10.699
                            ],
                            [
                              -23.125,
                              3.449
                            ],
                            [
                              4.625,
                              -10.801
                            ],
                            [
                              14.125,
                              -1.551
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 42.497,
                      s: [
                        {
                          i: [
                            [
                              16,
                              -3.4
                            ],
                            [
                              0.583,
                              6.333
                            ],
                            [
                              -12.334,
                              7.683
                            ],
                            [
                              -10.834,
                              2.876
                            ]
                          ],
                          o: [
                            [
                              -16,
                              3.4
                            ],
                            [
                              18.149,
                              1.982
                            ],
                            [
                              10.104,
                              4.356
                            ],
                            [
                              -18.141,
                              10.142
                            ]
                          ],
                          v: [
                            [
                              -1.551,
                              19.541
                            ],
                            [
                              -32.736,
                              8.514
                            ],
                            [
                              -3.412,
                              -7.079
                            ],
                            [
                              19.569,
                              -1.755
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 71.818,
                      s: [
                        {
                          i: [
                            [
                              16,
                              -3.4
                            ],
                            [
                              14.63,
                              -17.604
                            ],
                            [
                              -12.334,
                              7.683
                            ],
                            [
                              -10.834,
                              2.876
                            ]
                          ],
                          o: [
                            [
                              -16,
                              3.4
                            ],
                            [
                              1.631,
                              -19.15
                            ],
                            [
                              10.104,
                              4.356
                            ],
                            [
                              -12.549,
                              7.904
                            ]
                          ],
                          v: [
                            [
                              -0.436,
                              41.859
                            ],
                            [
                              -57.409,
                              61.738
                            ],
                            [
                              -34.702,
                              21.076
                            ],
                            [
                              19.407,
                              9.343
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 97.6666666666667,
                      s: [
                        {
                          i: [
                            [
                              16,
                              -3.4
                            ],
                            [
                              0.583,
                              6.333
                            ],
                            [
                              -12.334,
                              7.683
                            ],
                            [
                              -10.834,
                              2.876
                            ]
                          ],
                          o: [
                            [
                              -16,
                              3.4
                            ],
                            [
                              18.149,
                              1.982
                            ],
                            [
                              10.104,
                              4.356
                            ],
                            [
                              -8,
                              6.083
                            ]
                          ],
                          v: [
                            [
                              -11.125,
                              10.949
                            ],
                            [
                              -32.875,
                              -3.801
                            ],
                            [
                              5.875,
                              -11.551
                            ],
                            [
                              32.875,
                              -11.551
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      0.852,
                      0.903,
                      0.933,
                      0.5,
                      0.926,
                      0.951,
                      0.967,
                      1,
                      1,
                      1,
                      1
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    32.875,
                    -4.587
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    -13.562,
                    -1.587
                  ],
                  ix: 6
                },
                t: 1,
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 1845",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Vector 1846",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 8.333,
                s: [
                  0
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 14.333,
                s: [
                  60
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 92,
                s: [
                  60
                ]
              },
              {
                t: 99.6666666666667,
                s: [
                  0
                ]
              }
            ],
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                t: 14.333,
                s: [
                  308.562,
                  67.337,
                  0
                ],
                to: [
                  179,
                  311,
                  0
                ],
                ti: [
                  -33,
                  -165,
                  0
                ]
              },
              {
                t: 97.6666666666667,
                s: [
                  45.562,
                  546.337,
                  0
                ]
              }
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        ef: [
          {
            ty: 29,
            nm: "高斯模糊",
            np: 5,
            mn: "ADBE Gaussian Blur 2",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 0,
                nm: "模糊度",
                mn: "ADBE Gaussian Blur 2-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 44,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "模糊方向",
                mn: "ADBE Gaussian Blur 2-0002",
                ix: 2,
                v: {
                  a: 0,
                  k: 1,
                  ix: 2
                }
              },
              {
                ty: 7,
                nm: "重复边缘像素",
                mn: "ADBE Gaussian Blur 2-0003",
                ix: 3,
                v: {
                  a: 0,
                  k: 0,
                  ix: 3
                }
              }
            ]
          }
        ],
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 25.333,
                      s: [
                        {
                          i: [
                            [
                              16,
                              -3.4
                            ],
                            [
                              0.583,
                              6.333
                            ],
                            [
                              -12.334,
                              7.683
                            ],
                            [
                              -10.834,
                              2.876
                            ]
                          ],
                          o: [
                            [
                              -16,
                              3.4
                            ],
                            [
                              18.149,
                              1.982
                            ],
                            [
                              10.104,
                              4.356
                            ],
                            [
                              -8,
                              6.083
                            ]
                          ],
                          v: [
                            [
                              4.875,
                              10.699
                            ],
                            [
                              -23.125,
                              3.449
                            ],
                            [
                              4.625,
                              -10.801
                            ],
                            [
                              14.125,
                              -1.551
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 49.667,
                      s: [
                        {
                          i: [
                            [
                              16,
                              -3.4
                            ],
                            [
                              0.583,
                              6.333
                            ],
                            [
                              -12.334,
                              7.683
                            ],
                            [
                              -10.834,
                              2.876
                            ]
                          ],
                          o: [
                            [
                              -16,
                              3.4
                            ],
                            [
                              18.149,
                              1.982
                            ],
                            [
                              10.104,
                              4.356
                            ],
                            [
                              -18.141,
                              10.142
                            ]
                          ],
                          v: [
                            [
                              -1.551,
                              19.541
                            ],
                            [
                              -32.736,
                              8.514
                            ],
                            [
                              -3.412,
                              -7.079
                            ],
                            [
                              19.569,
                              -1.755
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 75,
                      s: [
                        {
                          i: [
                            [
                              16,
                              -3.4
                            ],
                            [
                              14.63,
                              -17.604
                            ],
                            [
                              -12.334,
                              7.683
                            ],
                            [
                              -10.834,
                              2.876
                            ]
                          ],
                          o: [
                            [
                              -16,
                              3.4
                            ],
                            [
                              1.631,
                              -19.15
                            ],
                            [
                              10.104,
                              4.356
                            ],
                            [
                              -12.549,
                              7.904
                            ]
                          ],
                          v: [
                            [
                              -0.436,
                              41.859
                            ],
                            [
                              -57.409,
                              61.738
                            ],
                            [
                              -34.702,
                              21.076
                            ],
                            [
                              19.407,
                              9.343
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 97.6666666666667,
                      s: [
                        {
                          i: [
                            [
                              16,
                              -3.4
                            ],
                            [
                              0.583,
                              6.333
                            ],
                            [
                              -12.334,
                              7.683
                            ],
                            [
                              -10.834,
                              2.876
                            ]
                          ],
                          o: [
                            [
                              -16,
                              3.4
                            ],
                            [
                              18.149,
                              1.982
                            ],
                            [
                              10.104,
                              4.356
                            ],
                            [
                              -8,
                              6.083
                            ]
                          ],
                          v: [
                            [
                              -11.125,
                              10.949
                            ],
                            [
                              -32.875,
                              -3.801
                            ],
                            [
                              5.875,
                              -11.551
                            ],
                            [
                              32.875,
                              -11.551
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0.028,
                      0.827,
                      0.906,
                      0.992,
                      0.514,
                      0.914,
                      0.953,
                      0.996,
                      1,
                      1,
                      1,
                      1
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -8.399,
                    43.073
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    -0.724,
                    -14.136
                  ],
                  ix: 6
                },
                t: 1,
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 1846",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      }
    ]
  },
  {
    id: "comp_1",
    nm: "Frame 427322877",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Vector 3813",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 68.333,
                s: [
                  100
                ]
              },
              {
                t: 85.6666666666667,
                s: [
                  0
                ]
              }
            ],
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              111.736,
              145.587,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              130,
              130,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        ef: [
          {
            ty: 29,
            nm: "高斯模糊",
            np: 5,
            mn: "ADBE Gaussian Blur 2",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 0,
                nm: "模糊度",
                mn: "ADBE Gaussian Blur 2-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 6,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "模糊方向",
                mn: "ADBE Gaussian Blur 2-0002",
                ix: 2,
                v: {
                  a: 0,
                  k: 1,
                  ix: 2
                }
              },
              {
                ty: 7,
                nm: "重复边缘像素",
                mn: "ADBE Gaussian Blur 2-0003",
                ix: 3,
                v: {
                  a: 0,
                  k: 0,
                  ix: 3
                }
              }
            ]
          }
        ],
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 34.667,
                      s: [
                        {
                          i: [
                            [
                              -0.065,
                              0.81
                            ],
                            [
                              -0.838,
                              -0.032
                            ],
                            [
                              0.218,
                              -0.402
                            ],
                            [
                              0.053,
                              -0.855
                            ],
                            [
                              0.526,
                              -0.654
                            ],
                            [
                              1.723,
                              0.482
                            ],
                            [
                              -0.027,
                              -0.304
                            ]
                          ],
                          o: [
                            [
                              0.31,
                              -0.408
                            ],
                            [
                              0.475,
                              -0.188
                            ],
                            [
                              0.125,
                              0.254
                            ],
                            [
                              0.147,
                              0.27
                            ],
                            [
                              -0.099,
                              0.565
                            ],
                            [
                              -1.559,
                              -1.05
                            ],
                            [
                              -0.059,
                              -0.992
                            ]
                          ],
                          v: [
                            [
                              -1.609,
                              10.384
                            ],
                            [
                              8e-3,
                              9.57
                            ],
                            [
                              1.608,
                              10.534
                            ],
                            [
                              2.961,
                              12.955
                            ],
                            [
                              1.894,
                              16.192
                            ],
                            [
                              -1.365,
                              17.556
                            ],
                            [
                              -2.115,
                              13.874
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 75.6666666666667,
                      s: [
                        {
                          i: [
                            [
                              0,
                              6.512
                            ],
                            [
                              -3.637,
                              -0.059
                            ],
                            [
                              1.408,
                              -2.605
                            ],
                            [
                              -2.552,
                              -2.464
                            ],
                            [
                              0.264,
                              -2.376
                            ],
                            [
                              4.048,
                              -1.848
                            ],
                            [
                              1.144,
                              3.52
                            ]
                          ],
                          o: [
                            [
                              0,
                              -7.395
                            ],
                            [
                              -0.88,
                              0.851
                            ],
                            [
                              -1.76,
                              3.256
                            ],
                            [
                              2.552,
                              2.464
                            ],
                            [
                              -0.264,
                              2.376
                            ],
                            [
                              2.288,
                              -4.84
                            ],
                            [
                              -1.144,
                              -3.52
                            ]
                          ],
                          v: [
                            [
                              -5.765,
                              -8.491
                            ],
                            [
                              4.883,
                              -17.555
                            ],
                            [
                              0.483,
                              -11.747
                            ],
                            [
                              3.211,
                              -2.42
                            ],
                            [
                              5.675,
                              7.348
                            ],
                            [
                              -1.365,
                              17.556
                            ],
                            [
                              -1.365,
                              4.092
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      0.5,
                      1,
                      1,
                      1,
                      1,
                      1,
                      1,
                      1,
                      0,
                      1,
                      0.5,
                      0.5,
                      1,
                      0
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    0,
                    -17.556
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    4.3,
                    14.908
                  ],
                  ix: 6
                },
                t: 1,
                nm: `gradient
 1`,
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 3813",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Vector 3812",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 34.667,
                s: [
                  100
                ]
              },
              {
                t: 61.6666666666667,
                s: [
                  0
                ]
              }
            ],
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              100.742,
              128.745,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              130,
              130,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        ef: [
          {
            ty: 29,
            nm: "高斯模糊",
            np: 5,
            mn: "ADBE Gaussian Blur 2",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 0,
                nm: "模糊度",
                mn: "ADBE Gaussian Blur 2-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 6,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "模糊方向",
                mn: "ADBE Gaussian Blur 2-0002",
                ix: 2,
                v: {
                  a: 0,
                  k: 1,
                  ix: 2
                }
              },
              {
                ty: 7,
                nm: "重复边缘像素",
                mn: "ADBE Gaussian Blur 2-0003",
                ix: 3,
                v: {
                  a: 0,
                  k: 0,
                  ix: 3
                }
              }
            ]
          }
        ],
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 15,
                      s: [
                        {
                          i: [
                            [
                              -0.715,
                              0.722
                            ],
                            [
                              -1.487,
                              0.932
                            ],
                            [
                              -0.558,
                              -1.318
                            ],
                            [
                              0.835,
                              -0.544
                            ],
                            [
                              3.112,
                              -0.858
                            ],
                            [
                              0.616,
                              0
                            ],
                            [
                              -2.182,
                              0.315
                            ]
                          ],
                          o: [
                            [
                              1.059,
                              -1.068
                            ],
                            [
                              0.888,
                              0.057
                            ],
                            [
                              0.612,
                              0.564
                            ],
                            [
                              -0.165,
                              0.768
                            ],
                            [
                              -2.219,
                              0.612
                            ],
                            [
                              -2.725,
                              -0.777
                            ],
                            [
                              2.182,
                              -0.315
                            ]
                          ],
                          v: [
                            [
                              -1.864,
                              28.824
                            ],
                            [
                              0.869,
                              27.448
                            ],
                            [
                              3.021,
                              28.566
                            ],
                            [
                              3.423,
                              32.112
                            ],
                            [
                              0.414,
                              33.394
                            ],
                            [
                              -3.33,
                              33.783
                            ],
                            [
                              -5.359,
                              30.306
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 48.6666666666667,
                      s: [
                        {
                          i: [
                            [
                              -0.754,
                              6.033
                            ],
                            [
                              2.845,
                              0.616
                            ],
                            [
                              -1.89,
                              -5.997
                            ],
                            [
                              3.515,
                              -4.803
                            ],
                            [
                              -0.719,
                              -3.146
                            ],
                            [
                              0.616,
                              0
                            ],
                            [
                              -2.816,
                              7.92
                            ]
                          ],
                          o: [
                            [
                              0.915,
                              -7.321
                            ],
                            [
                              3.653,
                              -1.557
                            ],
                            [
                              1.292,
                              4.1
                            ],
                            [
                              -4.844,
                              6.62
                            ],
                            [
                              2.112,
                              9.241
                            ],
                            [
                              -10.032,
                              -11.264
                            ],
                            [
                              2.816,
                              -7.92
                            ]
                          ],
                          v: [
                            [
                              0.199,
                              -13.739
                            ],
                            [
                              -7.193,
                              -24.739
                            ],
                            [
                              6.271,
                              -17.434
                            ],
                            [
                              4.423,
                              -0.45
                            ],
                            [
                              0.727,
                              13.894
                            ],
                            [
                              3.983,
                              25.158
                            ],
                            [
                              -5.609,
                              0.869
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      0.5,
                      1,
                      1,
                      1,
                      1,
                      1,
                      1,
                      1,
                      0,
                      1,
                      0.5,
                      0.5,
                      1,
                      0
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    0,
                    -25.158
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    5.365,
                    21.363
                  ],
                  ix: 6
                },
                t: 1,
                nm: `gradient
 1`,
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 3812",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Vector 3811",
        sr: 1,
        ks: {
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                t: 28,
                s: [
                  100
                ]
              },
              {
                t: 55.3333333333333,
                s: [
                  0
                ]
              }
            ],
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              86.776,
              125.993,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              130,
              130,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        ef: [
          {
            ty: 29,
            nm: "高斯模糊",
            np: 5,
            mn: "ADBE Gaussian Blur 2",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 0,
                nm: "模糊度",
                mn: "ADBE Gaussian Blur 2-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 6,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "模糊方向",
                mn: "ADBE Gaussian Blur 2-0002",
                ix: 2,
                v: {
                  a: 0,
                  k: 1,
                  ix: 2
                }
              },
              {
                ty: 7,
                nm: "重复边缘像素",
                mn: "ADBE Gaussian Blur 2-0003",
                ix: 3,
                v: {
                  a: 0,
                  k: 0,
                  ix: 3
                }
              }
            ]
          }
        ],
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0.177,
                              0.387
                            ],
                            [
                              -1.103,
                              0.157
                            ],
                            [
                              -0.972,
                              -0.096
                            ],
                            [
                              -0.654,
                              -0.69
                            ],
                            [
                              0.49,
                              -0.018
                            ],
                            [
                              1.232,
                              0.401
                            ]
                          ],
                          o: [
                            [
                              -0.104,
                              -0.676
                            ],
                            [
                              -0.165,
                              -0.874
                            ],
                            [
                              0.434,
                              0.841
                            ],
                            [
                              1.596,
                              1.748
                            ],
                            [
                              -1.792,
                              -0.487
                            ],
                            [
                              -2.179,
                              -0.709
                            ]
                          ],
                          v: [
                            [
                              3.859,
                              33.745
                            ],
                            [
                              5.889,
                              32.819
                            ],
                            [
                              8.602,
                              32.103
                            ],
                            [
                              9.909,
                              34.134
                            ],
                            [
                              9.89,
                              36.494
                            ],
                            [
                              6.34,
                              35.278
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 40.3333333333333,
                      s: [
                        {
                          i: [
                            [
                              -2.112,
                              5.632
                            ],
                            [
                              2.699,
                              1.408
                            ],
                            [
                              1.496,
                              -7.398
                            ],
                            [
                              2.816,
                              -7.128
                            ],
                            [
                              -1.672,
                              -2.963
                            ],
                            [
                              0.282,
                              4.083
                            ]
                          ],
                          o: [
                            [
                              1.69,
                              -4.505
                            ],
                            [
                              7.48,
                              0.705
                            ],
                            [
                              -0.597,
                              2.953
                            ],
                            [
                              -2.253,
                              5.702
                            ],
                            [
                              -2.816,
                              -3.256
                            ],
                            [
                              -0.352,
                              -5.104
                            ]
                          ],
                          v: [
                            [
                              0.546,
                              -10.38
                            ],
                            [
                              -6.142,
                              -20.244
                            ],
                            [
                              5.914,
                              -7.647
                            ],
                            [
                              1.69,
                              4.228
                            ],
                            [
                              3.89,
                              20.244
                            ],
                            [
                              -4.91,
                              5.372
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      0.5,
                      1,
                      1,
                      1,
                      1,
                      1,
                      1,
                      1,
                      0,
                      1,
                      0.5,
                      0.5,
                      1,
                      0
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    0,
                    -20.244
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    4.581,
                    17.19
                  ],
                  ix: 6
                },
                t: 1,
                nm: `gradient
 1`,
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 3811",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Ellipse 3721",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              98.624,
              174.022,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    75.684,
                    15.933
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "椭圆路径 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      0.451,
                      0.235,
                      0.098,
                      0.5,
                      0.62,
                      0.386,
                      0.194,
                      1,
                      0.788,
                      0.537,
                      0.29
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -23.338,
                    16.192
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    156.655,
                    16.192
                  ],
                  ix: 6
                },
                t: 2,
                h: {
                  a: 0,
                  k: 0,
                  ix: 7
                },
                a: {
                  a: 0,
                  k: 0,
                  ix: 8
                },
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Ellipse 3721",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Vector 3809 (Stroke)",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              149.996,
              199.09,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        -2.361,
                        0
                      ],
                      [
                        -0.134,
                        2.24
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.217,
                        0.519
                      ],
                      [
                        -0.612,
                        0.732
                      ],
                      [
                        -2.918,
                        -0.157
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.943,
                        -0.703
                      ],
                      [
                        -0.436,
                        -1.304
                      ],
                      [
                        0.085,
                        -1.386
                      ],
                      [
                        0.129,
                        -0.251
                      ],
                      [
                        1.541,
                        -1.08
                      ],
                      [
                        5.134,
                        -1.5
                      ],
                      [
                        0.472,
                        -0.12
                      ],
                      [
                        2.43,
                        -1.094
                      ],
                      [
                        1.765,
                        -4.8
                      ],
                      [
                        -2.216,
                        -0.815
                      ],
                      [
                        -0.815,
                        2.216
                      ],
                      [
                        -2.204,
                        0.992
                      ],
                      [
                        -1.577,
                        0.4
                      ],
                      [
                        -0.711,
                        0.208
                      ],
                      [
                        -2.809,
                        1.969
                      ],
                      [
                        -1.199,
                        2.337
                      ],
                      [
                        -0.134,
                        2.177
                      ],
                      [
                        0.859,
                        2.57
                      ],
                      [
                        2.644,
                        1.969
                      ],
                      [
                        4.05,
                        0.018
                      ],
                      [
                        2.54,
                        -3.04
                      ],
                      [
                        0.553,
                        -1.32
                      ],
                      [
                        0,
                        -1.23
                      ]
                    ],
                    o: [
                      [
                        2.274,
                        0
                      ],
                      [
                        0,
                        2e-3
                      ],
                      [
                        6e-3,
                        1e-3
                      ],
                      [
                        0.275,
                        -0.655
                      ],
                      [
                        1.147,
                        -1.373
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2.589,
                        -1e-3
                      ],
                      [
                        0.963,
                        0.718
                      ],
                      [
                        0.444,
                        1.33
                      ],
                      [
                        -0.09,
                        1.458
                      ],
                      [
                        -0.745,
                        1.452
                      ],
                      [
                        -1.697,
                        1.189
                      ],
                      [
                        -0.271,
                        0.079
                      ],
                      [
                        -1.683,
                        0.426
                      ],
                      [
                        -3.314,
                        1.492
                      ],
                      [
                        -0.815,
                        2.216
                      ],
                      [
                        2.216,
                        0.815
                      ],
                      [
                        0.664,
                        -1.806
                      ],
                      [
                        1.675,
                        -0.754
                      ],
                      [
                        0.688,
                        -0.175
                      ],
                      [
                        5.504,
                        -1.608
                      ],
                      [
                        2.965,
                        -2.078
                      ],
                      [
                        0.843,
                        -1.644
                      ],
                      [
                        0.138,
                        -2.249
                      ],
                      [
                        -0.867,
                        -2.595
                      ],
                      [
                        -2.639,
                        -1.966
                      ],
                      [
                        -6.006,
                        -0.285
                      ],
                      [
                        -1.24,
                        1.484
                      ],
                      [
                        -0.485,
                        1.158
                      ],
                      [
                        0,
                        2.361
                      ]
                    ],
                    v: [
                      [
                        -8.673,
                        -4.361
                      ],
                      [
                        -4.406,
                        -8.377
                      ],
                      [
                        -4.405,
                        -8.374
                      ],
                      [
                        -4.134,
                        -9.153
                      ],
                      [
                        -2.812,
                        -11.33
                      ],
                      [
                        2.999,
                        -13.746
                      ],
                      [
                        3.114,
                        -13.739
                      ],
                      [
                        3.23,
                        -13.739
                      ],
                      [
                        8.3,
                        -12.388
                      ],
                      [
                        10.385,
                        -9.337
                      ],
                      [
                        10.885,
                        -5.118
                      ],
                      [
                        10.355,
                        -2.475
                      ],
                      [
                        7.315,
                        1.112
                      ],
                      [
                        -2.342,
                        5.137
                      ],
                      [
                        -3.472,
                        5.434
                      ],
                      [
                        -10.348,
                        7.653
                      ],
                      [
                        -19.194,
                        16.558
                      ],
                      [
                        -16.657,
                        22.046
                      ],
                      [
                        -11.17,
                        19.508
                      ],
                      [
                        -6.839,
                        15.449
                      ],
                      [
                        -2.037,
                        13.902
                      ],
                      [
                        0.056,
                        13.343
                      ],
                      [
                        12.222,
                        8.114
                      ],
                      [
                        17.962,
                        1.427
                      ],
                      [
                        19.419,
                        -4.594
                      ],
                      [
                        18.494,
                        -12.046
                      ],
                      [
                        13.407,
                        -19.244
                      ],
                      [
                        3.341,
                        -22.289
                      ],
                      [
                        -9.373,
                        -16.812
                      ],
                      [
                        -12.02,
                        -12.456
                      ],
                      [
                        -12.948,
                        -8.636
                      ]
                    ],
                    c: !0
                  },
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gs",
                o: {
                  a: 0,
                  k: 100,
                  ix: 9
                },
                w: {
                  a: 0,
                  k: 0.389,
                  ix: 10
                },
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      0.5,
                      1,
                      1,
                      1,
                      1,
                      1,
                      1,
                      1,
                      0,
                      1,
                      0.5,
                      0.5,
                      1,
                      0
                    ],
                    ix: 8
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -5.029,
                    -12.728
                  ],
                  ix: 4
                },
                e: {
                  a: 0,
                  k: [
                    5.111,
                    1.661
                  ],
                  ix: 5
                },
                t: 1,
                lc: 2,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 13
                },
                bm: 0,
                nm: `gradient stroke
 1`,
                mn: "ADBE Vector Graphic - G-Stroke",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 5,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      0.192,
                      0.965,
                      0.965,
                      0.965,
                      0.384,
                      0.929,
                      0.929,
                      0.929,
                      0.692,
                      0.963,
                      0.963,
                      0.963,
                      1,
                      0.996,
                      0.996,
                      0.996,
                      0,
                      0,
                      0.192,
                      0.18,
                      0.384,
                      0.36,
                      0.692,
                      0.68,
                      1,
                      1
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    4.04,
                    10.411
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    -11.636,
                    -11.077
                  ],
                  ix: 6
                },
                t: 1,
                nm: `gradient
 1`,
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 5,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      1,
                      1,
                      0.33,
                      0.965,
                      0.965,
                      0.965,
                      0.66,
                      0.929,
                      0.929,
                      0.929,
                      0.83,
                      0.963,
                      0.963,
                      0.963,
                      1,
                      0.996,
                      0.996,
                      0.996
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    36.54,
                    -9.232
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    -22.925,
                    -10.482
                  ],
                  ix: 6
                },
                t: 1,
                nm: `gradient
 2`,
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 3809 (Stroke)",
            np: 4,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Ellipse 3720",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              98.624,
              174.023,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    98.904,
                    26.038
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "椭圆路径 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 5,
                  k: {
                    a: 0,
                    k: [
                      0.206,
                      1,
                      1,
                      1,
                      0.427,
                      0.978,
                      0.978,
                      0.978,
                      0.647,
                      0.957,
                      0.957,
                      0.957,
                      0.824,
                      0.937,
                      0.937,
                      0.937,
                      1,
                      0.918,
                      0.918,
                      0.918
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    6.898,
                    -13.019
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    114.566,
                    -13.019
                  ],
                  ix: 6
                },
                t: 2,
                h: {
                  a: 0,
                  k: 0,
                  ix: 7
                },
                a: {
                  a: 0,
                  k: 0,
                  ix: 8
                },
                nm: `gradient
 1`,
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Ellipse 3720",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "Vector 3810",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              98.569,
              204.212,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0.389,
                        6.072
                      ],
                      [
                        -0.13,
                        1.603
                      ],
                      [
                        -3.653,
                        0.544
                      ],
                      [
                        1.837,
                        -7.143
                      ],
                      [
                        10.453,
                        -10.937
                      ],
                      [
                        7.319,
                        -0.356
                      ],
                      [
                        10.493,
                        10.959
                      ]
                    ],
                    o: [
                      [
                        -0.311,
                        -4.858
                      ],
                      [
                        31.349,
                        0.097
                      ],
                      [
                        0.777,
                        2.623
                      ],
                      [
                        -1.605,
                        6.241
                      ],
                      [
                        -10.453,
                        10.937
                      ],
                      [
                        -7.837,
                        0.389
                      ],
                      [
                        -13.116,
                        -13.699
                      ]
                    ],
                    v: [
                      [
                        -49.397,
                        -19.599
                      ],
                      [
                        -49.397,
                        -30.481
                      ],
                      [
                        49.215,
                        -30.869
                      ],
                      [
                        47.66,
                        -6.872
                      ],
                      [
                        34.35,
                        18.777
                      ],
                      [
                        1.9,
                        30.824
                      ],
                      [
                        -34.727,
                        18.291
                      ]
                    ],
                    c: !0
                  },
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 5,
                  k: {
                    a: 0,
                    k: [
                      0.206,
                      1,
                      1,
                      1,
                      0.427,
                      0.978,
                      0.978,
                      0.978,
                      0.647,
                      0.957,
                      0.957,
                      0.957,
                      0.824,
                      0.937,
                      0.937,
                      0.937,
                      1,
                      0.918,
                      0.918,
                      0.918
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -32.569,
                    -25.783
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    88.306,
                    -25.783
                  ],
                  ix: 6
                },
                t: 2,
                h: {
                  a: 0,
                  k: 0,
                  ix: 7
                },
                a: {
                  a: 0,
                  k: 0,
                  ix: 8
                },
                nm: `gradient
 1`,
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 3810",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: "形状图层 1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 40,
            ix: 11
          },
          r: {
            a: 0,
            k: -4.201,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              96.5,
              175.5,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        ef: [
          {
            ty: 29,
            nm: "高斯模糊",
            np: 5,
            mn: "ADBE Gaussian Blur 2",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 0,
                nm: "模糊度",
                mn: "ADBE Gaussian Blur 2-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 10.8,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "模糊方向",
                mn: "ADBE Gaussian Blur 2-0002",
                ix: 2,
                v: {
                  a: 0,
                  k: 1,
                  ix: 2
                }
              },
              {
                ty: 7,
                nm: "重复边缘像素",
                mn: "ADBE Gaussian Blur 2-0003",
                ix: 3,
                v: {
                  a: 0,
                  k: 0,
                  ix: 3
                }
              }
            ]
          }
        ],
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    111.16,
                    24.965
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "椭圆路径 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      0.336,
                      0.336,
                      0.542,
                      0.5,
                      0.5,
                      0.483,
                      0.64,
                      1,
                      0.664,
                      0.63,
                      0.738,
                      0,
                      1,
                      0.5,
                      0.5,
                      1,
                      0
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    100,
                    0
                  ],
                  ix: 6
                },
                t: 1,
                nm: `gradient 1
`,
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    27.955,
                    50.658
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "椭圆 1",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: -0.66666666666667,
        op: 106,
        st: 6,
        ct: 1,
        bm: 0
      }
    ]
  },
  {
    id: "comp_2",
    nm: "Frame 427322878",
    fr: 60,
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Ellipse 3653",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              101.496,
              96.108,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        -6.973,
                        0
                      ],
                      [
                        -2.31,
                        2.974
                      ],
                      [
                        5.446,
                        4.016
                      ],
                      [
                        0,
                        -3.508
                      ]
                    ],
                    o: [
                      [
                        4.057,
                        0
                      ],
                      [
                        -5.165,
                        -5.817
                      ],
                      [
                        -2.31,
                        2.288
                      ],
                      [
                        0,
                        6.973
                      ]
                    ],
                    v: [
                      [
                        1.324,
                        10.798
                      ],
                      [
                        11.301,
                        5.91
                      ],
                      [
                        -7.56,
                        -10.798
                      ],
                      [
                        -11.301,
                        -1.827
                      ]
                    ],
                    c: !0
                  },
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    1,
                    1,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Ellipse 3653",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Ellipse 3651",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              93.897,
              107.742,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    34.709,
                    104.21
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "椭圆路径 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      0.882,
                      0.333,
                      0.286,
                      0.5,
                      0.904,
                      0.39,
                      0.312,
                      1,
                      0.925,
                      0.447,
                      0.337
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    0,
                    -52.105
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    0,
                    52.105
                  ],
                  ix: 6
                },
                t: 1,
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: -47.737,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Ellipse 3651",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Ellipse 3652",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              93.897,
              107.743,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    41.596,
                    113.259
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "椭圆路径 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: !1
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0.796078443527,
                    0.729411780834,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: -47.737,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Ellipse 3652",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Vector 1852",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              117.148,
              81.664,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        8.3,
                        -7.801
                      ],
                      [
                        9.792,
                        -9.833
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -5.3,
                        10.5
                      ],
                      [
                        1.333,
                        9
                      ],
                      [
                        -7.7,
                        8.6
                      ],
                      [
                        3.875,
                        3.417
                      ],
                      [
                        6.3,
                        5.4
                      ],
                      [
                        2.799,
                        -2.826
                      ]
                    ],
                    o: [
                      [
                        -27.5,
                        -4.5
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        3.167,
                        -4.667
                      ],
                      [
                        5.3,
                        -10.5
                      ],
                      [
                        3.25,
                        -3.625
                      ],
                      [
                        7.7,
                        -8.6
                      ],
                      [
                        -1.125,
                        -1.125
                      ],
                      [
                        -6.3,
                        -5.4
                      ],
                      [
                        -4.5,
                        4.542
                      ]
                    ],
                    v: [
                      [
                        2.173,
                        -37.835
                      ],
                      [
                        -61.577,
                        -13.96
                      ],
                      [
                        -10.827,
                        38.539
                      ],
                      [
                        19.673,
                        62.664
                      ],
                      [
                        35.798,
                        35.539
                      ],
                      [
                        38.423,
                        -4.586
                      ],
                      [
                        57.798,
                        -26.211
                      ],
                      [
                        55.798,
                        -47.211
                      ],
                      [
                        44.548,
                        -57.336
                      ],
                      [
                        26.048,
                        -61.211
                      ]
                    ],
                    c: !0
                  },
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      1,
                      0.435,
                      0.486,
                      0.5,
                      1,
                      0.504,
                      0.475,
                      1,
                      1,
                      0.573,
                      0.463
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -14.227,
                    -40.592
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    22.43,
                    -7.319
                  ],
                  ix: 6
                },
                t: 1,
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 1852",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Vector 1853",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              178.428,
              181.096,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        1.75,
                        2.583
                      ]
                    ],
                    o: [
                      [
                        -11.409,
                        6.317
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        5.017,
                        -110.02
                      ],
                      [
                        -22.642,
                        -106.382
                      ]
                    ],
                    c: !1
                  },
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -2.125,
                        -5.542
                      ]
                    ],
                    o: [
                      [
                        9.5,
                        6
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        -14.358,
                        -132.645
                      ],
                      [
                        5.017,
                        -110.02
                      ]
                    ],
                    c: !1
                  },
                  ix: 2
                },
                nm: "路径 2",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ind: 2,
                ty: "sh",
                ix: 3,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        13.9
                      ],
                      [
                        5.708,
                        3.125
                      ]
                    ],
                    o: [
                      [
                        0,
                        -68.125
                      ],
                      [
                        -0.4,
                        -14.1
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        22.642,
                        132.645
                      ],
                      [
                        22.642,
                        -83.02
                      ],
                      [
                        5.017,
                        -110.02
                      ]
                    ],
                    c: !1
                  },
                  ix: 2
                },
                nm: "路径 3",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "mm",
                mm: 1,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: !1
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    1,
                    1,
                    1,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 7,
                  ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Vector 1853",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Ellipse 3715",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              202.936,
              316.875,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    83.076,
                    37.228
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "椭圆路径 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      0.29,
                      0.576,
                      1,
                      0.5,
                      0.149,
                      0.429,
                      0.935,
                      1,
                      8e-3,
                      0.282,
                      0.871
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    -58.539,
                    16.557
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    39.123,
                    -16.118
                  ],
                  ix: 6
                },
                t: 1,
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: -10.722,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Ellipse 3715",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "Ellipse 3714",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 40,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              233.155,
              307.227,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              66.527,
              83.014,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        ef: [
          {
            ty: 29,
            nm: "高斯模糊",
            np: 5,
            mn: "ADBE Gaussian Blur 2",
            ix: 1,
            en: 1,
            ef: [
              {
                ty: 0,
                nm: "模糊度",
                mn: "ADBE Gaussian Blur 2-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 10,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "模糊方向",
                mn: "ADBE Gaussian Blur 2-0002",
                ix: 2,
                v: {
                  a: 0,
                  k: 1,
                  ix: 2
                }
              },
              {
                ty: 7,
                nm: "重复边缘像素",
                mn: "ADBE Gaussian Blur 2-0003",
                ix: 3,
                v: {
                  a: 0,
                  k: 0,
                  ix: 3
                }
              }
            ]
          }
        ],
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        -36.913,
                        0
                      ],
                      [
                        0,
                        16.901
                      ],
                      [
                        36.913,
                        0
                      ],
                      [
                        0,
                        -16.901
                      ]
                    ],
                    o: [
                      [
                        36.913,
                        0
                      ],
                      [
                        0,
                        -16.901
                      ],
                      [
                        -36.913,
                        0
                      ],
                      [
                        0,
                        16.901
                      ]
                    ],
                    v: [
                      [
                        3.484,
                        24.619
                      ],
                      [
                        66.837,
                        2.424
                      ],
                      [
                        8.111,
                        -24.619
                      ],
                      [
                        -66.837,
                        2.424
                      ]
                    ],
                    c: !0
                  },
                  ix: 2
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "gf",
                o: {
                  a: 0,
                  k: 100,
                  ix: 10
                },
                r: 1,
                bm: 0,
                g: {
                  p: 3,
                  k: {
                    a: 0,
                    k: [
                      0,
                      0.072,
                      0,
                      0.405,
                      0.5,
                      0.036,
                      0.037,
                      0.41,
                      1,
                      0,
                      0.074,
                      0.415,
                      0,
                      0,
                      0.5,
                      0.5,
                      1,
                      1
                    ],
                    ix: 9
                  }
                },
                s: {
                  a: 0,
                  k: [
                    19.828,
                    -44.954
                  ],
                  ix: 5
                },
                e: {
                  a: 0,
                  k: [
                    -17.084,
                    -12.917
                  ],
                  ix: 6
                },
                t: 1,
                nm: "gradient 1",
                mn: "ADBE Vector Graphic - G-Fill",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: -10.504,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "变换"
              }
            ],
            nm: "Ellipse 3714",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }
        ],
        ip: 0,
        op: 100,
        st: 0,
        ct: 1,
        bm: 0
      }
    ]
  }
], layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 0,
    nm: "Frame 427322988",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          276,
          253,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          200,
          326,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 400,
    h: 652,
    ip: 0,
    op: 100,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 0,
    nm: "Frame 427322877",
    refId: "comp_1",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          50,
          596,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          104.5,
          180,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          50,
          50,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 209,
    h: 360,
    ip: 0,
    op: 100,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 0,
    nm: "Frame 427322878",
    refId: "comp_2",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          339.5,
          558.25,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          148,
          192,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          45,
          45,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 296,
    h: 384,
    ip: 0,
    op: 100,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 2,
    nm: "Frame 427322877.jpg",
    cl: "jpg",
    refId: "image_0",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          200,
          328,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          400,
          652,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          50,
          50,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    ip: 0,
    op: 100,
    st: 0,
    bm: 0
  }
], markers = [], loginBanner = {
  v,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
}, LeftBanner = () => {
  const e = useRef(), t = useLanguageContext();
  return useEffect(() => (lottie.loadAnimation({
    name: "leftBannerAnimation",
    container: e.current,
    renderer: "svg",
    loop: !0,
    autoplay: !0,
    animationData: loginBanner
  }), () => {
    lottie.destroy("leftBannerAnimation");
  }), []), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$2.leftBanner, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: e, className: styles$2.bannner }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(leftBannerDesc, { lang: t })
  ] });
}, bannner$1 = "_bannner_bz57p_1", bannerFlex$1 = "_bannerFlex_bz57p_12", bannerText$1 = "_bannerText_bz57p_18", styles$1 = {
  bannner: bannner$1,
  bannerFlex: bannerFlex$1,
  bannerText: bannerText$1
}, getstarted = "data:image/png;base64,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", getstartedjp = "data:image/png;base64,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", getEmployer = "data:image/png;base64,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", switchLoginType = new BroadcastChannel("SWITCH_LOGIN_TYPE"), LeftBanner2$1 = () => {
  var a;
  const [e, t] = useState("jobSeeker"), r = ((a = window == null ? void 0 : window.location) == null ? void 0 : a.pathname) || "", i = getCountryKey();
  useEffect(() => {
    const s = getCookie("loginType") || "jobSeeker";
    t(s), switchLoginType.onmessage = (l) => {
      l.message.type === "SWITCH_LOGIN_TYPE" && t(l.message.data);
    };
  }, [r]);
  const n = useMemo(() => e === "recruiter" ? getEmployer : i === "jp" ? getstartedjp : getstarted, [e]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$1.bannner, children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { style: { width: "100%", height: "100%" }, src: n, alt: "getstarted" }) });
}, bannner = "_bannner_snt96_1", bannerFlex = "_bannerFlex_snt96_14", bannerText = "_bannerText_snt96_20", styles = {
  bannner,
  bannerFlex,
  bannerText
}, LeftBanner2 = ({ getStarted: e }) => {
  const {
    neptune: t,
    neptuneOffersJob: r
  } = e || {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: `${styles.bannner} `, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.bannerFlex, style: { backgroundImage: `url(${WebPng})`, backgroundRepeat: "no-repeat" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.bannerText, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
    t,
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: r })
  ] }) }) }) });
};
function LeftContainer(e) {
  const { bannerType: t, dictionary: r } = e, i = useMemo(() => {
    if (t == LeftBannerEnums.aicv)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LeftBanner, {});
    if (t == LeftBannerEnums.bossjob)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LeftBanner2$1, { getStarted: r.getStarted });
    if (t == LeftBannerEnums.neptune)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LeftBanner2, { getStarted: r.getStarted });
  }, [t, r.getStarted]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: i });
}
export {
  Apple as A,
  BossjobLogo as B,
  Compact as C,
  Line as D,
  Email as E,
  FB as F,
  Google as G,
  genCompactItemStyle as H,
  useSize$1 as I,
  EmailBlack as J,
  LeftBannerEnums as L,
  More as M,
  NoCompactStyle as N,
  Portal as P,
  QrCodeComponent as Q,
  RefResizeObserver as R,
  Trigger as T,
  X,
  LeftContainer as a,
  useLayoutEffect$1 as b,
  codePopver as c,
  default_1 as d,
  Popover$1 as e,
  initMotion as f,
  getTransitionName as g,
  isVisible as h,
  isMobile as i,
  cloneElement as j,
  Tooltip$1 as k,
  lottie as l,
  initZoomMotion as m,
  initCollapseMotion as n,
  omit as o,
  getArrowStyle as p,
  getArrowOffsetToken as q,
  getArrowToken as r,
  styles$3 as s,
  toArray$1 as t,
  useSessionWithBanner as u,
  getPlacements as v,
  useStyle$3 as w,
  useCompactItemContext as x,
  Button$1 as y,
  Phone as z
};
//# sourceMappingURL=index-384e14bf.js.map
